import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigFloat: any;
  BigInt: any;
  Cursor: any;
  Date: any;
  Datetime: any;
  JSON: any;
  Jwt: any;
  Upload: File | Blob;
};

export type Account = {
  __typename?: 'Account';
  delegateEnabled?: Maybe<Scalars['Boolean']>;
  delegateExpireAt?: Maybe<Scalars['Datetime']>;
  delegateIssuedAt?: Maybe<Scalars['Datetime']>;
  delegateToken?: Maybe<Scalars['String']>;
  systemCode?: Maybe<Scalars['String']>;
  tenantBusinessName?: Maybe<Scalars['String']>;
  tenantCreatedAt?: Maybe<Scalars['Datetime']>;
  tenantEmail?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantNit?: Maybe<Scalars['BigInt']>;
  tenantPhoneNumber?: Maybe<Scalars['String']>;
};

export type ActiveSubscription = {
  __typename?: 'ActiveSubscription';
  cancelledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  discount?: Maybe<Scalars['BigFloat']>;
  discountType?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  planBillingDay?: Maybe<Scalars['Int']>;
  planBillingMonths?: Maybe<Scalars['Int']>;
  planCurrency?: Maybe<Scalars['String']>;
  planDescription?: Maybe<Scalars['String']>;
  planKey?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['BigFloat']>;
  quotas: SubscriptionQuotasConnection;
  startedAt?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
};


export type ActiveSubscriptionQuotasArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SubscriptionQuotaFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AllDelegatedToken = {
  __typename?: 'AllDelegatedToken';
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  revoked?: Maybe<Scalars['Boolean']>;
  sub?: Maybe<Scalars['String']>;
  systemCode?: Maybe<Scalars['String']>;
  tenantBusinessName?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  tenantNit?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type AllDelegatedTokenCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  nit?: InputMaybe<Scalars['String']>;
  revoked?: InputMaybe<Scalars['Boolean']>;
  sub?: InputMaybe<Scalars['String']>;
  systemCode?: InputMaybe<Scalars['String']>;
  tenantBusinessName?: InputMaybe<Scalars['String']>;
  tenantKey?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  tenantNit?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type AllDelegatedTokenFilter = {
  and?: InputMaybe<Array<AllDelegatedTokenFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  expireAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  nit?: InputMaybe<StringFilter>;
  not?: InputMaybe<AllDelegatedTokenFilter>;
  or?: InputMaybe<Array<AllDelegatedTokenFilter>>;
  revoked?: InputMaybe<BooleanFilter>;
  sub?: InputMaybe<StringFilter>;
  systemCode?: InputMaybe<StringFilter>;
  tenantBusinessName?: InputMaybe<StringFilter>;
  tenantKey?: InputMaybe<StringFilter>;
  tenantName?: InputMaybe<StringFilter>;
  tenantNit?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type AllDelegatedTokensConnection = {
  __typename?: 'AllDelegatedTokensConnection';
  edges: Array<AllDelegatedTokensEdge>;
  nodes: Array<Maybe<AllDelegatedToken>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AllDelegatedTokensEdge = {
  __typename?: 'AllDelegatedTokensEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<AllDelegatedToken>;
};

export enum AllDelegatedTokensOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  ExpireAtAsc = 'EXPIRE_AT_ASC',
  ExpireAtDesc = 'EXPIRE_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IssuedAtAsc = 'ISSUED_AT_ASC',
  IssuedAtDesc = 'ISSUED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  NitAsc = 'NIT_ASC',
  NitDesc = 'NIT_DESC',
  RevokedAsc = 'REVOKED_ASC',
  RevokedDesc = 'REVOKED_DESC',
  SubAsc = 'SUB_ASC',
  SubDesc = 'SUB_DESC',
  SystemCodeAsc = 'SYSTEM_CODE_ASC',
  SystemCodeDesc = 'SYSTEM_CODE_DESC',
  TenantBusinessNameAsc = 'TENANT_BUSINESS_NAME_ASC',
  TenantBusinessNameDesc = 'TENANT_BUSINESS_NAME_DESC',
  TenantKeyAsc = 'TENANT_KEY_ASC',
  TenantKeyDesc = 'TENANT_KEY_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  TenantNitAsc = 'TENANT_NIT_ASC',
  TenantNitDesc = 'TENANT_NIT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type AllDigitalSignature = {
  __typename?: 'AllDigitalSignature';
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  issuerCommonName?: Maybe<Scalars['String']>;
  issuerCountry?: Maybe<Scalars['String']>;
  issuerOrganization?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  revoked?: Maybe<Scalars['Boolean']>;
  subjectBusinessName?: Maybe<Scalars['String']>;
  subjectCountry?: Maybe<Scalars['String']>;
  subjectDocumentComplement?: Maybe<Scalars['String']>;
  subjectDocumentNumber?: Maybe<Scalars['String']>;
  subjectDocumentType?: Maybe<Scalars['String']>;
  subjectJobTitle?: Maybe<Scalars['String']>;
  subjectLegalRepresentative?: Maybe<Scalars['String']>;
  subjectNit?: Maybe<Scalars['String']>;
  tenantBusinessName?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  tenantNit?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type AllDigitalSignatureCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  issuerCommonName?: InputMaybe<Scalars['String']>;
  issuerCountry?: InputMaybe<Scalars['String']>;
  issuerOrganization?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  revoked?: InputMaybe<Scalars['Boolean']>;
  subjectBusinessName?: InputMaybe<Scalars['String']>;
  subjectCountry?: InputMaybe<Scalars['String']>;
  subjectDocumentComplement?: InputMaybe<Scalars['String']>;
  subjectDocumentNumber?: InputMaybe<Scalars['String']>;
  subjectDocumentType?: InputMaybe<Scalars['String']>;
  subjectJobTitle?: InputMaybe<Scalars['String']>;
  subjectLegalRepresentative?: InputMaybe<Scalars['String']>;
  subjectNit?: InputMaybe<Scalars['String']>;
  tenantBusinessName?: InputMaybe<Scalars['String']>;
  tenantKey?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  tenantNit?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type AllDigitalSignatureFilter = {
  and?: InputMaybe<Array<AllDigitalSignatureFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  expireAt?: InputMaybe<DatetimeFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  issuerCommonName?: InputMaybe<StringFilter>;
  issuerCountry?: InputMaybe<StringFilter>;
  issuerOrganization?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<AllDigitalSignatureFilter>;
  or?: InputMaybe<Array<AllDigitalSignatureFilter>>;
  revoked?: InputMaybe<BooleanFilter>;
  subjectBusinessName?: InputMaybe<StringFilter>;
  subjectCountry?: InputMaybe<StringFilter>;
  subjectDocumentComplement?: InputMaybe<StringFilter>;
  subjectDocumentNumber?: InputMaybe<StringFilter>;
  subjectDocumentType?: InputMaybe<StringFilter>;
  subjectJobTitle?: InputMaybe<StringFilter>;
  subjectLegalRepresentative?: InputMaybe<StringFilter>;
  subjectNit?: InputMaybe<StringFilter>;
  tenantBusinessName?: InputMaybe<StringFilter>;
  tenantKey?: InputMaybe<StringFilter>;
  tenantName?: InputMaybe<StringFilter>;
  tenantNit?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type AllDigitalSignaturesConnection = {
  __typename?: 'AllDigitalSignaturesConnection';
  edges: Array<AllDigitalSignaturesEdge>;
  nodes: Array<Maybe<AllDigitalSignature>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AllDigitalSignaturesEdge = {
  __typename?: 'AllDigitalSignaturesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<AllDigitalSignature>;
};

export enum AllDigitalSignaturesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  ExpireAtAsc = 'EXPIRE_AT_ASC',
  ExpireAtDesc = 'EXPIRE_AT_DESC',
  IssuedAtAsc = 'ISSUED_AT_ASC',
  IssuedAtDesc = 'ISSUED_AT_DESC',
  IssuerCommonNameAsc = 'ISSUER_COMMON_NAME_ASC',
  IssuerCommonNameDesc = 'ISSUER_COMMON_NAME_DESC',
  IssuerCountryAsc = 'ISSUER_COUNTRY_ASC',
  IssuerCountryDesc = 'ISSUER_COUNTRY_DESC',
  IssuerOrganizationAsc = 'ISSUER_ORGANIZATION_ASC',
  IssuerOrganizationDesc = 'ISSUER_ORGANIZATION_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  RevokedAsc = 'REVOKED_ASC',
  RevokedDesc = 'REVOKED_DESC',
  SubjectBusinessNameAsc = 'SUBJECT_BUSINESS_NAME_ASC',
  SubjectBusinessNameDesc = 'SUBJECT_BUSINESS_NAME_DESC',
  SubjectCountryAsc = 'SUBJECT_COUNTRY_ASC',
  SubjectCountryDesc = 'SUBJECT_COUNTRY_DESC',
  SubjectDocumentComplementAsc = 'SUBJECT_DOCUMENT_COMPLEMENT_ASC',
  SubjectDocumentComplementDesc = 'SUBJECT_DOCUMENT_COMPLEMENT_DESC',
  SubjectDocumentNumberAsc = 'SUBJECT_DOCUMENT_NUMBER_ASC',
  SubjectDocumentNumberDesc = 'SUBJECT_DOCUMENT_NUMBER_DESC',
  SubjectDocumentTypeAsc = 'SUBJECT_DOCUMENT_TYPE_ASC',
  SubjectDocumentTypeDesc = 'SUBJECT_DOCUMENT_TYPE_DESC',
  SubjectJobTitleAsc = 'SUBJECT_JOB_TITLE_ASC',
  SubjectJobTitleDesc = 'SUBJECT_JOB_TITLE_DESC',
  SubjectLegalRepresentativeAsc = 'SUBJECT_LEGAL_REPRESENTATIVE_ASC',
  SubjectLegalRepresentativeDesc = 'SUBJECT_LEGAL_REPRESENTATIVE_DESC',
  SubjectNitAsc = 'SUBJECT_NIT_ASC',
  SubjectNitDesc = 'SUBJECT_NIT_DESC',
  TenantBusinessNameAsc = 'TENANT_BUSINESS_NAME_ASC',
  TenantBusinessNameDesc = 'TENANT_BUSINESS_NAME_DESC',
  TenantKeyAsc = 'TENANT_KEY_ASC',
  TenantKeyDesc = 'TENANT_KEY_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  TenantNitAsc = 'TENANT_NIT_ASC',
  TenantNitDesc = 'TENANT_NIT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type AllSubscriptionCharge = {
  __typename?: 'AllSubscriptionCharge';
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCreatedAt?: Maybe<Scalars['Datetime']>;
  chargeDescription?: Maybe<Scalars['String']>;
  chargeKey?: Maybe<Scalars['String']>;
  chargeOverageAmount?: Maybe<Scalars['BigFloat']>;
  chargeStatus?: Maybe<SubscriptionChargeStatus>;
  chargeTotalAmount?: Maybe<Scalars['BigFloat']>;
  chargeType?: Maybe<SubscriptionChargeType>;
  periodDescription?: Maybe<Scalars['String']>;
  periodEndAt?: Maybe<Scalars['Datetime']>;
  periodEndAtDate?: Maybe<Scalars['Date']>;
  periodKey?: Maybe<Scalars['String']>;
  periodStartAt?: Maybe<Scalars['Datetime']>;
  periodStartAtDate?: Maybe<Scalars['Date']>;
  periodStatus?: Maybe<SubscriptionPeriodStatus>;
  planCurrency?: Maybe<Scalars['String']>;
  planKey?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['BigFloat']>;
  subscriptionCancelledAt?: Maybe<Scalars['Datetime']>;
  subscriptionKey?: Maybe<Scalars['String']>;
  subscriptionStartedAt?: Maybe<Scalars['Datetime']>;
  tenantBusinessName?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  tenantNit?: Maybe<Scalars['BigInt']>;
};

export type AllSubscriptionChargeCondition = {
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeCreatedAt?: InputMaybe<Scalars['Datetime']>;
  chargeDescription?: InputMaybe<Scalars['String']>;
  chargeKey?: InputMaybe<Scalars['String']>;
  chargeOverageAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeStatus?: InputMaybe<SubscriptionChargeStatus>;
  chargeTotalAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeType?: InputMaybe<SubscriptionChargeType>;
  periodDescription?: InputMaybe<Scalars['String']>;
  periodEndAt?: InputMaybe<Scalars['Datetime']>;
  periodEndAtDate?: InputMaybe<Scalars['Date']>;
  periodKey?: InputMaybe<Scalars['String']>;
  periodStartAt?: InputMaybe<Scalars['Datetime']>;
  periodStartAtDate?: InputMaybe<Scalars['Date']>;
  periodStatus?: InputMaybe<SubscriptionPeriodStatus>;
  planCurrency?: InputMaybe<Scalars['String']>;
  planKey?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planPrice?: InputMaybe<Scalars['BigFloat']>;
  subscriptionCancelledAt?: InputMaybe<Scalars['Datetime']>;
  subscriptionKey?: InputMaybe<Scalars['String']>;
  subscriptionStartedAt?: InputMaybe<Scalars['Datetime']>;
  tenantBusinessName?: InputMaybe<Scalars['String']>;
  tenantKey?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  tenantNit?: InputMaybe<Scalars['BigInt']>;
};

export type AllSubscriptionChargeFilter = {
  and?: InputMaybe<Array<AllSubscriptionChargeFilter>>;
  chargeAmount?: InputMaybe<BigFloatFilter>;
  chargeCreatedAt?: InputMaybe<DatetimeFilter>;
  chargeDescription?: InputMaybe<StringFilter>;
  chargeKey?: InputMaybe<StringFilter>;
  chargeOverageAmount?: InputMaybe<BigFloatFilter>;
  chargeStatus?: InputMaybe<SubscriptionChargeStatusFilter>;
  chargeTotalAmount?: InputMaybe<BigFloatFilter>;
  chargeType?: InputMaybe<SubscriptionChargeTypeFilter>;
  not?: InputMaybe<AllSubscriptionChargeFilter>;
  or?: InputMaybe<Array<AllSubscriptionChargeFilter>>;
  periodDescription?: InputMaybe<StringFilter>;
  periodEndAt?: InputMaybe<DatetimeFilter>;
  periodEndAtDate?: InputMaybe<DateFilter>;
  periodKey?: InputMaybe<StringFilter>;
  periodStartAt?: InputMaybe<DatetimeFilter>;
  periodStartAtDate?: InputMaybe<DateFilter>;
  periodStatus?: InputMaybe<SubscriptionPeriodStatusFilter>;
  planCurrency?: InputMaybe<StringFilter>;
  planKey?: InputMaybe<StringFilter>;
  planName?: InputMaybe<StringFilter>;
  planPrice?: InputMaybe<BigFloatFilter>;
  subscriptionCancelledAt?: InputMaybe<DatetimeFilter>;
  subscriptionKey?: InputMaybe<StringFilter>;
  subscriptionStartedAt?: InputMaybe<DatetimeFilter>;
  tenantBusinessName?: InputMaybe<StringFilter>;
  tenantKey?: InputMaybe<StringFilter>;
  tenantName?: InputMaybe<StringFilter>;
  tenantNit?: InputMaybe<BigIntFilter>;
};

export type AllSubscriptionChargesConnection = {
  __typename?: 'AllSubscriptionChargesConnection';
  edges: Array<AllSubscriptionChargesEdge>;
  nodes: Array<Maybe<AllSubscriptionCharge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AllSubscriptionChargesEdge = {
  __typename?: 'AllSubscriptionChargesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<AllSubscriptionCharge>;
};

export enum AllSubscriptionChargesOrderBy {
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCreatedAtAsc = 'CHARGE_CREATED_AT_ASC',
  ChargeCreatedAtDesc = 'CHARGE_CREATED_AT_DESC',
  ChargeDescriptionAsc = 'CHARGE_DESCRIPTION_ASC',
  ChargeDescriptionDesc = 'CHARGE_DESCRIPTION_DESC',
  ChargeKeyAsc = 'CHARGE_KEY_ASC',
  ChargeKeyDesc = 'CHARGE_KEY_DESC',
  ChargeOverageAmountAsc = 'CHARGE_OVERAGE_AMOUNT_ASC',
  ChargeOverageAmountDesc = 'CHARGE_OVERAGE_AMOUNT_DESC',
  ChargeStatusAsc = 'CHARGE_STATUS_ASC',
  ChargeStatusDesc = 'CHARGE_STATUS_DESC',
  ChargeTotalAmountAsc = 'CHARGE_TOTAL_AMOUNT_ASC',
  ChargeTotalAmountDesc = 'CHARGE_TOTAL_AMOUNT_DESC',
  ChargeTypeAsc = 'CHARGE_TYPE_ASC',
  ChargeTypeDesc = 'CHARGE_TYPE_DESC',
  Natural = 'NATURAL',
  PeriodDescriptionAsc = 'PERIOD_DESCRIPTION_ASC',
  PeriodDescriptionDesc = 'PERIOD_DESCRIPTION_DESC',
  PeriodEndAtAsc = 'PERIOD_END_AT_ASC',
  PeriodEndAtDateAsc = 'PERIOD_END_AT_DATE_ASC',
  PeriodEndAtDateDesc = 'PERIOD_END_AT_DATE_DESC',
  PeriodEndAtDesc = 'PERIOD_END_AT_DESC',
  PeriodKeyAsc = 'PERIOD_KEY_ASC',
  PeriodKeyDesc = 'PERIOD_KEY_DESC',
  PeriodStartAtAsc = 'PERIOD_START_AT_ASC',
  PeriodStartAtDateAsc = 'PERIOD_START_AT_DATE_ASC',
  PeriodStartAtDateDesc = 'PERIOD_START_AT_DATE_DESC',
  PeriodStartAtDesc = 'PERIOD_START_AT_DESC',
  PeriodStatusAsc = 'PERIOD_STATUS_ASC',
  PeriodStatusDesc = 'PERIOD_STATUS_DESC',
  PlanCurrencyAsc = 'PLAN_CURRENCY_ASC',
  PlanCurrencyDesc = 'PLAN_CURRENCY_DESC',
  PlanKeyAsc = 'PLAN_KEY_ASC',
  PlanKeyDesc = 'PLAN_KEY_DESC',
  PlanNameAsc = 'PLAN_NAME_ASC',
  PlanNameDesc = 'PLAN_NAME_DESC',
  PlanPriceAsc = 'PLAN_PRICE_ASC',
  PlanPriceDesc = 'PLAN_PRICE_DESC',
  SubscriptionCancelledAtAsc = 'SUBSCRIPTION_CANCELLED_AT_ASC',
  SubscriptionCancelledAtDesc = 'SUBSCRIPTION_CANCELLED_AT_DESC',
  SubscriptionKeyAsc = 'SUBSCRIPTION_KEY_ASC',
  SubscriptionKeyDesc = 'SUBSCRIPTION_KEY_DESC',
  SubscriptionStartedAtAsc = 'SUBSCRIPTION_STARTED_AT_ASC',
  SubscriptionStartedAtDesc = 'SUBSCRIPTION_STARTED_AT_DESC',
  TenantBusinessNameAsc = 'TENANT_BUSINESS_NAME_ASC',
  TenantBusinessNameDesc = 'TENANT_BUSINESS_NAME_DESC',
  TenantKeyAsc = 'TENANT_KEY_ASC',
  TenantKeyDesc = 'TENANT_KEY_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  TenantNitAsc = 'TENANT_NIT_ASC',
  TenantNitDesc = 'TENANT_NIT_DESC'
}

export type AllSubscriptionPeriod = {
  __typename?: 'AllSubscriptionPeriod';
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCreatedAt?: Maybe<Scalars['Datetime']>;
  chargeDescription?: Maybe<Scalars['String']>;
  chargeKey?: Maybe<Scalars['String']>;
  chargeOverageAmount?: Maybe<Scalars['BigFloat']>;
  chargeStatus?: Maybe<SubscriptionChargeStatus>;
  chargeTotalAmount?: Maybe<Scalars['BigFloat']>;
  chargeType?: Maybe<SubscriptionChargeType>;
  description?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  planCurrency?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['BigFloat']>;
  startAt?: Maybe<Scalars['Datetime']>;
  status?: Maybe<SubscriptionPeriodStatus>;
  tenantBusinessName?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  tenantNit?: Maybe<Scalars['BigInt']>;
};

export type AllSubscriptionPeriodCondition = {
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeCreatedAt?: InputMaybe<Scalars['Datetime']>;
  chargeDescription?: InputMaybe<Scalars['String']>;
  chargeKey?: InputMaybe<Scalars['String']>;
  chargeOverageAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeStatus?: InputMaybe<SubscriptionChargeStatus>;
  chargeTotalAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeType?: InputMaybe<SubscriptionChargeType>;
  description?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  planCurrency?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planPrice?: InputMaybe<Scalars['BigFloat']>;
  startAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<SubscriptionPeriodStatus>;
  tenantBusinessName?: InputMaybe<Scalars['String']>;
  tenantKey?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  tenantNit?: InputMaybe<Scalars['BigInt']>;
};

export type AllSubscriptionPeriodFilter = {
  and?: InputMaybe<Array<AllSubscriptionPeriodFilter>>;
  chargeAmount?: InputMaybe<BigFloatFilter>;
  chargeCreatedAt?: InputMaybe<DatetimeFilter>;
  chargeDescription?: InputMaybe<StringFilter>;
  chargeKey?: InputMaybe<StringFilter>;
  chargeOverageAmount?: InputMaybe<BigFloatFilter>;
  chargeStatus?: InputMaybe<SubscriptionChargeStatusFilter>;
  chargeTotalAmount?: InputMaybe<BigFloatFilter>;
  chargeType?: InputMaybe<SubscriptionChargeTypeFilter>;
  description?: InputMaybe<StringFilter>;
  endAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<AllSubscriptionPeriodFilter>;
  or?: InputMaybe<Array<AllSubscriptionPeriodFilter>>;
  planCurrency?: InputMaybe<StringFilter>;
  planName?: InputMaybe<StringFilter>;
  planPrice?: InputMaybe<BigFloatFilter>;
  startAt?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<SubscriptionPeriodStatusFilter>;
  tenantBusinessName?: InputMaybe<StringFilter>;
  tenantKey?: InputMaybe<StringFilter>;
  tenantName?: InputMaybe<StringFilter>;
  tenantNit?: InputMaybe<BigIntFilter>;
};

export type AllSubscriptionPeriodsConnection = {
  __typename?: 'AllSubscriptionPeriodsConnection';
  edges: Array<AllSubscriptionPeriodsEdge>;
  nodes: Array<Maybe<AllSubscriptionPeriod>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AllSubscriptionPeriodsEdge = {
  __typename?: 'AllSubscriptionPeriodsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<AllSubscriptionPeriod>;
};

export enum AllSubscriptionPeriodsOrderBy {
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCreatedAtAsc = 'CHARGE_CREATED_AT_ASC',
  ChargeCreatedAtDesc = 'CHARGE_CREATED_AT_DESC',
  ChargeDescriptionAsc = 'CHARGE_DESCRIPTION_ASC',
  ChargeDescriptionDesc = 'CHARGE_DESCRIPTION_DESC',
  ChargeKeyAsc = 'CHARGE_KEY_ASC',
  ChargeKeyDesc = 'CHARGE_KEY_DESC',
  ChargeOverageAmountAsc = 'CHARGE_OVERAGE_AMOUNT_ASC',
  ChargeOverageAmountDesc = 'CHARGE_OVERAGE_AMOUNT_DESC',
  ChargeStatusAsc = 'CHARGE_STATUS_ASC',
  ChargeStatusDesc = 'CHARGE_STATUS_DESC',
  ChargeTotalAmountAsc = 'CHARGE_TOTAL_AMOUNT_ASC',
  ChargeTotalAmountDesc = 'CHARGE_TOTAL_AMOUNT_DESC',
  ChargeTypeAsc = 'CHARGE_TYPE_ASC',
  ChargeTypeDesc = 'CHARGE_TYPE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EndAtAsc = 'END_AT_ASC',
  EndAtDesc = 'END_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PlanCurrencyAsc = 'PLAN_CURRENCY_ASC',
  PlanCurrencyDesc = 'PLAN_CURRENCY_DESC',
  PlanNameAsc = 'PLAN_NAME_ASC',
  PlanNameDesc = 'PLAN_NAME_DESC',
  PlanPriceAsc = 'PLAN_PRICE_ASC',
  PlanPriceDesc = 'PLAN_PRICE_DESC',
  StartAtAsc = 'START_AT_ASC',
  StartAtDesc = 'START_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantBusinessNameAsc = 'TENANT_BUSINESS_NAME_ASC',
  TenantBusinessNameDesc = 'TENANT_BUSINESS_NAME_DESC',
  TenantKeyAsc = 'TENANT_KEY_ASC',
  TenantKeyDesc = 'TENANT_KEY_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  TenantNitAsc = 'TENANT_NIT_ASC',
  TenantNitDesc = 'TENANT_NIT_DESC'
}

export type AllTenant = {
  __typename?: 'AllTenant';
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  planBillingPeriod?: Maybe<Scalars['String']>;
  planCurrency?: Maybe<Scalars['String']>;
  planKey?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['BigFloat']>;
  subscriptionKey?: Maybe<Scalars['String']>;
  subscriptionStartedAt?: Maybe<Scalars['Datetime']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
};

export type AllTenantCondition = {
  businessName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  email?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nit?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  planBillingPeriod?: InputMaybe<Scalars['String']>;
  planCurrency?: InputMaybe<Scalars['String']>;
  planKey?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planPrice?: InputMaybe<Scalars['BigFloat']>;
  subscriptionKey?: InputMaybe<Scalars['String']>;
  subscriptionStartedAt?: InputMaybe<Scalars['Datetime']>;
  subscriptionStatus?: InputMaybe<SubscriptionStatus>;
};

export type AllTenantFilter = {
  and?: InputMaybe<Array<AllTenantFilter>>;
  businessName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nit?: InputMaybe<StringFilter>;
  not?: InputMaybe<AllTenantFilter>;
  or?: InputMaybe<Array<AllTenantFilter>>;
  phoneNumber?: InputMaybe<StringFilter>;
  planBillingPeriod?: InputMaybe<StringFilter>;
  planCurrency?: InputMaybe<StringFilter>;
  planKey?: InputMaybe<StringFilter>;
  planName?: InputMaybe<StringFilter>;
  planPrice?: InputMaybe<BigFloatFilter>;
  subscriptionKey?: InputMaybe<StringFilter>;
  subscriptionStartedAt?: InputMaybe<DatetimeFilter>;
  subscriptionStatus?: InputMaybe<SubscriptionStatusFilter>;
};

export type AllTenantsConnection = {
  __typename?: 'AllTenantsConnection';
  edges: Array<AllTenantsEdge>;
  nodes: Array<Maybe<AllTenant>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AllTenantsEdge = {
  __typename?: 'AllTenantsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<AllTenant>;
};

export enum AllTenantsOrderBy {
  BusinessNameAsc = 'BUSINESS_NAME_ASC',
  BusinessNameDesc = 'BUSINESS_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NitAsc = 'NIT_ASC',
  NitDesc = 'NIT_DESC',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PlanBillingPeriodAsc = 'PLAN_BILLING_PERIOD_ASC',
  PlanBillingPeriodDesc = 'PLAN_BILLING_PERIOD_DESC',
  PlanCurrencyAsc = 'PLAN_CURRENCY_ASC',
  PlanCurrencyDesc = 'PLAN_CURRENCY_DESC',
  PlanKeyAsc = 'PLAN_KEY_ASC',
  PlanKeyDesc = 'PLAN_KEY_DESC',
  PlanNameAsc = 'PLAN_NAME_ASC',
  PlanNameDesc = 'PLAN_NAME_DESC',
  PlanPriceAsc = 'PLAN_PRICE_ASC',
  PlanPriceDesc = 'PLAN_PRICE_DESC',
  SubscriptionKeyAsc = 'SUBSCRIPTION_KEY_ASC',
  SubscriptionKeyDesc = 'SUBSCRIPTION_KEY_DESC',
  SubscriptionStartedAtAsc = 'SUBSCRIPTION_STARTED_AT_ASC',
  SubscriptionStartedAtDesc = 'SUBSCRIPTION_STARTED_AT_DESC',
  SubscriptionStatusAsc = 'SUBSCRIPTION_STATUS_ASC',
  SubscriptionStatusDesc = 'SUBSCRIPTION_STATUS_DESC'
}

export type AllUser = {
  __typename?: 'AllUser';
  blocked?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  lastConnection?: Maybe<Scalars['Datetime']>;
  tenantBusinessName?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  tenantNit?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
};

export type AllUserCondition = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  lastConnection?: InputMaybe<Scalars['Datetime']>;
  tenantBusinessName?: InputMaybe<Scalars['String']>;
  tenantKey?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  tenantNit?: InputMaybe<Scalars['BigInt']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  username?: InputMaybe<Scalars['String']>;
};

export type AllUserFilter = {
  and?: InputMaybe<Array<AllUserFilter>>;
  blocked?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  fullName?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  lastConnection?: InputMaybe<DatetimeFilter>;
  not?: InputMaybe<AllUserFilter>;
  or?: InputMaybe<Array<AllUserFilter>>;
  tenantBusinessName?: InputMaybe<StringFilter>;
  tenantKey?: InputMaybe<StringFilter>;
  tenantName?: InputMaybe<StringFilter>;
  tenantNit?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type AllUsersConnection = {
  __typename?: 'AllUsersConnection';
  edges: Array<AllUsersEdge>;
  nodes: Array<Maybe<AllUser>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AllUsersEdge = {
  __typename?: 'AllUsersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<AllUser>;
};

export enum AllUsersOrderBy {
  BlockedAsc = 'BLOCKED_ASC',
  BlockedDesc = 'BLOCKED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  LastConnectionAsc = 'LAST_CONNECTION_ASC',
  LastConnectionDesc = 'LAST_CONNECTION_DESC',
  Natural = 'NATURAL',
  TenantBusinessNameAsc = 'TENANT_BUSINESS_NAME_ASC',
  TenantBusinessNameDesc = 'TENANT_BUSINESS_NAME_DESC',
  TenantKeyAsc = 'TENANT_KEY_ASC',
  TenantKeyDesc = 'TENANT_KEY_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  TenantNitAsc = 'TENANT_NIT_ASC',
  TenantNitDesc = 'TENANT_NIT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC'
}

export type AuthenticateByApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type AuthenticateByApiKeyPayload = {
  __typename?: 'AuthenticateByApiKeyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  jwt?: Maybe<Scalars['Jwt']>;
  query?: Maybe<Query>;
};

export type AuthenticateInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type AuthenticatePayload = {
  __typename?: 'AuthenticatePayload';
  jwt?: Maybe<Scalars['Jwt']>;
};

export type BigFloatFilter = {
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

export type BigIntFilter = {
  distinctFrom?: InputMaybe<Scalars['BigInt']>;
  equalTo?: InputMaybe<Scalars['BigInt']>;
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['BigInt']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  notDistinctFrom?: InputMaybe<Scalars['BigInt']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BooleanFilter = {
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  equalTo?: InputMaybe<Scalars['Boolean']>;
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['Boolean']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BranchOffice = {
  __typename?: 'BranchOffice';
  address: Scalars['String'];
  code: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  key: Scalars['String'];
  municipality: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  pointOfSales: PointOfSalesConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type BranchOfficePointOfSalesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BranchOfficeInput = {
  address: Scalars['String'];
  code: Scalars['Int'];
  municipality: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSales?: InputMaybe<FkPointOfSaleToBranchOfficeInverseInput>;
};

export type BranchOfficeOnPointOfSaleForFkPointOfSaleToBranchOfficeUsingPkBranchOfficeUpdate = {
  key: Scalars['String'];
  patch: UpdateBranchOfficeOnPointOfSaleForFkPointOfSaleToBranchOfficePatch;
};

export type BranchOfficePatch = {
  address?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  municipality?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSales?: InputMaybe<FkPointOfSaleToBranchOfficeInverseInput>;
};

export type BranchOfficePkBranchOfficeConnect = {
  key: Scalars['String'];
};

export type BranchOfficesEdge = {
  __typename?: 'BranchOfficesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<BranchOffice>;
};

export type CancelInvoiceInput = {
  key: Scalars['String'];
  reasonCode: Scalars['Int'];
};

export type CancelInvoicePayload = {
  __typename?: 'CancelInvoicePayload';
  invoiceCancellation?: Maybe<InvoiceCancellation>;
  message?: Maybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  createdAt: Scalars['Datetime'];
  editable: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  homologation?: Maybe<ClientHomologation>;
  /** @deprecated Please use homologation instead */
  homologations: ClientHomologationsConnection;
  key: Scalars['String'];
  name: Scalars['String'];
  observation?: Maybe<Scalars['String']>;
  orders: OrdersConnection;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ClientHomologationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ClientOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ClientHomologation = {
  __typename?: 'ClientHomologation';
  allowInvalidNit: Scalars['Boolean'];
  client?: Maybe<Client>;
  clientKey: Scalars['String'];
  createdAt: Scalars['Datetime'];
  documentComplement?: Maybe<Scalars['String']>;
  documentNumber: Scalars['String'];
  documentTypeCode: Scalars['Int'];
  documentTypeDescription: Scalars['String'];
  key: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ClientHomologationInput = {
  allowInvalidNit?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<FkClientHomologationToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  documentComplement?: InputMaybe<Scalars['String']>;
  documentNumber: Scalars['String'];
  documentTypeCode: Scalars['Int'];
};

export type ClientHomologationOnClientHomologationForFkClientHomologationToClientUsingPkClientHomologationUpdate = {
  key: Scalars['String'];
  patch: UpdateClientHomologationOnClientHomologationForFkClientHomologationToClientPatch;
};

export type ClientHomologationOnClientHomologationForFkClientHomologationToClientUsingUkClientHomologationClientIdUpdate = {
  clientKey: Scalars['String'];
  patch: UpdateClientHomologationOnClientHomologationForFkClientHomologationToClientPatch;
};

export type ClientHomologationPatch = {
  allowInvalidNit?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<FkClientHomologationToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  documentComplement?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
};

export type ClientHomologationPkClientHomologationConnect = {
  key: Scalars['String'];
};

export type ClientHomologationUkClientHomologationClientIdConnect = {
  clientKey: Scalars['String'];
};

export type ClientHomologationsConnection = {
  __typename?: 'ClientHomologationsConnection';
  edges: Array<ClientHomologationsEdge>;
  nodes: Array<Maybe<ClientHomologation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ClientHomologationsEdge = {
  __typename?: 'ClientHomologationsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ClientHomologation>;
};

export type ClientInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  homologations?: InputMaybe<FkClientHomologationToClientInverseInput>;
  name: Scalars['String'];
  observation?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToClientInverseInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ClientOnClientHomologationForFkClientHomologationToClientUsingPkClientUpdate = {
  key: Scalars['String'];
  patch: UpdateClientOnClientHomologationForFkClientHomologationToClientPatch;
};

export type ClientOnOrderForFkOrderToClientUsingPkClientUpdate = {
  key: Scalars['String'];
  patch: UpdateClientOnOrderForFkOrderToClientPatch;
};

export type ClientPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  homologations?: InputMaybe<FkClientHomologationToClientInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToClientInverseInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ClientPkClientConnect = {
  key: Scalars['String'];
};

export type ClientsEdge = {
  __typename?: 'ClientsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Client>;
};

export type ComboTenant = {
  __typename?: 'ComboTenant';
  businessName?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['BigInt']>;
};

export type ComboTenantCondition = {
  businessName?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nit?: InputMaybe<Scalars['BigInt']>;
};

export type ComboTenantFilter = {
  and?: InputMaybe<Array<ComboTenantFilter>>;
  businessName?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nit?: InputMaybe<BigIntFilter>;
  not?: InputMaybe<ComboTenantFilter>;
  or?: InputMaybe<Array<ComboTenantFilter>>;
};

export type ComboTenantsConnection = {
  __typename?: 'ComboTenantsConnection';
  edges: Array<ComboTenantsEdge>;
  nodes: Array<Maybe<ComboTenant>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ComboTenantsEdge = {
  __typename?: 'ComboTenantsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ComboTenant>;
};

export enum ComboTenantsOrderBy {
  BusinessNameAsc = 'BUSINESS_NAME_ASC',
  BusinessNameDesc = 'BUSINESS_NAME_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NitAsc = 'NIT_ASC',
  NitDesc = 'NIT_DESC'
}

export type ConfirmActionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pToken: Scalars['String'];
};

export type ConfirmActionPayload = {
  __typename?: 'ConfirmActionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']>;
};

export type CreateBranchOfficeInput = {
  branchOffice: BranchOfficeInput;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateBranchOfficePayload = {
  __typename?: 'CreateBranchOfficePayload';
  branchOffice?: Maybe<BranchOffice>;
  branchOfficeEdge?: Maybe<BranchOfficesEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type CreateClientHomologationInput = {
  clientHomologation: ClientHomologationInput;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateClientHomologationPayload = {
  __typename?: 'CreateClientHomologationPayload';
  client?: Maybe<Client>;
  clientHomologation?: Maybe<ClientHomologation>;
  clientHomologationEdge?: Maybe<ClientHomologationsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type CreateClientInput = {
  client: ClientInput;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateClientPayload = {
  __typename?: 'CreateClientPayload';
  client?: Maybe<Client>;
  clientEdge?: Maybe<ClientsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type CreateExportServiceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetail: ExportServiceOrderDetailInput;
};

export type CreateExportServiceOrderDetailPayload = {
  __typename?: 'CreateExportServiceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderDetail?: Maybe<ExportServiceOrderDetail>;
  exportServiceOrderDetailEdge?: Maybe<ExportServiceOrderDetailsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};


export type CreateExportServiceOrderDetailPayloadExportServiceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ExportServiceOrderDetailsOrderBy>>;
};

export type CreateExportServiceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  exportServiceOrder: ExportServiceOrderInput;
};

export type CreateExportServiceOrderPayload = {
  __typename?: 'CreateExportServiceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderEdge?: Maybe<ExportServiceOrdersEdge>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
};


export type CreateExportServiceOrderPayloadExportServiceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ExportServiceOrdersOrderBy>>;
};

export type CreateInsuranceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  insuranceOrderDetail: InsuranceOrderDetailInput;
};

export type CreateInsuranceOrderDetailPayload = {
  __typename?: 'CreateInsuranceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderDetail?: Maybe<InsuranceOrderDetail>;
  insuranceOrderDetailEdge?: Maybe<InsuranceOrderDetailsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};


export type CreateInsuranceOrderDetailPayloadInsuranceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceOrderDetailsOrderBy>>;
};

export type CreateInsuranceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  insuranceOrder: InsuranceOrderInput;
};

export type CreateInsuranceOrderPayload = {
  __typename?: 'CreateInsuranceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderEdge?: Maybe<InsuranceOrdersEdge>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
};


export type CreateInsuranceOrderPayloadInsuranceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceOrdersOrderBy>>;
};

export type CreateOrderHomologationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderHomologation: OrderHomologationInput;
};

export type CreateOrderHomologationPayload = {
  __typename?: 'CreateOrderHomologationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderHomologation?: Maybe<OrderHomologation>;
  orderHomologationEdge?: Maybe<OrderHomologationsEdge>;
  query?: Maybe<Query>;
};

export type CreateOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  order: OrderInput;
};

export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  client?: Maybe<Client>;
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderEdge?: Maybe<OrdersEdge>;
  pointOfSale?: Maybe<PointOfSale>;
  query?: Maybe<Query>;
};

export type CreatePersonInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  person: PersonInput;
};

export type CreatePersonPayload = {
  __typename?: 'CreatePersonPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  personEdge?: Maybe<PeopleEdge>;
  query?: Maybe<Query>;
};

export type CreatePointOfSaleInput = {
  branchOfficeCode: Scalars['Int'];
  commissionAgentNit?: InputMaybe<Scalars['BigInt']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  finishDate?: InputMaybe<Scalars['Datetime']>;
  modalityCode: Scalars['Int'];
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['Datetime']>;
  typeCode: Scalars['Int'];
};

export type CreatePointOfSalePayload = {
  __typename?: 'CreatePointOfSalePayload';
  pointOfSale?: Maybe<PointOfSale>;
};

export type CreatePointOfSaleUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pointOfSaleUser: PointOfSaleUserInput;
};

export type CreatePointOfSaleUserPayload = {
  __typename?: 'CreatePointOfSaleUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleUser?: Maybe<PointOfSaleUser>;
  pointOfSaleUserEdge?: Maybe<PointOfSaleUsersEdge>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type CreateProductHomologationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  productHomologation: ProductHomologationInput;
};

export type CreateProductHomologationPayload = {
  __typename?: 'CreateProductHomologationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productHomologation?: Maybe<ProductHomologation>;
  productHomologationEdge?: Maybe<ProductHomologationsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};

export type CreateProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  product: ProductInput;
};

export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productEdge?: Maybe<ProductsEdge>;
  query?: Maybe<Query>;
};

export type CreateProductTmpInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  productTmp: ProductTmpInput;
};

export type CreateProductTmpPayload = {
  __typename?: 'CreateProductTmpPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productTmp?: Maybe<ProductTmp>;
  productTmpEdge?: Maybe<ProductTmpsEdge>;
  query?: Maybe<Query>;
};


export type CreateProductTmpPayloadProductTmpEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductTmpsOrderBy>>;
};

export type CreateRegisterFormInput = {
  branchOfficeAddress: Scalars['String'];
  branchOfficeMunicipality: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  personDocumentNumber: Scalars['String'];
  personFirstName: Scalars['String'];
  personJobTitle: Scalars['String'];
  personLastName: Scalars['String'];
  personPhone: Scalars['String'];
  tenantBusinessName: Scalars['String'];
  tenantNit: Scalars['BigInt'];
  tenantSiatUsername: Scalars['String'];
};

export type CreateRegisterFormPayload = {
  __typename?: 'CreateRegisterFormPayload';
  businessName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['BigInt']>;
};

export type CreateRentalOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  rentalOrderDetail: RentalOrderDetailInput;
};

export type CreateRentalOrderDetailPayload = {
  __typename?: 'CreateRentalOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderDetail?: Maybe<RentalOrderDetail>;
  rentalOrderDetailEdge?: Maybe<RentalOrderDetailsEdge>;
};


export type CreateRentalOrderDetailPayloadRentalOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<RentalOrderDetailsOrderBy>>;
};

export type CreateRentalOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  rentalOrder: RentalOrderInput;
};

export type CreateRentalOrderPayload = {
  __typename?: 'CreateRentalOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderEdge?: Maybe<RentalOrdersEdge>;
};


export type CreateRentalOrderPayloadRentalOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<RentalOrdersOrderBy>>;
};

export type CreateRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pDescription?: InputMaybe<Scalars['String']>;
  pName?: InputMaybe<Scalars['String']>;
  pPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateRolePayload = {
  __typename?: 'CreateRolePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']>;
};

export type CreateSaleOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  saleOrderDetail: SaleOrderDetailInput;
};

export type CreateSaleOrderDetailPayload = {
  __typename?: 'CreateSaleOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  saleOrder?: Maybe<SaleOrder>;
  saleOrderDetail?: Maybe<SaleOrderDetail>;
  saleOrderDetailEdge?: Maybe<SaleOrderDetailsEdge>;
};

export type CreateSaleOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  saleOrder: SaleOrderInput;
};

export type CreateSaleOrderPayload = {
  __typename?: 'CreateSaleOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  saleOrder?: Maybe<SaleOrder>;
  saleOrderEdge?: Maybe<SaleOrdersEdge>;
};

export type CreateSignificantEventInput = {
  cafc?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  pointOfSaleKey: Scalars['String'];
  reasonCode: Scalars['Int'];
  startDate: Scalars['Datetime'];
};

export type CreateSignificantEventPayload = {
  __typename?: 'CreateSignificantEventPayload';
  significantEvent?: Maybe<SignificantEvent>;
};

export type CreateTenantInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pBranchOfficeAddress: Scalars['String'];
  pBranchOfficeMunicipality: Scalars['String'];
  pBranchOfficeName: Scalars['String'];
  pBusinessName: Scalars['String'];
  pEmail: Scalars['String'];
  pFirstName: Scalars['String'];
  pFirstSurname: Scalars['String'];
  pMiddleName: Scalars['String'];
  pNameTenant: Scalars['String'];
  pNit: Scalars['BigInt'];
  pPhoneNumber: Scalars['String'];
  pPointOfSaleName: Scalars['String'];
  pSecondSurname: Scalars['String'];
};

export type CreateTenantPayload = {
  __typename?: 'CreateTenantPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  tenant?: Maybe<Tenant>;
};

export type CreateTouristServiceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  touristServiceOrderDetail: TouristServiceOrderDetailInput;
};

export type CreateTouristServiceOrderDetailPayload = {
  __typename?: 'CreateTouristServiceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderDetail?: Maybe<TouristServiceOrderDetail>;
  touristServiceOrderDetailEdge?: Maybe<TouristServiceOrderDetailsEdge>;
};


export type CreateTouristServiceOrderDetailPayloadTouristServiceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<TouristServiceOrderDetailsOrderBy>>;
};

export type CreateTouristServiceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  touristServiceOrder: TouristServiceOrderInput;
};

export type CreateTouristServiceOrderPayload = {
  __typename?: 'CreateTouristServiceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderEdge?: Maybe<TouristServiceOrdersEdge>;
};


export type CreateTouristServiceOrderPayloadTouristServiceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<TouristServiceOrdersOrderBy>>;
};

export type CreateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pEmail: Scalars['String'];
  pFirstName: Scalars['String'];
  pFirstSurname: Scalars['String'];
  pMiddleName: Scalars['String'];
  pRoleKey: Scalars['String'];
  pSecondSurname: Scalars['String'];
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};

export type CreateViewBranchOfficeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  viewBranchOffice: ViewBranchOfficeInput;
};

export type CreateViewBranchOfficePayload = {
  __typename?: 'CreateViewBranchOfficePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  viewBranchOffice?: Maybe<ViewBranchOffice>;
  viewBranchOfficeEdge?: Maybe<ViewBranchOfficesEdge>;
};


export type CreateViewBranchOfficePayloadViewBranchOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<ViewBranchOfficesOrderBy>>;
};

export type CreateViewDelegatedTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  viewDelegatedToken: ViewDelegatedTokenInput;
};

export type CreateViewDelegatedTokenPayload = {
  __typename?: 'CreateViewDelegatedTokenPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  viewDelegatedToken?: Maybe<ViewDelegatedToken>;
  viewDelegatedTokenEdge?: Maybe<ViewDelegatedTokensEdge>;
};


export type CreateViewDelegatedTokenPayloadViewDelegatedTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<ViewDelegatedTokensOrderBy>>;
};

export type CreateViewDigitalSignatureInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  viewDigitalSignature: ViewDigitalSignatureInput;
};

export type CreateViewDigitalSignaturePayload = {
  __typename?: 'CreateViewDigitalSignaturePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  viewDigitalSignature?: Maybe<ViewDigitalSignature>;
  viewDigitalSignatureEdge?: Maybe<ViewDigitalSignaturesEdge>;
};


export type CreateViewDigitalSignaturePayloadViewDigitalSignatureEdgeArgs = {
  orderBy?: InputMaybe<Array<ViewDigitalSignaturesOrderBy>>;
};

export type CreateViewSyncParameterInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  viewSyncParameter: ViewSyncParameterInput;
};

export type CreateViewSyncParameterPayload = {
  __typename?: 'CreateViewSyncParameterPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  viewSyncParameter?: Maybe<ViewSyncParameter>;
  viewSyncParameterEdge?: Maybe<ViewSyncParametersEdge>;
};


export type CreateViewSyncParameterPayloadViewSyncParameterEdgeArgs = {
  orderBy?: InputMaybe<Array<ViewSyncParametersOrderBy>>;
};

export type CreateViewSyncRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  viewSyncRequest: ViewSyncRequestInput;
};

export type CreateViewSyncRequestPayload = {
  __typename?: 'CreateViewSyncRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  viewSyncRequest?: Maybe<ViewSyncRequest>;
  viewSyncRequestEdge?: Maybe<ViewSyncRequestsEdge>;
};


export type CreateViewSyncRequestPayloadViewSyncRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<ViewSyncRequestsOrderBy>>;
};

export type Cufd = {
  __typename?: 'Cufd';
  address?: Maybe<Scalars['String']>;
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  controlCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cuis?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  generatedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<Scalars['String']>;
  sendingType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type Cuis = {
  __typename?: 'Cuis';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  generatedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<Scalars['String']>;
  sendingType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type CurrentBillingInfo = {
  __typename?: 'CurrentBillingInfo';
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  documentComplement?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['Int']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type CurrentTenantInfo = {
  __typename?: 'CurrentTenantInfo';
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['BigInt']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type DateFilter = {
  distinctFrom?: InputMaybe<Scalars['Date']>;
  equalTo?: InputMaybe<Scalars['Date']>;
  greaterThan?: InputMaybe<Scalars['Date']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<Scalars['Date']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['Date']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  notDistinctFrom?: InputMaybe<Scalars['Date']>;
  notEqualTo?: InputMaybe<Scalars['Date']>;
  notIn?: InputMaybe<Array<Scalars['Date']>>;
};

export type DatetimeFilter = {
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  equalTo?: InputMaybe<Scalars['Datetime']>;
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['Datetime']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

export type DelegatedToken = {
  __typename?: 'DelegatedToken';
  createdAt?: Maybe<Scalars['Datetime']>;
  createdBy?: Maybe<Scalars['Int']>;
  delegatedNit?: Maybe<Scalars['BigInt']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  revoked?: Maybe<Scalars['Boolean']>;
  subsystem?: Maybe<Scalars['String']>;
  systemCode?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type DeleteClientInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteClientPayload = {
  __typename?: 'DeleteClientPayload';
  client?: Maybe<Client>;
  clientEdge?: Maybe<ClientsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type DeleteExportServiceOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
};

export type DeleteExportServiceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteExportServiceOrderDetailPayload = {
  __typename?: 'DeleteExportServiceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExportServiceOrderDetailNodeId?: Maybe<Scalars['ID']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderDetail?: Maybe<ExportServiceOrderDetail>;
  exportServiceOrderDetailEdge?: Maybe<ExportServiceOrderDetailsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};


export type DeleteExportServiceOrderDetailPayloadExportServiceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ExportServiceOrderDetailsOrderBy>>;
};

export type DeleteExportServiceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteExportServiceOrderPayload = {
  __typename?: 'DeleteExportServiceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedExportServiceOrderNodeId?: Maybe<Scalars['ID']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderEdge?: Maybe<ExportServiceOrdersEdge>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
};


export type DeleteExportServiceOrderPayloadExportServiceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ExportServiceOrdersOrderBy>>;
};

export type DeleteInsuranceOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
};

export type DeleteInsuranceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteInsuranceOrderDetailPayload = {
  __typename?: 'DeleteInsuranceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInsuranceOrderDetailNodeId?: Maybe<Scalars['ID']>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderDetail?: Maybe<InsuranceOrderDetail>;
  insuranceOrderDetailEdge?: Maybe<InsuranceOrderDetailsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};


export type DeleteInsuranceOrderDetailPayloadInsuranceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceOrderDetailsOrderBy>>;
};

export type DeleteInsuranceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteInsuranceOrderPayload = {
  __typename?: 'DeleteInsuranceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInsuranceOrderNodeId?: Maybe<Scalars['ID']>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderEdge?: Maybe<InsuranceOrdersEdge>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
};


export type DeleteInsuranceOrderPayloadInsuranceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceOrdersOrderBy>>;
};

export type DeletePointOfSaleUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeletePointOfSaleUserPayload = {
  __typename?: 'DeletePointOfSaleUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPointOfSaleUserNodeId?: Maybe<Scalars['ID']>;
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleUser?: Maybe<PointOfSaleUser>;
  pointOfSaleUserEdge?: Maybe<PointOfSaleUsersEdge>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type DeleteRentalOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
};

export type DeleteRentalOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteRentalOrderDetailPayload = {
  __typename?: 'DeleteRentalOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRentalOrderDetailNodeId?: Maybe<Scalars['ID']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderDetail?: Maybe<RentalOrderDetail>;
  rentalOrderDetailEdge?: Maybe<RentalOrderDetailsEdge>;
};


export type DeleteRentalOrderDetailPayloadRentalOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<RentalOrderDetailsOrderBy>>;
};

export type DeleteRentalOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteRentalOrderPayload = {
  __typename?: 'DeleteRentalOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRentalOrderNodeId?: Maybe<Scalars['ID']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderEdge?: Maybe<RentalOrdersEdge>;
};


export type DeleteRentalOrderPayloadRentalOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<RentalOrdersOrderBy>>;
};

export type DeleteTouristServiceOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
};

export type DeleteTouristServiceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteTouristServiceOrderDetailPayload = {
  __typename?: 'DeleteTouristServiceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTouristServiceOrderDetailNodeId?: Maybe<Scalars['ID']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderDetail?: Maybe<TouristServiceOrderDetail>;
  touristServiceOrderDetailEdge?: Maybe<TouristServiceOrderDetailsEdge>;
};


export type DeleteTouristServiceOrderDetailPayloadTouristServiceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<TouristServiceOrderDetailsOrderBy>>;
};

export type DeleteTouristServiceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeleteTouristServiceOrderPayload = {
  __typename?: 'DeleteTouristServiceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTouristServiceOrderNodeId?: Maybe<Scalars['ID']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderEdge?: Maybe<TouristServiceOrdersEdge>;
};


export type DeleteTouristServiceOrderPayloadTouristServiceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<TouristServiceOrdersOrderBy>>;
};

export enum ExecutionMode {
  Async = 'ASYNC',
  Sync = 'SYNC'
}

export type ExportServiceOrder = {
  __typename?: 'ExportServiceOrder';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  exportServiceOrderDetails: ExportServiceOrderDetailsConnection;
  key: Scalars['String'];
  order?: Maybe<Order>;
  orderKey: Scalars['String'];
  sinCodigoPais: Scalars['Int'];
  sinDireccionComprador: Scalars['String'];
  sinInformacionAdicional?: Maybe<Scalars['String']>;
  sinLugarDestino: Scalars['String'];
  tenantId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};


export type ExportServiceOrderExportServiceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExportServiceOrderDetailCondition>;
  filter?: InputMaybe<ExportServiceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExportServiceOrderDetailsOrderBy>>;
};

export type ExportServiceOrderCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinCodigoPais?: InputMaybe<Scalars['Int']>;
  sinDireccionComprador?: InputMaybe<Scalars['String']>;
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type ExportServiceOrderDetail = {
  __typename?: 'ExportServiceOrderDetail';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  discount: Scalars['BigFloat'];
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderKey: Scalars['String'];
  key: Scalars['String'];
  price: Scalars['BigFloat'];
  productKey: Scalars['String'];
  productService?: Maybe<Product>;
  quantity: Scalars['Int'];
  subtotal: Scalars['BigFloat'];
  tenantId: Scalars['Int'];
  total: Scalars['BigFloat'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type ExportServiceOrderDetailCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  exportServiceOrderKey?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type ExportServiceOrderDetailFilter = {
  and?: InputMaybe<Array<ExportServiceOrderDetailFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  discount?: InputMaybe<BigFloatFilter>;
  exportServiceOrderKey?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ExportServiceOrderDetailFilter>;
  or?: InputMaybe<Array<ExportServiceOrderDetailFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  productKey?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  subtotal?: InputMaybe<BigFloatFilter>;
  tenantId?: InputMaybe<IntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type ExportServiceOrderDetailInput = {
  discount: Scalars['BigFloat'];
  exportServiceOrder?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInput>;
  exportServiceOrderKey?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkExportServiceOrderDetailToProductInput>;
  quantity: Scalars['Int'];
};

export type ExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderUsingPkExportServiceOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderPatch;
};

export type ExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductUsingPkExportServiceOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductPatch;
};

export type ExportServiceOrderDetailPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  exportServiceOrder?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInput>;
  exportServiceOrderKey?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkExportServiceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ExportServiceOrderDetailPkExportServiceOrderDetailConnect = {
  key: Scalars['String'];
};

export type ExportServiceOrderDetailPkExportServiceOrderDetailDelete = {
  key: Scalars['String'];
};

export type ExportServiceOrderDetailsConnection = {
  __typename?: 'ExportServiceOrderDetailsConnection';
  edges: Array<ExportServiceOrderDetailsEdge>;
  nodes: Array<Maybe<ExportServiceOrderDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ExportServiceOrderDetailsEdge = {
  __typename?: 'ExportServiceOrderDetailsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ExportServiceOrderDetail>;
};

export enum ExportServiceOrderDetailsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  DiscountAsc = 'DISCOUNT_ASC',
  DiscountDesc = 'DISCOUNT_DESC',
  ExportServiceOrderByExportServiceOrderKeyCreatedAtAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__CREATED_AT_ASC',
  ExportServiceOrderByExportServiceOrderKeyCreatedAtDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__CREATED_AT_DESC',
  ExportServiceOrderByExportServiceOrderKeyCreatedByAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__CREATED_BY_ASC',
  ExportServiceOrderByExportServiceOrderKeyCreatedByDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__CREATED_BY_DESC',
  ExportServiceOrderByExportServiceOrderKeyDeletedAtAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__DELETED_AT_ASC',
  ExportServiceOrderByExportServiceOrderKeyDeletedAtDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__DELETED_AT_DESC',
  ExportServiceOrderByExportServiceOrderKeyDeletedByAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__DELETED_BY_ASC',
  ExportServiceOrderByExportServiceOrderKeyDeletedByDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__DELETED_BY_DESC',
  ExportServiceOrderByExportServiceOrderKeyDeletionAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__DELETION_ASC',
  ExportServiceOrderByExportServiceOrderKeyDeletionDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__DELETION_DESC',
  ExportServiceOrderByExportServiceOrderKeyKeyAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__KEY_ASC',
  ExportServiceOrderByExportServiceOrderKeyKeyDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__KEY_DESC',
  ExportServiceOrderByExportServiceOrderKeyOrderKeyAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__ORDER_KEY_ASC',
  ExportServiceOrderByExportServiceOrderKeyOrderKeyDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__ORDER_KEY_DESC',
  ExportServiceOrderByExportServiceOrderKeySinCodigoPaisAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_CODIGO_PAIS_ASC',
  ExportServiceOrderByExportServiceOrderKeySinCodigoPaisDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_CODIGO_PAIS_DESC',
  ExportServiceOrderByExportServiceOrderKeySinDireccionCompradorAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_DIRECCION_COMPRADOR_ASC',
  ExportServiceOrderByExportServiceOrderKeySinDireccionCompradorDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_DIRECCION_COMPRADOR_DESC',
  ExportServiceOrderByExportServiceOrderKeySinInformacionAdicionalAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_INFORMACION_ADICIONAL_ASC',
  ExportServiceOrderByExportServiceOrderKeySinInformacionAdicionalDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_INFORMACION_ADICIONAL_DESC',
  ExportServiceOrderByExportServiceOrderKeySinLugarDestinoAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_LUGAR_DESTINO_ASC',
  ExportServiceOrderByExportServiceOrderKeySinLugarDestinoDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__SIN_LUGAR_DESTINO_DESC',
  ExportServiceOrderByExportServiceOrderKeyTenantIdAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__TENANT_ID_ASC',
  ExportServiceOrderByExportServiceOrderKeyTenantIdDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__TENANT_ID_DESC',
  ExportServiceOrderByExportServiceOrderKeyUpdatedAtAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__UPDATED_AT_ASC',
  ExportServiceOrderByExportServiceOrderKeyUpdatedAtDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__UPDATED_AT_DESC',
  ExportServiceOrderByExportServiceOrderKeyUpdatedByAsc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__UPDATED_BY_ASC',
  ExportServiceOrderByExportServiceOrderKeyUpdatedByDesc = 'EXPORT_SERVICE_ORDER_BY_EXPORT_SERVICE_ORDER_KEY__UPDATED_BY_DESC',
  ExportServiceOrderKeyAsc = 'EXPORT_SERVICE_ORDER_KEY_ASC',
  ExportServiceOrderKeyDesc = 'EXPORT_SERVICE_ORDER_KEY_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductByProductKeyCodeAsc = 'PRODUCT_BY_PRODUCT_KEY__CODE_ASC',
  ProductByProductKeyCodeDesc = 'PRODUCT_BY_PRODUCT_KEY__CODE_DESC',
  ProductByProductKeyCreatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_ASC',
  ProductByProductKeyCreatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_DESC',
  ProductByProductKeyCreatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_ASC',
  ProductByProductKeyCreatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_DESC',
  ProductByProductKeyDeletedAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_ASC',
  ProductByProductKeyDeletedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_ASC',
  ProductByProductKeyDeletedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_DESC',
  ProductByProductKeyDeletedByAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_ASC',
  ProductByProductKeyDeletedByDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_DESC',
  ProductByProductKeyDeletedDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_DESC',
  ProductByProductKeyDescriptionAsc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_ASC',
  ProductByProductKeyDescriptionDesc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_DESC',
  ProductByProductKeyKeyAsc = 'PRODUCT_BY_PRODUCT_KEY__KEY_ASC',
  ProductByProductKeyKeyDesc = 'PRODUCT_BY_PRODUCT_KEY__KEY_DESC',
  ProductByProductKeyNameAsc = 'PRODUCT_BY_PRODUCT_KEY__NAME_ASC',
  ProductByProductKeyNameDesc = 'PRODUCT_BY_PRODUCT_KEY__NAME_DESC',
  ProductByProductKeyPriceAsc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_ASC',
  ProductByProductKeyPriceDesc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_DESC',
  ProductByProductKeyTenantIdAsc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_ASC',
  ProductByProductKeyTenantIdDesc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_DESC',
  ProductByProductKeyTypeAsc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_ASC',
  ProductByProductKeyTypeDesc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_DESC',
  ProductByProductKeyUpdatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_ASC',
  ProductByProductKeyUpdatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_DESC',
  ProductByProductKeyUpdatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_ASC',
  ProductByProductKeyUpdatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_DESC',
  ProductKeyAsc = 'PRODUCT_KEY_ASC',
  ProductKeyDesc = 'PRODUCT_KEY_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type ExportServiceOrderFilter = {
  and?: InputMaybe<Array<ExportServiceOrderFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ExportServiceOrderFilter>;
  or?: InputMaybe<Array<ExportServiceOrderFilter>>;
  orderKey?: InputMaybe<StringFilter>;
  sinCodigoPais?: InputMaybe<IntFilter>;
  sinDireccionComprador?: InputMaybe<StringFilter>;
  sinInformacionAdicional?: InputMaybe<StringFilter>;
  sinLugarDestino?: InputMaybe<StringFilter>;
  tenantId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type ExportServiceOrderInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInverseInput>;
  order?: InputMaybe<FkExportServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinCodigoPais: Scalars['Int'];
  sinDireccionComprador: Scalars['String'];
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino: Scalars['String'];
};

export type ExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderUsingPkExportServiceOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderPatch;
};

export type ExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderUsingUkExportServiceOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderPatch;
};

export type ExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderUsingPkExportServiceOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderPatch;
};

export type ExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderUsingUkExportServiceOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderPatch;
};

export type ExportServiceOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInverseInput>;
  order?: InputMaybe<FkExportServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinCodigoPais?: InputMaybe<Scalars['Int']>;
  sinDireccionComprador?: InputMaybe<Scalars['String']>;
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino?: InputMaybe<Scalars['String']>;
};

export type ExportServiceOrderPkExportServiceOrderConnect = {
  key: Scalars['String'];
};

export type ExportServiceOrderPkExportServiceOrderDelete = {
  key: Scalars['String'];
};

export type ExportServiceOrderUkExportServiceOrderOrderKeyConnect = {
  orderKey: Scalars['String'];
};

export type ExportServiceOrderUkExportServiceOrderOrderKeyDelete = {
  orderKey: Scalars['String'];
};

export type ExportServiceOrdersConnection = {
  __typename?: 'ExportServiceOrdersConnection';
  edges: Array<ExportServiceOrdersEdge>;
  nodes: Array<Maybe<ExportServiceOrder>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ExportServiceOrdersEdge = {
  __typename?: 'ExportServiceOrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ExportServiceOrder>;
};

export enum ExportServiceOrdersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  ExportServiceOrderDetailsByExportServiceOrderKeyCountAsc = 'EXPORT_SERVICE_ORDER_DETAILS_BY_EXPORT_SERVICE_ORDER_KEY__COUNT_ASC',
  ExportServiceOrderDetailsByExportServiceOrderKeyCountDesc = 'EXPORT_SERVICE_ORDER_DETAILS_BY_EXPORT_SERVICE_ORDER_KEY__COUNT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  OrderByOrderKeyChangeAmountAsc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_ASC',
  OrderByOrderKeyChangeAmountDesc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_DESC',
  OrderByOrderKeyClientKeyAsc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_ASC',
  OrderByOrderKeyClientKeyDesc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_DESC',
  OrderByOrderKeyCreatedAtAsc = 'ORDER_BY_ORDER_KEY__CREATED_AT_ASC',
  OrderByOrderKeyCreatedAtDesc = 'ORDER_BY_ORDER_KEY__CREATED_AT_DESC',
  OrderByOrderKeyCreatedByAsc = 'ORDER_BY_ORDER_KEY__CREATED_BY_ASC',
  OrderByOrderKeyCreatedByDesc = 'ORDER_BY_ORDER_KEY__CREATED_BY_DESC',
  OrderByOrderKeyDeletedAtAsc = 'ORDER_BY_ORDER_KEY__DELETED_AT_ASC',
  OrderByOrderKeyDeletedAtDesc = 'ORDER_BY_ORDER_KEY__DELETED_AT_DESC',
  OrderByOrderKeyDeletedByAsc = 'ORDER_BY_ORDER_KEY__DELETED_BY_ASC',
  OrderByOrderKeyDeletedByDesc = 'ORDER_BY_ORDER_KEY__DELETED_BY_DESC',
  OrderByOrderKeyDeletionAsc = 'ORDER_BY_ORDER_KEY__DELETION_ASC',
  OrderByOrderKeyDeletionDesc = 'ORDER_BY_ORDER_KEY__DELETION_DESC',
  OrderByOrderKeyDiscountAsc = 'ORDER_BY_ORDER_KEY__DISCOUNT_ASC',
  OrderByOrderKeyDiscountDesc = 'ORDER_BY_ORDER_KEY__DISCOUNT_DESC',
  OrderByOrderKeyEmailAsc = 'ORDER_BY_ORDER_KEY__EMAIL_ASC',
  OrderByOrderKeyEmailDesc = 'ORDER_BY_ORDER_KEY__EMAIL_DESC',
  OrderByOrderKeyKeyAsc = 'ORDER_BY_ORDER_KEY__KEY_ASC',
  OrderByOrderKeyKeyDesc = 'ORDER_BY_ORDER_KEY__KEY_DESC',
  OrderByOrderKeyPaymentAmountAsc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_ASC',
  OrderByOrderKeyPaymentAmountDesc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_DESC',
  OrderByOrderKeyPhoneNumberAsc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_ASC',
  OrderByOrderKeyPhoneNumberDesc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_DESC',
  OrderByOrderKeyPointOfSaleKeyAsc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_ASC',
  OrderByOrderKeyPointOfSaleKeyDesc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_DESC',
  OrderByOrderKeyQuantityAsc = 'ORDER_BY_ORDER_KEY__QUANTITY_ASC',
  OrderByOrderKeyQuantityDesc = 'ORDER_BY_ORDER_KEY__QUANTITY_DESC',
  OrderByOrderKeyStatusAsc = 'ORDER_BY_ORDER_KEY__STATUS_ASC',
  OrderByOrderKeyStatusDesc = 'ORDER_BY_ORDER_KEY__STATUS_DESC',
  OrderByOrderKeySubtotalAsc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_ASC',
  OrderByOrderKeySubtotalDesc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_DESC',
  OrderByOrderKeyTenantIdAsc = 'ORDER_BY_ORDER_KEY__TENANT_ID_ASC',
  OrderByOrderKeyTenantIdDesc = 'ORDER_BY_ORDER_KEY__TENANT_ID_DESC',
  OrderByOrderKeyTotalAsc = 'ORDER_BY_ORDER_KEY__TOTAL_ASC',
  OrderByOrderKeyTotalDesc = 'ORDER_BY_ORDER_KEY__TOTAL_DESC',
  OrderByOrderKeyUpdatedAtAsc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_ASC',
  OrderByOrderKeyUpdatedAtDesc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_DESC',
  OrderByOrderKeyUpdatedByAsc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_ASC',
  OrderByOrderKeyUpdatedByDesc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_DESC',
  OrderKeyAsc = 'ORDER_KEY_ASC',
  OrderKeyDesc = 'ORDER_KEY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SinCodigoPaisAsc = 'SIN_CODIGO_PAIS_ASC',
  SinCodigoPaisDesc = 'SIN_CODIGO_PAIS_DESC',
  SinDireccionCompradorAsc = 'SIN_DIRECCION_COMPRADOR_ASC',
  SinDireccionCompradorDesc = 'SIN_DIRECCION_COMPRADOR_DESC',
  SinInformacionAdicionalAsc = 'SIN_INFORMACION_ADICIONAL_ASC',
  SinInformacionAdicionalDesc = 'SIN_INFORMACION_ADICIONAL_DESC',
  SinLugarDestinoAsc = 'SIN_LUGAR_DESTINO_ASC',
  SinLugarDestinoDesc = 'SIN_LUGAR_DESTINO_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type File = {
  __typename?: 'File';
  base64?: Maybe<Scalars['String']>;
  encoding?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['BigFloat']>;
  mimetype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type FileFilter = {
  and?: InputMaybe<Array<FileFilter>>;
  base64?: InputMaybe<StringFilter>;
  encoding?: InputMaybe<StringFilter>;
  filename?: InputMaybe<StringFilter>;
  filesize?: InputMaybe<BigFloatFilter>;
  mimetype?: InputMaybe<StringFilter>;
  not?: InputMaybe<FileFilter>;
  or?: InputMaybe<Array<FileFilter>>;
  type?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type FilesConnection = {
  __typename?: 'FilesConnection';
  edges: Array<FilesEdge>;
  nodes: Array<Maybe<File>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FilesEdge = {
  __typename?: 'FilesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<File>;
};

export type FkAppUserToPersonInput = {
  connectByKey?: InputMaybe<PersonPkPersonConnect>;
  create?: InputMaybe<FkAppUserToPersonPersonCreateInput>;
  updateByKey?: InputMaybe<PersonOnUserForFkAppUserToPersonUsingPkPersonUpdate>;
};

export type FkAppUserToPersonInverseInput = {
  connectByKey?: InputMaybe<Array<UserPkUserConnect>>;
  updateByKey?: InputMaybe<Array<UserOnUserForFkAppUserToPersonUsingPkUserUpdate>>;
};

export type FkAppUserToPersonPersonCreateInput = {
  firstName: Scalars['String'];
  firstSurname: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  secondSurname?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<FkAppUserToPersonInverseInput>;
};

export type FkClientHomologationToClientClientCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  homologations?: InputMaybe<FkClientHomologationToClientInverseInput>;
  name: Scalars['String'];
  observation?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToClientInverseInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type FkClientHomologationToClientClientHomologationCreateInput = {
  allowInvalidNit?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<FkClientHomologationToClientInput>;
  documentComplement?: InputMaybe<Scalars['String']>;
  documentNumber: Scalars['String'];
  documentTypeCode: Scalars['Int'];
};

export type FkClientHomologationToClientInput = {
  connectByKey?: InputMaybe<ClientPkClientConnect>;
  create?: InputMaybe<FkClientHomologationToClientClientCreateInput>;
  updateByKey?: InputMaybe<ClientOnClientHomologationForFkClientHomologationToClientUsingPkClientUpdate>;
};

export type FkClientHomologationToClientInverseInput = {
  connectByClientKey?: InputMaybe<ClientHomologationUkClientHomologationClientIdConnect>;
  connectByKey?: InputMaybe<ClientHomologationPkClientHomologationConnect>;
  create?: InputMaybe<Array<FkClientHomologationToClientClientHomologationCreateInput>>;
  updateByClientKey?: InputMaybe<ClientHomologationOnClientHomologationForFkClientHomologationToClientUsingUkClientHomologationClientIdUpdate>;
  updateByKey?: InputMaybe<ClientHomologationOnClientHomologationForFkClientHomologationToClientUsingPkClientHomologationUpdate>;
};

export type FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderCreateInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInverseInput>;
  order?: InputMaybe<FkExportServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinCodigoPais: Scalars['Int'];
  sinDireccionComprador: Scalars['String'];
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino: Scalars['String'];
};

export type FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  exportServiceOrder?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInput>;
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkExportServiceOrderDetailToProductInput>;
  quantity: Scalars['Int'];
};

export type FkExportServiceOrderDetailToExportServiceOrderInput = {
  connectByKey?: InputMaybe<ExportServiceOrderPkExportServiceOrderConnect>;
  connectByOrderKey?: InputMaybe<ExportServiceOrderUkExportServiceOrderOrderKeyConnect>;
  create?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderCreateInput>;
  deleteByKey?: InputMaybe<ExportServiceOrderPkExportServiceOrderDelete>;
  deleteByOrderKey?: InputMaybe<ExportServiceOrderUkExportServiceOrderOrderKeyDelete>;
  updateByKey?: InputMaybe<ExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderUsingPkExportServiceOrderUpdate>;
  updateByOrderKey?: InputMaybe<ExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderUsingUkExportServiceOrderOrderKeyUpdate>;
};

export type FkExportServiceOrderDetailToExportServiceOrderInverseInput = {
  connectByKey?: InputMaybe<Array<ExportServiceOrderDetailPkExportServiceOrderDetailConnect>>;
  create?: InputMaybe<Array<FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<ExportServiceOrderDetailPkExportServiceOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<ExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderUsingPkExportServiceOrderDetailUpdate>>;
};

export type FkExportServiceOrderDetailToProductExportServiceOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  exportServiceOrder?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInput>;
  exportServiceOrderKey?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  productService?: InputMaybe<FkExportServiceOrderDetailToProductInput>;
  quantity: Scalars['Int'];
};

export type FkExportServiceOrderDetailToProductInput = {
  connectByKey?: InputMaybe<ProductPkProductConnect>;
  create?: InputMaybe<FkExportServiceOrderDetailToProductProductCreateInput>;
  updateByKey?: InputMaybe<ProductOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductUsingPkProductUpdate>;
};

export type FkExportServiceOrderDetailToProductInverseInput = {
  connectByKey?: InputMaybe<Array<ExportServiceOrderDetailPkExportServiceOrderDetailConnect>>;
  create?: InputMaybe<Array<FkExportServiceOrderDetailToProductExportServiceOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<ExportServiceOrderDetailPkExportServiceOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<ExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductUsingPkExportServiceOrderDetailUpdate>>;
};

export type FkExportServiceOrderDetailToProductProductCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type FkExportServiceOrderToOrderExportServiceOrderCreateInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInverseInput>;
  order?: InputMaybe<FkExportServiceOrderToOrderInput>;
  sinCodigoPais: Scalars['Int'];
  sinDireccionComprador: Scalars['String'];
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino: Scalars['String'];
};

export type FkExportServiceOrderToOrderInput = {
  connectByKey?: InputMaybe<OrderPkOrderConnect>;
  create?: InputMaybe<FkExportServiceOrderToOrderOrderCreateInput>;
  updateByKey?: InputMaybe<OrderOnExportServiceOrderForFkExportServiceOrderToOrderUsingPkOrderUpdate>;
};

export type FkExportServiceOrderToOrderInverseInput = {
  connectByKey?: InputMaybe<ExportServiceOrderPkExportServiceOrderConnect>;
  connectByOrderKey?: InputMaybe<ExportServiceOrderUkExportServiceOrderOrderKeyConnect>;
  create?: InputMaybe<Array<FkExportServiceOrderToOrderExportServiceOrderCreateInput>>;
  deleteByKey?: InputMaybe<ExportServiceOrderPkExportServiceOrderDelete>;
  deleteByOrderKey?: InputMaybe<ExportServiceOrderUkExportServiceOrderOrderKeyDelete>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<ExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderUsingPkExportServiceOrderUpdate>;
  updateByOrderKey?: InputMaybe<ExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderUsingUkExportServiceOrderOrderKeyUpdate>;
};

export type FkExportServiceOrderToOrderOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkInsuranceOrderDetailToInsuranceOrderInput = {
  connectByKey?: InputMaybe<InsuranceOrderPkInsuranceOrderConnect>;
  connectByOrderKey?: InputMaybe<InsuranceOrderUkInsuranceOrderOrderKeyConnect>;
  create?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInsuranceOrderCreateInput>;
  deleteByKey?: InputMaybe<InsuranceOrderPkInsuranceOrderDelete>;
  deleteByOrderKey?: InputMaybe<InsuranceOrderUkInsuranceOrderOrderKeyDelete>;
  updateByKey?: InputMaybe<InsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderUsingPkInsuranceOrderUpdate>;
  updateByOrderKey?: InputMaybe<InsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderUsingUkInsuranceOrderOrderKeyUpdate>;
};

export type FkInsuranceOrderDetailToInsuranceOrderInsuranceOrderCreateInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInverseInput>;
  order?: InputMaybe<FkInsuranceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinAjusteAfectacionIva: Scalars['BigFloat'];
};

export type FkInsuranceOrderDetailToInsuranceOrderInsuranceOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  insuranceOrder?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInput>;
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkInsuranceOrderDetailToProductInput>;
  quantity: Scalars['Int'];
};

export type FkInsuranceOrderDetailToInsuranceOrderInverseInput = {
  connectByKey?: InputMaybe<Array<InsuranceOrderDetailPkInsuranceOrderDetailConnect>>;
  create?: InputMaybe<Array<FkInsuranceOrderDetailToInsuranceOrderInsuranceOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<InsuranceOrderDetailPkInsuranceOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<InsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderUsingPkInsuranceOrderDetailUpdate>>;
};

export type FkInsuranceOrderDetailToProductInput = {
  connectByKey?: InputMaybe<ProductPkProductConnect>;
  create?: InputMaybe<FkInsuranceOrderDetailToProductProductCreateInput>;
  updateByKey?: InputMaybe<ProductOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductUsingPkProductUpdate>;
};

export type FkInsuranceOrderDetailToProductInsuranceOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  insuranceOrder?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInput>;
  insuranceOrderKey?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  productService?: InputMaybe<FkInsuranceOrderDetailToProductInput>;
  quantity: Scalars['Int'];
};

export type FkInsuranceOrderDetailToProductInverseInput = {
  connectByKey?: InputMaybe<Array<InsuranceOrderDetailPkInsuranceOrderDetailConnect>>;
  create?: InputMaybe<Array<FkInsuranceOrderDetailToProductInsuranceOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<InsuranceOrderDetailPkInsuranceOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<InsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductUsingPkInsuranceOrderDetailUpdate>>;
};

export type FkInsuranceOrderDetailToProductProductCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type FkInsuranceOrderToOrderInput = {
  connectByKey?: InputMaybe<OrderPkOrderConnect>;
  create?: InputMaybe<FkInsuranceOrderToOrderOrderCreateInput>;
  updateByKey?: InputMaybe<OrderOnInsuranceOrderForFkInsuranceOrderToOrderUsingPkOrderUpdate>;
};

export type FkInsuranceOrderToOrderInsuranceOrderCreateInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInverseInput>;
  order?: InputMaybe<FkInsuranceOrderToOrderInput>;
  sinAjusteAfectacionIva: Scalars['BigFloat'];
};

export type FkInsuranceOrderToOrderInverseInput = {
  connectByKey?: InputMaybe<InsuranceOrderPkInsuranceOrderConnect>;
  connectByOrderKey?: InputMaybe<InsuranceOrderUkInsuranceOrderOrderKeyConnect>;
  create?: InputMaybe<Array<FkInsuranceOrderToOrderInsuranceOrderCreateInput>>;
  deleteByKey?: InputMaybe<InsuranceOrderPkInsuranceOrderDelete>;
  deleteByOrderKey?: InputMaybe<InsuranceOrderUkInsuranceOrderOrderKeyDelete>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<InsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderUsingPkInsuranceOrderUpdate>;
  updateByOrderKey?: InputMaybe<InsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderUsingUkInsuranceOrderOrderKeyUpdate>;
};

export type FkInsuranceOrderToOrderOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkOrderHomologationToOrderInput = {
  connectByKey?: InputMaybe<OrderPkOrderConnect>;
  create?: InputMaybe<FkOrderHomologationToOrderOrderCreateInput>;
  updateByKey?: InputMaybe<OrderOnOrderHomologationForFkOrderHomologationToOrderUsingPkOrderUpdate>;
};

export type FkOrderHomologationToOrderInverseInput = {
  connectByKey?: InputMaybe<OrderHomologationPkOrderHomologationConnect>;
  connectByOrderKey?: InputMaybe<OrderHomologationUkOrderHomologationOrderIdConnect>;
  create?: InputMaybe<Array<FkOrderHomologationToOrderOrderHomologationCreateInput>>;
  updateByKey?: InputMaybe<OrderHomologationOnOrderHomologationForFkOrderHomologationToOrderUsingPkOrderHomologationUpdate>;
  updateByOrderKey?: InputMaybe<OrderHomologationOnOrderHomologationForFkOrderHomologationToOrderUsingUkOrderHomologationOrderIdUpdate>;
};

export type FkOrderHomologationToOrderOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkOrderHomologationToOrderOrderHomologationCreateInput = {
  activityCode: Scalars['String'];
  cardNumber?: InputMaybe<Scalars['BigInt']>;
  currencyCode: Scalars['Int'];
  emissionTypeCode: Scalars['Int'];
  exchangeRate: Scalars['BigFloat'];
  invoiceTypeCode?: InputMaybe<Scalars['Int']>;
  modalityTypeCode: Scalars['Int'];
  order?: InputMaybe<FkOrderHomologationToOrderInput>;
  paymentMethodCode: Scalars['Int'];
  sectorDocumentCode?: InputMaybe<Scalars['Int']>;
};

export type FkOrderToClientClientCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  homologations?: InputMaybe<FkClientHomologationToClientInverseInput>;
  name: Scalars['String'];
  observation?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToClientInverseInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type FkOrderToClientInput = {
  connectByKey?: InputMaybe<ClientPkClientConnect>;
  create?: InputMaybe<FkOrderToClientClientCreateInput>;
  updateByKey?: InputMaybe<ClientOnOrderForFkOrderToClientUsingPkClientUpdate>;
};

export type FkOrderToClientInverseInput = {
  connectByKey?: InputMaybe<Array<OrderPkOrderConnect>>;
  create?: InputMaybe<Array<FkOrderToClientOrderCreateInput>>;
  updateByKey?: InputMaybe<Array<OrderOnOrderForFkOrderToClientUsingPkOrderUpdate>>;
};

export type FkOrderToClientOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkOrderToPointOfSaleInput = {
  connectByKey?: InputMaybe<PointOfSalePkPointOfSaleConnect>;
  updateByKey?: InputMaybe<PointOfSaleOnOrderForFkOrderToPointOfSaleUsingPkPointOfSaleUpdate>;
};

export type FkOrderToPointOfSaleInverseInput = {
  connectByKey?: InputMaybe<Array<OrderPkOrderConnect>>;
  create?: InputMaybe<Array<FkOrderToPointOfSaleOrderCreateInput>>;
  updateByKey?: InputMaybe<Array<OrderOnOrderForFkOrderToPointOfSaleUsingPkOrderUpdate>>;
};

export type FkOrderToPointOfSaleOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkPointOfSaleToBranchOfficeBranchOfficeCreateInput = {
  address: Scalars['String'];
  code: Scalars['Int'];
  municipality: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSales?: InputMaybe<FkPointOfSaleToBranchOfficeInverseInput>;
};

export type FkPointOfSaleToBranchOfficeInput = {
  connectByKey?: InputMaybe<BranchOfficePkBranchOfficeConnect>;
  create?: InputMaybe<FkPointOfSaleToBranchOfficeBranchOfficeCreateInput>;
  updateByKey?: InputMaybe<BranchOfficeOnPointOfSaleForFkPointOfSaleToBranchOfficeUsingPkBranchOfficeUpdate>;
};

export type FkPointOfSaleToBranchOfficeInverseInput = {
  connectByKey?: InputMaybe<Array<PointOfSalePkPointOfSaleConnect>>;
  updateByKey?: InputMaybe<Array<PointOfSaleOnPointOfSaleForFkPointOfSaleToBranchOfficeUsingPkPointOfSaleUpdate>>;
};

export type FkPointOfSaleUserToPointOfSaleInput = {
  connectByKey?: InputMaybe<PointOfSalePkPointOfSaleConnect>;
  updateByKey?: InputMaybe<PointOfSaleOnPointOfSaleUserForFkPointOfSaleUserToPointOfSaleUsingPkPointOfSaleUpdate>;
};

export type FkPointOfSaleUserToPointOfSaleInverseInput = {
  connectByKey?: InputMaybe<Array<PointOfSaleUserPkPointOfSaleUserConnect>>;
  create?: InputMaybe<Array<FkPointOfSaleUserToPointOfSalePointOfSaleUserCreateInput>>;
  deleteByKey?: InputMaybe<Array<PointOfSaleUserPkPointOfSaleUserDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<PointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToPointOfSaleUsingPkPointOfSaleUserUpdate>>;
};

export type FkPointOfSaleUserToPointOfSalePointOfSaleUserCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<FkPointOfSaleUserToPointOfSaleInput>;
  user?: InputMaybe<FkPointOfSaleUserToUserInput>;
  userKey?: InputMaybe<Scalars['String']>;
};

export type FkPointOfSaleUserToUserInput = {
  connectByKey?: InputMaybe<UserPkUserConnect>;
  updateByKey?: InputMaybe<UserOnPointOfSaleUserForFkPointOfSaleUserToUserUsingPkUserUpdate>;
};

export type FkPointOfSaleUserToUserInverseInput = {
  connectByKey?: InputMaybe<Array<PointOfSaleUserPkPointOfSaleUserConnect>>;
  create?: InputMaybe<Array<FkPointOfSaleUserToUserPointOfSaleUserCreateInput>>;
  deleteByKey?: InputMaybe<Array<PointOfSaleUserPkPointOfSaleUserDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<PointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToUserUsingPkPointOfSaleUserUpdate>>;
};

export type FkPointOfSaleUserToUserPointOfSaleUserCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<FkPointOfSaleUserToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FkPointOfSaleUserToUserInput>;
};

export type FkProductHomologationToProductInput = {
  connectByKey?: InputMaybe<ProductPkProductConnect>;
  create?: InputMaybe<FkProductHomologationToProductProductCreateInput>;
  updateByKey?: InputMaybe<ProductOnProductHomologationForFkProductHomologationToProductUsingPkProductUpdate>;
};

export type FkProductHomologationToProductInverseInput = {
  connectByKey?: InputMaybe<ProductHomologationPkProductHomologationConnect>;
  connectByProductKey?: InputMaybe<ProductHomologationUkProductHomologationProductKeyConnect>;
  create?: InputMaybe<Array<FkProductHomologationToProductProductHomologationCreateInput>>;
  updateByKey?: InputMaybe<ProductHomologationOnProductHomologationForFkProductHomologationToProductUsingPkProductHomologationUpdate>;
  updateByProductKey?: InputMaybe<ProductHomologationOnProductHomologationForFkProductHomologationToProductUsingUkProductHomologationProductKeyUpdate>;
};

export type FkProductHomologationToProductProductCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type FkProductHomologationToProductProductHomologationCreateInput = {
  activityCode: Scalars['String'];
  measureUnitCode: Scalars['Int'];
  productCode: Scalars['Int'];
  productService?: InputMaybe<FkProductHomologationToProductInput>;
};

export type FkRentalOrderDetailToProductInput = {
  connectByKey?: InputMaybe<ProductPkProductConnect>;
  create?: InputMaybe<FkRentalOrderDetailToProductProductCreateInput>;
  updateByKey?: InputMaybe<ProductOnRentalOrderDetailForFkRentalOrderDetailToProductUsingPkProductUpdate>;
};

export type FkRentalOrderDetailToProductInverseInput = {
  connectByKey?: InputMaybe<Array<RentalOrderDetailPkRentalOrderDetailConnect>>;
  create?: InputMaybe<Array<FkRentalOrderDetailToProductRentalOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<RentalOrderDetailPkRentalOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<RentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToProductUsingPkRentalOrderDetailUpdate>>;
};

export type FkRentalOrderDetailToProductProductCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type FkRentalOrderDetailToProductRentalOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productService?: InputMaybe<FkRentalOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  rentalOrder?: InputMaybe<FkRentalOrderDetailToRentalOrderInput>;
  rentalOrderKey?: InputMaybe<Scalars['String']>;
};

export type FkRentalOrderDetailToRentalOrderInput = {
  connectByKey?: InputMaybe<RentalOrderPkRentalOrderConnect>;
  connectByOrderKey?: InputMaybe<RentalOrderUkRentalOrderOrderIdConnect>;
  create?: InputMaybe<FkRentalOrderDetailToRentalOrderRentalOrderCreateInput>;
  deleteByKey?: InputMaybe<RentalOrderPkRentalOrderDelete>;
  deleteByOrderKey?: InputMaybe<RentalOrderUkRentalOrderOrderIdDelete>;
  updateByKey?: InputMaybe<RentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderUsingPkRentalOrderUpdate>;
  updateByOrderKey?: InputMaybe<RentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderUsingUkRentalOrderOrderIdUpdate>;
};

export type FkRentalOrderDetailToRentalOrderInverseInput = {
  connectByKey?: InputMaybe<Array<RentalOrderDetailPkRentalOrderDetailConnect>>;
  create?: InputMaybe<Array<FkRentalOrderDetailToRentalOrderRentalOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<RentalOrderDetailPkRentalOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<RentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderUsingPkRentalOrderDetailUpdate>>;
};

export type FkRentalOrderDetailToRentalOrderRentalOrderCreateInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<FkRentalOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToRentalOrderInverseInput>;
};

export type FkRentalOrderDetailToRentalOrderRentalOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkRentalOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  rentalOrder?: InputMaybe<FkRentalOrderDetailToRentalOrderInput>;
};

export type FkRentalOrderToOrderInput = {
  connectByKey?: InputMaybe<OrderPkOrderConnect>;
  create?: InputMaybe<FkRentalOrderToOrderOrderCreateInput>;
  updateByKey?: InputMaybe<OrderOnRentalOrderForFkRentalOrderToOrderUsingPkOrderUpdate>;
};

export type FkRentalOrderToOrderInverseInput = {
  connectByKey?: InputMaybe<RentalOrderPkRentalOrderConnect>;
  connectByOrderKey?: InputMaybe<RentalOrderUkRentalOrderOrderIdConnect>;
  create?: InputMaybe<Array<FkRentalOrderToOrderRentalOrderCreateInput>>;
  deleteByKey?: InputMaybe<RentalOrderPkRentalOrderDelete>;
  deleteByOrderKey?: InputMaybe<RentalOrderUkRentalOrderOrderIdDelete>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<RentalOrderOnRentalOrderForFkRentalOrderToOrderUsingPkRentalOrderUpdate>;
  updateByOrderKey?: InputMaybe<RentalOrderOnRentalOrderForFkRentalOrderToOrderUsingUkRentalOrderOrderIdUpdate>;
};

export type FkRentalOrderToOrderOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkRentalOrderToOrderRentalOrderCreateInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<FkRentalOrderToOrderInput>;
  period?: InputMaybe<Scalars['String']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToRentalOrderInverseInput>;
};

export type FkSaleOrderDetailToProductInput = {
  connectByKey?: InputMaybe<ProductPkProductConnect>;
  create?: InputMaybe<FkSaleOrderDetailToProductProductCreateInput>;
  updateByKey?: InputMaybe<ProductOnSaleOrderDetailForFkSaleOrderDetailToProductUsingPkProductUpdate>;
};

export type FkSaleOrderDetailToProductInverseInput = {
  connectByKey?: InputMaybe<Array<SaleOrderDetailPkSaleOrderDetailConnect>>;
  create?: InputMaybe<Array<FkSaleOrderDetailToProductSaleOrderDetailCreateInput>>;
  updateByKey?: InputMaybe<Array<SaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToProductUsingPkSaleOrderDetailUpdate>>;
};

export type FkSaleOrderDetailToProductProductCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type FkSaleOrderDetailToProductSaleOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productService?: InputMaybe<FkSaleOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  saleOrder?: InputMaybe<FkSaleOrderDetailToSaleOrderInput>;
  saleOrderKey?: InputMaybe<Scalars['String']>;
  sinNumeroImei?: InputMaybe<Scalars['String']>;
  sinNumeroSerie?: InputMaybe<Scalars['String']>;
};

export type FkSaleOrderDetailToSaleOrderInput = {
  connectByKey?: InputMaybe<SaleOrderPkSaleOrderConnect>;
  connectByOrderKey?: InputMaybe<SaleOrderUkSaleOrderOrderKeyConnect>;
  create?: InputMaybe<FkSaleOrderDetailToSaleOrderSaleOrderCreateInput>;
  updateByKey?: InputMaybe<SaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderUsingPkSaleOrderUpdate>;
  updateByOrderKey?: InputMaybe<SaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderUsingUkSaleOrderOrderKeyUpdate>;
};

export type FkSaleOrderDetailToSaleOrderInverseInput = {
  connectByKey?: InputMaybe<Array<SaleOrderDetailPkSaleOrderDetailConnect>>;
  create?: InputMaybe<Array<FkSaleOrderDetailToSaleOrderSaleOrderDetailCreateInput>>;
  updateByKey?: InputMaybe<Array<SaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderUsingPkSaleOrderDetailUpdate>>;
};

export type FkSaleOrderDetailToSaleOrderSaleOrderCreateInput = {
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  order?: InputMaybe<FkSaleOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToSaleOrderInverseInput>;
};

export type FkSaleOrderDetailToSaleOrderSaleOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkSaleOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  saleOrder?: InputMaybe<FkSaleOrderDetailToSaleOrderInput>;
  sinNumeroImei?: InputMaybe<Scalars['String']>;
  sinNumeroSerie?: InputMaybe<Scalars['String']>;
};

export type FkSaleOrderToOrderInput = {
  connectByKey?: InputMaybe<OrderPkOrderConnect>;
  create?: InputMaybe<FkSaleOrderToOrderOrderCreateInput>;
  updateByKey?: InputMaybe<OrderOnSaleOrderForFkSaleOrderToOrderUsingPkOrderUpdate>;
};

export type FkSaleOrderToOrderInverseInput = {
  connectByKey?: InputMaybe<SaleOrderPkSaleOrderConnect>;
  connectByOrderKey?: InputMaybe<SaleOrderUkSaleOrderOrderKeyConnect>;
  create?: InputMaybe<Array<FkSaleOrderToOrderSaleOrderCreateInput>>;
  updateByKey?: InputMaybe<SaleOrderOnSaleOrderForFkSaleOrderToOrderUsingPkSaleOrderUpdate>;
  updateByOrderKey?: InputMaybe<SaleOrderOnSaleOrderForFkSaleOrderToOrderUsingUkSaleOrderOrderKeyUpdate>;
};

export type FkSaleOrderToOrderOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkSaleOrderToOrderSaleOrderCreateInput = {
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  order?: InputMaybe<FkSaleOrderToOrderInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToSaleOrderInverseInput>;
};

export type FkTouristServiceOrderDetailToProductInput = {
  connectByKey?: InputMaybe<ProductPkProductConnect>;
  create?: InputMaybe<FkTouristServiceOrderDetailToProductProductCreateInput>;
  updateByKey?: InputMaybe<ProductOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductUsingPkProductUpdate>;
};

export type FkTouristServiceOrderDetailToProductInverseInput = {
  connectByKey?: InputMaybe<Array<TouristServiceOrderDetailPkTouristServiceOrderDetailConnect>>;
  create?: InputMaybe<Array<FkTouristServiceOrderDetailToProductTouristServiceOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<TouristServiceOrderDetailPkTouristServiceOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<TouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductUsingPkTouristServiceOrderDetailUpdate>>;
};

export type FkTouristServiceOrderDetailToProductProductCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type FkTouristServiceOrderDetailToProductTouristServiceOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productService?: InputMaybe<FkTouristServiceOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  touristServiceOrder?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInput>;
  touristServiceOrderKey?: InputMaybe<Scalars['String']>;
};

export type FkTouristServiceOrderDetailToTouristServiceOrderInput = {
  connectByKey?: InputMaybe<TouristServiceOrderPkTouristServiceOrderConnect>;
  connectByOrderKey?: InputMaybe<TouristServiceOrderUkTouristServiceOrderOrderKeyConnect>;
  create?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderTouristServiceOrderCreateInput>;
  deleteByKey?: InputMaybe<TouristServiceOrderPkTouristServiceOrderDelete>;
  deleteByOrderKey?: InputMaybe<TouristServiceOrderUkTouristServiceOrderOrderKeyDelete>;
  updateByKey?: InputMaybe<TouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderUsingPkTouristServiceOrderUpdate>;
  updateByOrderKey?: InputMaybe<TouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderUsingUkTouristServiceOrderOrderKeyUpdate>;
};

export type FkTouristServiceOrderDetailToTouristServiceOrderInverseInput = {
  connectByKey?: InputMaybe<Array<TouristServiceOrderDetailPkTouristServiceOrderDetailConnect>>;
  create?: InputMaybe<Array<FkTouristServiceOrderDetailToTouristServiceOrderTouristServiceOrderDetailCreateInput>>;
  deleteByKey?: InputMaybe<Array<TouristServiceOrderDetailPkTouristServiceOrderDetailDelete>>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<Array<TouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderUsingPkTouristServiceOrderDetailUpdate>>;
};

export type FkTouristServiceOrderDetailToTouristServiceOrderTouristServiceOrderCreateInput = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<FkTouristServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInverseInput>;
};

export type FkTouristServiceOrderDetailToTouristServiceOrderTouristServiceOrderDetailCreateInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkTouristServiceOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  touristServiceOrder?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInput>;
};

export type FkTouristServiceOrderToOrderInput = {
  connectByKey?: InputMaybe<OrderPkOrderConnect>;
  create?: InputMaybe<FkTouristServiceOrderToOrderOrderCreateInput>;
  updateByKey?: InputMaybe<OrderOnTouristServiceOrderForFkTouristServiceOrderToOrderUsingPkOrderUpdate>;
};

export type FkTouristServiceOrderToOrderInverseInput = {
  connectByKey?: InputMaybe<TouristServiceOrderPkTouristServiceOrderConnect>;
  connectByOrderKey?: InputMaybe<TouristServiceOrderUkTouristServiceOrderOrderKeyConnect>;
  create?: InputMaybe<Array<FkTouristServiceOrderToOrderTouristServiceOrderCreateInput>>;
  deleteByKey?: InputMaybe<TouristServiceOrderPkTouristServiceOrderDelete>;
  deleteByOrderKey?: InputMaybe<TouristServiceOrderUkTouristServiceOrderOrderKeyDelete>;
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  updateByKey?: InputMaybe<TouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderUsingPkTouristServiceOrderUpdate>;
  updateByOrderKey?: InputMaybe<TouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderUsingUkTouristServiceOrderOrderKeyUpdate>;
};

export type FkTouristServiceOrderToOrderOrderCreateInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type FkTouristServiceOrderToOrderTouristServiceOrderCreateInput = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<FkTouristServiceOrderToOrderInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInverseInput>;
};

export type GenerateCufdInput = {
  executionMode: ExecutionMode;
  pointOfSaleKey: Scalars['String'];
};

export type GenerateCufdPayload = {
  __typename?: 'GenerateCufdPayload';
  cufd?: Maybe<Cufd>;
  message: Scalars['String'];
};

export type GenerateCuisInput = {
  executionMode: ExecutionMode;
  pointOfSaleKey: Scalars['String'];
};

export type GenerateCuisPayload = {
  __typename?: 'GenerateCuisPayload';
  cuis?: Maybe<Cuis>;
  message: Scalars['String'];
};

export type GenerateInvoiceInput = {
  orderKey: Scalars['String'];
};

export type GenerateInvoicePayload = {
  __typename?: 'GenerateInvoicePayload';
  boolean?: Maybe<Scalars['Boolean']>;
  invoice?: Maybe<Invoice>;
};

export type InsuranceOrder = {
  __typename?: 'InsuranceOrder';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  insuranceOrderDetails: InsuranceOrderDetailsConnection;
  key: Scalars['String'];
  order?: Maybe<Order>;
  orderKey: Scalars['String'];
  sinAjusteAfectacionIva: Scalars['BigFloat'];
  tenantId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};


export type InsuranceOrderInsuranceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceOrderDetailCondition>;
  filter?: InputMaybe<InsuranceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceOrderDetailsOrderBy>>;
};

export type InsuranceOrderCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinAjusteAfectacionIva?: InputMaybe<Scalars['BigFloat']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type InsuranceOrderDetail = {
  __typename?: 'InsuranceOrderDetail';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  discount: Scalars['BigFloat'];
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderKey: Scalars['String'];
  key: Scalars['String'];
  price: Scalars['BigFloat'];
  productKey: Scalars['String'];
  productService?: Maybe<Product>;
  quantity: Scalars['Int'];
  subtotal: Scalars['BigFloat'];
  tenantId: Scalars['Int'];
  total: Scalars['BigFloat'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type InsuranceOrderDetailCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  insuranceOrderKey?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type InsuranceOrderDetailFilter = {
  and?: InputMaybe<Array<InsuranceOrderDetailFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  discount?: InputMaybe<BigFloatFilter>;
  insuranceOrderKey?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<InsuranceOrderDetailFilter>;
  or?: InputMaybe<Array<InsuranceOrderDetailFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  productKey?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  subtotal?: InputMaybe<BigFloatFilter>;
  tenantId?: InputMaybe<IntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type InsuranceOrderDetailInput = {
  discount: Scalars['BigFloat'];
  insuranceOrder?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInput>;
  insuranceOrderKey?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkInsuranceOrderDetailToProductInput>;
  quantity: Scalars['Int'];
};

export type InsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderUsingPkInsuranceOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateInsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderPatch;
};

export type InsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductUsingPkInsuranceOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateInsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductPatch;
};

export type InsuranceOrderDetailPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  insuranceOrder?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInput>;
  insuranceOrderKey?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkInsuranceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type InsuranceOrderDetailPkInsuranceOrderDetailConnect = {
  key: Scalars['String'];
};

export type InsuranceOrderDetailPkInsuranceOrderDetailDelete = {
  key: Scalars['String'];
};

export type InsuranceOrderDetailsConnection = {
  __typename?: 'InsuranceOrderDetailsConnection';
  edges: Array<InsuranceOrderDetailsEdge>;
  nodes: Array<Maybe<InsuranceOrderDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InsuranceOrderDetailsEdge = {
  __typename?: 'InsuranceOrderDetailsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<InsuranceOrderDetail>;
};

export enum InsuranceOrderDetailsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  DiscountAsc = 'DISCOUNT_ASC',
  DiscountDesc = 'DISCOUNT_DESC',
  InsuranceOrderByInsuranceOrderKeyCreatedAtAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__CREATED_AT_ASC',
  InsuranceOrderByInsuranceOrderKeyCreatedAtDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__CREATED_AT_DESC',
  InsuranceOrderByInsuranceOrderKeyCreatedByAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__CREATED_BY_ASC',
  InsuranceOrderByInsuranceOrderKeyCreatedByDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__CREATED_BY_DESC',
  InsuranceOrderByInsuranceOrderKeyDeletedAtAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__DELETED_AT_ASC',
  InsuranceOrderByInsuranceOrderKeyDeletedAtDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__DELETED_AT_DESC',
  InsuranceOrderByInsuranceOrderKeyDeletedByAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__DELETED_BY_ASC',
  InsuranceOrderByInsuranceOrderKeyDeletedByDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__DELETED_BY_DESC',
  InsuranceOrderByInsuranceOrderKeyDeletionAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__DELETION_ASC',
  InsuranceOrderByInsuranceOrderKeyDeletionDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__DELETION_DESC',
  InsuranceOrderByInsuranceOrderKeyKeyAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__KEY_ASC',
  InsuranceOrderByInsuranceOrderKeyKeyDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__KEY_DESC',
  InsuranceOrderByInsuranceOrderKeyOrderKeyAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__ORDER_KEY_ASC',
  InsuranceOrderByInsuranceOrderKeyOrderKeyDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__ORDER_KEY_DESC',
  InsuranceOrderByInsuranceOrderKeySinAjusteAfectacionIvaAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__SIN_AJUSTE_AFECTACION_IVA_ASC',
  InsuranceOrderByInsuranceOrderKeySinAjusteAfectacionIvaDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__SIN_AJUSTE_AFECTACION_IVA_DESC',
  InsuranceOrderByInsuranceOrderKeyTenantIdAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__TENANT_ID_ASC',
  InsuranceOrderByInsuranceOrderKeyTenantIdDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__TENANT_ID_DESC',
  InsuranceOrderByInsuranceOrderKeyUpdatedAtAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__UPDATED_AT_ASC',
  InsuranceOrderByInsuranceOrderKeyUpdatedAtDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__UPDATED_AT_DESC',
  InsuranceOrderByInsuranceOrderKeyUpdatedByAsc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__UPDATED_BY_ASC',
  InsuranceOrderByInsuranceOrderKeyUpdatedByDesc = 'INSURANCE_ORDER_BY_INSURANCE_ORDER_KEY__UPDATED_BY_DESC',
  InsuranceOrderKeyAsc = 'INSURANCE_ORDER_KEY_ASC',
  InsuranceOrderKeyDesc = 'INSURANCE_ORDER_KEY_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductByProductKeyCodeAsc = 'PRODUCT_BY_PRODUCT_KEY__CODE_ASC',
  ProductByProductKeyCodeDesc = 'PRODUCT_BY_PRODUCT_KEY__CODE_DESC',
  ProductByProductKeyCreatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_ASC',
  ProductByProductKeyCreatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_DESC',
  ProductByProductKeyCreatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_ASC',
  ProductByProductKeyCreatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_DESC',
  ProductByProductKeyDeletedAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_ASC',
  ProductByProductKeyDeletedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_ASC',
  ProductByProductKeyDeletedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_DESC',
  ProductByProductKeyDeletedByAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_ASC',
  ProductByProductKeyDeletedByDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_DESC',
  ProductByProductKeyDeletedDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_DESC',
  ProductByProductKeyDescriptionAsc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_ASC',
  ProductByProductKeyDescriptionDesc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_DESC',
  ProductByProductKeyKeyAsc = 'PRODUCT_BY_PRODUCT_KEY__KEY_ASC',
  ProductByProductKeyKeyDesc = 'PRODUCT_BY_PRODUCT_KEY__KEY_DESC',
  ProductByProductKeyNameAsc = 'PRODUCT_BY_PRODUCT_KEY__NAME_ASC',
  ProductByProductKeyNameDesc = 'PRODUCT_BY_PRODUCT_KEY__NAME_DESC',
  ProductByProductKeyPriceAsc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_ASC',
  ProductByProductKeyPriceDesc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_DESC',
  ProductByProductKeyTenantIdAsc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_ASC',
  ProductByProductKeyTenantIdDesc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_DESC',
  ProductByProductKeyTypeAsc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_ASC',
  ProductByProductKeyTypeDesc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_DESC',
  ProductByProductKeyUpdatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_ASC',
  ProductByProductKeyUpdatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_DESC',
  ProductByProductKeyUpdatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_ASC',
  ProductByProductKeyUpdatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_DESC',
  ProductKeyAsc = 'PRODUCT_KEY_ASC',
  ProductKeyDesc = 'PRODUCT_KEY_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type InsuranceOrderFilter = {
  and?: InputMaybe<Array<InsuranceOrderFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<InsuranceOrderFilter>;
  or?: InputMaybe<Array<InsuranceOrderFilter>>;
  orderKey?: InputMaybe<StringFilter>;
  sinAjusteAfectacionIva?: InputMaybe<BigFloatFilter>;
  tenantId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type InsuranceOrderInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInverseInput>;
  order?: InputMaybe<FkInsuranceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinAjusteAfectacionIva: Scalars['BigFloat'];
};

export type InsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderUsingPkInsuranceOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateInsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderPatch;
};

export type InsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderUsingUkInsuranceOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateInsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderPatch;
};

export type InsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderUsingPkInsuranceOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateInsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderPatch;
};

export type InsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderUsingUkInsuranceOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateInsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderPatch;
};

export type InsuranceOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInverseInput>;
  order?: InputMaybe<FkInsuranceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinAjusteAfectacionIva?: InputMaybe<Scalars['BigFloat']>;
};

export type InsuranceOrderPkInsuranceOrderConnect = {
  key: Scalars['String'];
};

export type InsuranceOrderPkInsuranceOrderDelete = {
  key: Scalars['String'];
};

export type InsuranceOrderUkInsuranceOrderOrderKeyConnect = {
  orderKey: Scalars['String'];
};

export type InsuranceOrderUkInsuranceOrderOrderKeyDelete = {
  orderKey: Scalars['String'];
};

export type InsuranceOrdersConnection = {
  __typename?: 'InsuranceOrdersConnection';
  edges: Array<InsuranceOrdersEdge>;
  nodes: Array<Maybe<InsuranceOrder>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InsuranceOrdersEdge = {
  __typename?: 'InsuranceOrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<InsuranceOrder>;
};

export enum InsuranceOrdersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  InsuranceOrderDetailsByInsuranceOrderKeyCountAsc = 'INSURANCE_ORDER_DETAILS_BY_INSURANCE_ORDER_KEY__COUNT_ASC',
  InsuranceOrderDetailsByInsuranceOrderKeyCountDesc = 'INSURANCE_ORDER_DETAILS_BY_INSURANCE_ORDER_KEY__COUNT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  OrderByOrderKeyChangeAmountAsc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_ASC',
  OrderByOrderKeyChangeAmountDesc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_DESC',
  OrderByOrderKeyClientKeyAsc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_ASC',
  OrderByOrderKeyClientKeyDesc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_DESC',
  OrderByOrderKeyCreatedAtAsc = 'ORDER_BY_ORDER_KEY__CREATED_AT_ASC',
  OrderByOrderKeyCreatedAtDesc = 'ORDER_BY_ORDER_KEY__CREATED_AT_DESC',
  OrderByOrderKeyCreatedByAsc = 'ORDER_BY_ORDER_KEY__CREATED_BY_ASC',
  OrderByOrderKeyCreatedByDesc = 'ORDER_BY_ORDER_KEY__CREATED_BY_DESC',
  OrderByOrderKeyDeletedAtAsc = 'ORDER_BY_ORDER_KEY__DELETED_AT_ASC',
  OrderByOrderKeyDeletedAtDesc = 'ORDER_BY_ORDER_KEY__DELETED_AT_DESC',
  OrderByOrderKeyDeletedByAsc = 'ORDER_BY_ORDER_KEY__DELETED_BY_ASC',
  OrderByOrderKeyDeletedByDesc = 'ORDER_BY_ORDER_KEY__DELETED_BY_DESC',
  OrderByOrderKeyDeletionAsc = 'ORDER_BY_ORDER_KEY__DELETION_ASC',
  OrderByOrderKeyDeletionDesc = 'ORDER_BY_ORDER_KEY__DELETION_DESC',
  OrderByOrderKeyDiscountAsc = 'ORDER_BY_ORDER_KEY__DISCOUNT_ASC',
  OrderByOrderKeyDiscountDesc = 'ORDER_BY_ORDER_KEY__DISCOUNT_DESC',
  OrderByOrderKeyEmailAsc = 'ORDER_BY_ORDER_KEY__EMAIL_ASC',
  OrderByOrderKeyEmailDesc = 'ORDER_BY_ORDER_KEY__EMAIL_DESC',
  OrderByOrderKeyKeyAsc = 'ORDER_BY_ORDER_KEY__KEY_ASC',
  OrderByOrderKeyKeyDesc = 'ORDER_BY_ORDER_KEY__KEY_DESC',
  OrderByOrderKeyPaymentAmountAsc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_ASC',
  OrderByOrderKeyPaymentAmountDesc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_DESC',
  OrderByOrderKeyPhoneNumberAsc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_ASC',
  OrderByOrderKeyPhoneNumberDesc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_DESC',
  OrderByOrderKeyPointOfSaleKeyAsc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_ASC',
  OrderByOrderKeyPointOfSaleKeyDesc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_DESC',
  OrderByOrderKeyQuantityAsc = 'ORDER_BY_ORDER_KEY__QUANTITY_ASC',
  OrderByOrderKeyQuantityDesc = 'ORDER_BY_ORDER_KEY__QUANTITY_DESC',
  OrderByOrderKeyStatusAsc = 'ORDER_BY_ORDER_KEY__STATUS_ASC',
  OrderByOrderKeyStatusDesc = 'ORDER_BY_ORDER_KEY__STATUS_DESC',
  OrderByOrderKeySubtotalAsc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_ASC',
  OrderByOrderKeySubtotalDesc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_DESC',
  OrderByOrderKeyTenantIdAsc = 'ORDER_BY_ORDER_KEY__TENANT_ID_ASC',
  OrderByOrderKeyTenantIdDesc = 'ORDER_BY_ORDER_KEY__TENANT_ID_DESC',
  OrderByOrderKeyTotalAsc = 'ORDER_BY_ORDER_KEY__TOTAL_ASC',
  OrderByOrderKeyTotalDesc = 'ORDER_BY_ORDER_KEY__TOTAL_DESC',
  OrderByOrderKeyUpdatedAtAsc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_ASC',
  OrderByOrderKeyUpdatedAtDesc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_DESC',
  OrderByOrderKeyUpdatedByAsc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_ASC',
  OrderByOrderKeyUpdatedByDesc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_DESC',
  OrderKeyAsc = 'ORDER_KEY_ASC',
  OrderKeyDesc = 'ORDER_KEY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SinAjusteAfectacionIvaAsc = 'SIN_AJUSTE_AFECTACION_IVA_ASC',
  SinAjusteAfectacionIvaDesc = 'SIN_AJUSTE_AFECTACION_IVA_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type IntFilter = {
  distinctFrom?: InputMaybe<Scalars['Int']>;
  equalTo?: InputMaybe<Scalars['Int']>;
  greaterThan?: InputMaybe<Scalars['Int']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['Int']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  notEqualTo?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  additionalDiscount?: Maybe<Scalars['BigFloat']>;
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cuf?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['Int']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['String']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  emissionTypeCode?: Maybe<Scalars['Int']>;
  exchangeRate?: Maybe<Scalars['BigFloat']>;
  invoiceTypeCode?: Maybe<Scalars['Int']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  modalityTypeCode?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
  orderKey?: Maybe<Scalars['String']>;
  sectorDocumentCode?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['BigFloat']>;
  totalAmountCurrency?: Maybe<Scalars['BigFloat']>;
  totalAmountSubjectToIva?: Maybe<Scalars['BigFloat']>;
  totalAmountToPay?: Maybe<Scalars['BigFloat']>;
  url?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type InvoiceCancellation = {
  __typename?: 'InvoiceCancellation';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cufd?: Maybe<Scalars['String']>;
  cuis?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['Int']>;
  reasonDescription?: Maybe<Scalars['String']>;
  receptionCode?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type InvoiceFilter = {
  additionalDiscount?: InputMaybe<BigFloatFilter>;
  and?: InputMaybe<Array<InvoiceFilter>>;
  businessName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  cuf?: InputMaybe<StringFilter>;
  currencyCode?: InputMaybe<IntFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentTypeCode?: InputMaybe<StringFilter>;
  documentTypeDescription?: InputMaybe<StringFilter>;
  emissionTypeCode?: InputMaybe<IntFilter>;
  exchangeRate?: InputMaybe<BigFloatFilter>;
  invoiceTypeCode?: InputMaybe<IntFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  modalityTypeCode?: InputMaybe<IntFilter>;
  not?: InputMaybe<InvoiceFilter>;
  number?: InputMaybe<IntFilter>;
  or?: InputMaybe<Array<InvoiceFilter>>;
  orderKey?: InputMaybe<StringFilter>;
  sectorDocumentCode?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountCurrency?: InputMaybe<BigFloatFilter>;
  totalAmountSubjectToIva?: InputMaybe<BigFloatFilter>;
  totalAmountToPay?: InputMaybe<BigFloatFilter>;
  url?: InputMaybe<StringFilter>;
  verificationStatus?: InputMaybe<StringFilter>;
};

export type InvoiceRestoration = {
  __typename?: 'InvoiceRestoration';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cufd?: Maybe<Scalars['String']>;
  cuis?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  receptionCode?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum InvoiceStatus {
  Cancelled = 'CANCELLED',
  Generated = 'GENERATED',
  Invoiced = 'INVOICED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED'
}

export type InvoiceStatusFilter = {
  distinctFrom?: InputMaybe<InvoiceStatus>;
  equalTo?: InputMaybe<InvoiceStatus>;
  greaterThan?: InputMaybe<InvoiceStatus>;
  greaterThanOrEqualTo?: InputMaybe<InvoiceStatus>;
  in?: InputMaybe<Array<InvoiceStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<InvoiceStatus>;
  lessThanOrEqualTo?: InputMaybe<InvoiceStatus>;
  notDistinctFrom?: InputMaybe<InvoiceStatus>;
  notEqualTo?: InputMaybe<InvoiceStatus>;
  notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoicesConnection = {
  __typename?: 'InvoicesConnection';
  edges: Array<InvoicesEdge>;
  nodes: Array<Maybe<Invoice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type InvoicesEdge = {
  __typename?: 'InvoicesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Invoice>;
};

export enum MessageType {
  Invoice = 'INVOICE',
  SignificantEvent = 'SIGNIFICANT_EVENT'
}

export type MessagesInput = {
  key: Scalars['String'];
  type: MessageType;
};

export type MessagesPayload = {
  __typename?: 'MessagesPayload';
  messages: Array<Maybe<SinMessage>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticate?: Maybe<AuthenticatePayload>;
  authenticateByApiKey?: Maybe<AuthenticateByApiKeyPayload>;
  cancelInvoice?: Maybe<CancelInvoicePayload>;
  confirmAction?: Maybe<ConfirmActionPayload>;
  createBranchOffice?: Maybe<CreateBranchOfficePayload>;
  createClient?: Maybe<CreateClientPayload>;
  createClientHomologation?: Maybe<CreateClientHomologationPayload>;
  createExportServiceOrder?: Maybe<CreateExportServiceOrderPayload>;
  createExportServiceOrderDetail?: Maybe<CreateExportServiceOrderDetailPayload>;
  createInsuranceOrder?: Maybe<CreateInsuranceOrderPayload>;
  createInsuranceOrderDetail?: Maybe<CreateInsuranceOrderDetailPayload>;
  createOrder?: Maybe<CreateOrderPayload>;
  createOrderHomologation?: Maybe<CreateOrderHomologationPayload>;
  createPerson?: Maybe<CreatePersonPayload>;
  createPointOfSale?: Maybe<CreatePointOfSalePayload>;
  createPointOfSaleUser?: Maybe<CreatePointOfSaleUserPayload>;
  createProduct?: Maybe<CreateProductPayload>;
  createProductHomologation?: Maybe<CreateProductHomologationPayload>;
  createProductTmp?: Maybe<CreateProductTmpPayload>;
  createRegisterForm: CreateRegisterFormPayload;
  createRentalOrder?: Maybe<CreateRentalOrderPayload>;
  createRentalOrderDetail?: Maybe<CreateRentalOrderDetailPayload>;
  createRole?: Maybe<CreateRolePayload>;
  createSaleOrder?: Maybe<CreateSaleOrderPayload>;
  createSaleOrderDetail?: Maybe<CreateSaleOrderDetailPayload>;
  createSignificantEvent?: Maybe<CreateSignificantEventPayload>;
  createTenant?: Maybe<CreateTenantPayload>;
  createTouristServiceOrder?: Maybe<CreateTouristServiceOrderPayload>;
  createTouristServiceOrderDetail?: Maybe<CreateTouristServiceOrderDetailPayload>;
  createUser?: Maybe<CreateUserPayload>;
  createViewBranchOffice?: Maybe<CreateViewBranchOfficePayload>;
  createViewDelegatedToken?: Maybe<CreateViewDelegatedTokenPayload>;
  createViewDigitalSignature?: Maybe<CreateViewDigitalSignaturePayload>;
  createViewSyncParameter?: Maybe<CreateViewSyncParameterPayload>;
  createViewSyncRequest?: Maybe<CreateViewSyncRequestPayload>;
  deleteClient?: Maybe<DeleteClientPayload>;
  deleteExportServiceOrder?: Maybe<DeleteExportServiceOrderPayload>;
  deleteExportServiceOrderByOrderKey?: Maybe<DeleteExportServiceOrderPayload>;
  deleteExportServiceOrderDetail?: Maybe<DeleteExportServiceOrderDetailPayload>;
  deleteInsuranceOrder?: Maybe<DeleteInsuranceOrderPayload>;
  deleteInsuranceOrderByOrderKey?: Maybe<DeleteInsuranceOrderPayload>;
  deleteInsuranceOrderDetail?: Maybe<DeleteInsuranceOrderDetailPayload>;
  deletePointOfSaleUser?: Maybe<DeletePointOfSaleUserPayload>;
  deleteRentalOrder?: Maybe<DeleteRentalOrderPayload>;
  deleteRentalOrderByOrderKey?: Maybe<DeleteRentalOrderPayload>;
  deleteRentalOrderDetail?: Maybe<DeleteRentalOrderDetailPayload>;
  deleteTouristServiceOrder?: Maybe<DeleteTouristServiceOrderPayload>;
  deleteTouristServiceOrderByOrderKey?: Maybe<DeleteTouristServiceOrderPayload>;
  deleteTouristServiceOrderDetail?: Maybe<DeleteTouristServiceOrderDetailPayload>;
  generateCufd?: Maybe<GenerateCufdPayload>;
  generateCuis?: Maybe<GenerateCuisPayload>;
  generateInvoice?: Maybe<GenerateInvoicePayload>;
  generateSubscriptionChargePaymentRequest?: Maybe<PaymentRequest>;
  processProductBatchImport?: Maybe<ProcessProductBatchImportPayload>;
  requestPasswordReset?: Maybe<RequestPasswordResetPayload>;
  requestSync?: Maybe<RequestSyncPayload>;
  resentInvoice?: Maybe<ResentInvoicePayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  restoreInvoice?: Maybe<RestoreInvoicePayload>;
  saveSelectedTenant?: Maybe<SaveSelectedTenantPayload>;
  sendSignificantEvent?: Maybe<SendSignificantEventPayload>;
  sinGenerateMassiveCufds?: Maybe<SinGenerateMassiveCufdsPayload>;
  syncPointsOfSale?: Maybe<SyncPointsOfSalePayload>;
  unlockUser?: Maybe<UnlockUserPayload>;
  updateBranchOffice?: Maybe<UpdateBranchOfficePayload>;
  updateClient?: Maybe<UpdateClientPayload>;
  updateClientHomologation?: Maybe<UpdateClientHomologationPayload>;
  updateClientHomologationByClientKey?: Maybe<UpdateClientHomologationPayload>;
  updateCurrentBillingInfo?: Maybe<UpdateCurrentBillingInfoPayload>;
  updateCurrentTenantInfo?: Maybe<UpdateCurrentTenantInfoPayload>;
  updateExportServiceOrder?: Maybe<UpdateExportServiceOrderPayload>;
  updateExportServiceOrderByOrderKey?: Maybe<UpdateExportServiceOrderPayload>;
  updateExportServiceOrderDetail?: Maybe<UpdateExportServiceOrderDetailPayload>;
  updateInsuranceOrder?: Maybe<UpdateInsuranceOrderPayload>;
  updateInsuranceOrderByOrderKey?: Maybe<UpdateInsuranceOrderPayload>;
  updateInsuranceOrderDetail?: Maybe<UpdateInsuranceOrderDetailPayload>;
  updateOrder?: Maybe<UpdateOrderPayload>;
  updateOrderHomologation?: Maybe<UpdateOrderHomologationPayload>;
  updateOrderHomologationByOrderKey?: Maybe<UpdateOrderHomologationPayload>;
  updatePerson?: Maybe<UpdatePersonPayload>;
  updatePointOfSaleUser?: Maybe<UpdatePointOfSaleUserPayload>;
  updateProduct?: Maybe<UpdateProductPayload>;
  updateProductHomologation?: Maybe<UpdateProductHomologationPayload>;
  updateProductHomologationByProductKey?: Maybe<UpdateProductHomologationPayload>;
  updateRentalOrder?: Maybe<UpdateRentalOrderPayload>;
  updateRentalOrderByOrderKey?: Maybe<UpdateRentalOrderPayload>;
  updateRentalOrderDetail?: Maybe<UpdateRentalOrderDetailPayload>;
  updateRole?: Maybe<UpdateRolePayload>;
  updateSaleOrder?: Maybe<UpdateSaleOrderPayload>;
  updateSaleOrderByOrderKey?: Maybe<UpdateSaleOrderPayload>;
  updateSaleOrderDetail?: Maybe<UpdateSaleOrderDetailPayload>;
  updateTouristServiceOrder?: Maybe<UpdateTouristServiceOrderPayload>;
  updateTouristServiceOrderByOrderKey?: Maybe<UpdateTouristServiceOrderPayload>;
  updateTouristServiceOrderDetail?: Maybe<UpdateTouristServiceOrderDetailPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserRoles?: Maybe<UpdateUserRolesPayload>;
  uploadDelegatedToken: UploadDelegatedTokenPayload;
  uploadDigitalSignature: UploadDigitalSignaturePayload;
  uploadProducts: UploadProductsPayload;
  uploadRegisterDocuments: UploadRegisterDocumentsPayload;
  validateToken?: Maybe<ValidateTokenPayload>;
};


export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationAuthenticateByApiKeyArgs = {
  input: AuthenticateByApiKeyInput;
};


export type MutationCancelInvoiceArgs = {
  input: CancelInvoiceInput;
};


export type MutationConfirmActionArgs = {
  input: ConfirmActionInput;
};


export type MutationCreateBranchOfficeArgs = {
  input: CreateBranchOfficeInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateClientHomologationArgs = {
  input: CreateClientHomologationInput;
};


export type MutationCreateExportServiceOrderArgs = {
  input: CreateExportServiceOrderInput;
};


export type MutationCreateExportServiceOrderDetailArgs = {
  input: CreateExportServiceOrderDetailInput;
};


export type MutationCreateInsuranceOrderArgs = {
  input: CreateInsuranceOrderInput;
};


export type MutationCreateInsuranceOrderDetailArgs = {
  input: CreateInsuranceOrderDetailInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateOrderHomologationArgs = {
  input: CreateOrderHomologationInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePointOfSaleArgs = {
  input: CreatePointOfSaleInput;
};


export type MutationCreatePointOfSaleUserArgs = {
  input: CreatePointOfSaleUserInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductHomologationArgs = {
  input: CreateProductHomologationInput;
};


export type MutationCreateProductTmpArgs = {
  input: CreateProductTmpInput;
};


export type MutationCreateRegisterFormArgs = {
  input: CreateRegisterFormInput;
};


export type MutationCreateRentalOrderArgs = {
  input: CreateRentalOrderInput;
};


export type MutationCreateRentalOrderDetailArgs = {
  input: CreateRentalOrderDetailInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSaleOrderArgs = {
  input: CreateSaleOrderInput;
};


export type MutationCreateSaleOrderDetailArgs = {
  input: CreateSaleOrderDetailInput;
};


export type MutationCreateSignificantEventArgs = {
  input: CreateSignificantEventInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateTouristServiceOrderArgs = {
  input: CreateTouristServiceOrderInput;
};


export type MutationCreateTouristServiceOrderDetailArgs = {
  input: CreateTouristServiceOrderDetailInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateViewBranchOfficeArgs = {
  input: CreateViewBranchOfficeInput;
};


export type MutationCreateViewDelegatedTokenArgs = {
  input: CreateViewDelegatedTokenInput;
};


export type MutationCreateViewDigitalSignatureArgs = {
  input: CreateViewDigitalSignatureInput;
};


export type MutationCreateViewSyncParameterArgs = {
  input: CreateViewSyncParameterInput;
};


export type MutationCreateViewSyncRequestArgs = {
  input: CreateViewSyncRequestInput;
};


export type MutationDeleteClientArgs = {
  input: DeleteClientInput;
};


export type MutationDeleteExportServiceOrderArgs = {
  input: DeleteExportServiceOrderInput;
};


export type MutationDeleteExportServiceOrderByOrderKeyArgs = {
  input: DeleteExportServiceOrderByOrderKeyInput;
};


export type MutationDeleteExportServiceOrderDetailArgs = {
  input: DeleteExportServiceOrderDetailInput;
};


export type MutationDeleteInsuranceOrderArgs = {
  input: DeleteInsuranceOrderInput;
};


export type MutationDeleteInsuranceOrderByOrderKeyArgs = {
  input: DeleteInsuranceOrderByOrderKeyInput;
};


export type MutationDeleteInsuranceOrderDetailArgs = {
  input: DeleteInsuranceOrderDetailInput;
};


export type MutationDeletePointOfSaleUserArgs = {
  input: DeletePointOfSaleUserInput;
};


export type MutationDeleteRentalOrderArgs = {
  input: DeleteRentalOrderInput;
};


export type MutationDeleteRentalOrderByOrderKeyArgs = {
  input: DeleteRentalOrderByOrderKeyInput;
};


export type MutationDeleteRentalOrderDetailArgs = {
  input: DeleteRentalOrderDetailInput;
};


export type MutationDeleteTouristServiceOrderArgs = {
  input: DeleteTouristServiceOrderInput;
};


export type MutationDeleteTouristServiceOrderByOrderKeyArgs = {
  input: DeleteTouristServiceOrderByOrderKeyInput;
};


export type MutationDeleteTouristServiceOrderDetailArgs = {
  input: DeleteTouristServiceOrderDetailInput;
};


export type MutationGenerateCufdArgs = {
  input: GenerateCufdInput;
};


export type MutationGenerateCuisArgs = {
  input: GenerateCuisInput;
};


export type MutationGenerateInvoiceArgs = {
  input: GenerateInvoiceInput;
};


export type MutationGenerateSubscriptionChargePaymentRequestArgs = {
  key: Scalars['String'];
};


export type MutationProcessProductBatchImportArgs = {
  input: ProcessProductBatchImportInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestSyncArgs = {
  input: RequestSyncInput;
};


export type MutationResentInvoiceArgs = {
  input: ResentInvoiceInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRestoreInvoiceArgs = {
  input: RestoreInvoiceInput;
};


export type MutationSaveSelectedTenantArgs = {
  input: SaveSelectedTenantInput;
};


export type MutationSendSignificantEventArgs = {
  input: SendSignificantEventInput;
};


export type MutationSinGenerateMassiveCufdsArgs = {
  input: SinGenerateMassiveCufdsInput;
};


export type MutationUnlockUserArgs = {
  input: UnlockUserInput;
};


export type MutationUpdateBranchOfficeArgs = {
  input: UpdateBranchOfficeInput;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateClientHomologationArgs = {
  input: UpdateClientHomologationInput;
};


export type MutationUpdateClientHomologationByClientKeyArgs = {
  input: UpdateClientHomologationByClientKeyInput;
};


export type MutationUpdateCurrentBillingInfoArgs = {
  input: UpdateCurrentBillingInfoInput;
};


export type MutationUpdateCurrentTenantInfoArgs = {
  input: UpdateCurrentTenantInfoInput;
};


export type MutationUpdateExportServiceOrderArgs = {
  input: UpdateExportServiceOrderInput;
};


export type MutationUpdateExportServiceOrderByOrderKeyArgs = {
  input: UpdateExportServiceOrderByOrderKeyInput;
};


export type MutationUpdateExportServiceOrderDetailArgs = {
  input: UpdateExportServiceOrderDetailInput;
};


export type MutationUpdateInsuranceOrderArgs = {
  input: UpdateInsuranceOrderInput;
};


export type MutationUpdateInsuranceOrderByOrderKeyArgs = {
  input: UpdateInsuranceOrderByOrderKeyInput;
};


export type MutationUpdateInsuranceOrderDetailArgs = {
  input: UpdateInsuranceOrderDetailInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrderHomologationArgs = {
  input: UpdateOrderHomologationInput;
};


export type MutationUpdateOrderHomologationByOrderKeyArgs = {
  input: UpdateOrderHomologationByOrderKeyInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePointOfSaleUserArgs = {
  input: UpdatePointOfSaleUserInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductHomologationArgs = {
  input: UpdateProductHomologationInput;
};


export type MutationUpdateProductHomologationByProductKeyArgs = {
  input: UpdateProductHomologationByProductKeyInput;
};


export type MutationUpdateRentalOrderArgs = {
  input: UpdateRentalOrderInput;
};


export type MutationUpdateRentalOrderByOrderKeyArgs = {
  input: UpdateRentalOrderByOrderKeyInput;
};


export type MutationUpdateRentalOrderDetailArgs = {
  input: UpdateRentalOrderDetailInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSaleOrderArgs = {
  input: UpdateSaleOrderInput;
};


export type MutationUpdateSaleOrderByOrderKeyArgs = {
  input: UpdateSaleOrderByOrderKeyInput;
};


export type MutationUpdateSaleOrderDetailArgs = {
  input: UpdateSaleOrderDetailInput;
};


export type MutationUpdateTouristServiceOrderArgs = {
  input: UpdateTouristServiceOrderInput;
};


export type MutationUpdateTouristServiceOrderByOrderKeyArgs = {
  input: UpdateTouristServiceOrderByOrderKeyInput;
};


export type MutationUpdateTouristServiceOrderDetailArgs = {
  input: UpdateTouristServiceOrderDetailInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserRolesArgs = {
  input: UpdateUserRolesInput;
};


export type MutationUploadDelegatedTokenArgs = {
  input: UploadDelegatedTokenInput;
};


export type MutationUploadDigitalSignatureArgs = {
  input: UploadDigitalSignatureInput;
};


export type MutationUploadProductsArgs = {
  input: UploadProductsInput;
};


export type MutationUploadRegisterDocumentsArgs = {
  backDocumentPhoto: Scalars['Upload'];
  certificateRequestPhoto: Scalars['Upload'];
  frontDocumentPhoto: Scalars['Upload'];
  frontDocumentSelfie: Scalars['Upload'];
  nitDocumentPhoto: Scalars['Upload'];
  token: Scalars['String'];
};


export type MutationValidateTokenArgs = {
  input: ValidateTokenInput;
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  data?: Maybe<Scalars['JSON']>;
  icon?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  readAt?: Maybe<Scalars['Datetime']>;
  severity?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  edges: Array<NotificationsEdge>;
  nodes: Array<Maybe<Notification>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Notification>;
};

export enum NotificationsOrderBy {
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  IconAsc = 'ICON_ASC',
  IconDesc = 'ICON_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  ReadAtAsc = 'READ_AT_ASC',
  ReadAtDesc = 'READ_AT_DESC',
  SeverityAsc = 'SEVERITY_ASC',
  SeverityDesc = 'SEVERITY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type Order = {
  __typename?: 'Order';
  changeAmount: Scalars['BigFloat'];
  client?: Maybe<Client>;
  clientKey: Scalars['String'];
  createdAt: Scalars['Datetime'];
  discount: Scalars['BigFloat'];
  email?: Maybe<Scalars['String']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  /** @deprecated Please use exportServiceOrder instead */
  exportServiceOrders: ExportServiceOrdersConnection;
  homologation?: Maybe<OrderHomologation>;
  /** @deprecated Please use homologation instead */
  homologations: OrderHomologationsConnection;
  insuranceOrder?: Maybe<InsuranceOrder>;
  /** @deprecated Please use insuranceOrder instead */
  insuranceOrders: InsuranceOrdersConnection;
  invoice?: Maybe<Invoice>;
  key: Scalars['String'];
  paymentAmount: Scalars['BigFloat'];
  phoneNumber?: Maybe<Scalars['String']>;
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleKey: Scalars['String'];
  quantity: Scalars['BigFloat'];
  rentalOrder?: Maybe<RentalOrder>;
  /** @deprecated Please use rentalOrder instead */
  rentalOrders: RentalOrdersConnection;
  saleOrder?: Maybe<SaleOrder>;
  /** @deprecated Please use saleOrder instead */
  saleOrders: SaleOrdersConnection;
  status: OrderStatus;
  subtotal: Scalars['BigFloat'];
  total: Scalars['BigFloat'];
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  /** @deprecated Please use touristServiceOrder instead */
  touristServiceOrders: TouristServiceOrdersConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type OrderExportServiceOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExportServiceOrderCondition>;
  filter?: InputMaybe<ExportServiceOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExportServiceOrdersOrderBy>>;
};


export type OrderHomologationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type OrderInsuranceOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceOrderCondition>;
  filter?: InputMaybe<InsuranceOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceOrdersOrderBy>>;
};


export type OrderRentalOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RentalOrderCondition>;
  filter?: InputMaybe<RentalOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RentalOrdersOrderBy>>;
};


export type OrderSaleOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type OrderTouristServiceOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TouristServiceOrderCondition>;
  filter?: InputMaybe<TouristServiceOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TouristServiceOrdersOrderBy>>;
};

export type OrderHomologation = {
  __typename?: 'OrderHomologation';
  activityCode: Scalars['String'];
  activityDescription: Scalars['String'];
  cardNumber?: Maybe<Scalars['BigInt']>;
  createdAt: Scalars['Datetime'];
  currencyCode: Scalars['Int'];
  emissionTypeCode: Scalars['Int'];
  exchangeRate: Scalars['BigFloat'];
  invoiceTypeCode: Scalars['Int'];
  key: Scalars['String'];
  modalityTypeCode: Scalars['Int'];
  order?: Maybe<Order>;
  orderKey: Scalars['String'];
  paymentMethodCode: Scalars['Int'];
  paymentMethodDescription?: Maybe<Scalars['String']>;
  sectorDocumentCode: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type OrderHomologationInput = {
  activityCode: Scalars['String'];
  cardNumber?: InputMaybe<Scalars['BigInt']>;
  currencyCode: Scalars['Int'];
  emissionTypeCode: Scalars['Int'];
  exchangeRate: Scalars['BigFloat'];
  invoiceTypeCode?: InputMaybe<Scalars['Int']>;
  modalityTypeCode: Scalars['Int'];
  order?: InputMaybe<FkOrderHomologationToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  paymentMethodCode: Scalars['Int'];
  sectorDocumentCode?: InputMaybe<Scalars['Int']>;
};

export type OrderHomologationOnOrderHomologationForFkOrderHomologationToOrderUsingPkOrderHomologationUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderHomologationOnOrderHomologationForFkOrderHomologationToOrderPatch;
};

export type OrderHomologationOnOrderHomologationForFkOrderHomologationToOrderUsingUkOrderHomologationOrderIdUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateOrderHomologationOnOrderHomologationForFkOrderHomologationToOrderPatch;
};

export type OrderHomologationPatch = {
  activityCode?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['BigInt']>;
  currencyCode?: InputMaybe<Scalars['Int']>;
  emissionTypeCode?: InputMaybe<Scalars['Int']>;
  exchangeRate?: InputMaybe<Scalars['BigFloat']>;
  invoiceTypeCode?: InputMaybe<Scalars['Int']>;
  modalityTypeCode?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FkOrderHomologationToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  paymentMethodCode?: InputMaybe<Scalars['Int']>;
  sectorDocumentCode?: InputMaybe<Scalars['Int']>;
};

export type OrderHomologationPkOrderHomologationConnect = {
  key: Scalars['String'];
};

export type OrderHomologationUkOrderHomologationOrderIdConnect = {
  orderKey: Scalars['String'];
};

export type OrderHomologationsConnection = {
  __typename?: 'OrderHomologationsConnection';
  edges: Array<OrderHomologationsEdge>;
  nodes: Array<Maybe<OrderHomologation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrderHomologationsEdge = {
  __typename?: 'OrderHomologationsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<OrderHomologation>;
};

export type OrderInput = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type OrderOnExportServiceOrderForFkExportServiceOrderToOrderUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnExportServiceOrderForFkExportServiceOrderToOrderPatch;
};

export type OrderOnInsuranceOrderForFkInsuranceOrderToOrderUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnInsuranceOrderForFkInsuranceOrderToOrderPatch;
};

export type OrderOnOrderForFkOrderToClientUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnOrderForFkOrderToClientPatch;
};

export type OrderOnOrderForFkOrderToPointOfSaleUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnOrderForFkOrderToPointOfSalePatch;
};

export type OrderOnOrderHomologationForFkOrderHomologationToOrderUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnOrderHomologationForFkOrderHomologationToOrderPatch;
};

export type OrderOnRentalOrderForFkRentalOrderToOrderUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnRentalOrderForFkRentalOrderToOrderPatch;
};

export type OrderOnSaleOrderForFkSaleOrderToOrderUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnSaleOrderForFkSaleOrderToOrderPatch;
};

export type OrderOnTouristServiceOrderForFkTouristServiceOrderToOrderUsingPkOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderPatch;
};

export type OrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type OrderPkOrderConnect = {
  key: Scalars['String'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Generated = 'GENERATED',
  Invoiced = 'INVOICED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED'
}

export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  edges: Array<OrdersEdge>;
  nodes: Array<Maybe<Order>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Order>;
};

export type OwnRole = {
  __typename?: 'OwnRole';
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissionCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  userCount?: Maybe<Scalars['Int']>;
};

export type OwnRoleCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissionCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userCount?: InputMaybe<Scalars['Int']>;
};

export type OwnRoleFilter = {
  and?: InputMaybe<Array<OwnRoleFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<OwnRoleFilter>;
  or?: InputMaybe<Array<OwnRoleFilter>>;
  permissionCount?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  userCount?: InputMaybe<IntFilter>;
};

export type OwnRolesConnection = {
  __typename?: 'OwnRolesConnection';
  edges: Array<OwnRolesEdge>;
  nodes: Array<Maybe<OwnRole>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OwnRolesEdge = {
  __typename?: 'OwnRolesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<OwnRole>;
};

export enum OwnRolesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PermissionCountAsc = 'PERMISSION_COUNT_ASC',
  PermissionCountDesc = 'PERMISSION_COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserCountAsc = 'USER_COUNT_ASC',
  UserCountDesc = 'USER_COUNT_DESC'
}

export type OwnSubscriptionPeriod = {
  __typename?: 'OwnSubscriptionPeriod';
  chargeAmount?: Maybe<Scalars['BigFloat']>;
  chargeCreatedAt?: Maybe<Scalars['Datetime']>;
  chargeDescription?: Maybe<Scalars['String']>;
  chargeKey?: Maybe<Scalars['String']>;
  chargeOverageAmount?: Maybe<Scalars['BigFloat']>;
  chargeStatus?: Maybe<SubscriptionChargeStatus>;
  chargeTotalAmount?: Maybe<Scalars['BigFloat']>;
  chargeType?: Maybe<SubscriptionChargeType>;
  description?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  planCurrency?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['BigFloat']>;
  startAt?: Maybe<Scalars['Datetime']>;
  status?: Maybe<SubscriptionPeriodStatus>;
};

export type OwnSubscriptionPeriodCondition = {
  chargeAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeCreatedAt?: InputMaybe<Scalars['Datetime']>;
  chargeDescription?: InputMaybe<Scalars['String']>;
  chargeKey?: InputMaybe<Scalars['String']>;
  chargeOverageAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeStatus?: InputMaybe<SubscriptionChargeStatus>;
  chargeTotalAmount?: InputMaybe<Scalars['BigFloat']>;
  chargeType?: InputMaybe<SubscriptionChargeType>;
  description?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  planCurrency?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planPrice?: InputMaybe<Scalars['BigFloat']>;
  startAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<SubscriptionPeriodStatus>;
};

export type OwnSubscriptionPeriodFilter = {
  and?: InputMaybe<Array<OwnSubscriptionPeriodFilter>>;
  chargeAmount?: InputMaybe<BigFloatFilter>;
  chargeCreatedAt?: InputMaybe<DatetimeFilter>;
  chargeDescription?: InputMaybe<StringFilter>;
  chargeKey?: InputMaybe<StringFilter>;
  chargeOverageAmount?: InputMaybe<BigFloatFilter>;
  chargeStatus?: InputMaybe<SubscriptionChargeStatusFilter>;
  chargeTotalAmount?: InputMaybe<BigFloatFilter>;
  chargeType?: InputMaybe<SubscriptionChargeTypeFilter>;
  description?: InputMaybe<StringFilter>;
  endAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<OwnSubscriptionPeriodFilter>;
  number?: InputMaybe<IntFilter>;
  or?: InputMaybe<Array<OwnSubscriptionPeriodFilter>>;
  planCurrency?: InputMaybe<StringFilter>;
  planName?: InputMaybe<StringFilter>;
  planPrice?: InputMaybe<BigFloatFilter>;
  startAt?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<SubscriptionPeriodStatusFilter>;
};

export type OwnSubscriptionPeriodsConnection = {
  __typename?: 'OwnSubscriptionPeriodsConnection';
  edges: Array<OwnSubscriptionPeriodsEdge>;
  nodes: Array<Maybe<OwnSubscriptionPeriod>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OwnSubscriptionPeriodsEdge = {
  __typename?: 'OwnSubscriptionPeriodsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<OwnSubscriptionPeriod>;
};

export enum OwnSubscriptionPeriodsOrderBy {
  ChargeAmountAsc = 'CHARGE_AMOUNT_ASC',
  ChargeAmountDesc = 'CHARGE_AMOUNT_DESC',
  ChargeCreatedAtAsc = 'CHARGE_CREATED_AT_ASC',
  ChargeCreatedAtDesc = 'CHARGE_CREATED_AT_DESC',
  ChargeDescriptionAsc = 'CHARGE_DESCRIPTION_ASC',
  ChargeDescriptionDesc = 'CHARGE_DESCRIPTION_DESC',
  ChargeKeyAsc = 'CHARGE_KEY_ASC',
  ChargeKeyDesc = 'CHARGE_KEY_DESC',
  ChargeOverageAmountAsc = 'CHARGE_OVERAGE_AMOUNT_ASC',
  ChargeOverageAmountDesc = 'CHARGE_OVERAGE_AMOUNT_DESC',
  ChargeStatusAsc = 'CHARGE_STATUS_ASC',
  ChargeStatusDesc = 'CHARGE_STATUS_DESC',
  ChargeTotalAmountAsc = 'CHARGE_TOTAL_AMOUNT_ASC',
  ChargeTotalAmountDesc = 'CHARGE_TOTAL_AMOUNT_DESC',
  ChargeTypeAsc = 'CHARGE_TYPE_ASC',
  ChargeTypeDesc = 'CHARGE_TYPE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EndAtAsc = 'END_AT_ASC',
  EndAtDesc = 'END_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  PlanCurrencyAsc = 'PLAN_CURRENCY_ASC',
  PlanCurrencyDesc = 'PLAN_CURRENCY_DESC',
  PlanNameAsc = 'PLAN_NAME_ASC',
  PlanNameDesc = 'PLAN_NAME_DESC',
  PlanPriceAsc = 'PLAN_PRICE_ASC',
  PlanPriceDesc = 'PLAN_PRICE_DESC',
  StartAtAsc = 'START_AT_ASC',
  StartAtDesc = 'START_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type OwnUser = {
  __typename?: 'OwnUser';
  blocked?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  lastConnection?: Maybe<Scalars['Datetime']>;
  permissionCount?: Maybe<Scalars['Int']>;
  roleCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
};

export type OwnUserCondition = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fullName?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  lastConnection?: InputMaybe<Scalars['Datetime']>;
  permissionCount?: InputMaybe<Scalars['Int']>;
  roleCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  username?: InputMaybe<Scalars['String']>;
};

export type OwnUserFilter = {
  and?: InputMaybe<Array<OwnUserFilter>>;
  blocked?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  fullName?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  lastConnection?: InputMaybe<DatetimeFilter>;
  not?: InputMaybe<OwnUserFilter>;
  or?: InputMaybe<Array<OwnUserFilter>>;
  permissionCount?: InputMaybe<IntFilter>;
  roleCount?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  username?: InputMaybe<StringFilter>;
};

export type OwnUsersConnection = {
  __typename?: 'OwnUsersConnection';
  edges: Array<OwnUsersEdge>;
  nodes: Array<Maybe<OwnUser>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OwnUsersEdge = {
  __typename?: 'OwnUsersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<OwnUser>;
};

export enum OwnUsersOrderBy {
  BlockedAsc = 'BLOCKED_ASC',
  BlockedDesc = 'BLOCKED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  LastConnectionAsc = 'LAST_CONNECTION_ASC',
  LastConnectionDesc = 'LAST_CONNECTION_DESC',
  Natural = 'NATURAL',
  PermissionCountAsc = 'PERMISSION_COUNT_ASC',
  PermissionCountDesc = 'PERMISSION_COUNT_DESC',
  RoleCountAsc = 'ROLE_COUNT_ASC',
  RoleCountDesc = 'ROLE_COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC'
}

export type Package = {
  __typename?: 'Package';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  emissionTypeCode?: Maybe<Scalars['Int']>;
  invoiceTypeCode?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  modalityTypeCode?: Maybe<Scalars['Int']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  receptionCode?: Maybe<Scalars['String']>;
  sectorDocumentCode?: Maybe<Scalars['Int']>;
  sectorDocumentDescription?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  validationSendingStatus?: Maybe<Scalars['String']>;
  validationStatus?: Maybe<Scalars['String']>;
};

export enum PackageStatus {
  Accepted = 'ACCEPTED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED'
}

export type PackageStatusFilter = {
  distinctFrom?: InputMaybe<PackageStatus>;
  equalTo?: InputMaybe<PackageStatus>;
  greaterThan?: InputMaybe<PackageStatus>;
  greaterThanOrEqualTo?: InputMaybe<PackageStatus>;
  in?: InputMaybe<Array<PackageStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<PackageStatus>;
  lessThanOrEqualTo?: InputMaybe<PackageStatus>;
  notDistinctFrom?: InputMaybe<PackageStatus>;
  notEqualTo?: InputMaybe<PackageStatus>;
  notIn?: InputMaybe<Array<PackageStatus>>;
};

export enum PackageValidationStatus {
  Failed = 'FAILED',
  Observed = 'OBSERVED',
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  Validated = 'VALIDATED'
}

export type PackageValidationStatusFilter = {
  distinctFrom?: InputMaybe<PackageValidationStatus>;
  equalTo?: InputMaybe<PackageValidationStatus>;
  greaterThan?: InputMaybe<PackageValidationStatus>;
  greaterThanOrEqualTo?: InputMaybe<PackageValidationStatus>;
  in?: InputMaybe<Array<PackageValidationStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<PackageValidationStatus>;
  lessThanOrEqualTo?: InputMaybe<PackageValidationStatus>;
  notDistinctFrom?: InputMaybe<PackageValidationStatus>;
  notEqualTo?: InputMaybe<PackageValidationStatus>;
  notIn?: InputMaybe<Array<PackageValidationStatus>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Parameter = {
  __typename?: 'Parameter';
  classifier?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type PaymentMethodInfo = {
  __typename?: 'PaymentMethodInfo';
  showCardNumber?: Maybe<Scalars['Boolean']>;
  showGiftCard?: Maybe<Scalars['Boolean']>;
};

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  amount: Scalars['BigFloat'];
  currency: Scalars['String'];
  data: Scalars['String'];
  description: Scalars['String'];
  expiresAt: Scalars['Date'];
  key: Scalars['String'];
  paidAt?: Maybe<Scalars['Date']>;
  status: Scalars['String'];
};

export type PeopleEdge = {
  __typename?: 'PeopleEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Person>;
};

export type Permission = {
  __typename?: 'Permission';
  code: Scalars['String'];
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Person = {
  __typename?: 'Person';
  createdAt: Scalars['Datetime'];
  firstName: Scalars['String'];
  firstSurname: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  secondSurname?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  users: UsersConnection;
};


export type PersonUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PersonInput = {
  firstName: Scalars['String'];
  firstSurname: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  secondSurname?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<FkAppUserToPersonInverseInput>;
};

export type PersonOnUserForFkAppUserToPersonUsingPkPersonUpdate = {
  key: Scalars['String'];
  patch: UpdatePersonOnUserForFkAppUserToPersonPatch;
};

export type PersonPatch = {
  firstName?: InputMaybe<Scalars['String']>;
  firstSurname?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  secondSurname?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<FkAppUserToPersonInverseInput>;
};

export type PersonPkPersonConnect = {
  key: Scalars['String'];
};

export type PointOfSale = {
  __typename?: 'PointOfSale';
  branchOffice?: Maybe<BranchOffice>;
  branchOfficeKey: Scalars['String'];
  code: Scalars['Int'];
  commissionAgentNit?: Maybe<Scalars['BigInt']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  cufd?: Maybe<Cufd>;
  cuis?: Maybe<Cuis>;
  description?: Maybe<Scalars['String']>;
  finishDate?: Maybe<Scalars['Datetime']>;
  key: Scalars['String'];
  modalityCode: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  orders: OrdersConnection;
  pointOfSaleUsers: PointOfSaleUsersConnection;
  startDate?: Maybe<Scalars['Datetime']>;
  status: PointOfSaleStatus;
  typeCode: Scalars['Int'];
  typeName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type PointOfSaleOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PointOfSalePointOfSaleUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PointOfSaleOnOrderForFkOrderToPointOfSaleUsingPkPointOfSaleUpdate = {
  key: Scalars['String'];
  patch: UpdatePointOfSaleOnOrderForFkOrderToPointOfSalePatch;
};

export type PointOfSaleOnPointOfSaleForFkPointOfSaleToBranchOfficeUsingPkPointOfSaleUpdate = {
  key: Scalars['String'];
  patch: UpdatePointOfSaleOnPointOfSaleForFkPointOfSaleToBranchOfficePatch;
};

export type PointOfSaleOnPointOfSaleUserForFkPointOfSaleUserToPointOfSaleUsingPkPointOfSaleUpdate = {
  key: Scalars['String'];
  patch: UpdatePointOfSaleOnPointOfSaleUserForFkPointOfSaleUserToPointOfSalePatch;
};

export type PointOfSalePkPointOfSaleConnect = {
  key: Scalars['String'];
};

export enum PointOfSaleStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export type PointOfSaleStatusFilter = {
  distinctFrom?: InputMaybe<PointOfSaleStatus>;
  equalTo?: InputMaybe<PointOfSaleStatus>;
  greaterThan?: InputMaybe<PointOfSaleStatus>;
  greaterThanOrEqualTo?: InputMaybe<PointOfSaleStatus>;
  in?: InputMaybe<Array<PointOfSaleStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<PointOfSaleStatus>;
  lessThanOrEqualTo?: InputMaybe<PointOfSaleStatus>;
  notDistinctFrom?: InputMaybe<PointOfSaleStatus>;
  notEqualTo?: InputMaybe<PointOfSaleStatus>;
  notIn?: InputMaybe<Array<PointOfSaleStatus>>;
};

export type PointOfSaleUser = {
  __typename?: 'PointOfSaleUser';
  createdAt: Scalars['Datetime'];
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleKey: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  user?: Maybe<User>;
  userKey: Scalars['String'];
};

export type PointOfSaleUserInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<FkPointOfSaleUserToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FkPointOfSaleUserToUserInput>;
  userKey?: InputMaybe<Scalars['String']>;
};

export type PointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToPointOfSaleUsingPkPointOfSaleUserUpdate = {
  key: Scalars['String'];
  patch: UpdatePointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToPointOfSalePatch;
};

export type PointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToUserUsingPkPointOfSaleUserUpdate = {
  key: Scalars['String'];
  patch: UpdatePointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToUserPatch;
};

export type PointOfSaleUserPatch = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<FkPointOfSaleUserToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FkPointOfSaleUserToUserInput>;
  userKey?: InputMaybe<Scalars['String']>;
};

export type PointOfSaleUserPkPointOfSaleUserConnect = {
  key: Scalars['String'];
};

export type PointOfSaleUserPkPointOfSaleUserDelete = {
  key: Scalars['String'];
};

export type PointOfSaleUsersConnection = {
  __typename?: 'PointOfSaleUsersConnection';
  edges: Array<PointOfSaleUsersEdge>;
  nodes: Array<Maybe<PointOfSaleUser>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PointOfSaleUsersEdge = {
  __typename?: 'PointOfSaleUsersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<PointOfSaleUser>;
};

export type PointOfSalesConnection = {
  __typename?: 'PointOfSalesConnection';
  edges: Array<PointOfSalesEdge>;
  nodes: Array<Maybe<PointOfSale>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PointOfSalesEdge = {
  __typename?: 'PointOfSalesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<PointOfSale>;
};

export type ProcessProductBatchImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pKey: Scalars['String'];
};

export type ProcessProductBatchImportPayload = {
  __typename?: 'ProcessProductBatchImportPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productBatchImport?: Maybe<ProductBatchImport>;
  query?: Maybe<Query>;
};

export type Product = {
  __typename?: 'Product';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  exportServiceOrderDetails: ExportServiceOrderDetailsConnection;
  homologation?: Maybe<ProductHomologation>;
  /** @deprecated Please use homologation instead */
  homologations: ProductHomologationsConnection;
  insuranceOrderDetails: InsuranceOrderDetailsConnection;
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails: RentalOrderDetailsConnection;
  saleOrderDetails: SaleOrderDetailsConnection;
  touristServiceOrderDetails: TouristServiceOrderDetailsConnection;
  type: ProductType;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ProductExportServiceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExportServiceOrderDetailCondition>;
  filter?: InputMaybe<ExportServiceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExportServiceOrderDetailsOrderBy>>;
};


export type ProductHomologationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductInsuranceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceOrderDetailCondition>;
  filter?: InputMaybe<InsuranceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceOrderDetailsOrderBy>>;
};


export type ProductRentalOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RentalOrderDetailCondition>;
  filter?: InputMaybe<RentalOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RentalOrderDetailsOrderBy>>;
};


export type ProductSaleOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductTouristServiceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TouristServiceOrderDetailCondition>;
  filter?: InputMaybe<TouristServiceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TouristServiceOrderDetailsOrderBy>>;
};

export type ProductBatchImport = {
  __typename?: 'ProductBatchImport';
  createdAt?: Maybe<Scalars['Datetime']>;
  details: ProductBatchImportDetailsConnection;
  encoding?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  mimetype?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ProductBatchImportDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ProductBatchImportDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProductBatchImportDetail = {
  __typename?: 'ProductBatchImportDetail';
  activityCode?: Maybe<Scalars['String']>;
  activityDescription?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  key?: Maybe<Scalars['String']>;
  measureUnitCode?: Maybe<Scalars['String']>;
  measureUnitDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigFloat']>;
  productCode?: Maybe<Scalars['String']>;
  productDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ProductBatchImportDetailFilter = {
  activityCode?: InputMaybe<StringFilter>;
  activityDescription?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<ProductBatchImportDetailFilter>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  errors?: InputMaybe<StringListFilter>;
  key?: InputMaybe<StringFilter>;
  measureUnitCode?: InputMaybe<StringFilter>;
  measureUnitDescription?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ProductBatchImportDetailFilter>;
  or?: InputMaybe<Array<ProductBatchImportDetailFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  productCode?: InputMaybe<StringFilter>;
  productDescription?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ProductBatchImportDetailsConnection = {
  __typename?: 'ProductBatchImportDetailsConnection';
  edges: Array<ProductBatchImportDetailsEdge>;
  nodes: Array<Maybe<ProductBatchImportDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductBatchImportDetailsEdge = {
  __typename?: 'ProductBatchImportDetailsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ProductBatchImportDetail>;
};

export type ProductHomologation = {
  __typename?: 'ProductHomologation';
  activityCode: Scalars['String'];
  activityDescription: Scalars['String'];
  createdAt: Scalars['Datetime'];
  key: Scalars['String'];
  measureUnitCode: Scalars['Int'];
  measureUnitDescription: Scalars['String'];
  productCode: Scalars['Int'];
  productDescription: Scalars['String'];
  productKey: Scalars['String'];
  productService?: Maybe<Product>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ProductHomologationInput = {
  activityCode: Scalars['String'];
  measureUnitCode: Scalars['Int'];
  productCode: Scalars['Int'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkProductHomologationToProductInput>;
};

export type ProductHomologationOnProductHomologationForFkProductHomologationToProductUsingPkProductHomologationUpdate = {
  key: Scalars['String'];
  patch: UpdateProductHomologationOnProductHomologationForFkProductHomologationToProductPatch;
};

export type ProductHomologationOnProductHomologationForFkProductHomologationToProductUsingUkProductHomologationProductKeyUpdate = {
  patch: UpdateProductHomologationOnProductHomologationForFkProductHomologationToProductPatch;
  productKey: Scalars['String'];
};

export type ProductHomologationPatch = {
  activityCode?: InputMaybe<Scalars['String']>;
  measureUnitCode?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['Int']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkProductHomologationToProductInput>;
};

export type ProductHomologationPkProductHomologationConnect = {
  key: Scalars['String'];
};

export type ProductHomologationUkProductHomologationProductKeyConnect = {
  productKey: Scalars['String'];
};

export type ProductHomologationsConnection = {
  __typename?: 'ProductHomologationsConnection';
  edges: Array<ProductHomologationsEdge>;
  nodes: Array<Maybe<ProductHomologation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductHomologationsEdge = {
  __typename?: 'ProductHomologationsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ProductHomologation>;
};

export type ProductInput = {
  code?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type: ProductType;
};

export type ProductOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductUsingPkProductUpdate = {
  key: Scalars['String'];
  patch: UpdateProductOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductPatch;
};

export type ProductOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductUsingPkProductUpdate = {
  key: Scalars['String'];
  patch: UpdateProductOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductPatch;
};

export type ProductOnProductHomologationForFkProductHomologationToProductUsingPkProductUpdate = {
  key: Scalars['String'];
  patch: UpdateProductOnProductHomologationForFkProductHomologationToProductPatch;
};

export type ProductOnRentalOrderDetailForFkRentalOrderDetailToProductUsingPkProductUpdate = {
  key: Scalars['String'];
  patch: UpdateProductOnRentalOrderDetailForFkRentalOrderDetailToProductPatch;
};

export type ProductOnSaleOrderDetailForFkSaleOrderDetailToProductUsingPkProductUpdate = {
  key: Scalars['String'];
  patch: UpdateProductOnSaleOrderDetailForFkSaleOrderDetailToProductPatch;
};

export type ProductOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductUsingPkProductUpdate = {
  key: Scalars['String'];
  patch: UpdateProductOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductPatch;
};

export type ProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type ProductPkProductConnect = {
  key: Scalars['String'];
};

export type ProductTmp = {
  __typename?: 'ProductTmp';
  code: Scalars['String'];
  description: Scalars['String'];
  homActivityCode: Scalars['String'];
  homMeasureUnit: Scalars['String'];
  homProductCode: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  type: Scalars['String'];
};

export type ProductTmpCondition = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  homActivityCode?: InputMaybe<Scalars['String']>;
  homMeasureUnit?: InputMaybe<Scalars['String']>;
  homProductCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProductTmpFilter = {
  and?: InputMaybe<Array<ProductTmpFilter>>;
  code?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  homActivityCode?: InputMaybe<StringFilter>;
  homMeasureUnit?: InputMaybe<StringFilter>;
  homProductCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  not?: InputMaybe<ProductTmpFilter>;
  or?: InputMaybe<Array<ProductTmpFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ProductTmpInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  homActivityCode: Scalars['String'];
  homMeasureUnit: Scalars['String'];
  homProductCode: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price: Scalars['BigFloat'];
  type: Scalars['String'];
};

export type ProductTmpsConnection = {
  __typename?: 'ProductTmpsConnection';
  edges: Array<ProductTmpsEdge>;
  nodes: Array<Maybe<ProductTmp>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductTmpsEdge = {
  __typename?: 'ProductTmpsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ProductTmp>;
};

export enum ProductTmpsOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  HomActivityCodeAsc = 'HOM_ACTIVITY_CODE_ASC',
  HomActivityCodeDesc = 'HOM_ACTIVITY_CODE_DESC',
  HomMeasureUnitAsc = 'HOM_MEASURE_UNIT_ASC',
  HomMeasureUnitDesc = 'HOM_MEASURE_UNIT_DESC',
  HomProductCodeAsc = 'HOM_PRODUCT_CODE_ASC',
  HomProductCodeDesc = 'HOM_PRODUCT_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export enum ProductType {
  Product = 'PRODUCT',
  Service = 'SERVICE'
}

export type ProductTypeFilter = {
  distinctFrom?: InputMaybe<ProductType>;
  equalTo?: InputMaybe<ProductType>;
  greaterThan?: InputMaybe<ProductType>;
  greaterThanOrEqualTo?: InputMaybe<ProductType>;
  in?: InputMaybe<Array<ProductType>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<ProductType>;
  lessThanOrEqualTo?: InputMaybe<ProductType>;
  notDistinctFrom?: InputMaybe<ProductType>;
  notEqualTo?: InputMaybe<ProductType>;
  notIn?: InputMaybe<Array<ProductType>>;
};

export type ProductsEdge = {
  __typename?: 'ProductsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Product>;
};

export type Query = {
  __typename?: 'Query';
  accountByTenantKey?: Maybe<Account>;
  activeSubscription?: Maybe<ActiveSubscription>;
  allDelegatedTokens?: Maybe<AllDelegatedTokensConnection>;
  allDigitalSignatures?: Maybe<AllDigitalSignaturesConnection>;
  allSubscriptionCharges?: Maybe<AllSubscriptionChargesConnection>;
  allSubscriptionPeriods?: Maybe<AllSubscriptionPeriodsConnection>;
  allTenants?: Maybe<AllTenantsConnection>;
  allUsers?: Maybe<AllUsersConnection>;
  branchOffice?: Maybe<BranchOffice>;
  client?: Maybe<Client>;
  clientHomologation?: Maybe<ClientHomologation>;
  clientHomologationByClientKey?: Maybe<ClientHomologation>;
  comboTenants?: Maybe<ComboTenantsConnection>;
  cufdByKey?: Maybe<Cufd>;
  cuisByKey?: Maybe<Cuis>;
  currentBillingInfo?: Maybe<CurrentBillingInfo>;
  currentPermissions?: Maybe<UserPermissionRecordsConnection>;
  currentTenantInfo?: Maybe<CurrentTenantInfo>;
  currentUser?: Maybe<User>;
  downloadInvoice: File;
  downloadOrders: File;
  downloadProducts: File;
  downloadRegisterFile: File;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderByOrderKey?: Maybe<ExportServiceOrder>;
  exportServiceOrderDetail?: Maybe<ExportServiceOrderDetail>;
  exportServiceOrderDetails?: Maybe<ExportServiceOrderDetailsConnection>;
  exportServiceOrders?: Maybe<ExportServiceOrdersConnection>;
  getParameter?: Maybe<Parameter>;
  getRegisterFilesByTenantKey?: Maybe<FilesConnection>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderByOrderKey?: Maybe<InsuranceOrder>;
  insuranceOrderDetail?: Maybe<InsuranceOrderDetail>;
  insuranceOrderDetails?: Maybe<InsuranceOrderDetailsConnection>;
  insuranceOrders?: Maybe<InsuranceOrdersConnection>;
  invoiceByKey?: Maybe<Invoice>;
  invoiceCancellationByKey?: Maybe<InvoiceCancellation>;
  invoiceRestorationByKey?: Maybe<InvoiceRestoration>;
  messages: MessagesPayload;
  notifications?: Maybe<NotificationsConnection>;
  order?: Maybe<Order>;
  orderHomologation?: Maybe<OrderHomologation>;
  orderHomologationByOrderKey?: Maybe<OrderHomologation>;
  ownRoles?: Maybe<OwnRolesConnection>;
  ownSubscriptionPeriods?: Maybe<OwnSubscriptionPeriodsConnection>;
  ownUsers?: Maybe<OwnUsersConnection>;
  packageByKey?: Maybe<Package>;
  packageInvoices?: Maybe<InvoicesConnection>;
  paymentMethodInfoByCode?: Maybe<PaymentMethodInfo>;
  person?: Maybe<Person>;
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleUser?: Maybe<PointOfSaleUser>;
  product?: Maybe<Product>;
  productBatchImport?: Maybe<ProductBatchImport>;
  productHomologation?: Maybe<ProductHomologation>;
  productHomologationByProductKey?: Maybe<ProductHomologation>;
  productTmps?: Maybe<ProductTmpsConnection>;
  query: Query;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderByOrderKey?: Maybe<RentalOrder>;
  rentalOrderDetail?: Maybe<RentalOrderDetail>;
  rentalOrderDetails?: Maybe<RentalOrderDetailsConnection>;
  rentalOrders?: Maybe<RentalOrdersConnection>;
  role: Role;
  rolesByUserKey?: Maybe<Array<Role>>;
  saleOrder?: Maybe<SaleOrder>;
  saleOrderByOrderKey?: Maybe<SaleOrder>;
  saleOrderDetail?: Maybe<SaleOrderDetail>;
  sectorDocumentInvoiceTypes?: Maybe<SectorDocumentInvoiceTypesConnection>;
  sectorDocumentInvoiceTypesByActivityCode?: Maybe<SectorDocumentInvoiceTypesConnection>;
  sectorDocumentsByActivityCode?: Maybe<SyncParametersConnection>;
  significantEventByKey?: Maybe<SignificantEvent>;
  sinVerifyNit: Scalars['Boolean'];
  sinVerifyNitOnRegister: SinVerifyNitPayload;
  syncActivities?: Maybe<SyncActivitiesConnection>;
  syncActivitySectorDocuments?: Maybe<SyncActivitySectorDocumentsConnection>;
  syncDatetimes?: Maybe<SyncDatetimesConnection>;
  syncInvoiceLegends?: Maybe<SyncInvoiceLegendsConnection>;
  syncRequestByKey?: Maybe<SyncRequest>;
  syncRequestsSummary?: Maybe<SyncRequestsConnection>;
  tenantFullInfo?: Maybe<TenantFullInfo>;
  tenantSubscription?: Maybe<TenantSubscription>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderByOrderKey?: Maybe<TouristServiceOrder>;
  touristServiceOrderDetail?: Maybe<TouristServiceOrderDetail>;
  touristServiceOrderDetails?: Maybe<TouristServiceOrderDetailsConnection>;
  touristServiceOrders?: Maybe<TouristServiceOrdersConnection>;
  user?: Maybe<User>;
  users?: Maybe<UsersConnection>;
  viewAllClients?: Maybe<ViewAllClientsConnection>;
  viewBranchOffices?: Maybe<ViewBranchOfficesConnection>;
  viewClients?: Maybe<ViewClientsConnection>;
  viewCufdCodes?: Maybe<ViewCufdCodesConnection>;
  viewCuisCodes?: Maybe<ViewCuisCodesConnection>;
  viewDelegatedTokens?: Maybe<ViewDelegatedTokensConnection>;
  viewDigitalSignatures?: Maybe<ViewDigitalSignaturesConnection>;
  viewInvoices?: Maybe<ViewInvoicesConnection>;
  viewOrders?: Maybe<ViewOrdersConnection>;
  viewPackageInvoices?: Maybe<ViewPackageInvoicesConnection>;
  viewPackages?: Maybe<ViewPackagesConnection>;
  viewPaymentMethods?: Maybe<ViewPaymentMethodsConnection>;
  viewPointOfSales?: Maybe<ViewPointOfSalesConnection>;
  viewProducts?: Maybe<ViewProductsConnection>;
  viewRoles?: Maybe<ViewRolesConnection>;
  viewSignificantEvents?: Maybe<ViewSignificantEventsConnection>;
  viewSyncParameters?: Maybe<ViewSyncParametersConnection>;
  viewSyncProducts?: Maybe<ViewSyncProductsConnection>;
  viewSyncRequests?: Maybe<ViewSyncRequestsConnection>;
};


export type QueryAccountByTenantKeyArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QueryAllDelegatedTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllDelegatedTokenCondition>;
  filter?: InputMaybe<AllDelegatedTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllDelegatedTokensOrderBy>>;
};


export type QueryAllDigitalSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllDigitalSignatureCondition>;
  filter?: InputMaybe<AllDigitalSignatureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllDigitalSignaturesOrderBy>>;
};


export type QueryAllSubscriptionChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllSubscriptionChargeCondition>;
  filter?: InputMaybe<AllSubscriptionChargeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSubscriptionChargesOrderBy>>;
};


export type QueryAllSubscriptionPeriodsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllSubscriptionPeriodCondition>;
  filter?: InputMaybe<AllSubscriptionPeriodFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSubscriptionPeriodsOrderBy>>;
};


export type QueryAllTenantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllTenantCondition>;
  filter?: InputMaybe<AllTenantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllTenantsOrderBy>>;
};


export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AllUserCondition>;
  filter?: InputMaybe<AllUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllUsersOrderBy>>;
};


export type QueryBranchOfficeArgs = {
  key: Scalars['String'];
};


export type QueryClientArgs = {
  key: Scalars['String'];
};


export type QueryClientHomologationArgs = {
  key: Scalars['String'];
};


export type QueryClientHomologationByClientKeyArgs = {
  clientKey: Scalars['String'];
};


export type QueryComboTenantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ComboTenantCondition>;
  filter?: InputMaybe<ComboTenantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ComboTenantsOrderBy>>;
};


export type QueryCufdByKeyArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QueryCuisByKeyArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QueryCurrentPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserPermissionRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryDownloadInvoiceArgs = {
  key: Scalars['String'];
};


export type QueryDownloadRegisterFileArgs = {
  uuid: Scalars['String'];
};


export type QueryExportServiceOrderArgs = {
  key: Scalars['String'];
};


export type QueryExportServiceOrderByOrderKeyArgs = {
  orderKey: Scalars['String'];
};


export type QueryExportServiceOrderDetailArgs = {
  key: Scalars['String'];
};


export type QueryExportServiceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExportServiceOrderDetailCondition>;
  filter?: InputMaybe<ExportServiceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExportServiceOrderDetailsOrderBy>>;
};


export type QueryExportServiceOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExportServiceOrderCondition>;
  filter?: InputMaybe<ExportServiceOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExportServiceOrdersOrderBy>>;
};


export type QueryGetParameterArgs = {
  classifier: Scalars['String'];
  code: Scalars['String'];
};


export type QueryGetRegisterFilesByTenantKeyArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryInsuranceOrderArgs = {
  key: Scalars['String'];
};


export type QueryInsuranceOrderByOrderKeyArgs = {
  orderKey: Scalars['String'];
};


export type QueryInsuranceOrderDetailArgs = {
  key: Scalars['String'];
};


export type QueryInsuranceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceOrderDetailCondition>;
  filter?: InputMaybe<InsuranceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceOrderDetailsOrderBy>>;
};


export type QueryInsuranceOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InsuranceOrderCondition>;
  filter?: InputMaybe<InsuranceOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsuranceOrdersOrderBy>>;
};


export type QueryInvoiceByKeyArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceCancellationByKeyArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceRestorationByKeyArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QueryMessagesArgs = {
  input?: InputMaybe<MessagesInput>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type QueryOrderArgs = {
  key: Scalars['String'];
};


export type QueryOrderHomologationArgs = {
  key: Scalars['String'];
};


export type QueryOrderHomologationByOrderKeyArgs = {
  orderKey: Scalars['String'];
};


export type QueryOwnRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OwnRoleCondition>;
  filter?: InputMaybe<OwnRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OwnRolesOrderBy>>;
};


export type QueryOwnSubscriptionPeriodsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OwnSubscriptionPeriodCondition>;
  filter?: InputMaybe<OwnSubscriptionPeriodFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OwnSubscriptionPeriodsOrderBy>>;
};


export type QueryOwnUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OwnUserCondition>;
  filter?: InputMaybe<OwnUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OwnUsersOrderBy>>;
};


export type QueryPackageByKeyArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QueryPackageInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<InvoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentMethodInfoByCodeArgs = {
  code: Scalars['Int'];
};


export type QueryPersonArgs = {
  key: Scalars['String'];
};


export type QueryPointOfSaleArgs = {
  key: Scalars['String'];
};


export type QueryPointOfSaleUserArgs = {
  key: Scalars['String'];
};


export type QueryProductArgs = {
  key: Scalars['String'];
};


export type QueryProductBatchImportArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QueryProductHomologationArgs = {
  key: Scalars['String'];
};


export type QueryProductHomologationByProductKeyArgs = {
  productKey: Scalars['String'];
};


export type QueryProductTmpsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductTmpCondition>;
  filter?: InputMaybe<ProductTmpFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductTmpsOrderBy>>;
};


export type QueryRentalOrderArgs = {
  key: Scalars['String'];
};


export type QueryRentalOrderByOrderKeyArgs = {
  orderKey: Scalars['String'];
};


export type QueryRentalOrderDetailArgs = {
  key: Scalars['String'];
};


export type QueryRentalOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RentalOrderDetailCondition>;
  filter?: InputMaybe<RentalOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RentalOrderDetailsOrderBy>>;
};


export type QueryRentalOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RentalOrderCondition>;
  filter?: InputMaybe<RentalOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RentalOrdersOrderBy>>;
};


export type QueryRoleArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QueryRolesByUserKeyArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type QuerySaleOrderArgs = {
  key: Scalars['String'];
};


export type QuerySaleOrderByOrderKeyArgs = {
  orderKey: Scalars['String'];
};


export type QuerySaleOrderDetailArgs = {
  key: Scalars['String'];
};


export type QuerySectorDocumentInvoiceTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SectorDocumentInvoiceTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySectorDocumentInvoiceTypesByActivityCodeArgs = {
  activityCode: Scalars['String'];
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SectorDocumentInvoiceTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySectorDocumentsByActivityCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  code: Scalars['String'];
  filter?: InputMaybe<SyncParameterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySignificantEventByKeyArgs = {
  pkey?: InputMaybe<Scalars['String']>;
};


export type QuerySinVerifyNitArgs = {
  nit: Scalars['BigFloat'];
};


export type QuerySinVerifyNitOnRegisterArgs = {
  nit: Scalars['BigFloat'];
};


export type QuerySyncActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SyncActivityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySyncActivitySectorDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SyncActivitySectorDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySyncDatetimesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SyncDatetimeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySyncInvoiceLegendsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SyncInvoiceLegendFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySyncRequestByKeyArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QuerySyncRequestsSummaryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SyncRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTenantFullInfoArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QueryTenantSubscriptionArgs = {
  pKey?: InputMaybe<Scalars['String']>;
};


export type QueryTouristServiceOrderArgs = {
  key: Scalars['String'];
};


export type QueryTouristServiceOrderByOrderKeyArgs = {
  orderKey: Scalars['String'];
};


export type QueryTouristServiceOrderDetailArgs = {
  key: Scalars['String'];
};


export type QueryTouristServiceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TouristServiceOrderDetailCondition>;
  filter?: InputMaybe<TouristServiceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TouristServiceOrderDetailsOrderBy>>;
};


export type QueryTouristServiceOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TouristServiceOrderCondition>;
  filter?: InputMaybe<TouristServiceOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TouristServiceOrdersOrderBy>>;
};


export type QueryUserArgs = {
  key: Scalars['String'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryViewAllClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewAllClientCondition>;
  filter?: InputMaybe<ViewAllClientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewAllClientsOrderBy>>;
};


export type QueryViewBranchOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewBranchOfficeCondition>;
  filter?: InputMaybe<ViewBranchOfficeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewBranchOfficesOrderBy>>;
};


export type QueryViewClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewClientCondition>;
  filter?: InputMaybe<ViewClientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewClientsOrderBy>>;
};


export type QueryViewCufdCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewCufdCodeCondition>;
  filter?: InputMaybe<ViewCufdCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewCufdCodesOrderBy>>;
};


export type QueryViewCuisCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewCuisCodeCondition>;
  filter?: InputMaybe<ViewCuisCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewCuisCodesOrderBy>>;
};


export type QueryViewDelegatedTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewDelegatedTokenCondition>;
  filter?: InputMaybe<ViewDelegatedTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewDelegatedTokensOrderBy>>;
};


export type QueryViewDigitalSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewDigitalSignatureCondition>;
  filter?: InputMaybe<ViewDigitalSignatureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewDigitalSignaturesOrderBy>>;
};


export type QueryViewInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewInvoiceCondition>;
  filter?: InputMaybe<ViewInvoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewInvoicesOrderBy>>;
};


export type QueryViewOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewOrderCondition>;
  filter?: InputMaybe<ViewOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewOrdersOrderBy>>;
};


export type QueryViewPackageInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewPackageInvoiceCondition>;
  filter?: InputMaybe<ViewPackageInvoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewPackageInvoicesOrderBy>>;
};


export type QueryViewPackagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewPackageCondition>;
  filter?: InputMaybe<ViewPackageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewPackagesOrderBy>>;
};


export type QueryViewPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewPaymentMethodCondition>;
  filter?: InputMaybe<ViewPaymentMethodFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewPaymentMethodsOrderBy>>;
};


export type QueryViewPointOfSalesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewPointOfSaleCondition>;
  filter?: InputMaybe<ViewPointOfSaleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewPointOfSalesOrderBy>>;
};


export type QueryViewProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewProductCondition>;
  filter?: InputMaybe<ViewProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewProductsOrderBy>>;
};


export type QueryViewRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewRoleCondition>;
  filter?: InputMaybe<ViewRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewRolesOrderBy>>;
};


export type QueryViewSignificantEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewSignificantEventCondition>;
  filter?: InputMaybe<ViewSignificantEventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewSignificantEventsOrderBy>>;
};


export type QueryViewSyncParametersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewSyncParameterCondition>;
  filter?: InputMaybe<ViewSyncParameterFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewSyncParametersOrderBy>>;
};


export type QueryViewSyncProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewSyncProductCondition>;
  filter?: InputMaybe<ViewSyncProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewSyncProductsOrderBy>>;
};


export type QueryViewSyncRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ViewSyncRequestCondition>;
  filter?: InputMaybe<ViewSyncRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewSyncRequestsOrderBy>>;
};

export type RentalOrder = {
  __typename?: 'RentalOrder';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  key: Scalars['String'];
  order?: Maybe<Order>;
  orderKey: Scalars['String'];
  period?: Maybe<Scalars['String']>;
  rentalOrderDetails: RentalOrderDetailsConnection;
  tenantId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};


export type RentalOrderRentalOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RentalOrderDetailCondition>;
  filter?: InputMaybe<RentalOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RentalOrderDetailsOrderBy>>;
};

export type RentalOrderCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  orderKey?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type RentalOrderDetail = {
  __typename?: 'RentalOrderDetail';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  discount: Scalars['BigFloat'];
  key: Scalars['String'];
  price: Scalars['BigFloat'];
  productKey: Scalars['String'];
  productService?: Maybe<Product>;
  quantity: Scalars['BigFloat'];
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderKey: Scalars['String'];
  subtotal: Scalars['BigFloat'];
  tenantId: Scalars['Int'];
  total: Scalars['BigFloat'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type RentalOrderDetailCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  key?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderKey?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type RentalOrderDetailFilter = {
  and?: InputMaybe<Array<RentalOrderDetailFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  discount?: InputMaybe<BigFloatFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<RentalOrderDetailFilter>;
  or?: InputMaybe<Array<RentalOrderDetailFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  productKey?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<BigFloatFilter>;
  rentalOrderKey?: InputMaybe<StringFilter>;
  subtotal?: InputMaybe<BigFloatFilter>;
  tenantId?: InputMaybe<IntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type RentalOrderDetailInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkRentalOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  rentalOrder?: InputMaybe<FkRentalOrderDetailToRentalOrderInput>;
  rentalOrderKey?: InputMaybe<Scalars['String']>;
};

export type RentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToProductUsingPkRentalOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateRentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToProductPatch;
};

export type RentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderUsingPkRentalOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateRentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderPatch;
};

export type RentalOrderDetailPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkRentalOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  rentalOrder?: InputMaybe<FkRentalOrderDetailToRentalOrderInput>;
  rentalOrderKey?: InputMaybe<Scalars['String']>;
};

export type RentalOrderDetailPkRentalOrderDetailConnect = {
  key: Scalars['String'];
};

export type RentalOrderDetailPkRentalOrderDetailDelete = {
  key: Scalars['String'];
};

export type RentalOrderDetailsConnection = {
  __typename?: 'RentalOrderDetailsConnection';
  edges: Array<RentalOrderDetailsEdge>;
  nodes: Array<Maybe<RentalOrderDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RentalOrderDetailsEdge = {
  __typename?: 'RentalOrderDetailsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<RentalOrderDetail>;
};

export enum RentalOrderDetailsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  DiscountAsc = 'DISCOUNT_ASC',
  DiscountDesc = 'DISCOUNT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductByProductKeyCodeAsc = 'PRODUCT_BY_PRODUCT_KEY__CODE_ASC',
  ProductByProductKeyCodeDesc = 'PRODUCT_BY_PRODUCT_KEY__CODE_DESC',
  ProductByProductKeyCreatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_ASC',
  ProductByProductKeyCreatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_DESC',
  ProductByProductKeyCreatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_ASC',
  ProductByProductKeyCreatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_DESC',
  ProductByProductKeyDeletedAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_ASC',
  ProductByProductKeyDeletedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_ASC',
  ProductByProductKeyDeletedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_DESC',
  ProductByProductKeyDeletedByAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_ASC',
  ProductByProductKeyDeletedByDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_DESC',
  ProductByProductKeyDeletedDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_DESC',
  ProductByProductKeyDescriptionAsc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_ASC',
  ProductByProductKeyDescriptionDesc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_DESC',
  ProductByProductKeyKeyAsc = 'PRODUCT_BY_PRODUCT_KEY__KEY_ASC',
  ProductByProductKeyKeyDesc = 'PRODUCT_BY_PRODUCT_KEY__KEY_DESC',
  ProductByProductKeyNameAsc = 'PRODUCT_BY_PRODUCT_KEY__NAME_ASC',
  ProductByProductKeyNameDesc = 'PRODUCT_BY_PRODUCT_KEY__NAME_DESC',
  ProductByProductKeyPriceAsc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_ASC',
  ProductByProductKeyPriceDesc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_DESC',
  ProductByProductKeyTenantIdAsc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_ASC',
  ProductByProductKeyTenantIdDesc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_DESC',
  ProductByProductKeyTypeAsc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_ASC',
  ProductByProductKeyTypeDesc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_DESC',
  ProductByProductKeyUpdatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_ASC',
  ProductByProductKeyUpdatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_DESC',
  ProductByProductKeyUpdatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_ASC',
  ProductByProductKeyUpdatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_DESC',
  ProductKeyAsc = 'PRODUCT_KEY_ASC',
  ProductKeyDesc = 'PRODUCT_KEY_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  RentalOrderByRentalOrderKeyCreatedAtAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__CREATED_AT_ASC',
  RentalOrderByRentalOrderKeyCreatedAtDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__CREATED_AT_DESC',
  RentalOrderByRentalOrderKeyCreatedByAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__CREATED_BY_ASC',
  RentalOrderByRentalOrderKeyCreatedByDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__CREATED_BY_DESC',
  RentalOrderByRentalOrderKeyDeletedAtAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__DELETED_AT_ASC',
  RentalOrderByRentalOrderKeyDeletedAtDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__DELETED_AT_DESC',
  RentalOrderByRentalOrderKeyDeletedByAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__DELETED_BY_ASC',
  RentalOrderByRentalOrderKeyDeletedByDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__DELETED_BY_DESC',
  RentalOrderByRentalOrderKeyDeletionAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__DELETION_ASC',
  RentalOrderByRentalOrderKeyDeletionDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__DELETION_DESC',
  RentalOrderByRentalOrderKeyKeyAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__KEY_ASC',
  RentalOrderByRentalOrderKeyKeyDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__KEY_DESC',
  RentalOrderByRentalOrderKeyOrderKeyAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__ORDER_KEY_ASC',
  RentalOrderByRentalOrderKeyOrderKeyDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__ORDER_KEY_DESC',
  RentalOrderByRentalOrderKeyPeriodAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__PERIOD_ASC',
  RentalOrderByRentalOrderKeyPeriodDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__PERIOD_DESC',
  RentalOrderByRentalOrderKeyTenantIdAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__TENANT_ID_ASC',
  RentalOrderByRentalOrderKeyTenantIdDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__TENANT_ID_DESC',
  RentalOrderByRentalOrderKeyUpdatedAtAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__UPDATED_AT_ASC',
  RentalOrderByRentalOrderKeyUpdatedAtDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__UPDATED_AT_DESC',
  RentalOrderByRentalOrderKeyUpdatedByAsc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__UPDATED_BY_ASC',
  RentalOrderByRentalOrderKeyUpdatedByDesc = 'RENTAL_ORDER_BY_RENTAL_ORDER_KEY__UPDATED_BY_DESC',
  RentalOrderKeyAsc = 'RENTAL_ORDER_KEY_ASC',
  RentalOrderKeyDesc = 'RENTAL_ORDER_KEY_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type RentalOrderFilter = {
  and?: InputMaybe<Array<RentalOrderFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<RentalOrderFilter>;
  or?: InputMaybe<Array<RentalOrderFilter>>;
  orderKey?: InputMaybe<StringFilter>;
  period?: InputMaybe<StringFilter>;
  tenantId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type RentalOrderInput = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<FkRentalOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToRentalOrderInverseInput>;
};

export type RentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderUsingPkRentalOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateRentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderPatch;
};

export type RentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderUsingUkRentalOrderOrderIdUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateRentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderPatch;
};

export type RentalOrderOnRentalOrderForFkRentalOrderToOrderUsingPkRentalOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateRentalOrderOnRentalOrderForFkRentalOrderToOrderPatch;
};

export type RentalOrderOnRentalOrderForFkRentalOrderToOrderUsingUkRentalOrderOrderIdUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateRentalOrderOnRentalOrderForFkRentalOrderToOrderPatch;
};

export type RentalOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<FkRentalOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToRentalOrderInverseInput>;
};

export type RentalOrderPkRentalOrderConnect = {
  key: Scalars['String'];
};

export type RentalOrderPkRentalOrderDelete = {
  key: Scalars['String'];
};

export type RentalOrderUkRentalOrderOrderIdConnect = {
  orderKey: Scalars['String'];
};

export type RentalOrderUkRentalOrderOrderIdDelete = {
  orderKey: Scalars['String'];
};

export type RentalOrdersConnection = {
  __typename?: 'RentalOrdersConnection';
  edges: Array<RentalOrdersEdge>;
  nodes: Array<Maybe<RentalOrder>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RentalOrdersEdge = {
  __typename?: 'RentalOrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<RentalOrder>;
};

export enum RentalOrdersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  OrderByOrderKeyChangeAmountAsc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_ASC',
  OrderByOrderKeyChangeAmountDesc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_DESC',
  OrderByOrderKeyClientKeyAsc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_ASC',
  OrderByOrderKeyClientKeyDesc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_DESC',
  OrderByOrderKeyCreatedAtAsc = 'ORDER_BY_ORDER_KEY__CREATED_AT_ASC',
  OrderByOrderKeyCreatedAtDesc = 'ORDER_BY_ORDER_KEY__CREATED_AT_DESC',
  OrderByOrderKeyCreatedByAsc = 'ORDER_BY_ORDER_KEY__CREATED_BY_ASC',
  OrderByOrderKeyCreatedByDesc = 'ORDER_BY_ORDER_KEY__CREATED_BY_DESC',
  OrderByOrderKeyDeletedAtAsc = 'ORDER_BY_ORDER_KEY__DELETED_AT_ASC',
  OrderByOrderKeyDeletedAtDesc = 'ORDER_BY_ORDER_KEY__DELETED_AT_DESC',
  OrderByOrderKeyDeletedByAsc = 'ORDER_BY_ORDER_KEY__DELETED_BY_ASC',
  OrderByOrderKeyDeletedByDesc = 'ORDER_BY_ORDER_KEY__DELETED_BY_DESC',
  OrderByOrderKeyDeletionAsc = 'ORDER_BY_ORDER_KEY__DELETION_ASC',
  OrderByOrderKeyDeletionDesc = 'ORDER_BY_ORDER_KEY__DELETION_DESC',
  OrderByOrderKeyDiscountAsc = 'ORDER_BY_ORDER_KEY__DISCOUNT_ASC',
  OrderByOrderKeyDiscountDesc = 'ORDER_BY_ORDER_KEY__DISCOUNT_DESC',
  OrderByOrderKeyEmailAsc = 'ORDER_BY_ORDER_KEY__EMAIL_ASC',
  OrderByOrderKeyEmailDesc = 'ORDER_BY_ORDER_KEY__EMAIL_DESC',
  OrderByOrderKeyKeyAsc = 'ORDER_BY_ORDER_KEY__KEY_ASC',
  OrderByOrderKeyKeyDesc = 'ORDER_BY_ORDER_KEY__KEY_DESC',
  OrderByOrderKeyPaymentAmountAsc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_ASC',
  OrderByOrderKeyPaymentAmountDesc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_DESC',
  OrderByOrderKeyPhoneNumberAsc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_ASC',
  OrderByOrderKeyPhoneNumberDesc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_DESC',
  OrderByOrderKeyPointOfSaleKeyAsc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_ASC',
  OrderByOrderKeyPointOfSaleKeyDesc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_DESC',
  OrderByOrderKeyQuantityAsc = 'ORDER_BY_ORDER_KEY__QUANTITY_ASC',
  OrderByOrderKeyQuantityDesc = 'ORDER_BY_ORDER_KEY__QUANTITY_DESC',
  OrderByOrderKeyStatusAsc = 'ORDER_BY_ORDER_KEY__STATUS_ASC',
  OrderByOrderKeyStatusDesc = 'ORDER_BY_ORDER_KEY__STATUS_DESC',
  OrderByOrderKeySubtotalAsc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_ASC',
  OrderByOrderKeySubtotalDesc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_DESC',
  OrderByOrderKeyTenantIdAsc = 'ORDER_BY_ORDER_KEY__TENANT_ID_ASC',
  OrderByOrderKeyTenantIdDesc = 'ORDER_BY_ORDER_KEY__TENANT_ID_DESC',
  OrderByOrderKeyTotalAsc = 'ORDER_BY_ORDER_KEY__TOTAL_ASC',
  OrderByOrderKeyTotalDesc = 'ORDER_BY_ORDER_KEY__TOTAL_DESC',
  OrderByOrderKeyUpdatedAtAsc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_ASC',
  OrderByOrderKeyUpdatedAtDesc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_DESC',
  OrderByOrderKeyUpdatedByAsc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_ASC',
  OrderByOrderKeyUpdatedByDesc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_DESC',
  OrderKeyAsc = 'ORDER_KEY_ASC',
  OrderKeyDesc = 'ORDER_KEY_DESC',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RentalOrderDetailsByRentalOrderKeyCountAsc = 'RENTAL_ORDER_DETAILS_BY_RENTAL_ORDER_KEY__COUNT_ASC',
  RentalOrderDetailsByRentalOrderKeyCountDesc = 'RENTAL_ORDER_DETAILS_BY_RENTAL_ORDER_KEY__COUNT_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type RequestPasswordResetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pEmail: Scalars['String'];
};

export type RequestPasswordResetPayload = {
  __typename?: 'RequestPasswordResetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export enum RequestStatus {
  Failed = 'FAILED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED',
  Success = 'SUCCESS'
}

export type RequestStatusFilter = {
  distinctFrom?: InputMaybe<RequestStatus>;
  equalTo?: InputMaybe<RequestStatus>;
  greaterThan?: InputMaybe<RequestStatus>;
  greaterThanOrEqualTo?: InputMaybe<RequestStatus>;
  in?: InputMaybe<Array<RequestStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<RequestStatus>;
  lessThanOrEqualTo?: InputMaybe<RequestStatus>;
  notDistinctFrom?: InputMaybe<RequestStatus>;
  notEqualTo?: InputMaybe<RequestStatus>;
  notIn?: InputMaybe<Array<RequestStatus>>;
};

export type RequestSyncInput = {
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  type: SyncRequestType;
};

export type RequestSyncPayload = {
  __typename?: 'RequestSyncPayload';
  syncRequest: SyncRequest;
};

export type ResentInvoiceInput = {
  key: Scalars['String'];
};

export type ResentInvoicePayload = {
  __typename?: 'ResentInvoicePayload';
  invoice?: Maybe<Invoice>;
  message?: Maybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pNewPassword: Scalars['String'];
  pToken: Scalars['String'];
};

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type RestoreInvoiceInput = {
  key: Scalars['String'];
};

export type RestoreInvoicePayload = {
  __typename?: 'RestoreInvoicePayload';
  code?: Maybe<Scalars['String']>;
  invoiceRestoration?: Maybe<InvoiceRestoration>;
  message?: Maybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<Permission>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SaleOrder = {
  __typename?: 'SaleOrder';
  createdAt: Scalars['Datetime'];
  giftCard: Scalars['BigFloat'];
  key: Scalars['String'];
  order?: Maybe<Order>;
  orderKey: Scalars['String'];
  saleOrderDetails: SaleOrderDetailsConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type SaleOrderSaleOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SaleOrderDetail = {
  __typename?: 'SaleOrderDetail';
  createdAt: Scalars['Datetime'];
  discount: Scalars['BigFloat'];
  key: Scalars['String'];
  price: Scalars['BigFloat'];
  productKey: Scalars['String'];
  productService?: Maybe<Product>;
  quantity: Scalars['BigFloat'];
  saleOrder?: Maybe<SaleOrder>;
  saleOrderKey: Scalars['String'];
  sinNumeroImei?: Maybe<Scalars['String']>;
  sinNumeroSerie?: Maybe<Scalars['String']>;
  subtotal: Scalars['BigFloat'];
  total: Scalars['BigFloat'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SaleOrderDetailInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkSaleOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  saleOrder?: InputMaybe<FkSaleOrderDetailToSaleOrderInput>;
  saleOrderKey?: InputMaybe<Scalars['String']>;
  sinNumeroImei?: InputMaybe<Scalars['String']>;
  sinNumeroSerie?: InputMaybe<Scalars['String']>;
};

export type SaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToProductUsingPkSaleOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateSaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToProductPatch;
};

export type SaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderUsingPkSaleOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateSaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderPatch;
};

export type SaleOrderDetailPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkSaleOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  saleOrder?: InputMaybe<FkSaleOrderDetailToSaleOrderInput>;
  saleOrderKey?: InputMaybe<Scalars['String']>;
  sinNumeroImei?: InputMaybe<Scalars['String']>;
  sinNumeroSerie?: InputMaybe<Scalars['String']>;
};

export type SaleOrderDetailPkSaleOrderDetailConnect = {
  key: Scalars['String'];
};

export type SaleOrderDetailsConnection = {
  __typename?: 'SaleOrderDetailsConnection';
  edges: Array<SaleOrderDetailsEdge>;
  nodes: Array<Maybe<SaleOrderDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SaleOrderDetailsEdge = {
  __typename?: 'SaleOrderDetailsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SaleOrderDetail>;
};

export type SaleOrderInput = {
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  order?: InputMaybe<FkSaleOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToSaleOrderInverseInput>;
};

export type SaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderUsingPkSaleOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateSaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderPatch;
};

export type SaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderUsingUkSaleOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateSaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderPatch;
};

export type SaleOrderOnSaleOrderForFkSaleOrderToOrderUsingPkSaleOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateSaleOrderOnSaleOrderForFkSaleOrderToOrderPatch;
};

export type SaleOrderOnSaleOrderForFkSaleOrderToOrderUsingUkSaleOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateSaleOrderOnSaleOrderForFkSaleOrderToOrderPatch;
};

export type SaleOrderPatch = {
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  order?: InputMaybe<FkSaleOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToSaleOrderInverseInput>;
};

export type SaleOrderPkSaleOrderConnect = {
  key: Scalars['String'];
};

export type SaleOrderUkSaleOrderOrderKeyConnect = {
  orderKey: Scalars['String'];
};

export type SaleOrdersConnection = {
  __typename?: 'SaleOrdersConnection';
  edges: Array<SaleOrdersEdge>;
  nodes: Array<Maybe<SaleOrder>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SaleOrdersEdge = {
  __typename?: 'SaleOrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SaleOrder>;
};

export type SaveSelectedTenantInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pTenantKey?: InputMaybe<Scalars['String']>;
};

export type SaveSelectedTenantPayload = {
  __typename?: 'SaveSelectedTenantPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type SectorDocumentInvoiceType = {
  __typename?: 'SectorDocumentInvoiceType';
  createdAt?: Maybe<Scalars['Datetime']>;
  createdBy?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['String']>;
  invoiceTypeCode?: Maybe<Scalars['Int']>;
  invoiceTypeDescription?: Maybe<Scalars['String']>;
  sectorDocumentCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type SectorDocumentInvoiceTypeFilter = {
  and?: InputMaybe<Array<SectorDocumentInvoiceTypeFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  description?: InputMaybe<StringFilter>;
  features?: InputMaybe<StringFilter>;
  invoiceTypeCode?: InputMaybe<IntFilter>;
  invoiceTypeDescription?: InputMaybe<StringFilter>;
  not?: InputMaybe<SectorDocumentInvoiceTypeFilter>;
  or?: InputMaybe<Array<SectorDocumentInvoiceTypeFilter>>;
  sectorDocumentCode?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type SectorDocumentInvoiceTypesConnection = {
  __typename?: 'SectorDocumentInvoiceTypesConnection';
  edges: Array<SectorDocumentInvoiceTypesEdge>;
  nodes: Array<Maybe<SectorDocumentInvoiceType>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SectorDocumentInvoiceTypesEdge = {
  __typename?: 'SectorDocumentInvoiceTypesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SectorDocumentInvoiceType>;
};

export type SendSignificantEventInput = {
  key: Scalars['String'];
};

export type SendSignificantEventPayload = {
  __typename?: 'SendSignificantEventPayload';
  significantEvent?: Maybe<SignificantEvent>;
};

export enum SendingStatus {
  NotSent = 'NOT_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type SendingStatusFilter = {
  distinctFrom?: InputMaybe<SendingStatus>;
  equalTo?: InputMaybe<SendingStatus>;
  greaterThan?: InputMaybe<SendingStatus>;
  greaterThanOrEqualTo?: InputMaybe<SendingStatus>;
  in?: InputMaybe<Array<SendingStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SendingStatus>;
  lessThanOrEqualTo?: InputMaybe<SendingStatus>;
  notDistinctFrom?: InputMaybe<SendingStatus>;
  notEqualTo?: InputMaybe<SendingStatus>;
  notIn?: InputMaybe<Array<SendingStatus>>;
};

export enum SendingType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type SendingTypeFilter = {
  distinctFrom?: InputMaybe<SendingType>;
  equalTo?: InputMaybe<SendingType>;
  greaterThan?: InputMaybe<SendingType>;
  greaterThanOrEqualTo?: InputMaybe<SendingType>;
  in?: InputMaybe<Array<SendingType>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SendingType>;
  lessThanOrEqualTo?: InputMaybe<SendingType>;
  notDistinctFrom?: InputMaybe<SendingType>;
  notEqualTo?: InputMaybe<SendingType>;
  notIn?: InputMaybe<Array<SendingType>>;
};

export type SignificantEvent = {
  __typename?: 'SignificantEvent';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  cafc?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cufd?: Maybe<Scalars['String']>;
  cufdEvent?: Maybe<Scalars['String']>;
  cuis?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  finishDate?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['Int']>;
  reasonDescription?: Maybe<Scalars['String']>;
  receptionCode?: Maybe<Scalars['BigInt']>;
  sendingStatus?: Maybe<Scalars['String']>;
  sendingType?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Datetime']>;
  startDate?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum SignificantEventStatus {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED',
  Success = 'SUCCESS'
}

export type SignificantEventStatusFilter = {
  distinctFrom?: InputMaybe<SignificantEventStatus>;
  equalTo?: InputMaybe<SignificantEventStatus>;
  greaterThan?: InputMaybe<SignificantEventStatus>;
  greaterThanOrEqualTo?: InputMaybe<SignificantEventStatus>;
  in?: InputMaybe<Array<SignificantEventStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SignificantEventStatus>;
  lessThanOrEqualTo?: InputMaybe<SignificantEventStatus>;
  notDistinctFrom?: InputMaybe<SignificantEventStatus>;
  notEqualTo?: InputMaybe<SignificantEventStatus>;
  notIn?: InputMaybe<Array<SignificantEventStatus>>;
};

export type SinGenerateMassiveCufdsInput = {
  pointOfSaleCodes: Array<InputMaybe<Scalars['Int']>>;
};

export type SinGenerateMassiveCufdsPayload = {
  __typename?: 'SinGenerateMassiveCufdsPayload';
  cufds: Array<Maybe<Cufd>>;
};

export type SinMessage = {
  __typename?: 'SinMessage';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SinVerifyNitPayload = {
  __typename?: 'SinVerifyNitPayload';
  isValid: Scalars['Boolean'];
};

export type StringFilter = {
  distinctFrom?: InputMaybe<Scalars['String']>;
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  equalTo?: InputMaybe<Scalars['String']>;
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  greaterThan?: InputMaybe<Scalars['String']>;
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  includes?: InputMaybe<Scalars['String']>;
  includesInsensitive?: InputMaybe<Scalars['String']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Scalars['String']>;
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  like?: InputMaybe<Scalars['String']>;
  likeInsensitive?: InputMaybe<Scalars['String']>;
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  notEndsWith?: InputMaybe<Scalars['String']>;
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  notEqualTo?: InputMaybe<Scalars['String']>;
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  notIncludes?: InputMaybe<Scalars['String']>;
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  notLike?: InputMaybe<Scalars['String']>;
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  notStartsWith?: InputMaybe<Scalars['String']>;
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

export type StringListFilter = {
  anyEqualTo?: InputMaybe<Scalars['String']>;
  anyGreaterThan?: InputMaybe<Scalars['String']>;
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  anyLessThan?: InputMaybe<Scalars['String']>;
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  anyNotEqualTo?: InputMaybe<Scalars['String']>;
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  userEvents?: Maybe<UserEvent>;
};

export enum SubscriptionChargeStatus {
  Paid = 'PAID',
  PendingPayment = 'PENDING_PAYMENT',
  Waived = 'WAIVED'
}

export type SubscriptionChargeStatusFilter = {
  distinctFrom?: InputMaybe<SubscriptionChargeStatus>;
  equalTo?: InputMaybe<SubscriptionChargeStatus>;
  greaterThan?: InputMaybe<SubscriptionChargeStatus>;
  greaterThanOrEqualTo?: InputMaybe<SubscriptionChargeStatus>;
  in?: InputMaybe<Array<SubscriptionChargeStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SubscriptionChargeStatus>;
  lessThanOrEqualTo?: InputMaybe<SubscriptionChargeStatus>;
  notDistinctFrom?: InputMaybe<SubscriptionChargeStatus>;
  notEqualTo?: InputMaybe<SubscriptionChargeStatus>;
  notIn?: InputMaybe<Array<SubscriptionChargeStatus>>;
};

export enum SubscriptionChargeType {
  FreePeriod = 'FREE_PERIOD',
  Manual = 'MANUAL',
  Overage = 'OVERAGE',
  Period = 'PERIOD',
  PeriodAndOverage = 'PERIOD_AND_OVERAGE'
}

export type SubscriptionChargeTypeFilter = {
  distinctFrom?: InputMaybe<SubscriptionChargeType>;
  equalTo?: InputMaybe<SubscriptionChargeType>;
  greaterThan?: InputMaybe<SubscriptionChargeType>;
  greaterThanOrEqualTo?: InputMaybe<SubscriptionChargeType>;
  in?: InputMaybe<Array<SubscriptionChargeType>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SubscriptionChargeType>;
  lessThanOrEqualTo?: InputMaybe<SubscriptionChargeType>;
  notDistinctFrom?: InputMaybe<SubscriptionChargeType>;
  notEqualTo?: InputMaybe<SubscriptionChargeType>;
  notIn?: InputMaybe<Array<SubscriptionChargeType>>;
};

export enum SubscriptionPeriodStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export type SubscriptionPeriodStatusFilter = {
  distinctFrom?: InputMaybe<SubscriptionPeriodStatus>;
  equalTo?: InputMaybe<SubscriptionPeriodStatus>;
  greaterThan?: InputMaybe<SubscriptionPeriodStatus>;
  greaterThanOrEqualTo?: InputMaybe<SubscriptionPeriodStatus>;
  in?: InputMaybe<Array<SubscriptionPeriodStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SubscriptionPeriodStatus>;
  lessThanOrEqualTo?: InputMaybe<SubscriptionPeriodStatus>;
  notDistinctFrom?: InputMaybe<SubscriptionPeriodStatus>;
  notEqualTo?: InputMaybe<SubscriptionPeriodStatus>;
  notIn?: InputMaybe<Array<SubscriptionPeriodStatus>>;
};

export type SubscriptionQuota = {
  __typename?: 'SubscriptionQuota';
  exceededAction?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  overageCurrency?: Maybe<Scalars['String']>;
  overagePrice?: Maybe<Scalars['BigFloat']>;
  type?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type SubscriptionQuotaFilter = {
  and?: InputMaybe<Array<SubscriptionQuotaFilter>>;
  exceededAction?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<SubscriptionQuotaFilter>;
  or?: InputMaybe<Array<SubscriptionQuotaFilter>>;
  overageCurrency?: InputMaybe<StringFilter>;
  overagePrice?: InputMaybe<BigFloatFilter>;
  type?: InputMaybe<StringFilter>;
  used?: InputMaybe<IntFilter>;
  value?: InputMaybe<IntFilter>;
};

export type SubscriptionQuotasConnection = {
  __typename?: 'SubscriptionQuotasConnection';
  edges: Array<SubscriptionQuotasEdge>;
  nodes: Array<Maybe<SubscriptionQuota>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SubscriptionQuotasEdge = {
  __typename?: 'SubscriptionQuotasEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SubscriptionQuota>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Suspended = 'SUSPENDED'
}

export type SubscriptionStatusFilter = {
  distinctFrom?: InputMaybe<SubscriptionStatus>;
  equalTo?: InputMaybe<SubscriptionStatus>;
  greaterThan?: InputMaybe<SubscriptionStatus>;
  greaterThanOrEqualTo?: InputMaybe<SubscriptionStatus>;
  in?: InputMaybe<Array<SubscriptionStatus>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SubscriptionStatus>;
  lessThanOrEqualTo?: InputMaybe<SubscriptionStatus>;
  notDistinctFrom?: InputMaybe<SubscriptionStatus>;
  notEqualTo?: InputMaybe<SubscriptionStatus>;
  notIn?: InputMaybe<Array<SubscriptionStatus>>;
};

export type SyncActivitiesConnection = {
  __typename?: 'SyncActivitiesConnection';
  edges: Array<SyncActivitiesEdge>;
  nodes: Array<Maybe<SyncActivity>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SyncActivitiesEdge = {
  __typename?: 'SyncActivitiesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SyncActivity>;
};

export type SyncActivity = {
  __typename?: 'SyncActivity';
  caebCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SyncActivityFilter = {
  and?: InputMaybe<Array<SyncActivityFilter>>;
  caebCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  not?: InputMaybe<SyncActivityFilter>;
  or?: InputMaybe<Array<SyncActivityFilter>>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type SyncActivitySectorDocument = {
  __typename?: 'SyncActivitySectorDocument';
  activityCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  sectorDocumentCode?: Maybe<Scalars['String']>;
  sectorDocumentType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SyncActivitySectorDocumentFilter = {
  activityCode?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<SyncActivitySectorDocumentFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  not?: InputMaybe<SyncActivitySectorDocumentFilter>;
  or?: InputMaybe<Array<SyncActivitySectorDocumentFilter>>;
  sectorDocumentCode?: InputMaybe<StringFilter>;
  sectorDocumentType?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type SyncActivitySectorDocumentsConnection = {
  __typename?: 'SyncActivitySectorDocumentsConnection';
  edges: Array<SyncActivitySectorDocumentsEdge>;
  nodes: Array<Maybe<SyncActivitySectorDocument>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SyncActivitySectorDocumentsEdge = {
  __typename?: 'SyncActivitySectorDocumentsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SyncActivitySectorDocument>;
};

export type SyncDatetime = {
  __typename?: 'SyncDatetime';
  createdAt?: Maybe<Scalars['Datetime']>;
  value?: Maybe<Scalars['String']>;
};

export type SyncDatetimeFilter = {
  and?: InputMaybe<Array<SyncDatetimeFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  not?: InputMaybe<SyncDatetimeFilter>;
  or?: InputMaybe<Array<SyncDatetimeFilter>>;
  value?: InputMaybe<StringFilter>;
};

export type SyncDatetimesConnection = {
  __typename?: 'SyncDatetimesConnection';
  edges: Array<SyncDatetimesEdge>;
  nodes: Array<Maybe<SyncDatetime>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SyncDatetimesEdge = {
  __typename?: 'SyncDatetimesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SyncDatetime>;
};

export type SyncInvoiceLegend = {
  __typename?: 'SyncInvoiceLegend';
  activityCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SyncInvoiceLegendFilter = {
  activityCode?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<SyncInvoiceLegendFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  not?: InputMaybe<SyncInvoiceLegendFilter>;
  or?: InputMaybe<Array<SyncInvoiceLegendFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type SyncInvoiceLegendsConnection = {
  __typename?: 'SyncInvoiceLegendsConnection';
  edges: Array<SyncInvoiceLegendsEdge>;
  nodes: Array<Maybe<SyncInvoiceLegend>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SyncInvoiceLegendsEdge = {
  __typename?: 'SyncInvoiceLegendsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SyncInvoiceLegend>;
};

export type SyncParameter = {
  __typename?: 'SyncParameter';
  classifierCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type SyncParameterFilter = {
  and?: InputMaybe<Array<SyncParameterFilter>>;
  classifierCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  not?: InputMaybe<SyncParameterFilter>;
  or?: InputMaybe<Array<SyncParameterFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export enum SyncParameterType {
  CancellationReason = 'CANCELLATION_REASON',
  Currency = 'CURRENCY',
  EmissionType = 'EMISSION_TYPE',
  IdentityDocumentType = 'IDENTITY_DOCUMENT_TYPE',
  InvoiceType = 'INVOICE_TYPE',
  MeasureUnit = 'MEASURE_UNIT',
  Message = 'MESSAGE',
  OriginCountry = 'ORIGIN_COUNTRY',
  PaymentMethod = 'PAYMENT_METHOD',
  PointOfSaleType = 'POINT_OF_SALE_TYPE',
  RoomType = 'ROOM_TYPE',
  SectorDocumentType = 'SECTOR_DOCUMENT_TYPE',
  SignificantEvent = 'SIGNIFICANT_EVENT'
}

export type SyncParameterTypeFilter = {
  distinctFrom?: InputMaybe<SyncParameterType>;
  equalTo?: InputMaybe<SyncParameterType>;
  greaterThan?: InputMaybe<SyncParameterType>;
  greaterThanOrEqualTo?: InputMaybe<SyncParameterType>;
  in?: InputMaybe<Array<SyncParameterType>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SyncParameterType>;
  lessThanOrEqualTo?: InputMaybe<SyncParameterType>;
  notDistinctFrom?: InputMaybe<SyncParameterType>;
  notEqualTo?: InputMaybe<SyncParameterType>;
  notIn?: InputMaybe<Array<SyncParameterType>>;
};

export type SyncParametersConnection = {
  __typename?: 'SyncParametersConnection';
  edges: Array<SyncParametersEdge>;
  nodes: Array<Maybe<SyncParameter>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SyncParametersEdge = {
  __typename?: 'SyncParametersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SyncParameter>;
};

export type SyncPointsOfSalePayload = {
  __typename?: 'SyncPointsOfSalePayload';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type SyncRequest = {
  __typename?: 'SyncRequest';
  createdAt?: Maybe<Scalars['Datetime']>;
  createdBy?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<Scalars['String']>;
  sendingType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type SyncRequestFilter = {
  and?: InputMaybe<Array<SyncRequestFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<SyncRequestFilter>;
  or?: InputMaybe<Array<SyncRequestFilter>>;
  sendingStatus?: InputMaybe<StringFilter>;
  sendingType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export enum SyncRequestType {
  Activity = 'ACTIVITY',
  ActivitySectorDocument = 'ACTIVITY_SECTOR_DOCUMENT',
  Datetime = 'DATETIME',
  InvoiceLegend = 'INVOICE_LEGEND',
  ParamCancellationReason = 'PARAM_CANCELLATION_REASON',
  ParamCurrency = 'PARAM_CURRENCY',
  ParamEmissionType = 'PARAM_EMISSION_TYPE',
  ParamIdentityDocumentType = 'PARAM_IDENTITY_DOCUMENT_TYPE',
  ParamInvoiceType = 'PARAM_INVOICE_TYPE',
  ParamMeasureUnit = 'PARAM_MEASURE_UNIT',
  ParamMessage = 'PARAM_MESSAGE',
  ParamOriginCountry = 'PARAM_ORIGIN_COUNTRY',
  ParamPaymentMethod = 'PARAM_PAYMENT_METHOD',
  ParamPointOfSaleType = 'PARAM_POINT_OF_SALE_TYPE',
  ParamRoomType = 'PARAM_ROOM_TYPE',
  ParamSectorDocumentType = 'PARAM_SECTOR_DOCUMENT_TYPE',
  ParamSignificantEvent = 'PARAM_SIGNIFICANT_EVENT',
  ProductService = 'PRODUCT_SERVICE'
}

export type SyncRequestTypeFilter = {
  distinctFrom?: InputMaybe<SyncRequestType>;
  equalTo?: InputMaybe<SyncRequestType>;
  greaterThan?: InputMaybe<SyncRequestType>;
  greaterThanOrEqualTo?: InputMaybe<SyncRequestType>;
  in?: InputMaybe<Array<SyncRequestType>>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lessThan?: InputMaybe<SyncRequestType>;
  lessThanOrEqualTo?: InputMaybe<SyncRequestType>;
  notDistinctFrom?: InputMaybe<SyncRequestType>;
  notEqualTo?: InputMaybe<SyncRequestType>;
  notIn?: InputMaybe<Array<SyncRequestType>>;
};

export type SyncRequestsConnection = {
  __typename?: 'SyncRequestsConnection';
  edges: Array<SyncRequestsEdge>;
  nodes: Array<Maybe<SyncRequest>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SyncRequestsEdge = {
  __typename?: 'SyncRequestsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<SyncRequest>;
};

export type Tenant = {
  __typename?: 'Tenant';
  businessName?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['BigInt']>;
};

export type TenantFilter = {
  and?: InputMaybe<Array<TenantFilter>>;
  businessName?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nit?: InputMaybe<BigIntFilter>;
  not?: InputMaybe<TenantFilter>;
  or?: InputMaybe<Array<TenantFilter>>;
};

export type TenantFullInfo = {
  __typename?: 'TenantFullInfo';
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  digitalSignatureCreatedAt?: Maybe<Scalars['Datetime']>;
  digitalSignatureExpireAt?: Maybe<Scalars['Datetime']>;
  digitalSignatureIssuedAt?: Maybe<Scalars['Datetime']>;
  digitalSignatureKey?: Maybe<Scalars['String']>;
  digitalSignatureRevoked?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['BigInt']>;
  phone?: Maybe<Scalars['String']>;
  tokenExpireAt?: Maybe<Scalars['Datetime']>;
  tokenIssuedAt?: Maybe<Scalars['Datetime']>;
  tokenRevoked?: Maybe<Scalars['String']>;
  tokenValue?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type TenantSubscription = {
  __typename?: 'TenantSubscription';
  cancelledAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  discount?: Maybe<Scalars['BigFloat']>;
  discountAppliedAt?: Maybe<Scalars['Datetime']>;
  discountType?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  planBillingDay?: Maybe<Scalars['Int']>;
  planBillingPeriod?: Maybe<Scalars['String']>;
  planCurrency?: Maybe<Scalars['String']>;
  planDescription?: Maybe<Scalars['String']>;
  planKey?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['BigFloat']>;
  quotaBranchOfficesLimit?: Maybe<Scalars['Int']>;
  quotaBranchOfficesUsed?: Maybe<Scalars['Int']>;
  quotaInvoicesLimit?: Maybe<Scalars['Int']>;
  quotaInvoicesUsed?: Maybe<Scalars['Int']>;
  quotaPointsOfSaleLimit?: Maybe<Scalars['Int']>;
  quotaPointsOfSaleUsed?: Maybe<Scalars['Int']>;
  quotaUsersLimit?: Maybe<Scalars['Int']>;
  quotaUsersUsed?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  status?: Maybe<Scalars['String']>;
};

export type TenantsConnection = {
  __typename?: 'TenantsConnection';
  edges: Array<TenantsEdge>;
  nodes: Array<Maybe<Tenant>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TenantsEdge = {
  __typename?: 'TenantsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<Tenant>;
};

export type TouristServiceOrder = {
  __typename?: 'TouristServiceOrder';
  cantidadHabitaciones?: Maybe<Scalars['Int']>;
  cantidadHuespedes?: Maybe<Scalars['Int']>;
  cantidadMayores?: Maybe<Scalars['Int']>;
  cantidadMenores?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  fechaIngresoHospedaje?: Maybe<Scalars['Datetime']>;
  giftCard: Scalars['BigFloat'];
  key: Scalars['String'];
  operadorTurismoRazonSocial?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderKey: Scalars['String'];
  tenantId: Scalars['Int'];
  touristServiceOrderDetails: TouristServiceOrderDetailsConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};


export type TouristServiceOrderTouristServiceOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TouristServiceOrderDetailCondition>;
  filter?: InputMaybe<TouristServiceOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TouristServiceOrderDetailsOrderBy>>;
};

export type TouristServiceOrderCondition = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  key?: InputMaybe<Scalars['String']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  orderKey?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type TouristServiceOrderDetail = {
  __typename?: 'TouristServiceOrderDetail';
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletion: Scalars['Boolean'];
  discount: Scalars['BigFloat'];
  key: Scalars['String'];
  price: Scalars['BigFloat'];
  productKey: Scalars['String'];
  productService?: Maybe<Product>;
  quantity: Scalars['BigFloat'];
  sinDetalleHuespedesJson?: Maybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: Maybe<Scalars['Int']>;
  subtotal: Scalars['BigFloat'];
  tenantId: Scalars['Int'];
  total: Scalars['BigFloat'];
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderKey: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type TouristServiceOrderDetailCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  deletedBy?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  key?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  tenantId?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['BigFloat']>;
  touristServiceOrderKey?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type TouristServiceOrderDetailFilter = {
  and?: InputMaybe<Array<TouristServiceOrderDetailFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  discount?: InputMaybe<BigFloatFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<TouristServiceOrderDetailFilter>;
  or?: InputMaybe<Array<TouristServiceOrderDetailFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  productKey?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<BigFloatFilter>;
  sinDetalleHuespedesJson?: InputMaybe<StringFilter>;
  sinTipoHabitacionCodigo?: InputMaybe<IntFilter>;
  subtotal?: InputMaybe<BigFloatFilter>;
  tenantId?: InputMaybe<IntFilter>;
  total?: InputMaybe<BigFloatFilter>;
  touristServiceOrderKey?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type TouristServiceOrderDetailInput = {
  discount: Scalars['BigFloat'];
  price: Scalars['BigFloat'];
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkTouristServiceOrderDetailToProductInput>;
  quantity: Scalars['BigFloat'];
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  touristServiceOrder?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInput>;
  touristServiceOrderKey?: InputMaybe<Scalars['String']>;
};

export type TouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductUsingPkTouristServiceOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateTouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductPatch;
};

export type TouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderUsingPkTouristServiceOrderDetailUpdate = {
  key: Scalars['String'];
  patch: UpdateTouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderPatch;
};

export type TouristServiceOrderDetailPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkTouristServiceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  touristServiceOrder?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInput>;
  touristServiceOrderKey?: InputMaybe<Scalars['String']>;
};

export type TouristServiceOrderDetailPkTouristServiceOrderDetailConnect = {
  key: Scalars['String'];
};

export type TouristServiceOrderDetailPkTouristServiceOrderDetailDelete = {
  key: Scalars['String'];
};

export type TouristServiceOrderDetailsConnection = {
  __typename?: 'TouristServiceOrderDetailsConnection';
  edges: Array<TouristServiceOrderDetailsEdge>;
  nodes: Array<Maybe<TouristServiceOrderDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TouristServiceOrderDetailsEdge = {
  __typename?: 'TouristServiceOrderDetailsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<TouristServiceOrderDetail>;
};

export enum TouristServiceOrderDetailsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  DiscountAsc = 'DISCOUNT_ASC',
  DiscountDesc = 'DISCOUNT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductByProductKeyCodeAsc = 'PRODUCT_BY_PRODUCT_KEY__CODE_ASC',
  ProductByProductKeyCodeDesc = 'PRODUCT_BY_PRODUCT_KEY__CODE_DESC',
  ProductByProductKeyCreatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_ASC',
  ProductByProductKeyCreatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_AT_DESC',
  ProductByProductKeyCreatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_ASC',
  ProductByProductKeyCreatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__CREATED_BY_DESC',
  ProductByProductKeyDeletedAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_ASC',
  ProductByProductKeyDeletedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_ASC',
  ProductByProductKeyDeletedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_AT_DESC',
  ProductByProductKeyDeletedByAsc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_ASC',
  ProductByProductKeyDeletedByDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_BY_DESC',
  ProductByProductKeyDeletedDesc = 'PRODUCT_BY_PRODUCT_KEY__DELETED_DESC',
  ProductByProductKeyDescriptionAsc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_ASC',
  ProductByProductKeyDescriptionDesc = 'PRODUCT_BY_PRODUCT_KEY__DESCRIPTION_DESC',
  ProductByProductKeyKeyAsc = 'PRODUCT_BY_PRODUCT_KEY__KEY_ASC',
  ProductByProductKeyKeyDesc = 'PRODUCT_BY_PRODUCT_KEY__KEY_DESC',
  ProductByProductKeyNameAsc = 'PRODUCT_BY_PRODUCT_KEY__NAME_ASC',
  ProductByProductKeyNameDesc = 'PRODUCT_BY_PRODUCT_KEY__NAME_DESC',
  ProductByProductKeyPriceAsc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_ASC',
  ProductByProductKeyPriceDesc = 'PRODUCT_BY_PRODUCT_KEY__PRICE_DESC',
  ProductByProductKeyTenantIdAsc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_ASC',
  ProductByProductKeyTenantIdDesc = 'PRODUCT_BY_PRODUCT_KEY__TENANT_ID_DESC',
  ProductByProductKeyTypeAsc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_ASC',
  ProductByProductKeyTypeDesc = 'PRODUCT_BY_PRODUCT_KEY__TYPE_DESC',
  ProductByProductKeyUpdatedAtAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_ASC',
  ProductByProductKeyUpdatedAtDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_AT_DESC',
  ProductByProductKeyUpdatedByAsc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_ASC',
  ProductByProductKeyUpdatedByDesc = 'PRODUCT_BY_PRODUCT_KEY__UPDATED_BY_DESC',
  ProductKeyAsc = 'PRODUCT_KEY_ASC',
  ProductKeyDesc = 'PRODUCT_KEY_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  SinDetalleHuespedesJsonAsc = 'SIN_DETALLE_HUESPEDES_JSON_ASC',
  SinDetalleHuespedesJsonDesc = 'SIN_DETALLE_HUESPEDES_JSON_DESC',
  SinTipoHabitacionCodigoAsc = 'SIN_TIPO_HABITACION_CODIGO_ASC',
  SinTipoHabitacionCodigoDesc = 'SIN_TIPO_HABITACION_CODIGO_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadHabitacionesAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_HABITACIONES_ASC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadHabitacionesDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_HABITACIONES_DESC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadHuespedesAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_HUESPEDES_ASC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadHuespedesDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_HUESPEDES_DESC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadMayoresAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_MAYORES_ASC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadMayoresDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_MAYORES_DESC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadMenoresAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_MENORES_ASC',
  TouristServiceOrderByTouristServiceOrderKeyCantidadMenoresDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CANTIDAD_MENORES_DESC',
  TouristServiceOrderByTouristServiceOrderKeyCreatedAtAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CREATED_AT_ASC',
  TouristServiceOrderByTouristServiceOrderKeyCreatedAtDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CREATED_AT_DESC',
  TouristServiceOrderByTouristServiceOrderKeyCreatedByAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CREATED_BY_ASC',
  TouristServiceOrderByTouristServiceOrderKeyCreatedByDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__CREATED_BY_DESC',
  TouristServiceOrderByTouristServiceOrderKeyDeletedAtAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__DELETED_AT_ASC',
  TouristServiceOrderByTouristServiceOrderKeyDeletedAtDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__DELETED_AT_DESC',
  TouristServiceOrderByTouristServiceOrderKeyDeletedByAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__DELETED_BY_ASC',
  TouristServiceOrderByTouristServiceOrderKeyDeletedByDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__DELETED_BY_DESC',
  TouristServiceOrderByTouristServiceOrderKeyDeletionAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__DELETION_ASC',
  TouristServiceOrderByTouristServiceOrderKeyDeletionDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__DELETION_DESC',
  TouristServiceOrderByTouristServiceOrderKeyFechaIngresoHospedajeAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__FECHA_INGRESO_HOSPEDAJE_ASC',
  TouristServiceOrderByTouristServiceOrderKeyFechaIngresoHospedajeDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__FECHA_INGRESO_HOSPEDAJE_DESC',
  TouristServiceOrderByTouristServiceOrderKeyGiftCardAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__GIFT_CARD_ASC',
  TouristServiceOrderByTouristServiceOrderKeyGiftCardDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__GIFT_CARD_DESC',
  TouristServiceOrderByTouristServiceOrderKeyKeyAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__KEY_ASC',
  TouristServiceOrderByTouristServiceOrderKeyKeyDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__KEY_DESC',
  TouristServiceOrderByTouristServiceOrderKeyOperadorTurismoRazonSocialAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__OPERADOR_TURISMO_RAZON_SOCIAL_ASC',
  TouristServiceOrderByTouristServiceOrderKeyOperadorTurismoRazonSocialDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__OPERADOR_TURISMO_RAZON_SOCIAL_DESC',
  TouristServiceOrderByTouristServiceOrderKeyOrderKeyAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__ORDER_KEY_ASC',
  TouristServiceOrderByTouristServiceOrderKeyOrderKeyDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__ORDER_KEY_DESC',
  TouristServiceOrderByTouristServiceOrderKeyTenantIdAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__TENANT_ID_ASC',
  TouristServiceOrderByTouristServiceOrderKeyTenantIdDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__TENANT_ID_DESC',
  TouristServiceOrderByTouristServiceOrderKeyUpdatedAtAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__UPDATED_AT_ASC',
  TouristServiceOrderByTouristServiceOrderKeyUpdatedAtDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__UPDATED_AT_DESC',
  TouristServiceOrderByTouristServiceOrderKeyUpdatedByAsc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__UPDATED_BY_ASC',
  TouristServiceOrderByTouristServiceOrderKeyUpdatedByDesc = 'TOURIST_SERVICE_ORDER_BY_TOURIST_SERVICE_ORDER_KEY__UPDATED_BY_DESC',
  TouristServiceOrderKeyAsc = 'TOURIST_SERVICE_ORDER_KEY_ASC',
  TouristServiceOrderKeyDesc = 'TOURIST_SERVICE_ORDER_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type TouristServiceOrderFilter = {
  and?: InputMaybe<Array<TouristServiceOrderFilter>>;
  cantidadHabitaciones?: InputMaybe<IntFilter>;
  cantidadHuespedes?: InputMaybe<IntFilter>;
  cantidadMayores?: InputMaybe<IntFilter>;
  cantidadMenores?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdBy?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedBy?: InputMaybe<IntFilter>;
  deletion?: InputMaybe<BooleanFilter>;
  fechaIngresoHospedaje?: InputMaybe<DatetimeFilter>;
  giftCard?: InputMaybe<BigFloatFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<TouristServiceOrderFilter>;
  operadorTurismoRazonSocial?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TouristServiceOrderFilter>>;
  orderKey?: InputMaybe<StringFilter>;
  tenantId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type TouristServiceOrderInput = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<FkTouristServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInverseInput>;
};

export type TouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderUsingPkTouristServiceOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateTouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderPatch;
};

export type TouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderUsingUkTouristServiceOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateTouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderPatch;
};

export type TouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderUsingPkTouristServiceOrderUpdate = {
  key: Scalars['String'];
  patch: UpdateTouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderPatch;
};

export type TouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderUsingUkTouristServiceOrderOrderKeyUpdate = {
  orderKey: Scalars['String'];
  patch: UpdateTouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderPatch;
};

export type TouristServiceOrderPatch = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<FkTouristServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInverseInput>;
};

export type TouristServiceOrderPkTouristServiceOrderConnect = {
  key: Scalars['String'];
};

export type TouristServiceOrderPkTouristServiceOrderDelete = {
  key: Scalars['String'];
};

export type TouristServiceOrderUkTouristServiceOrderOrderKeyConnect = {
  orderKey: Scalars['String'];
};

export type TouristServiceOrderUkTouristServiceOrderOrderKeyDelete = {
  orderKey: Scalars['String'];
};

export type TouristServiceOrdersConnection = {
  __typename?: 'TouristServiceOrdersConnection';
  edges: Array<TouristServiceOrdersEdge>;
  nodes: Array<Maybe<TouristServiceOrder>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TouristServiceOrdersEdge = {
  __typename?: 'TouristServiceOrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<TouristServiceOrder>;
};

export enum TouristServiceOrdersOrderBy {
  CantidadHabitacionesAsc = 'CANTIDAD_HABITACIONES_ASC',
  CantidadHabitacionesDesc = 'CANTIDAD_HABITACIONES_DESC',
  CantidadHuespedesAsc = 'CANTIDAD_HUESPEDES_ASC',
  CantidadHuespedesDesc = 'CANTIDAD_HUESPEDES_DESC',
  CantidadMayoresAsc = 'CANTIDAD_MAYORES_ASC',
  CantidadMayoresDesc = 'CANTIDAD_MAYORES_DESC',
  CantidadMenoresAsc = 'CANTIDAD_MENORES_ASC',
  CantidadMenoresDesc = 'CANTIDAD_MENORES_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DeletedByAsc = 'DELETED_BY_ASC',
  DeletedByDesc = 'DELETED_BY_DESC',
  DeletionAsc = 'DELETION_ASC',
  DeletionDesc = 'DELETION_DESC',
  FechaIngresoHospedajeAsc = 'FECHA_INGRESO_HOSPEDAJE_ASC',
  FechaIngresoHospedajeDesc = 'FECHA_INGRESO_HOSPEDAJE_DESC',
  GiftCardAsc = 'GIFT_CARD_ASC',
  GiftCardDesc = 'GIFT_CARD_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  OperadorTurismoRazonSocialAsc = 'OPERADOR_TURISMO_RAZON_SOCIAL_ASC',
  OperadorTurismoRazonSocialDesc = 'OPERADOR_TURISMO_RAZON_SOCIAL_DESC',
  OrderByOrderKeyChangeAmountAsc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_ASC',
  OrderByOrderKeyChangeAmountDesc = 'ORDER_BY_ORDER_KEY__CHANGE_AMOUNT_DESC',
  OrderByOrderKeyClientKeyAsc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_ASC',
  OrderByOrderKeyClientKeyDesc = 'ORDER_BY_ORDER_KEY__CLIENT_KEY_DESC',
  OrderByOrderKeyCreatedAtAsc = 'ORDER_BY_ORDER_KEY__CREATED_AT_ASC',
  OrderByOrderKeyCreatedAtDesc = 'ORDER_BY_ORDER_KEY__CREATED_AT_DESC',
  OrderByOrderKeyCreatedByAsc = 'ORDER_BY_ORDER_KEY__CREATED_BY_ASC',
  OrderByOrderKeyCreatedByDesc = 'ORDER_BY_ORDER_KEY__CREATED_BY_DESC',
  OrderByOrderKeyDeletedAtAsc = 'ORDER_BY_ORDER_KEY__DELETED_AT_ASC',
  OrderByOrderKeyDeletedAtDesc = 'ORDER_BY_ORDER_KEY__DELETED_AT_DESC',
  OrderByOrderKeyDeletedByAsc = 'ORDER_BY_ORDER_KEY__DELETED_BY_ASC',
  OrderByOrderKeyDeletedByDesc = 'ORDER_BY_ORDER_KEY__DELETED_BY_DESC',
  OrderByOrderKeyDeletionAsc = 'ORDER_BY_ORDER_KEY__DELETION_ASC',
  OrderByOrderKeyDeletionDesc = 'ORDER_BY_ORDER_KEY__DELETION_DESC',
  OrderByOrderKeyDiscountAsc = 'ORDER_BY_ORDER_KEY__DISCOUNT_ASC',
  OrderByOrderKeyDiscountDesc = 'ORDER_BY_ORDER_KEY__DISCOUNT_DESC',
  OrderByOrderKeyEmailAsc = 'ORDER_BY_ORDER_KEY__EMAIL_ASC',
  OrderByOrderKeyEmailDesc = 'ORDER_BY_ORDER_KEY__EMAIL_DESC',
  OrderByOrderKeyKeyAsc = 'ORDER_BY_ORDER_KEY__KEY_ASC',
  OrderByOrderKeyKeyDesc = 'ORDER_BY_ORDER_KEY__KEY_DESC',
  OrderByOrderKeyPaymentAmountAsc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_ASC',
  OrderByOrderKeyPaymentAmountDesc = 'ORDER_BY_ORDER_KEY__PAYMENT_AMOUNT_DESC',
  OrderByOrderKeyPhoneNumberAsc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_ASC',
  OrderByOrderKeyPhoneNumberDesc = 'ORDER_BY_ORDER_KEY__PHONE_NUMBER_DESC',
  OrderByOrderKeyPointOfSaleKeyAsc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_ASC',
  OrderByOrderKeyPointOfSaleKeyDesc = 'ORDER_BY_ORDER_KEY__POINT_OF_SALE_KEY_DESC',
  OrderByOrderKeyQuantityAsc = 'ORDER_BY_ORDER_KEY__QUANTITY_ASC',
  OrderByOrderKeyQuantityDesc = 'ORDER_BY_ORDER_KEY__QUANTITY_DESC',
  OrderByOrderKeyStatusAsc = 'ORDER_BY_ORDER_KEY__STATUS_ASC',
  OrderByOrderKeyStatusDesc = 'ORDER_BY_ORDER_KEY__STATUS_DESC',
  OrderByOrderKeySubtotalAsc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_ASC',
  OrderByOrderKeySubtotalDesc = 'ORDER_BY_ORDER_KEY__SUBTOTAL_DESC',
  OrderByOrderKeyTenantIdAsc = 'ORDER_BY_ORDER_KEY__TENANT_ID_ASC',
  OrderByOrderKeyTenantIdDesc = 'ORDER_BY_ORDER_KEY__TENANT_ID_DESC',
  OrderByOrderKeyTotalAsc = 'ORDER_BY_ORDER_KEY__TOTAL_ASC',
  OrderByOrderKeyTotalDesc = 'ORDER_BY_ORDER_KEY__TOTAL_DESC',
  OrderByOrderKeyUpdatedAtAsc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_ASC',
  OrderByOrderKeyUpdatedAtDesc = 'ORDER_BY_ORDER_KEY__UPDATED_AT_DESC',
  OrderByOrderKeyUpdatedByAsc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_ASC',
  OrderByOrderKeyUpdatedByDesc = 'ORDER_BY_ORDER_KEY__UPDATED_BY_DESC',
  OrderKeyAsc = 'ORDER_KEY_ASC',
  OrderKeyDesc = 'ORDER_KEY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TouristServiceOrderDetailsByTouristServiceOrderKeyCountAsc = 'TOURIST_SERVICE_ORDER_DETAILS_BY_TOURIST_SERVICE_ORDER_KEY__COUNT_ASC',
  TouristServiceOrderDetailsByTouristServiceOrderKeyCountDesc = 'TOURIST_SERVICE_ORDER_DETAILS_BY_TOURIST_SERVICE_ORDER_KEY__COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type UnlockUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pKeyUser: Scalars['String'];
};

export type UnlockUserPayload = {
  __typename?: 'UnlockUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type UpdateBranchOfficeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: BranchOfficePatch;
};

export type UpdateBranchOfficePayload = {
  __typename?: 'UpdateBranchOfficePayload';
  branchOffice?: Maybe<BranchOffice>;
  branchOfficeEdge?: Maybe<BranchOfficesEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type UpdateClientHomologationByClientKeyInput = {
  clientKey: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  patch: ClientHomologationPatch;
};

export type UpdateClientHomologationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: ClientHomologationPatch;
};

export type UpdateClientHomologationPayload = {
  __typename?: 'UpdateClientHomologationPayload';
  client?: Maybe<Client>;
  clientHomologation?: Maybe<ClientHomologation>;
  clientHomologationEdge?: Maybe<ClientHomologationsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type UpdateClientInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: ClientPatch;
};

export type UpdateClientPayload = {
  __typename?: 'UpdateClientPayload';
  client?: Maybe<Client>;
  clientEdge?: Maybe<ClientsEdge>;
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type UpdateCurrentBillingInfoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pBusinessName: Scalars['String'];
  pDocumentComplement: Scalars['String'];
  pDocumentNumber: Scalars['String'];
  pDocumentTypeCode: Scalars['Int'];
  pEmail: Scalars['String'];
};

export type UpdateCurrentBillingInfoPayload = {
  __typename?: 'UpdateCurrentBillingInfoPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  currentBillingInfo?: Maybe<CurrentBillingInfo>;
  query?: Maybe<Query>;
};

export type UpdateCurrentTenantInfoInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pBusinessName: Scalars['String'];
  pEmail: Scalars['String'];
  pPhone: Scalars['String'];
};

export type UpdateCurrentTenantInfoPayload = {
  __typename?: 'UpdateCurrentTenantInfoPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  currentTenantInfo?: Maybe<CurrentTenantInfo>;
  query?: Maybe<Query>;
};

export type UpdateExportServiceOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
  patch: ExportServiceOrderPatch;
};

export type UpdateExportServiceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: ExportServiceOrderDetailPatch;
};

export type UpdateExportServiceOrderDetailPayload = {
  __typename?: 'UpdateExportServiceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderDetail?: Maybe<ExportServiceOrderDetail>;
  exportServiceOrderDetailEdge?: Maybe<ExportServiceOrderDetailsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};


export type UpdateExportServiceOrderDetailPayloadExportServiceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ExportServiceOrderDetailsOrderBy>>;
};

export type UpdateExportServiceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: ExportServiceOrderPatch;
};

export type UpdateExportServiceOrderPayload = {
  __typename?: 'UpdateExportServiceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  exportServiceOrder?: Maybe<ExportServiceOrder>;
  exportServiceOrderEdge?: Maybe<ExportServiceOrdersEdge>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
};


export type UpdateExportServiceOrderPayloadExportServiceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ExportServiceOrdersOrderBy>>;
};

export type UpdateInsuranceOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
  patch: InsuranceOrderPatch;
};

export type UpdateInsuranceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: InsuranceOrderDetailPatch;
};

export type UpdateInsuranceOrderDetailPayload = {
  __typename?: 'UpdateInsuranceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderDetail?: Maybe<InsuranceOrderDetail>;
  insuranceOrderDetailEdge?: Maybe<InsuranceOrderDetailsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};


export type UpdateInsuranceOrderDetailPayloadInsuranceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceOrderDetailsOrderBy>>;
};

export type UpdateInsuranceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: InsuranceOrderPatch;
};

export type UpdateInsuranceOrderPayload = {
  __typename?: 'UpdateInsuranceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  insuranceOrder?: Maybe<InsuranceOrder>;
  insuranceOrderEdge?: Maybe<InsuranceOrdersEdge>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
};


export type UpdateInsuranceOrderPayloadInsuranceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceOrdersOrderBy>>;
};

export type UpdateOrderHomologationByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
  patch: OrderHomologationPatch;
};

export type UpdateOrderHomologationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: OrderHomologationPatch;
};

export type UpdateOrderHomologationPayload = {
  __typename?: 'UpdateOrderHomologationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderHomologation?: Maybe<OrderHomologation>;
  orderHomologationEdge?: Maybe<OrderHomologationsEdge>;
  query?: Maybe<Query>;
};

export type UpdateOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: OrderPatch;
};

export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  client?: Maybe<Client>;
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderEdge?: Maybe<OrdersEdge>;
  pointOfSale?: Maybe<PointOfSale>;
  query?: Maybe<Query>;
};

export type UpdatePersonInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: PersonPatch;
};

export type UpdatePersonPayload = {
  __typename?: 'UpdatePersonPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  personEdge?: Maybe<PeopleEdge>;
  query?: Maybe<Query>;
};

export type UpdatePointOfSaleUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: PointOfSaleUserPatch;
};

export type UpdatePointOfSaleUserPayload = {
  __typename?: 'UpdatePointOfSaleUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleUser?: Maybe<PointOfSaleUser>;
  pointOfSaleUserEdge?: Maybe<PointOfSaleUsersEdge>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type UpdateProductHomologationByProductKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  patch: ProductHomologationPatch;
  productKey: Scalars['String'];
};

export type UpdateProductHomologationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: ProductHomologationPatch;
};

export type UpdateProductHomologationPayload = {
  __typename?: 'UpdateProductHomologationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productHomologation?: Maybe<ProductHomologation>;
  productHomologationEdge?: Maybe<ProductHomologationsEdge>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
};

export type UpdateProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: ProductPatch;
};

export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productEdge?: Maybe<ProductsEdge>;
  query?: Maybe<Query>;
};

export type UpdateRentalOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
  patch: RentalOrderPatch;
};

export type UpdateRentalOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: RentalOrderDetailPatch;
};

export type UpdateRentalOrderDetailPayload = {
  __typename?: 'UpdateRentalOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderDetail?: Maybe<RentalOrderDetail>;
  rentalOrderDetailEdge?: Maybe<RentalOrderDetailsEdge>;
};


export type UpdateRentalOrderDetailPayloadRentalOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<RentalOrderDetailsOrderBy>>;
};

export type UpdateRentalOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: RentalOrderPatch;
};

export type UpdateRentalOrderPayload = {
  __typename?: 'UpdateRentalOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  rentalOrder?: Maybe<RentalOrder>;
  rentalOrderEdge?: Maybe<RentalOrdersEdge>;
};


export type UpdateRentalOrderPayloadRentalOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<RentalOrdersOrderBy>>;
};

export type UpdateRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pDescription?: InputMaybe<Scalars['String']>;
  pKey?: InputMaybe<Scalars['String']>;
  pName?: InputMaybe<Scalars['String']>;
  pPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateRolePayload = {
  __typename?: 'UpdateRolePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']>;
};

export type UpdateSaleOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
  patch: SaleOrderPatch;
};

export type UpdateSaleOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: SaleOrderDetailPatch;
};

export type UpdateSaleOrderDetailPayload = {
  __typename?: 'UpdateSaleOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  saleOrder?: Maybe<SaleOrder>;
  saleOrderDetail?: Maybe<SaleOrderDetail>;
  saleOrderDetailEdge?: Maybe<SaleOrderDetailsEdge>;
};

export type UpdateSaleOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: SaleOrderPatch;
};

export type UpdateSaleOrderPayload = {
  __typename?: 'UpdateSaleOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  saleOrder?: Maybe<SaleOrder>;
  saleOrderEdge?: Maybe<SaleOrdersEdge>;
};

export type UpdateTouristServiceOrderByOrderKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderKey: Scalars['String'];
  patch: TouristServiceOrderPatch;
};

export type UpdateTouristServiceOrderDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: TouristServiceOrderDetailPatch;
};

export type UpdateTouristServiceOrderDetailPayload = {
  __typename?: 'UpdateTouristServiceOrderDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  productService?: Maybe<Product>;
  query?: Maybe<Query>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderDetail?: Maybe<TouristServiceOrderDetail>;
  touristServiceOrderDetailEdge?: Maybe<TouristServiceOrderDetailsEdge>;
};


export type UpdateTouristServiceOrderDetailPayloadTouristServiceOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<TouristServiceOrderDetailsOrderBy>>;
};

export type UpdateTouristServiceOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: TouristServiceOrderPatch;
};

export type UpdateTouristServiceOrderPayload = {
  __typename?: 'UpdateTouristServiceOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  query?: Maybe<Query>;
  touristServiceOrder?: Maybe<TouristServiceOrder>;
  touristServiceOrderEdge?: Maybe<TouristServiceOrdersEdge>;
};


export type UpdateTouristServiceOrderPayloadTouristServiceOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<TouristServiceOrdersOrderBy>>;
};

export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  patch: UserPatch;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};

export type UpdateUserRolesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pUserKey?: InputMaybe<Scalars['String']>;
};

export type UpdateUserRolesPayload = {
  __typename?: 'UpdateUserRolesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  strings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UploadDelegatedTokenInput = {
  tenantKey: Scalars['String'];
  token: Scalars['String'];
};

export type UploadDelegatedTokenPayload = {
  __typename?: 'UploadDelegatedTokenPayload';
  delegatedToken?: Maybe<DelegatedToken>;
  message?: Maybe<Scalars['String']>;
};

export type UploadDigitalSignatureInput = {
  file: Scalars['Upload'];
  password: Scalars['String'];
  tenantKey: Scalars['String'];
};

export type UploadDigitalSignaturePayload = {
  __typename?: 'UploadDigitalSignaturePayload';
  message: Scalars['String'];
};

export type UploadProductsInput = {
  file: Scalars['Upload'];
  tenantKey: Scalars['String'];
};

export type UploadProductsPayload = {
  __typename?: 'UploadProductsPayload';
  message: Scalars['String'];
  productBatchImportKey: Scalars['String'];
};

export type UploadRegisterDocumentsPayload = {
  __typename?: 'UploadRegisterDocumentsPayload';
  backDocumentPhotoValid: Scalars['Boolean'];
  certificateRequestPhotoValid: Scalars['Boolean'];
  frontDocumentPhotoValid: Scalars['Boolean'];
  frontDocumentSelfieValid: Scalars['Boolean'];
  nitDocumentPhotoValid: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  action?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  email: Scalars['String'];
  key: Scalars['String'];
  lastTenantKey?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  personKey: Scalars['String'];
  pointOfSaleUsers: PointOfSaleUsersConnection;
  tenant?: Maybe<Tenant>;
  tenants: TenantsConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
  username?: Maybe<Scalars['String']>;
};


export type UserPointOfSaleUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTenantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TenantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  createdAt: Scalars['String'];
  event: Scalars['String'];
  id: Scalars['String'];
  payload?: Maybe<Scalars['JSON']>;
};

export type UserOnPointOfSaleUserForFkPointOfSaleUserToUserUsingPkUserUpdate = {
  key: Scalars['String'];
  patch: UpdateUserOnPointOfSaleUserForFkPointOfSaleUserToUserPatch;
};

export type UserOnUserForFkAppUserToPersonUsingPkUserUpdate = {
  key: Scalars['String'];
  patch: UpdateUserOnUserForFkAppUserToPersonPatch;
};

export type UserPatch = {
  email?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<FkAppUserToPersonInput>;
  personKey?: InputMaybe<Scalars['String']>;
  pointOfSaleUsers?: InputMaybe<FkPointOfSaleUserToUserInverseInput>;
};

export type UserPermissionRecord = {
  __typename?: 'UserPermissionRecord';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type UserPermissionRecordFilter = {
  and?: InputMaybe<Array<UserPermissionRecordFilter>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<UserPermissionRecordFilter>;
  or?: InputMaybe<Array<UserPermissionRecordFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type UserPermissionRecordsConnection = {
  __typename?: 'UserPermissionRecordsConnection';
  edges: Array<UserPermissionRecordsEdge>;
  nodes: Array<Maybe<UserPermissionRecord>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserPermissionRecordsEdge = {
  __typename?: 'UserPermissionRecordsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<UserPermissionRecord>;
};

export type UserPkUserConnect = {
  key: Scalars['String'];
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UsersEdge>;
  nodes: Array<Maybe<User>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UsersEdge = {
  __typename?: 'UsersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<User>;
};

export type ValidateTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pToken: Scalars['String'];
};

export type ValidateTokenPayload = {
  __typename?: 'ValidateTokenPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
};

export type ViewAllClient = {
  __typename?: 'ViewAllClient';
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  documentComplement?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['Int']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  tenantKey?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewAllClientCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  documentComplement?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
  documentTypeDescription?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tenantKey?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewAllClientFilter = {
  and?: InputMaybe<Array<ViewAllClientFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  documentComplement?: InputMaybe<StringFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentTypeCode?: InputMaybe<IntFilter>;
  documentTypeDescription?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewAllClientFilter>;
  or?: InputMaybe<Array<ViewAllClientFilter>>;
  phoneNumber?: InputMaybe<StringFilter>;
  tenantKey?: InputMaybe<StringFilter>;
  tenantName?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewAllClientsConnection = {
  __typename?: 'ViewAllClientsConnection';
  edges: Array<ViewAllClientsEdge>;
  nodes: Array<Maybe<ViewAllClient>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewAllClientsEdge = {
  __typename?: 'ViewAllClientsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewAllClient>;
};

export enum ViewAllClientsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DocumentComplementAsc = 'DOCUMENT_COMPLEMENT_ASC',
  DocumentComplementDesc = 'DOCUMENT_COMPLEMENT_DESC',
  DocumentNumberAsc = 'DOCUMENT_NUMBER_ASC',
  DocumentNumberDesc = 'DOCUMENT_NUMBER_DESC',
  DocumentTypeCodeAsc = 'DOCUMENT_TYPE_CODE_ASC',
  DocumentTypeCodeDesc = 'DOCUMENT_TYPE_CODE_DESC',
  DocumentTypeDescriptionAsc = 'DOCUMENT_TYPE_DESCRIPTION_ASC',
  DocumentTypeDescriptionDesc = 'DOCUMENT_TYPE_DESCRIPTION_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  TenantKeyAsc = 'TENANT_KEY_ASC',
  TenantKeyDesc = 'TENANT_KEY_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewBranchOffice = {
  __typename?: 'ViewBranchOffice';
  address?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewBranchOfficeCondition = {
  address?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  municipality?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewBranchOfficeFilter = {
  address?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<ViewBranchOfficeFilter>>;
  code?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  municipality?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewBranchOfficeFilter>;
  or?: InputMaybe<Array<ViewBranchOfficeFilter>>;
  phoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewBranchOfficeInput = {
  address?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  municipality?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewBranchOfficesConnection = {
  __typename?: 'ViewBranchOfficesConnection';
  edges: Array<ViewBranchOfficesEdge>;
  nodes: Array<Maybe<ViewBranchOffice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewBranchOfficesEdge = {
  __typename?: 'ViewBranchOfficesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewBranchOffice>;
};

export enum ViewBranchOfficesOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  MunicipalityAsc = 'MUNICIPALITY_ASC',
  MunicipalityDesc = 'MUNICIPALITY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewClient = {
  __typename?: 'ViewClient';
  createdAt?: Maybe<Scalars['Datetime']>;
  documentComplement?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['Int']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewClientCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  documentComplement?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
  documentTypeDescription?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewClientFilter = {
  and?: InputMaybe<Array<ViewClientFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  documentComplement?: InputMaybe<StringFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentTypeCode?: InputMaybe<IntFilter>;
  documentTypeDescription?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewClientFilter>;
  or?: InputMaybe<Array<ViewClientFilter>>;
  phoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewClientsConnection = {
  __typename?: 'ViewClientsConnection';
  edges: Array<ViewClientsEdge>;
  nodes: Array<Maybe<ViewClient>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewClientsEdge = {
  __typename?: 'ViewClientsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewClient>;
};

export enum ViewClientsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DocumentComplementAsc = 'DOCUMENT_COMPLEMENT_ASC',
  DocumentComplementDesc = 'DOCUMENT_COMPLEMENT_DESC',
  DocumentNumberAsc = 'DOCUMENT_NUMBER_ASC',
  DocumentNumberDesc = 'DOCUMENT_NUMBER_DESC',
  DocumentTypeCodeAsc = 'DOCUMENT_TYPE_CODE_ASC',
  DocumentTypeCodeDesc = 'DOCUMENT_TYPE_CODE_DESC',
  DocumentTypeDescriptionAsc = 'DOCUMENT_TYPE_DESCRIPTION_ASC',
  DocumentTypeDescriptionDesc = 'DOCUMENT_TYPE_DESCRIPTION_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewCufdCode = {
  __typename?: 'ViewCufdCode';
  address?: Maybe<Scalars['String']>;
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  controlCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  generatedAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<SendingStatus>;
  sendingType?: Maybe<SendingType>;
  status?: Maybe<RequestStatus>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewCufdCodeCondition = {
  address?: InputMaybe<Scalars['String']>;
  branchOfficeCode?: InputMaybe<Scalars['Int']>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  branchOfficeName?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  generatedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  pointOfSaleCode?: InputMaybe<Scalars['Int']>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  pointOfSaleName?: InputMaybe<Scalars['String']>;
  sendingStatus?: InputMaybe<SendingStatus>;
  sendingType?: InputMaybe<SendingType>;
  status?: InputMaybe<RequestStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewCufdCodeFilter = {
  address?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<ViewCufdCodeFilter>>;
  branchOfficeCode?: InputMaybe<IntFilter>;
  branchOfficeKey?: InputMaybe<StringFilter>;
  branchOfficeName?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  controlCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  expireAt?: InputMaybe<DatetimeFilter>;
  generatedAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewCufdCodeFilter>;
  or?: InputMaybe<Array<ViewCufdCodeFilter>>;
  pointOfSaleCode?: InputMaybe<IntFilter>;
  pointOfSaleKey?: InputMaybe<StringFilter>;
  pointOfSaleName?: InputMaybe<StringFilter>;
  sendingStatus?: InputMaybe<SendingStatusFilter>;
  sendingType?: InputMaybe<SendingTypeFilter>;
  status?: InputMaybe<RequestStatusFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewCufdCodesConnection = {
  __typename?: 'ViewCufdCodesConnection';
  edges: Array<ViewCufdCodesEdge>;
  nodes: Array<Maybe<ViewCufdCode>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewCufdCodesEdge = {
  __typename?: 'ViewCufdCodesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewCufdCode>;
};

export enum ViewCufdCodesOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  BranchOfficeCodeAsc = 'BRANCH_OFFICE_CODE_ASC',
  BranchOfficeCodeDesc = 'BRANCH_OFFICE_CODE_DESC',
  BranchOfficeKeyAsc = 'BRANCH_OFFICE_KEY_ASC',
  BranchOfficeKeyDesc = 'BRANCH_OFFICE_KEY_DESC',
  BranchOfficeNameAsc = 'BRANCH_OFFICE_NAME_ASC',
  BranchOfficeNameDesc = 'BRANCH_OFFICE_NAME_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  ControlCodeAsc = 'CONTROL_CODE_ASC',
  ControlCodeDesc = 'CONTROL_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  ExpireAtAsc = 'EXPIRE_AT_ASC',
  ExpireAtDesc = 'EXPIRE_AT_DESC',
  GeneratedAtAsc = 'GENERATED_AT_ASC',
  GeneratedAtDesc = 'GENERATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PointOfSaleCodeAsc = 'POINT_OF_SALE_CODE_ASC',
  PointOfSaleCodeDesc = 'POINT_OF_SALE_CODE_DESC',
  PointOfSaleKeyAsc = 'POINT_OF_SALE_KEY_ASC',
  PointOfSaleKeyDesc = 'POINT_OF_SALE_KEY_DESC',
  PointOfSaleNameAsc = 'POINT_OF_SALE_NAME_ASC',
  PointOfSaleNameDesc = 'POINT_OF_SALE_NAME_DESC',
  SendingStatusAsc = 'SENDING_STATUS_ASC',
  SendingStatusDesc = 'SENDING_STATUS_DESC',
  SendingTypeAsc = 'SENDING_TYPE_ASC',
  SendingTypeDesc = 'SENDING_TYPE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewCuisCode = {
  __typename?: 'ViewCuisCode';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  generatedAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<SendingStatus>;
  sendingType?: Maybe<SendingType>;
  status?: Maybe<RequestStatus>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewCuisCodeCondition = {
  branchOfficeCode?: InputMaybe<Scalars['Int']>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  branchOfficeName?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  generatedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  pointOfSaleCode?: InputMaybe<Scalars['Int']>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  pointOfSaleName?: InputMaybe<Scalars['String']>;
  sendingStatus?: InputMaybe<SendingStatus>;
  sendingType?: InputMaybe<SendingType>;
  status?: InputMaybe<RequestStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewCuisCodeFilter = {
  and?: InputMaybe<Array<ViewCuisCodeFilter>>;
  branchOfficeCode?: InputMaybe<IntFilter>;
  branchOfficeKey?: InputMaybe<StringFilter>;
  branchOfficeName?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  expireAt?: InputMaybe<DatetimeFilter>;
  generatedAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewCuisCodeFilter>;
  or?: InputMaybe<Array<ViewCuisCodeFilter>>;
  pointOfSaleCode?: InputMaybe<IntFilter>;
  pointOfSaleKey?: InputMaybe<StringFilter>;
  pointOfSaleName?: InputMaybe<StringFilter>;
  sendingStatus?: InputMaybe<SendingStatusFilter>;
  sendingType?: InputMaybe<SendingTypeFilter>;
  status?: InputMaybe<RequestStatusFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewCuisCodesConnection = {
  __typename?: 'ViewCuisCodesConnection';
  edges: Array<ViewCuisCodesEdge>;
  nodes: Array<Maybe<ViewCuisCode>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewCuisCodesEdge = {
  __typename?: 'ViewCuisCodesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewCuisCode>;
};

export enum ViewCuisCodesOrderBy {
  BranchOfficeCodeAsc = 'BRANCH_OFFICE_CODE_ASC',
  BranchOfficeCodeDesc = 'BRANCH_OFFICE_CODE_DESC',
  BranchOfficeKeyAsc = 'BRANCH_OFFICE_KEY_ASC',
  BranchOfficeKeyDesc = 'BRANCH_OFFICE_KEY_DESC',
  BranchOfficeNameAsc = 'BRANCH_OFFICE_NAME_ASC',
  BranchOfficeNameDesc = 'BRANCH_OFFICE_NAME_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  ExpireAtAsc = 'EXPIRE_AT_ASC',
  ExpireAtDesc = 'EXPIRE_AT_DESC',
  GeneratedAtAsc = 'GENERATED_AT_ASC',
  GeneratedAtDesc = 'GENERATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PointOfSaleCodeAsc = 'POINT_OF_SALE_CODE_ASC',
  PointOfSaleCodeDesc = 'POINT_OF_SALE_CODE_DESC',
  PointOfSaleKeyAsc = 'POINT_OF_SALE_KEY_ASC',
  PointOfSaleKeyDesc = 'POINT_OF_SALE_KEY_DESC',
  PointOfSaleNameAsc = 'POINT_OF_SALE_NAME_ASC',
  PointOfSaleNameDesc = 'POINT_OF_SALE_NAME_DESC',
  SendingStatusAsc = 'SENDING_STATUS_ASC',
  SendingStatusDesc = 'SENDING_STATUS_DESC',
  SendingTypeAsc = 'SENDING_TYPE_ASC',
  SendingTypeDesc = 'SENDING_TYPE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewDelegatedToken = {
  __typename?: 'ViewDelegatedToken';
  createdAt?: Maybe<Scalars['Datetime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  nit?: Maybe<Scalars['String']>;
  revoked?: Maybe<Scalars['Boolean']>;
  sub?: Maybe<Scalars['String']>;
  systemCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewDelegatedTokenCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  nit?: InputMaybe<Scalars['String']>;
  revoked?: InputMaybe<Scalars['Boolean']>;
  sub?: InputMaybe<Scalars['String']>;
  systemCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewDelegatedTokenFilter = {
  and?: InputMaybe<Array<ViewDelegatedTokenFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  expireAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  nit?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewDelegatedTokenFilter>;
  or?: InputMaybe<Array<ViewDelegatedTokenFilter>>;
  revoked?: InputMaybe<BooleanFilter>;
  sub?: InputMaybe<StringFilter>;
  systemCode?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewDelegatedTokenInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  nit?: InputMaybe<Scalars['String']>;
  revoked?: InputMaybe<Scalars['Boolean']>;
  sub?: InputMaybe<Scalars['String']>;
  systemCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewDelegatedTokensConnection = {
  __typename?: 'ViewDelegatedTokensConnection';
  edges: Array<ViewDelegatedTokensEdge>;
  nodes: Array<Maybe<ViewDelegatedToken>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewDelegatedTokensEdge = {
  __typename?: 'ViewDelegatedTokensEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewDelegatedToken>;
};

export enum ViewDelegatedTokensOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  ExpireAtAsc = 'EXPIRE_AT_ASC',
  ExpireAtDesc = 'EXPIRE_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IssuedAtAsc = 'ISSUED_AT_ASC',
  IssuedAtDesc = 'ISSUED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  NitAsc = 'NIT_ASC',
  NitDesc = 'NIT_DESC',
  RevokedAsc = 'REVOKED_ASC',
  RevokedDesc = 'REVOKED_DESC',
  SubAsc = 'SUB_ASC',
  SubDesc = 'SUB_DESC',
  SystemCodeAsc = 'SYSTEM_CODE_ASC',
  SystemCodeDesc = 'SYSTEM_CODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewDigitalSignature = {
  __typename?: 'ViewDigitalSignature';
  createdAt?: Maybe<Scalars['Datetime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  issuerCommonName?: Maybe<Scalars['String']>;
  issuerCountry?: Maybe<Scalars['String']>;
  issuerOrganization?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  revoked?: Maybe<Scalars['Boolean']>;
  subjectBusinessName?: Maybe<Scalars['String']>;
  subjectCountry?: Maybe<Scalars['String']>;
  subjectDocumentComplement?: Maybe<Scalars['String']>;
  subjectDocumentNumber?: Maybe<Scalars['String']>;
  subjectDocumentType?: Maybe<Scalars['String']>;
  subjectJobTitle?: Maybe<Scalars['String']>;
  subjectLegalRepresentative?: Maybe<Scalars['String']>;
  subjectNit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewDigitalSignatureCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  issuerCommonName?: InputMaybe<Scalars['String']>;
  issuerCountry?: InputMaybe<Scalars['String']>;
  issuerOrganization?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  revoked?: InputMaybe<Scalars['Boolean']>;
  subjectBusinessName?: InputMaybe<Scalars['String']>;
  subjectCountry?: InputMaybe<Scalars['String']>;
  subjectDocumentComplement?: InputMaybe<Scalars['String']>;
  subjectDocumentNumber?: InputMaybe<Scalars['String']>;
  subjectDocumentType?: InputMaybe<Scalars['String']>;
  subjectJobTitle?: InputMaybe<Scalars['String']>;
  subjectLegalRepresentative?: InputMaybe<Scalars['String']>;
  subjectNit?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewDigitalSignatureFilter = {
  and?: InputMaybe<Array<ViewDigitalSignatureFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  expireAt?: InputMaybe<DatetimeFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  issuerCommonName?: InputMaybe<StringFilter>;
  issuerCountry?: InputMaybe<StringFilter>;
  issuerOrganization?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewDigitalSignatureFilter>;
  or?: InputMaybe<Array<ViewDigitalSignatureFilter>>;
  revoked?: InputMaybe<BooleanFilter>;
  subjectBusinessName?: InputMaybe<StringFilter>;
  subjectCountry?: InputMaybe<StringFilter>;
  subjectDocumentComplement?: InputMaybe<StringFilter>;
  subjectDocumentNumber?: InputMaybe<StringFilter>;
  subjectDocumentType?: InputMaybe<StringFilter>;
  subjectJobTitle?: InputMaybe<StringFilter>;
  subjectLegalRepresentative?: InputMaybe<StringFilter>;
  subjectNit?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewDigitalSignatureInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  issuerCommonName?: InputMaybe<Scalars['String']>;
  issuerCountry?: InputMaybe<Scalars['String']>;
  issuerOrganization?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  revoked?: InputMaybe<Scalars['Boolean']>;
  subjectBusinessName?: InputMaybe<Scalars['String']>;
  subjectCountry?: InputMaybe<Scalars['String']>;
  subjectDocumentComplement?: InputMaybe<Scalars['String']>;
  subjectDocumentNumber?: InputMaybe<Scalars['String']>;
  subjectDocumentType?: InputMaybe<Scalars['String']>;
  subjectJobTitle?: InputMaybe<Scalars['String']>;
  subjectLegalRepresentative?: InputMaybe<Scalars['String']>;
  subjectNit?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewDigitalSignaturesConnection = {
  __typename?: 'ViewDigitalSignaturesConnection';
  edges: Array<ViewDigitalSignaturesEdge>;
  nodes: Array<Maybe<ViewDigitalSignature>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewDigitalSignaturesEdge = {
  __typename?: 'ViewDigitalSignaturesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewDigitalSignature>;
};

export enum ViewDigitalSignaturesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  ExpireAtAsc = 'EXPIRE_AT_ASC',
  ExpireAtDesc = 'EXPIRE_AT_DESC',
  IssuedAtAsc = 'ISSUED_AT_ASC',
  IssuedAtDesc = 'ISSUED_AT_DESC',
  IssuerCommonNameAsc = 'ISSUER_COMMON_NAME_ASC',
  IssuerCommonNameDesc = 'ISSUER_COMMON_NAME_DESC',
  IssuerCountryAsc = 'ISSUER_COUNTRY_ASC',
  IssuerCountryDesc = 'ISSUER_COUNTRY_DESC',
  IssuerOrganizationAsc = 'ISSUER_ORGANIZATION_ASC',
  IssuerOrganizationDesc = 'ISSUER_ORGANIZATION_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  RevokedAsc = 'REVOKED_ASC',
  RevokedDesc = 'REVOKED_DESC',
  SubjectBusinessNameAsc = 'SUBJECT_BUSINESS_NAME_ASC',
  SubjectBusinessNameDesc = 'SUBJECT_BUSINESS_NAME_DESC',
  SubjectCountryAsc = 'SUBJECT_COUNTRY_ASC',
  SubjectCountryDesc = 'SUBJECT_COUNTRY_DESC',
  SubjectDocumentComplementAsc = 'SUBJECT_DOCUMENT_COMPLEMENT_ASC',
  SubjectDocumentComplementDesc = 'SUBJECT_DOCUMENT_COMPLEMENT_DESC',
  SubjectDocumentNumberAsc = 'SUBJECT_DOCUMENT_NUMBER_ASC',
  SubjectDocumentNumberDesc = 'SUBJECT_DOCUMENT_NUMBER_DESC',
  SubjectDocumentTypeAsc = 'SUBJECT_DOCUMENT_TYPE_ASC',
  SubjectDocumentTypeDesc = 'SUBJECT_DOCUMENT_TYPE_DESC',
  SubjectJobTitleAsc = 'SUBJECT_JOB_TITLE_ASC',
  SubjectJobTitleDesc = 'SUBJECT_JOB_TITLE_DESC',
  SubjectLegalRepresentativeAsc = 'SUBJECT_LEGAL_REPRESENTATIVE_ASC',
  SubjectLegalRepresentativeDesc = 'SUBJECT_LEGAL_REPRESENTATIVE_DESC',
  SubjectNitAsc = 'SUBJECT_NIT_ASC',
  SubjectNitDesc = 'SUBJECT_NIT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewInvoice = {
  __typename?: 'ViewInvoice';
  additionalDiscount?: Maybe<Scalars['BigFloat']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['Int']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['BigInt']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['BigFloat']>;
  totalAmount?: Maybe<Scalars['BigFloat']>;
  totalAmountCurrency?: Maybe<Scalars['BigFloat']>;
  totalAmountSubjectToIva?: Maybe<Scalars['BigFloat']>;
  totalAmountToPay?: Maybe<Scalars['BigFloat']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  verificationStatus?: Maybe<InvoiceStatus>;
};

export type ViewInvoiceCondition = {
  additionalDiscount?: InputMaybe<Scalars['BigFloat']>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
  documentTypeDescription?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['BigInt']>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvoiceStatus>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  totalAmount?: InputMaybe<Scalars['BigFloat']>;
  totalAmountCurrency?: InputMaybe<Scalars['BigFloat']>;
  totalAmountSubjectToIva?: InputMaybe<Scalars['BigFloat']>;
  totalAmountToPay?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  verificationStatus?: InputMaybe<InvoiceStatus>;
};

export type ViewInvoiceFilter = {
  additionalDiscount?: InputMaybe<BigFloatFilter>;
  and?: InputMaybe<Array<ViewInvoiceFilter>>;
  branchOfficeKey?: InputMaybe<StringFilter>;
  businessName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentTypeCode?: InputMaybe<IntFilter>;
  documentTypeDescription?: InputMaybe<StringFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewInvoiceFilter>;
  number?: InputMaybe<BigIntFilter>;
  or?: InputMaybe<Array<ViewInvoiceFilter>>;
  pointOfSaleKey?: InputMaybe<StringFilter>;
  status?: InputMaybe<InvoiceStatusFilter>;
  subtotal?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountCurrency?: InputMaybe<BigFloatFilter>;
  totalAmountSubjectToIva?: InputMaybe<BigFloatFilter>;
  totalAmountToPay?: InputMaybe<BigFloatFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  verificationStatus?: InputMaybe<InvoiceStatusFilter>;
};

export type ViewInvoicesConnection = {
  __typename?: 'ViewInvoicesConnection';
  edges: Array<ViewInvoicesEdge>;
  nodes: Array<Maybe<ViewInvoice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewInvoicesEdge = {
  __typename?: 'ViewInvoicesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewInvoice>;
};

export enum ViewInvoicesOrderBy {
  AdditionalDiscountAsc = 'ADDITIONAL_DISCOUNT_ASC',
  AdditionalDiscountDesc = 'ADDITIONAL_DISCOUNT_DESC',
  BranchOfficeKeyAsc = 'BRANCH_OFFICE_KEY_ASC',
  BranchOfficeKeyDesc = 'BRANCH_OFFICE_KEY_DESC',
  BusinessNameAsc = 'BUSINESS_NAME_ASC',
  BusinessNameDesc = 'BUSINESS_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DocumentNumberAsc = 'DOCUMENT_NUMBER_ASC',
  DocumentNumberDesc = 'DOCUMENT_NUMBER_DESC',
  DocumentTypeCodeAsc = 'DOCUMENT_TYPE_CODE_ASC',
  DocumentTypeCodeDesc = 'DOCUMENT_TYPE_CODE_DESC',
  DocumentTypeDescriptionAsc = 'DOCUMENT_TYPE_DESCRIPTION_ASC',
  DocumentTypeDescriptionDesc = 'DOCUMENT_TYPE_DESCRIPTION_DESC',
  IssuedAtAsc = 'ISSUED_AT_ASC',
  IssuedAtDesc = 'ISSUED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  PointOfSaleKeyAsc = 'POINT_OF_SALE_KEY_ASC',
  PointOfSaleKeyDesc = 'POINT_OF_SALE_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TotalAmountAsc = 'TOTAL_AMOUNT_ASC',
  TotalAmountCurrencyAsc = 'TOTAL_AMOUNT_CURRENCY_ASC',
  TotalAmountCurrencyDesc = 'TOTAL_AMOUNT_CURRENCY_DESC',
  TotalAmountDesc = 'TOTAL_AMOUNT_DESC',
  TotalAmountSubjectToIvaAsc = 'TOTAL_AMOUNT_SUBJECT_TO_IVA_ASC',
  TotalAmountSubjectToIvaDesc = 'TOTAL_AMOUNT_SUBJECT_TO_IVA_DESC',
  TotalAmountToPayAsc = 'TOTAL_AMOUNT_TO_PAY_ASC',
  TotalAmountToPayDesc = 'TOTAL_AMOUNT_TO_PAY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC'
}

export type ViewOrder = {
  __typename?: 'ViewOrder';
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  discount?: Maybe<Scalars['BigFloat']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['Int']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  invoiceIssuedAt?: Maybe<Scalars['Datetime']>;
  invoiceStatus?: Maybe<InvoiceStatus>;
  invoiceVerificationStatus?: Maybe<InvoiceStatus>;
  key?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['BigFloat']>;
  total?: Maybe<Scalars['BigFloat']>;
};

export type ViewOrderCondition = {
  businessName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
  documentTypeDescription?: InputMaybe<Scalars['String']>;
  invoiceIssuedAt?: InputMaybe<Scalars['Datetime']>;
  invoiceStatus?: InputMaybe<InvoiceStatus>;
  invoiceVerificationStatus?: InputMaybe<InvoiceStatus>;
  key?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  total?: InputMaybe<Scalars['BigFloat']>;
};

export type ViewOrderFilter = {
  and?: InputMaybe<Array<ViewOrderFilter>>;
  businessName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  discount?: InputMaybe<BigFloatFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentTypeCode?: InputMaybe<IntFilter>;
  documentTypeDescription?: InputMaybe<StringFilter>;
  invoiceIssuedAt?: InputMaybe<DatetimeFilter>;
  invoiceStatus?: InputMaybe<InvoiceStatusFilter>;
  invoiceVerificationStatus?: InputMaybe<InvoiceStatusFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewOrderFilter>;
  number?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<ViewOrderFilter>>;
  subtotal?: InputMaybe<BigFloatFilter>;
  total?: InputMaybe<BigFloatFilter>;
};

export type ViewOrdersConnection = {
  __typename?: 'ViewOrdersConnection';
  edges: Array<ViewOrdersEdge>;
  nodes: Array<Maybe<ViewOrder>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewOrdersEdge = {
  __typename?: 'ViewOrdersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewOrder>;
};

export enum ViewOrdersOrderBy {
  BusinessNameAsc = 'BUSINESS_NAME_ASC',
  BusinessNameDesc = 'BUSINESS_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DiscountAsc = 'DISCOUNT_ASC',
  DiscountDesc = 'DISCOUNT_DESC',
  DocumentNumberAsc = 'DOCUMENT_NUMBER_ASC',
  DocumentNumberDesc = 'DOCUMENT_NUMBER_DESC',
  DocumentTypeCodeAsc = 'DOCUMENT_TYPE_CODE_ASC',
  DocumentTypeCodeDesc = 'DOCUMENT_TYPE_CODE_DESC',
  DocumentTypeDescriptionAsc = 'DOCUMENT_TYPE_DESCRIPTION_ASC',
  DocumentTypeDescriptionDesc = 'DOCUMENT_TYPE_DESCRIPTION_DESC',
  InvoiceIssuedAtAsc = 'INVOICE_ISSUED_AT_ASC',
  InvoiceIssuedAtDesc = 'INVOICE_ISSUED_AT_DESC',
  InvoiceStatusAsc = 'INVOICE_STATUS_ASC',
  InvoiceStatusDesc = 'INVOICE_STATUS_DESC',
  InvoiceVerificationStatusAsc = 'INVOICE_VERIFICATION_STATUS_ASC',
  InvoiceVerificationStatusDesc = 'INVOICE_VERIFICATION_STATUS_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TotalAsc = 'TOTAL_ASC',
  TotalDesc = 'TOTAL_DESC'
}

export type ViewPackage = {
  __typename?: 'ViewPackage';
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  invoiceTypeCode?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sectorDocumentCode?: Maybe<Scalars['Int']>;
  sectorDocumentDescription?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<SendingStatus>;
  sendingType?: Maybe<SendingType>;
  sentAt?: Maybe<Scalars['Datetime']>;
  status?: Maybe<PackageStatus>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  validatedAt?: Maybe<Scalars['Datetime']>;
  validationSendingStatus?: Maybe<SendingStatus>;
  validationSendingType?: Maybe<SendingType>;
  validationStatus?: Maybe<PackageValidationStatus>;
};

export type ViewPackageCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  invoiceTypeCode?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sectorDocumentCode?: InputMaybe<Scalars['Int']>;
  sectorDocumentDescription?: InputMaybe<Scalars['String']>;
  sendingStatus?: InputMaybe<SendingStatus>;
  sendingType?: InputMaybe<SendingType>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<PackageStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  validatedAt?: InputMaybe<Scalars['Datetime']>;
  validationSendingStatus?: InputMaybe<SendingStatus>;
  validationSendingType?: InputMaybe<SendingType>;
  validationStatus?: InputMaybe<PackageValidationStatus>;
};

export type ViewPackageFilter = {
  and?: InputMaybe<Array<ViewPackageFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  invoiceTypeCode?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewPackageFilter>;
  or?: InputMaybe<Array<ViewPackageFilter>>;
  quantity?: InputMaybe<IntFilter>;
  sectorDocumentCode?: InputMaybe<IntFilter>;
  sectorDocumentDescription?: InputMaybe<StringFilter>;
  sendingStatus?: InputMaybe<SendingStatusFilter>;
  sendingType?: InputMaybe<SendingTypeFilter>;
  sentAt?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<PackageStatusFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  validatedAt?: InputMaybe<DatetimeFilter>;
  validationSendingStatus?: InputMaybe<SendingStatusFilter>;
  validationSendingType?: InputMaybe<SendingTypeFilter>;
  validationStatus?: InputMaybe<PackageValidationStatusFilter>;
};

export type ViewPackageInvoice = {
  __typename?: 'ViewPackageInvoice';
  additionalDiscount?: Maybe<Scalars['BigFloat']>;
  businessName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  date?: Maybe<Scalars['Date']>;
  documentNumber?: Maybe<Scalars['String']>;
  documentTypeCode?: Maybe<Scalars['Int']>;
  documentTypeDescription?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['BigInt']>;
  packageKey?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['BigFloat']>;
  totalAmount?: Maybe<Scalars['BigFloat']>;
  totalAmountCurrency?: Maybe<Scalars['BigFloat']>;
  totalAmountSubjectToIva?: Maybe<Scalars['BigFloat']>;
  totalAmountToPay?: Maybe<Scalars['BigFloat']>;
  verificationStatus?: Maybe<InvoiceStatus>;
};

export type ViewPackageInvoiceCondition = {
  additionalDiscount?: InputMaybe<Scalars['BigFloat']>;
  businessName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
  documentTypeDescription?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['BigInt']>;
  packageKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<InvoiceStatus>;
  subtotal?: InputMaybe<Scalars['BigFloat']>;
  totalAmount?: InputMaybe<Scalars['BigFloat']>;
  totalAmountCurrency?: InputMaybe<Scalars['BigFloat']>;
  totalAmountSubjectToIva?: InputMaybe<Scalars['BigFloat']>;
  totalAmountToPay?: InputMaybe<Scalars['BigFloat']>;
  verificationStatus?: InputMaybe<InvoiceStatus>;
};

export type ViewPackageInvoiceFilter = {
  additionalDiscount?: InputMaybe<BigFloatFilter>;
  and?: InputMaybe<Array<ViewPackageInvoiceFilter>>;
  businessName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  documentNumber?: InputMaybe<StringFilter>;
  documentTypeCode?: InputMaybe<IntFilter>;
  documentTypeDescription?: InputMaybe<StringFilter>;
  issuedAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewPackageInvoiceFilter>;
  number?: InputMaybe<BigIntFilter>;
  or?: InputMaybe<Array<ViewPackageInvoiceFilter>>;
  packageKey?: InputMaybe<StringFilter>;
  status?: InputMaybe<InvoiceStatusFilter>;
  subtotal?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountCurrency?: InputMaybe<BigFloatFilter>;
  totalAmountSubjectToIva?: InputMaybe<BigFloatFilter>;
  totalAmountToPay?: InputMaybe<BigFloatFilter>;
  verificationStatus?: InputMaybe<InvoiceStatusFilter>;
};

export type ViewPackageInvoicesConnection = {
  __typename?: 'ViewPackageInvoicesConnection';
  edges: Array<ViewPackageInvoicesEdge>;
  nodes: Array<Maybe<ViewPackageInvoice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewPackageInvoicesEdge = {
  __typename?: 'ViewPackageInvoicesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewPackageInvoice>;
};

export enum ViewPackageInvoicesOrderBy {
  AdditionalDiscountAsc = 'ADDITIONAL_DISCOUNT_ASC',
  AdditionalDiscountDesc = 'ADDITIONAL_DISCOUNT_DESC',
  BusinessNameAsc = 'BUSINESS_NAME_ASC',
  BusinessNameDesc = 'BUSINESS_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DocumentNumberAsc = 'DOCUMENT_NUMBER_ASC',
  DocumentNumberDesc = 'DOCUMENT_NUMBER_DESC',
  DocumentTypeCodeAsc = 'DOCUMENT_TYPE_CODE_ASC',
  DocumentTypeCodeDesc = 'DOCUMENT_TYPE_CODE_DESC',
  DocumentTypeDescriptionAsc = 'DOCUMENT_TYPE_DESCRIPTION_ASC',
  DocumentTypeDescriptionDesc = 'DOCUMENT_TYPE_DESCRIPTION_DESC',
  IssuedAtAsc = 'ISSUED_AT_ASC',
  IssuedAtDesc = 'ISSUED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  PackageKeyAsc = 'PACKAGE_KEY_ASC',
  PackageKeyDesc = 'PACKAGE_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SubtotalAsc = 'SUBTOTAL_ASC',
  SubtotalDesc = 'SUBTOTAL_DESC',
  TotalAmountAsc = 'TOTAL_AMOUNT_ASC',
  TotalAmountCurrencyAsc = 'TOTAL_AMOUNT_CURRENCY_ASC',
  TotalAmountCurrencyDesc = 'TOTAL_AMOUNT_CURRENCY_DESC',
  TotalAmountDesc = 'TOTAL_AMOUNT_DESC',
  TotalAmountSubjectToIvaAsc = 'TOTAL_AMOUNT_SUBJECT_TO_IVA_ASC',
  TotalAmountSubjectToIvaDesc = 'TOTAL_AMOUNT_SUBJECT_TO_IVA_DESC',
  TotalAmountToPayAsc = 'TOTAL_AMOUNT_TO_PAY_ASC',
  TotalAmountToPayDesc = 'TOTAL_AMOUNT_TO_PAY_DESC',
  VerificationStatusAsc = 'VERIFICATION_STATUS_ASC',
  VerificationStatusDesc = 'VERIFICATION_STATUS_DESC'
}

export type ViewPackagesConnection = {
  __typename?: 'ViewPackagesConnection';
  edges: Array<ViewPackagesEdge>;
  nodes: Array<Maybe<ViewPackage>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewPackagesEdge = {
  __typename?: 'ViewPackagesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewPackage>;
};

export enum ViewPackagesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  InvoiceTypeCodeAsc = 'INVOICE_TYPE_CODE_ASC',
  InvoiceTypeCodeDesc = 'INVOICE_TYPE_CODE_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  SectorDocumentCodeAsc = 'SECTOR_DOCUMENT_CODE_ASC',
  SectorDocumentCodeDesc = 'SECTOR_DOCUMENT_CODE_DESC',
  SectorDocumentDescriptionAsc = 'SECTOR_DOCUMENT_DESCRIPTION_ASC',
  SectorDocumentDescriptionDesc = 'SECTOR_DOCUMENT_DESCRIPTION_DESC',
  SendingStatusAsc = 'SENDING_STATUS_ASC',
  SendingStatusDesc = 'SENDING_STATUS_DESC',
  SendingTypeAsc = 'SENDING_TYPE_ASC',
  SendingTypeDesc = 'SENDING_TYPE_DESC',
  SentAtAsc = 'SENT_AT_ASC',
  SentAtDesc = 'SENT_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidatedAtAsc = 'VALIDATED_AT_ASC',
  ValidatedAtDesc = 'VALIDATED_AT_DESC',
  ValidationSendingStatusAsc = 'VALIDATION_SENDING_STATUS_ASC',
  ValidationSendingStatusDesc = 'VALIDATION_SENDING_STATUS_DESC',
  ValidationSendingTypeAsc = 'VALIDATION_SENDING_TYPE_ASC',
  ValidationSendingTypeDesc = 'VALIDATION_SENDING_TYPE_DESC',
  ValidationStatusAsc = 'VALIDATION_STATUS_ASC',
  ValidationStatusDesc = 'VALIDATION_STATUS_DESC'
}

export type ViewPaymentMethod = {
  __typename?: 'ViewPaymentMethod';
  classifierCode?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  showCardNumber?: Maybe<Scalars['Boolean']>;
  showGiftCard?: Maybe<Scalars['Boolean']>;
  type?: Maybe<SyncParameterType>;
};

export type ViewPaymentMethodCondition = {
  classifierCode?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  showCardNumber?: InputMaybe<Scalars['Boolean']>;
  showGiftCard?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<SyncParameterType>;
};

export type ViewPaymentMethodFilter = {
  and?: InputMaybe<Array<ViewPaymentMethodFilter>>;
  classifierCode?: InputMaybe<IntFilter>;
  description?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewPaymentMethodFilter>;
  or?: InputMaybe<Array<ViewPaymentMethodFilter>>;
  showCardNumber?: InputMaybe<BooleanFilter>;
  showGiftCard?: InputMaybe<BooleanFilter>;
  type?: InputMaybe<SyncParameterTypeFilter>;
};

export type ViewPaymentMethodsConnection = {
  __typename?: 'ViewPaymentMethodsConnection';
  edges: Array<ViewPaymentMethodsEdge>;
  nodes: Array<Maybe<ViewPaymentMethod>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewPaymentMethodsEdge = {
  __typename?: 'ViewPaymentMethodsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewPaymentMethod>;
};

export enum ViewPaymentMethodsOrderBy {
  ClassifierCodeAsc = 'CLASSIFIER_CODE_ASC',
  ClassifierCodeDesc = 'CLASSIFIER_CODE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  Natural = 'NATURAL',
  ShowCardNumberAsc = 'SHOW_CARD_NUMBER_ASC',
  ShowCardNumberDesc = 'SHOW_CARD_NUMBER_DESC',
  ShowGiftCardAsc = 'SHOW_GIFT_CARD_ASC',
  ShowGiftCardDesc = 'SHOW_GIFT_CARD_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type ViewPointOfSale = {
  __typename?: 'ViewPointOfSale';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  commissionAgentNit?: Maybe<Scalars['BigInt']>;
  contractNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cufd?: Maybe<Scalars['String']>;
  cufdExpireAt?: Maybe<Scalars['Datetime']>;
  cuis?: Maybe<Scalars['String']>;
  cuisExpireAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  finishDate?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  modalityCode?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
  status?: Maybe<PointOfSaleStatus>;
  typeCode?: Maybe<Scalars['Int']>;
  typeDescription?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewPointOfSaleCondition = {
  branchOfficeCode?: InputMaybe<Scalars['Int']>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  branchOfficeName?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  commissionAgentNit?: InputMaybe<Scalars['BigInt']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cufd?: InputMaybe<Scalars['String']>;
  cufdExpireAt?: InputMaybe<Scalars['Datetime']>;
  cuis?: InputMaybe<Scalars['String']>;
  cuisExpireAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  modalityCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<PointOfSaleStatus>;
  typeCode?: InputMaybe<Scalars['Int']>;
  typeDescription?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewPointOfSaleFilter = {
  and?: InputMaybe<Array<ViewPointOfSaleFilter>>;
  branchOfficeCode?: InputMaybe<IntFilter>;
  branchOfficeKey?: InputMaybe<StringFilter>;
  branchOfficeName?: InputMaybe<StringFilter>;
  code?: InputMaybe<IntFilter>;
  commissionAgentNit?: InputMaybe<BigIntFilter>;
  contractNumber?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  cufd?: InputMaybe<StringFilter>;
  cufdExpireAt?: InputMaybe<DatetimeFilter>;
  cuis?: InputMaybe<StringFilter>;
  cuisExpireAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  finishDate?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  modalityCode?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewPointOfSaleFilter>;
  or?: InputMaybe<Array<ViewPointOfSaleFilter>>;
  startDate?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<PointOfSaleStatusFilter>;
  typeCode?: InputMaybe<IntFilter>;
  typeDescription?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewPointOfSalesConnection = {
  __typename?: 'ViewPointOfSalesConnection';
  edges: Array<ViewPointOfSalesEdge>;
  nodes: Array<Maybe<ViewPointOfSale>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewPointOfSalesEdge = {
  __typename?: 'ViewPointOfSalesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewPointOfSale>;
};

export enum ViewPointOfSalesOrderBy {
  BranchOfficeCodeAsc = 'BRANCH_OFFICE_CODE_ASC',
  BranchOfficeCodeDesc = 'BRANCH_OFFICE_CODE_DESC',
  BranchOfficeKeyAsc = 'BRANCH_OFFICE_KEY_ASC',
  BranchOfficeKeyDesc = 'BRANCH_OFFICE_KEY_DESC',
  BranchOfficeNameAsc = 'BRANCH_OFFICE_NAME_ASC',
  BranchOfficeNameDesc = 'BRANCH_OFFICE_NAME_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CommissionAgentNitAsc = 'COMMISSION_AGENT_NIT_ASC',
  CommissionAgentNitDesc = 'COMMISSION_AGENT_NIT_DESC',
  ContractNumberAsc = 'CONTRACT_NUMBER_ASC',
  ContractNumberDesc = 'CONTRACT_NUMBER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CufdAsc = 'CUFD_ASC',
  CufdDesc = 'CUFD_DESC',
  CufdExpireAtAsc = 'CUFD_EXPIRE_AT_ASC',
  CufdExpireAtDesc = 'CUFD_EXPIRE_AT_DESC',
  CuisAsc = 'CUIS_ASC',
  CuisDesc = 'CUIS_DESC',
  CuisExpireAtAsc = 'CUIS_EXPIRE_AT_ASC',
  CuisExpireAtDesc = 'CUIS_EXPIRE_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FinishDateAsc = 'FINISH_DATE_ASC',
  FinishDateDesc = 'FINISH_DATE_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  ModalityCodeAsc = 'MODALITY_CODE_ASC',
  ModalityCodeDesc = 'MODALITY_CODE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TypeCodeAsc = 'TYPE_CODE_ASC',
  TypeCodeDesc = 'TYPE_CODE_DESC',
  TypeDescriptionAsc = 'TYPE_DESCRIPTION_ASC',
  TypeDescriptionDesc = 'TYPE_DESCRIPTION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewProduct = {
  __typename?: 'ViewProduct';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  homologationActivityCode?: Maybe<Scalars['String']>;
  homologationActivityDescription?: Maybe<Scalars['String']>;
  homologationMeasureUnitCode?: Maybe<Scalars['Int']>;
  homologationMeasureUnitDescription?: Maybe<Scalars['String']>;
  homologationProductCode?: Maybe<Scalars['Int']>;
  homologationProductDescription?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigFloat']>;
  type?: Maybe<ProductType>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewProductCondition = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  homologationActivityCode?: InputMaybe<Scalars['String']>;
  homologationActivityDescription?: InputMaybe<Scalars['String']>;
  homologationMeasureUnitCode?: InputMaybe<Scalars['Int']>;
  homologationMeasureUnitDescription?: InputMaybe<Scalars['String']>;
  homologationProductCode?: InputMaybe<Scalars['Int']>;
  homologationProductDescription?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  type?: InputMaybe<ProductType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewProductFilter = {
  and?: InputMaybe<Array<ViewProductFilter>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  homologationActivityCode?: InputMaybe<StringFilter>;
  homologationActivityDescription?: InputMaybe<StringFilter>;
  homologationMeasureUnitCode?: InputMaybe<IntFilter>;
  homologationMeasureUnitDescription?: InputMaybe<StringFilter>;
  homologationProductCode?: InputMaybe<IntFilter>;
  homologationProductDescription?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewProductFilter>;
  or?: InputMaybe<Array<ViewProductFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  type?: InputMaybe<ProductTypeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewProductsConnection = {
  __typename?: 'ViewProductsConnection';
  edges: Array<ViewProductsEdge>;
  nodes: Array<Maybe<ViewProduct>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewProductsEdge = {
  __typename?: 'ViewProductsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewProduct>;
};

export enum ViewProductsOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  HomologationActivityCodeAsc = 'HOMOLOGATION_ACTIVITY_CODE_ASC',
  HomologationActivityCodeDesc = 'HOMOLOGATION_ACTIVITY_CODE_DESC',
  HomologationActivityDescriptionAsc = 'HOMOLOGATION_ACTIVITY_DESCRIPTION_ASC',
  HomologationActivityDescriptionDesc = 'HOMOLOGATION_ACTIVITY_DESCRIPTION_DESC',
  HomologationMeasureUnitCodeAsc = 'HOMOLOGATION_MEASURE_UNIT_CODE_ASC',
  HomologationMeasureUnitCodeDesc = 'HOMOLOGATION_MEASURE_UNIT_CODE_DESC',
  HomologationMeasureUnitDescriptionAsc = 'HOMOLOGATION_MEASURE_UNIT_DESCRIPTION_ASC',
  HomologationMeasureUnitDescriptionDesc = 'HOMOLOGATION_MEASURE_UNIT_DESCRIPTION_DESC',
  HomologationProductCodeAsc = 'HOMOLOGATION_PRODUCT_CODE_ASC',
  HomologationProductCodeDesc = 'HOMOLOGATION_PRODUCT_CODE_DESC',
  HomologationProductDescriptionAsc = 'HOMOLOGATION_PRODUCT_DESCRIPTION_ASC',
  HomologationProductDescriptionDesc = 'HOMOLOGATION_PRODUCT_DESCRIPTION_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewRole = {
  __typename?: 'ViewRole';
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type ViewRoleCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export type ViewRoleFilter = {
  and?: InputMaybe<Array<ViewRoleFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewRoleFilter>;
  or?: InputMaybe<Array<ViewRoleFilter>>;
  updatedBy?: InputMaybe<IntFilter>;
};

export type ViewRolesConnection = {
  __typename?: 'ViewRolesConnection';
  edges: Array<ViewRolesEdge>;
  nodes: Array<Maybe<ViewRole>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewRolesEdge = {
  __typename?: 'ViewRolesEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewRole>;
};

export enum ViewRolesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type ViewSignificantEvent = {
  __typename?: 'ViewSignificantEvent';
  branchOfficeCode?: Maybe<Scalars['Int']>;
  branchOfficeKey?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  cufd?: Maybe<Scalars['String']>;
  cufdEvent?: Maybe<Scalars['String']>;
  cuis?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  finishDate?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  pointOfSaleCode?: Maybe<Scalars['Int']>;
  pointOfSaleKey?: Maybe<Scalars['String']>;
  pointOfSaleName?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['Int']>;
  reasonDescription?: Maybe<Scalars['String']>;
  receptionCode?: Maybe<Scalars['BigInt']>;
  sendingStatus?: Maybe<SendingStatus>;
  sendingType?: Maybe<SendingType>;
  sentAt?: Maybe<Scalars['Datetime']>;
  startDate?: Maybe<Scalars['Datetime']>;
  status?: Maybe<SignificantEventStatus>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewSignificantEventCondition = {
  branchOfficeCode?: InputMaybe<Scalars['Int']>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  branchOfficeName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cufd?: InputMaybe<Scalars['String']>;
  cufdEvent?: InputMaybe<Scalars['String']>;
  cuis?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  pointOfSaleCode?: InputMaybe<Scalars['Int']>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  pointOfSaleName?: InputMaybe<Scalars['String']>;
  reasonCode?: InputMaybe<Scalars['Int']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  receptionCode?: InputMaybe<Scalars['BigInt']>;
  sendingStatus?: InputMaybe<SendingStatus>;
  sendingType?: InputMaybe<SendingType>;
  sentAt?: InputMaybe<Scalars['Datetime']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<SignificantEventStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewSignificantEventFilter = {
  and?: InputMaybe<Array<ViewSignificantEventFilter>>;
  branchOfficeCode?: InputMaybe<IntFilter>;
  branchOfficeKey?: InputMaybe<StringFilter>;
  branchOfficeName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  cufd?: InputMaybe<StringFilter>;
  cufdEvent?: InputMaybe<StringFilter>;
  cuis?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  finishDate?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewSignificantEventFilter>;
  or?: InputMaybe<Array<ViewSignificantEventFilter>>;
  pointOfSaleCode?: InputMaybe<IntFilter>;
  pointOfSaleKey?: InputMaybe<StringFilter>;
  pointOfSaleName?: InputMaybe<StringFilter>;
  reasonCode?: InputMaybe<IntFilter>;
  reasonDescription?: InputMaybe<StringFilter>;
  receptionCode?: InputMaybe<BigIntFilter>;
  sendingStatus?: InputMaybe<SendingStatusFilter>;
  sendingType?: InputMaybe<SendingTypeFilter>;
  sentAt?: InputMaybe<DatetimeFilter>;
  startDate?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<SignificantEventStatusFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewSignificantEventsConnection = {
  __typename?: 'ViewSignificantEventsConnection';
  edges: Array<ViewSignificantEventsEdge>;
  nodes: Array<Maybe<ViewSignificantEvent>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewSignificantEventsEdge = {
  __typename?: 'ViewSignificantEventsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewSignificantEvent>;
};

export enum ViewSignificantEventsOrderBy {
  BranchOfficeCodeAsc = 'BRANCH_OFFICE_CODE_ASC',
  BranchOfficeCodeDesc = 'BRANCH_OFFICE_CODE_DESC',
  BranchOfficeKeyAsc = 'BRANCH_OFFICE_KEY_ASC',
  BranchOfficeKeyDesc = 'BRANCH_OFFICE_KEY_DESC',
  BranchOfficeNameAsc = 'BRANCH_OFFICE_NAME_ASC',
  BranchOfficeNameDesc = 'BRANCH_OFFICE_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CufdAsc = 'CUFD_ASC',
  CufdDesc = 'CUFD_DESC',
  CufdEventAsc = 'CUFD_EVENT_ASC',
  CufdEventDesc = 'CUFD_EVENT_DESC',
  CuisAsc = 'CUIS_ASC',
  CuisDesc = 'CUIS_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FinishDateAsc = 'FINISH_DATE_ASC',
  FinishDateDesc = 'FINISH_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PointOfSaleCodeAsc = 'POINT_OF_SALE_CODE_ASC',
  PointOfSaleCodeDesc = 'POINT_OF_SALE_CODE_DESC',
  PointOfSaleKeyAsc = 'POINT_OF_SALE_KEY_ASC',
  PointOfSaleKeyDesc = 'POINT_OF_SALE_KEY_DESC',
  PointOfSaleNameAsc = 'POINT_OF_SALE_NAME_ASC',
  PointOfSaleNameDesc = 'POINT_OF_SALE_NAME_DESC',
  ReasonCodeAsc = 'REASON_CODE_ASC',
  ReasonCodeDesc = 'REASON_CODE_DESC',
  ReasonDescriptionAsc = 'REASON_DESCRIPTION_ASC',
  ReasonDescriptionDesc = 'REASON_DESCRIPTION_DESC',
  ReceptionCodeAsc = 'RECEPTION_CODE_ASC',
  ReceptionCodeDesc = 'RECEPTION_CODE_DESC',
  SendingStatusAsc = 'SENDING_STATUS_ASC',
  SendingStatusDesc = 'SENDING_STATUS_DESC',
  SendingTypeAsc = 'SENDING_TYPE_ASC',
  SendingTypeDesc = 'SENDING_TYPE_DESC',
  SentAtAsc = 'SENT_AT_ASC',
  SentAtDesc = 'SENT_AT_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ViewSyncParameter = {
  __typename?: 'ViewSyncParameter';
  classifierCode?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<SyncParameterType>;
};

export type ViewSyncParameterCondition = {
  classifierCode?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SyncParameterType>;
};

export type ViewSyncParameterFilter = {
  and?: InputMaybe<Array<ViewSyncParameterFilter>>;
  classifierCode?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewSyncParameterFilter>;
  or?: InputMaybe<Array<ViewSyncParameterFilter>>;
  type?: InputMaybe<SyncParameterTypeFilter>;
};

export type ViewSyncParameterInput = {
  classifierCode?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SyncParameterType>;
};

export type ViewSyncParametersConnection = {
  __typename?: 'ViewSyncParametersConnection';
  edges: Array<ViewSyncParametersEdge>;
  nodes: Array<Maybe<ViewSyncParameter>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewSyncParametersEdge = {
  __typename?: 'ViewSyncParametersEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewSyncParameter>;
};

export enum ViewSyncParametersOrderBy {
  ClassifierCodeAsc = 'CLASSIFIER_CODE_ASC',
  ClassifierCodeDesc = 'CLASSIFIER_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  Natural = 'NATURAL',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type ViewSyncProduct = {
  __typename?: 'ViewSyncProduct';
  activityCode?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
};

export type ViewSyncProductCondition = {
  activityCode?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
};

export type ViewSyncProductFilter = {
  activityCode?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<ViewSyncProductFilter>>;
  code?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewSyncProductFilter>;
  or?: InputMaybe<Array<ViewSyncProductFilter>>;
};

export type ViewSyncProductsConnection = {
  __typename?: 'ViewSyncProductsConnection';
  edges: Array<ViewSyncProductsEdge>;
  nodes: Array<Maybe<ViewSyncProduct>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewSyncProductsEdge = {
  __typename?: 'ViewSyncProductsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewSyncProduct>;
};

export enum ViewSyncProductsOrderBy {
  ActivityCodeAsc = 'ACTIVITY_CODE_ASC',
  ActivityCodeDesc = 'ACTIVITY_CODE_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  Natural = 'NATURAL'
}

export type ViewSyncRequest = {
  __typename?: 'ViewSyncRequest';
  createdAt?: Maybe<Scalars['Datetime']>;
  key?: Maybe<Scalars['String']>;
  sendingStatus?: Maybe<SendingStatus>;
  sendingType?: Maybe<SendingType>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<SyncRequestType>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type ViewSyncRequestCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  sendingStatus?: InputMaybe<SendingStatus>;
  sendingType?: InputMaybe<SendingType>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SyncRequestType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewSyncRequestFilter = {
  and?: InputMaybe<Array<ViewSyncRequestFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  key?: InputMaybe<StringFilter>;
  not?: InputMaybe<ViewSyncRequestFilter>;
  or?: InputMaybe<Array<ViewSyncRequestFilter>>;
  sendingStatus?: InputMaybe<SendingStatusFilter>;
  sendingType?: InputMaybe<SendingTypeFilter>;
  status?: InputMaybe<StringFilter>;
  type?: InputMaybe<SyncRequestTypeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type ViewSyncRequestInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  key?: InputMaybe<Scalars['String']>;
  sendingStatus?: InputMaybe<SendingStatus>;
  sendingType?: InputMaybe<SendingType>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SyncRequestType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ViewSyncRequestsConnection = {
  __typename?: 'ViewSyncRequestsConnection';
  edges: Array<ViewSyncRequestsEdge>;
  nodes: Array<Maybe<ViewSyncRequest>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ViewSyncRequestsEdge = {
  __typename?: 'ViewSyncRequestsEdge';
  cursor?: Maybe<Scalars['Cursor']>;
  node?: Maybe<ViewSyncRequest>;
};

export enum ViewSyncRequestsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  SendingStatusAsc = 'SENDING_STATUS_ASC',
  SendingStatusDesc = 'SENDING_STATUS_DESC',
  SendingTypeAsc = 'SENDING_TYPE_ASC',
  SendingTypeDesc = 'SENDING_TYPE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type UpdateBranchOfficeOnPointOfSaleForFkPointOfSaleToBranchOfficePatch = {
  address?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  municipality?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSales?: InputMaybe<FkPointOfSaleToBranchOfficeInverseInput>;
};

export type UpdateClientHomologationOnClientHomologationForFkClientHomologationToClientPatch = {
  allowInvalidNit?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<FkClientHomologationToClientInput>;
  documentComplement?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  documentTypeCode?: InputMaybe<Scalars['Int']>;
};

export type UpdateClientOnClientHomologationForFkClientHomologationToClientPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  homologations?: InputMaybe<FkClientHomologationToClientInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToClientInverseInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateClientOnOrderForFkOrderToClientPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  homologations?: InputMaybe<FkClientHomologationToClientInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToClientInverseInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  exportServiceOrder?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInput>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkExportServiceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateExportServiceOrderDetailOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  exportServiceOrder?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInput>;
  exportServiceOrderKey?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productService?: InputMaybe<FkExportServiceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateExportServiceOrderOnExportServiceOrderDetailForFkExportServiceOrderDetailToExportServiceOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInverseInput>;
  order?: InputMaybe<FkExportServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinCodigoPais?: InputMaybe<Scalars['Int']>;
  sinDireccionComprador?: InputMaybe<Scalars['String']>;
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino?: InputMaybe<Scalars['String']>;
};

export type UpdateExportServiceOrderOnExportServiceOrderForFkExportServiceOrderToOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToExportServiceOrderInverseInput>;
  order?: InputMaybe<FkExportServiceOrderToOrderInput>;
  sinCodigoPais?: InputMaybe<Scalars['Int']>;
  sinDireccionComprador?: InputMaybe<Scalars['String']>;
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  sinLugarDestino?: InputMaybe<Scalars['String']>;
};

export type UpdateInsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  insuranceOrder?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInput>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkInsuranceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateInsuranceOrderDetailOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  insuranceOrder?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInput>;
  insuranceOrderKey?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productService?: InputMaybe<FkInsuranceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateInsuranceOrderOnInsuranceOrderDetailForFkInsuranceOrderDetailToInsuranceOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInverseInput>;
  order?: InputMaybe<FkInsuranceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  sinAjusteAfectacionIva?: InputMaybe<Scalars['BigFloat']>;
};

export type UpdateInsuranceOrderOnInsuranceOrderForFkInsuranceOrderToOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToInsuranceOrderInverseInput>;
  order?: InputMaybe<FkInsuranceOrderToOrderInput>;
  sinAjusteAfectacionIva?: InputMaybe<Scalars['BigFloat']>;
};

export type UpdateOrderHomologationOnOrderHomologationForFkOrderHomologationToOrderPatch = {
  activityCode?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['BigInt']>;
  currencyCode?: InputMaybe<Scalars['Int']>;
  emissionTypeCode?: InputMaybe<Scalars['Int']>;
  exchangeRate?: InputMaybe<Scalars['BigFloat']>;
  invoiceTypeCode?: InputMaybe<Scalars['Int']>;
  modalityTypeCode?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<FkOrderHomologationToOrderInput>;
  paymentMethodCode?: InputMaybe<Scalars['Int']>;
  sectorDocumentCode?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrderOnExportServiceOrderForFkExportServiceOrderToOrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnInsuranceOrderForFkInsuranceOrderToOrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnOrderForFkOrderToClientPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnOrderForFkOrderToPointOfSalePatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnOrderHomologationForFkOrderHomologationToOrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnRentalOrderForFkRentalOrderToOrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnSaleOrderForFkSaleOrderToOrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdateOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderPatch = {
  client?: InputMaybe<FkOrderToClientInput>;
  clientKey?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['BigFloat']>;
  email?: InputMaybe<Scalars['String']>;
  exportServiceOrders?: InputMaybe<FkExportServiceOrderToOrderInverseInput>;
  homologations?: InputMaybe<FkOrderHomologationToOrderInverseInput>;
  insuranceOrders?: InputMaybe<FkInsuranceOrderToOrderInverseInput>;
  paymentAmount?: InputMaybe<Scalars['BigFloat']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pointOfSale?: InputMaybe<FkOrderToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  rentalOrders?: InputMaybe<FkRentalOrderToOrderInverseInput>;
  saleOrders?: InputMaybe<FkSaleOrderToOrderInverseInput>;
  status?: InputMaybe<OrderStatus>;
  touristServiceOrders?: InputMaybe<FkTouristServiceOrderToOrderInverseInput>;
};

export type UpdatePersonOnUserForFkAppUserToPersonPatch = {
  firstName?: InputMaybe<Scalars['String']>;
  firstSurname?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  secondSurname?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<FkAppUserToPersonInverseInput>;
};

export type UpdatePointOfSaleOnOrderForFkOrderToPointOfSalePatch = {
  branchOffice?: InputMaybe<FkPointOfSaleToBranchOfficeInput>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  commissionAgentNit?: InputMaybe<Scalars['BigInt']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['Datetime']>;
  modalityCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToPointOfSaleInverseInput>;
  pointOfSaleUsers?: InputMaybe<FkPointOfSaleUserToPointOfSaleInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<PointOfSaleStatus>;
  typeCode?: InputMaybe<Scalars['Int']>;
};

export type UpdatePointOfSaleOnPointOfSaleForFkPointOfSaleToBranchOfficePatch = {
  branchOffice?: InputMaybe<FkPointOfSaleToBranchOfficeInput>;
  code?: InputMaybe<Scalars['Int']>;
  commissionAgentNit?: InputMaybe<Scalars['BigInt']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['Datetime']>;
  modalityCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToPointOfSaleInverseInput>;
  pointOfSaleUsers?: InputMaybe<FkPointOfSaleUserToPointOfSaleInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<PointOfSaleStatus>;
  typeCode?: InputMaybe<Scalars['Int']>;
};

export type UpdatePointOfSaleOnPointOfSaleUserForFkPointOfSaleUserToPointOfSalePatch = {
  branchOffice?: InputMaybe<FkPointOfSaleToBranchOfficeInput>;
  branchOfficeKey?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['Int']>;
  commissionAgentNit?: InputMaybe<Scalars['BigInt']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['Datetime']>;
  modalityCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<FkOrderToPointOfSaleInverseInput>;
  pointOfSaleUsers?: InputMaybe<FkPointOfSaleUserToPointOfSaleInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<PointOfSaleStatus>;
  typeCode?: InputMaybe<Scalars['Int']>;
};

export type UpdatePointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToPointOfSalePatch = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<FkPointOfSaleUserToPointOfSaleInput>;
  user?: InputMaybe<FkPointOfSaleUserToUserInput>;
  userKey?: InputMaybe<Scalars['String']>;
};

export type UpdatePointOfSaleUserOnPointOfSaleUserForFkPointOfSaleUserToUserPatch = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<FkPointOfSaleUserToPointOfSaleInput>;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FkPointOfSaleUserToUserInput>;
};

export type UpdateProductHomologationOnProductHomologationForFkProductHomologationToProductPatch = {
  activityCode?: InputMaybe<Scalars['String']>;
  measureUnitCode?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['Int']>;
  productService?: InputMaybe<FkProductHomologationToProductInput>;
};

export type UpdateProductOnExportServiceOrderDetailForFkExportServiceOrderDetailToProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type UpdateProductOnInsuranceOrderDetailForFkInsuranceOrderDetailToProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type UpdateProductOnProductHomologationForFkProductHomologationToProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type UpdateProductOnRentalOrderDetailForFkRentalOrderDetailToProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type UpdateProductOnSaleOrderDetailForFkSaleOrderDetailToProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type UpdateProductOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductPatch = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<FkExportServiceOrderDetailToProductInverseInput>;
  homologations?: InputMaybe<FkProductHomologationToProductInverseInput>;
  insuranceOrderDetails?: InputMaybe<FkInsuranceOrderDetailToProductInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToProductInverseInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToProductInverseInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToProductInverseInput>;
  type?: InputMaybe<ProductType>;
};

export type UpdateRentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToProductPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productService?: InputMaybe<FkRentalOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  rentalOrder?: InputMaybe<FkRentalOrderDetailToRentalOrderInput>;
  rentalOrderKey?: InputMaybe<Scalars['String']>;
};

export type UpdateRentalOrderDetailOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkRentalOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  rentalOrder?: InputMaybe<FkRentalOrderDetailToRentalOrderInput>;
};

export type UpdateRentalOrderOnRentalOrderDetailForFkRentalOrderDetailToRentalOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<FkRentalOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToRentalOrderInverseInput>;
};

export type UpdateRentalOrderOnRentalOrderForFkRentalOrderToOrderPatch = {
  deletion?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<FkRentalOrderToOrderInput>;
  period?: InputMaybe<Scalars['String']>;
  rentalOrderDetails?: InputMaybe<FkRentalOrderDetailToRentalOrderInverseInput>;
};

export type UpdateSaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToProductPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productService?: InputMaybe<FkSaleOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  saleOrder?: InputMaybe<FkSaleOrderDetailToSaleOrderInput>;
  saleOrderKey?: InputMaybe<Scalars['String']>;
  sinNumeroImei?: InputMaybe<Scalars['String']>;
  sinNumeroSerie?: InputMaybe<Scalars['String']>;
};

export type UpdateSaleOrderDetailOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkSaleOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  saleOrder?: InputMaybe<FkSaleOrderDetailToSaleOrderInput>;
  sinNumeroImei?: InputMaybe<Scalars['String']>;
  sinNumeroSerie?: InputMaybe<Scalars['String']>;
};

export type UpdateSaleOrderOnSaleOrderDetailForFkSaleOrderDetailToSaleOrderPatch = {
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  order?: InputMaybe<FkSaleOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToSaleOrderInverseInput>;
};

export type UpdateSaleOrderOnSaleOrderForFkSaleOrderToOrderPatch = {
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  order?: InputMaybe<FkSaleOrderToOrderInput>;
  saleOrderDetails?: InputMaybe<FkSaleOrderDetailToSaleOrderInverseInput>;
};

export type UpdateTouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToProductPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productService?: InputMaybe<FkTouristServiceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  touristServiceOrder?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInput>;
  touristServiceOrderKey?: InputMaybe<Scalars['String']>;
};

export type UpdateTouristServiceOrderDetailOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderPatch = {
  discount?: InputMaybe<Scalars['BigFloat']>;
  price?: InputMaybe<Scalars['BigFloat']>;
  productKey?: InputMaybe<Scalars['String']>;
  productService?: InputMaybe<FkTouristServiceOrderDetailToProductInput>;
  quantity?: InputMaybe<Scalars['BigFloat']>;
  sinDetalleHuespedesJson?: InputMaybe<Scalars['String']>;
  sinTipoHabitacionCodigo?: InputMaybe<Scalars['Int']>;
  touristServiceOrder?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInput>;
};

export type UpdateTouristServiceOrderOnTouristServiceOrderDetailForFkTouristServiceOrderDetailToTouristServiceOrderPatch = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<FkTouristServiceOrderToOrderInput>;
  orderKey?: InputMaybe<Scalars['String']>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInverseInput>;
};

export type UpdateTouristServiceOrderOnTouristServiceOrderForFkTouristServiceOrderToOrderPatch = {
  cantidadHabitaciones?: InputMaybe<Scalars['Int']>;
  cantidadHuespedes?: InputMaybe<Scalars['Int']>;
  cantidadMayores?: InputMaybe<Scalars['Int']>;
  cantidadMenores?: InputMaybe<Scalars['Int']>;
  deletion?: InputMaybe<Scalars['Boolean']>;
  fechaIngresoHospedaje?: InputMaybe<Scalars['Datetime']>;
  giftCard?: InputMaybe<Scalars['BigFloat']>;
  operadorTurismoRazonSocial?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<FkTouristServiceOrderToOrderInput>;
  touristServiceOrderDetails?: InputMaybe<FkTouristServiceOrderDetailToTouristServiceOrderInverseInput>;
};

export type UpdateUserOnPointOfSaleUserForFkPointOfSaleUserToUserPatch = {
  email?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<FkAppUserToPersonInput>;
  personKey?: InputMaybe<Scalars['String']>;
  pointOfSaleUsers?: InputMaybe<FkPointOfSaleUserToUserInverseInput>;
};

export type UpdateUserOnUserForFkAppUserToPersonPatch = {
  email?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<FkAppUserToPersonInput>;
  pointOfSaleUsers?: InputMaybe<FkPointOfSaleUserToUserInverseInput>;
};

export type AccountByTenantKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type AccountByTenantKeyQuery = { __typename?: 'Query', accountByTenantKey?: { __typename?: 'Account', tenantKey?: string | null, tenantCreatedAt?: any | null, tenantNit?: any | null, tenantBusinessName?: string | null, tenantEmail?: string | null, tenantPhoneNumber?: string | null, systemCode?: string | null, delegateToken?: string | null, delegateEnabled?: boolean | null, delegateIssuedAt?: any | null, delegateExpireAt?: any | null } | null };

export type DownloadRegisterFileQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type DownloadRegisterFileQuery = { __typename?: 'Query', downloadRegisterFile: { __typename?: 'File', filename?: string | null, filesize?: any | null, uuid?: string | null, type?: string | null, base64?: string | null } };

export type GetRegisterFilesByTenantKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetRegisterFilesByTenantKeyQuery = { __typename?: 'Query', getRegisterFilesByTenantKey?: { __typename?: 'FilesConnection', nodes: Array<{ __typename?: 'File', filename?: string | null, filesize?: any | null, uuid?: string | null, type?: string | null } | null> } | null };

export type AuthenticateMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate?: { __typename?: 'AuthenticatePayload', jwt?: any | null } | null };

export type BranchOfficesComboQueryVariables = Exact<{ [key: string]: never; }>;


export type BranchOfficesComboQuery = { __typename?: 'Query', viewBranchOffices?: { __typename?: 'ViewBranchOfficesConnection', nodes: Array<{ __typename?: 'ViewBranchOffice', key?: string | null, code?: number | null, name?: string | null } | null> } | null };

export type AllClientsComboQueryVariables = Exact<{ [key: string]: never; }>;


export type AllClientsComboQuery = { __typename?: 'Query', viewClients?: { __typename?: 'ViewClientsConnection', nodes: Array<{ __typename?: 'ViewClient', key?: string | null, name?: string | null, phoneNumber?: string | null, email?: string | null, documentNumber?: string | null, documentComplement?: string | null, documentTypeDescription?: string | null } | null> } | null };

export type ClientByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type ClientByKeyQuery = { __typename?: 'Query', client?: { __typename?: 'Client', key: string, name: string, observation?: string | null, phoneNumber?: string | null, email?: string | null, createdAt: any, updatedAt?: any | null, homologation?: { __typename?: 'ClientHomologation', documentNumber: string, documentComplement?: string | null, documentTypeCode: number, documentTypeDescription: string } | null } | null };

export type CreateClientMutationVariables = Exact<{
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  observation?: InputMaybe<Scalars['String']>;
  documentNumber: Scalars['String'];
  documentComplement?: InputMaybe<Scalars['String']>;
  documentTypeCode: Scalars['Int'];
  allowInvalidNit: Scalars['Boolean'];
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient?: { __typename?: 'CreateClientPayload', client?: { __typename?: 'Client', key: string, name: string, observation?: string | null, phoneNumber?: string | null, email?: string | null, createdAt: any, homologation?: { __typename?: 'ClientHomologation', key: string, documentNumber: string, documentComplement?: string | null, documentTypeCode: number, allowInvalidNit: boolean } | null } | null } | null };

export type PaginateClientsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewClientsOrderBy> | ViewClientsOrderBy>;
  filter?: InputMaybe<ViewClientFilter>;
}>;


export type PaginateClientsQuery = { __typename?: 'Query', viewClients?: { __typename?: 'ViewClientsConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewClient', key?: string | null, name?: string | null, phoneNumber?: string | null, email?: string | null, createdAt?: any | null, documentNumber?: string | null, documentComplement?: string | null, documentTypeDescription?: string | null } | null> } | null };

export type SearchClientsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  search: Scalars['String'];
  orderBy?: InputMaybe<Array<ViewClientsOrderBy> | ViewClientsOrderBy>;
}>;


export type SearchClientsQuery = { __typename?: 'Query', viewClients?: { __typename?: 'ViewClientsConnection', nodes: Array<{ __typename?: 'ViewClient', key?: string | null, name?: string | null, phoneNumber?: string | null, email?: string | null, documentNumber?: string | null, documentComplement?: string | null, documentTypeDescription?: string | null } | null> } | null };

export type GenerateCufdMutationVariables = Exact<{
  pointOfSaleKey: Scalars['String'];
  executionMode: ExecutionMode;
}>;


export type GenerateCufdMutation = { __typename?: 'Mutation', generateCufd?: { __typename?: 'GenerateCufdPayload', message: string, cufd?: { __typename?: 'Cufd', key?: string | null, code?: string | null, controlCode?: string | null, status?: string | null, sendingStatus?: string | null, expireAt?: any | null, createdAt?: any | null } | null } | null };

export type GenerateCuisMutationVariables = Exact<{
  pointOfSaleKey: Scalars['String'];
  executionMode: ExecutionMode;
}>;


export type GenerateCuisMutation = { __typename?: 'Mutation', generateCuis?: { __typename?: 'GenerateCuisPayload', message: string, cuis?: { __typename?: 'Cuis', key?: string | null, code?: string | null, status?: string | null, sendingStatus?: string | null, expireAt?: any | null, createdAt?: any | null } | null } | null };

export type PaginateViewCufdCodesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewCufdCodesOrderBy> | ViewCufdCodesOrderBy>;
  filter?: InputMaybe<ViewCufdCodeFilter>;
}>;


export type PaginateViewCufdCodesQuery = { __typename?: 'Query', viewCufdCodes?: { __typename?: 'ViewCufdCodesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewCufdCode', key?: string | null, code?: string | null, controlCode?: string | null, branchOfficeCode?: number | null, branchOfficeName?: string | null, pointOfSaleCode?: number | null, pointOfSaleName?: string | null, enabled?: boolean | null, generatedAt?: any | null, expireAt?: any | null, createdAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PaginateViewCuisCodesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewCuisCodesOrderBy> | ViewCuisCodesOrderBy>;
  filter?: InputMaybe<ViewCuisCodeFilter>;
}>;


export type PaginateViewCuisCodesQuery = { __typename?: 'Query', viewCuisCodes?: { __typename?: 'ViewCuisCodesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewCuisCode', key?: string | null, code?: string | null, branchOfficeCode?: number | null, branchOfficeName?: string | null, pointOfSaleCode?: number | null, pointOfSaleName?: string | null, status?: RequestStatus | null, enabled?: boolean | null, expireAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SinGenerateMassiveCufdsMutationVariables = Exact<{
  pointOfSaleCodes: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type SinGenerateMassiveCufdsMutation = { __typename?: 'Mutation', sinGenerateMassiveCufds?: { __typename?: 'SinGenerateMassiveCufdsPayload', cufds: Array<{ __typename?: 'Cufd', key?: string | null, code?: string | null, controlCode?: string | null, pointOfSaleCode?: number | null, pointOfSaleName?: string | null, expireAt?: any | null } | null> } | null };

export type ConfirmActionMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmActionMutation = { __typename?: 'Mutation', confirmAction?: { __typename?: 'ConfirmActionPayload', string?: string | null } | null };

export type CreateExportServiceOrderMutationVariables = Exact<{
  discount: Scalars['BigFloat'];
  paymentMethodCode: Scalars['Int'];
  currencyCode: Scalars['Int'];
  exchangeRate: Scalars['BigFloat'];
  activityCode: Scalars['String'];
  sectorDocumentCode: Scalars['Int'];
  invoiceTypeCode: Scalars['Int'];
  emissionTypeCode: Scalars['Int'];
  modalityTypeCode: Scalars['Int'];
  sinDireccionComprador: Scalars['String'];
  sinLugarDestino: Scalars['String'];
  sinCodigoPais: Scalars['Int'];
  sinInformacionAdicional?: InputMaybe<Scalars['String']>;
  exportServiceOrderDetails?: InputMaybe<Array<FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderDetailCreateInput> | FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderDetailCreateInput>;
  clientKey: Scalars['String'];
}>;


export type CreateExportServiceOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'CreateOrderPayload', order?: { __typename?: 'Order', key: string, quantity: any, subtotal: any, discount: any, total: any, homologation?: { __typename?: 'OrderHomologation', paymentMethodDescription?: string | null } | null, exportServiceOrder?: { __typename?: 'ExportServiceOrder', sinDireccionComprador: string, sinLugarDestino: string, sinCodigoPais: number, sinInformacionAdicional?: string | null, exportServiceOrderDetails: { __typename?: 'ExportServiceOrderDetailsConnection', nodes: Array<{ __typename?: 'ExportServiceOrderDetail', key: string, quantity: number, price: any, subtotal: any, discount: any, total: any, productService?: { __typename?: 'Product', key: string, name?: string | null, description: string } | null } | null> } } | null } | null } | null };

export type DeleteClientMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient?: { __typename?: 'DeleteClientPayload', client?: { __typename?: 'Client', key: string, homologation?: { __typename?: 'ClientHomologation', key: string } | null } | null } | null };

export type PaginateAllDigitalSignaturesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<AllDigitalSignaturesOrderBy> | AllDigitalSignaturesOrderBy>;
  filter?: InputMaybe<AllDigitalSignatureFilter>;
}>;


export type PaginateAllDigitalSignaturesQuery = { __typename?: 'Query', allDigitalSignatures?: { __typename?: 'AllDigitalSignaturesConnection', totalCount: number, nodes: Array<{ __typename?: 'AllDigitalSignature', tenantKey?: string | null, tenantName?: string | null, tenantNit?: any | null, tenantBusinessName?: string | null, key?: string | null, issuerCountry?: string | null, issuerCommonName?: string | null, issuerOrganization?: string | null, subjectCountry?: string | null, subjectBusinessName?: string | null, subjectNit?: string | null, subjectLegalRepresentative?: string | null, subjectJobTitle?: string | null, subjectDocumentType?: string | null, subjectDocumentNumber?: string | null, subjectDocumentComplement?: string | null, issuedAt?: any | null, expireAt?: any | null, enabled?: boolean | null, revoked?: boolean | null, createdAt?: any | null, updatedAt?: any | null, date?: any | null } | null> } | null };

export type PaginateDigitalSignaturesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewDigitalSignaturesOrderBy> | ViewDigitalSignaturesOrderBy>;
  filter?: InputMaybe<ViewDigitalSignatureFilter>;
}>;


export type PaginateDigitalSignaturesQuery = { __typename?: 'Query', viewDigitalSignatures?: { __typename?: 'ViewDigitalSignaturesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewDigitalSignature', key?: string | null, issuerCountry?: string | null, issuerCommonName?: string | null, issuerOrganization?: string | null, subjectCountry?: string | null, subjectBusinessName?: string | null, subjectNit?: string | null, subjectLegalRepresentative?: string | null, subjectJobTitle?: string | null, subjectDocumentType?: string | null, subjectDocumentNumber?: string | null, subjectDocumentComplement?: string | null, issuedAt?: any | null, expireAt?: any | null, enabled?: boolean | null, revoked?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type UploadDigitalSignatureMutationVariables = Exact<{
  tenantKey: Scalars['String'];
  file: Scalars['Upload'];
  password: Scalars['String'];
}>;


export type UploadDigitalSignatureMutation = { __typename?: 'Mutation', uploadDigitalSignature: { __typename?: 'UploadDigitalSignaturePayload', message: string } };

export type UserEventsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserEventsSubscription = { __typename?: 'Subscription', userEvents?: { __typename?: 'UserEvent', id: string, event: string, payload?: any | null, createdAt: string } | null };

export type GetParameterQueryVariables = Exact<{
  classifier: Scalars['String'];
  code: Scalars['String'];
}>;


export type GetParameterQuery = { __typename?: 'Query', getParameter?: { __typename?: 'Parameter', value?: string | null } | null };

export type CancelInvoiceMutationVariables = Exact<{
  key: Scalars['String'];
  reasonCode: Scalars['Int'];
}>;


export type CancelInvoiceMutation = { __typename?: 'Mutation', cancelInvoice?: { __typename?: 'CancelInvoicePayload', message?: string | null, invoiceCancellation?: { __typename?: 'InvoiceCancellation', key?: string | null, status?: string | null, sendingStatus?: string | null } | null } | null };

export type DownloadInvoiceQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type DownloadInvoiceQuery = { __typename?: 'Query', downloadInvoice: { __typename?: 'File', base64?: string | null } };

export type GenerateInvoiceMutationVariables = Exact<{
  orderKey: Scalars['String'];
}>;


export type GenerateInvoiceMutation = { __typename?: 'Mutation', generateInvoice?: { __typename?: 'GenerateInvoicePayload', invoice?: { __typename?: 'Invoice', key?: string | null, number?: number | null, totalAmount?: any | null, totalAmountToPay?: any | null, totalAmountSubjectToIva?: any | null, url?: string | null, status?: string | null, verificationStatus?: string | null, createdAt?: any | null } | null } | null };

export type InvoiceByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type InvoiceByKeyQuery = { __typename?: 'Query', invoiceByKey?: { __typename?: 'Invoice', key?: string | null, sectorDocumentCode?: number | null, invoiceTypeCode?: number | null, emissionTypeCode?: number | null, modalityTypeCode?: number | null, businessName?: string | null, documentNumber?: string | null, documentTypeCode?: string | null, documentTypeDescription?: string | null, totalAmount?: any | null, totalAmountToPay?: any | null, totalAmountSubjectToIva?: any | null, currencyCode?: number | null, exchangeRate?: any | null, totalAmountCurrency?: any | null, additionalDiscount?: any | null, number?: number | null, issuedAt?: any | null, cuf?: string | null, url?: string | null, orderKey?: string | null, status?: string | null, verificationStatus?: string | null, createdAt?: any | null } | null };

export type PaginateInvoicesByKeyQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  condition?: InputMaybe<ViewInvoiceCondition>;
  filter?: InputMaybe<ViewInvoiceFilter>;
}>;


export type PaginateInvoicesByKeyQuery = { __typename?: 'Query', viewInvoices?: { __typename?: 'ViewInvoicesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewInvoice', key?: string | null, businessName?: string | null, documentNumber?: string | null, documentTypeCode?: number | null, documentTypeDescription?: string | null, totalAmount?: any | null, number?: any | null, issuedAt?: any | null, status?: InvoiceStatus | null, verificationStatus?: InvoiceStatus | null, createdAt?: any | null } | null> } | null };

export type PaginatePackageInvoicesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewPackageInvoicesOrderBy> | ViewPackageInvoicesOrderBy>;
  condition?: InputMaybe<ViewPackageInvoiceCondition>;
  filter?: InputMaybe<ViewPackageInvoiceFilter>;
}>;


export type PaginatePackageInvoicesQuery = { __typename?: 'Query', viewPackageInvoices?: { __typename?: 'ViewPackageInvoicesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewPackageInvoice', key?: string | null, businessName?: string | null, documentNumber?: string | null, documentTypeCode?: number | null, documentTypeDescription?: string | null, subtotal?: any | null, additionalDiscount?: any | null, totalAmount?: any | null, totalAmountCurrency?: any | null, totalAmountToPay?: any | null, totalAmountSubjectToIva?: any | null, number?: any | null, issuedAt?: any | null, status?: InvoiceStatus | null, verificationStatus?: InvoiceStatus | null, createdAt?: any | null, date?: any | null } | null> } | null };

export type PaginateViewInvoicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ViewInvoicesOrderBy> | ViewInvoicesOrderBy>;
  filter?: InputMaybe<ViewInvoiceFilter>;
}>;


export type PaginateViewInvoicesQuery = { __typename?: 'Query', viewInvoices?: { __typename?: 'ViewInvoicesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewInvoice', key?: string | null, businessName?: string | null, documentNumber?: string | null, documentTypeCode?: number | null, documentTypeDescription?: string | null, subtotal?: any | null, additionalDiscount?: any | null, totalAmount?: any | null, totalAmountCurrency?: any | null, totalAmountToPay?: any | null, totalAmountSubjectToIva?: any | null, number?: any | null, issuedAt?: any | null, status?: InvoiceStatus | null, verificationStatus?: InvoiceStatus | null, createdAt?: any | null, date?: any | null } | null> } | null };

export type ResentInvoiceMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type ResentInvoiceMutation = { __typename?: 'Mutation', resentInvoice?: { __typename?: 'ResentInvoicePayload', message?: string | null, invoice?: { __typename?: 'Invoice', key?: string | null, number?: number | null, totalAmount?: any | null, totalAmountToPay?: any | null, totalAmountSubjectToIva?: any | null, url?: string | null, status?: string | null, verificationStatus?: string | null, createdAt?: any | null } | null } | null };

export type RestoreInvoiceMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type RestoreInvoiceMutation = { __typename?: 'Mutation', restoreInvoice?: { __typename?: 'RestoreInvoicePayload', code?: string | null, message?: string | null, invoiceRestoration?: { __typename?: 'InvoiceRestoration', key?: string | null, status?: string | null, sendingStatus?: string | null } | null } | null };

export type NotificationsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<NotificationsOrderBy> | NotificationsOrderBy>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Notification', key?: string | null, icon?: string | null, title?: string | null, body?: string | null, data?: any | null, severity?: string | null, readAt?: any | null, createdAt?: any | null } | null> } | null };

export type CreateSaleOrderMutationVariables = Exact<{
  pointOfSaleKey: Scalars['String'];
  discount: Scalars['BigFloat'];
  paymentAmount: Scalars['BigFloat'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  paymentMethodCode: Scalars['Int'];
  cardNumber?: InputMaybe<Scalars['BigInt']>;
  currencyCode: Scalars['Int'];
  exchangeRate: Scalars['BigFloat'];
  activityCode: Scalars['String'];
  sectorDocumentCode: Scalars['Int'];
  invoiceTypeCode: Scalars['Int'];
  emissionTypeCode: Scalars['Int'];
  modalityTypeCode: Scalars['Int'];
  giftCard: Scalars['BigFloat'];
  saleOrderDetails?: InputMaybe<Array<FkSaleOrderDetailToSaleOrderSaleOrderDetailCreateInput> | FkSaleOrderDetailToSaleOrderSaleOrderDetailCreateInput>;
  clientKey: Scalars['String'];
}>;


export type CreateSaleOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'CreateOrderPayload', order?: { __typename?: 'Order', key: string, quantity: any, subtotal: any, discount: any, total: any, paymentAmount: any, changeAmount: any, homologation?: { __typename?: 'OrderHomologation', paymentMethodDescription?: string | null } | null, saleOrder?: { __typename?: 'SaleOrder', giftCard: any, saleOrderDetails: { __typename?: 'SaleOrderDetailsConnection', nodes: Array<{ __typename?: 'SaleOrderDetail', key: string, quantity: any, price: any, subtotal: any, discount: any, total: any, productService?: { __typename?: 'Product', key: string, name?: string | null, description: string } | null } | null> } } | null } | null } | null };

export type DownloadOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadOrdersQuery = { __typename?: 'Query', downloadOrders: { __typename?: 'File', filename?: string | null, mimetype?: string | null, encoding?: string | null, filesize?: any | null, uuid?: string | null, type?: string | null, base64?: string | null } };

export type OrderByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type OrderByKeyQuery = { __typename?: 'Query', order?: { __typename?: 'Order', key: string, quantity: any, subtotal: any, discount: any, total: any, phoneNumber?: string | null, email?: string | null, status: OrderStatus, createdAt: any, homologation?: { __typename?: 'OrderHomologation', sectorDocumentCode: number, paymentMethodDescription?: string | null } | null, client?: { __typename?: 'Client', key: string, name: string, createdAt: any, phoneNumber?: string | null, email?: string | null, homologation?: { __typename?: 'ClientHomologation', documentNumber: string, documentTypeCode: number, documentTypeDescription: string } | null } | null, invoice?: { __typename?: 'Invoice', key?: string | null, number?: number | null, totalAmount?: any | null, totalAmountToPay?: any | null, totalAmountSubjectToIva?: any | null, url?: string | null, status?: string | null, verificationStatus?: string | null, createdAt?: any | null } | null } | null };

export type PaginateViewOrdersQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewOrdersOrderBy> | ViewOrdersOrderBy>;
  filter?: InputMaybe<ViewOrderFilter>;
}>;


export type PaginateViewOrdersQuery = { __typename?: 'Query', viewOrders?: { __typename?: 'ViewOrdersConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewOrder', key?: string | null, number?: string | null, businessName?: string | null, documentNumber?: string | null, documentTypeCode?: number | null, documentTypeDescription?: string | null, subtotal?: any | null, discount?: any | null, total?: any | null, invoiceIssuedAt?: any | null, invoiceStatus?: InvoiceStatus | null, invoiceVerificationStatus?: InvoiceStatus | null, createdAt?: any | null, date?: any | null } | null> } | null };

export type SaleOrderByOrderKeyQueryVariables = Exact<{
  orderKey: Scalars['String'];
}>;


export type SaleOrderByOrderKeyQuery = { __typename?: 'Query', saleOrderByOrderKey?: { __typename?: 'SaleOrder', orderKey: string, giftCard: any, saleOrderDetails: { __typename?: 'SaleOrderDetailsConnection', nodes: Array<{ __typename?: 'SaleOrderDetail', quantity: any, price: any, subtotal: any, discount: any, total: any, productService?: { __typename?: 'Product', key: string, code?: string | null, name?: string | null, description: string } | null } | null> } } | null };

export type PackageByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type PackageByKeyQuery = { __typename?: 'Query', packageByKey?: { __typename?: 'Package', key?: string | null, sectorDocumentCode?: number | null, sectorDocumentDescription?: string | null, branchOfficeCode?: number | null, branchOfficeName?: string | null, pointOfSaleCode?: number | null, pointOfSaleName?: string | null, quantity?: number | null, receptionCode?: string | null, status?: string | null, sendingStatus?: string | null, validationStatus?: string | null, validationSendingStatus?: string | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type PaginatePackagesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewPackagesOrderBy> | ViewPackagesOrderBy>;
  filter?: InputMaybe<ViewPackageFilter>;
}>;


export type PaginatePackagesQuery = { __typename?: 'Query', viewPackages?: { __typename?: 'ViewPackagesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewPackage', key?: string | null, sectorDocumentCode?: number | null, sectorDocumentDescription?: string | null, quantity?: number | null, status?: PackageStatus | null, sendingStatus?: SendingStatus | null, validationStatus?: PackageValidationStatus | null, validationSendingStatus?: SendingStatus | null, sentAt?: any | null, validatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type GenerateSubscriptionChargePaymentRequestMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type GenerateSubscriptionChargePaymentRequestMutation = { __typename?: 'Mutation', generateSubscriptionChargePaymentRequest?: { __typename?: 'PaymentRequest', key: string, amount: any, currency: string, description: string, expiresAt: any, paidAt?: any | null, data: string, status: string } | null };

export type CreatePointOfSaleUserMutationVariables = Exact<{
  pointOfSaleKey: Scalars['String'];
  userKey: Scalars['String'];
}>;


export type CreatePointOfSaleUserMutation = { __typename?: 'Mutation', createPointOfSaleUser?: { __typename?: 'CreatePointOfSaleUserPayload', pointOfSaleUser?: { __typename?: 'PointOfSaleUser', key: string, createdAt: any, updatedAt?: any | null, pointOfSale?: { __typename?: 'PointOfSale', key: string, code: number, name?: string | null, description?: string | null, typeCode: number } | null } | null } | null };

export type CreatePointOfSaleMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  branchOfficeCode: Scalars['Int'];
  typeCode: Scalars['Int'];
  modalityCode: Scalars['Int'];
  commissionAgentNit?: InputMaybe<Scalars['BigInt']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  finishDate?: InputMaybe<Scalars['Datetime']>;
}>;


export type CreatePointOfSaleMutation = { __typename?: 'Mutation', createPointOfSale?: { __typename?: 'CreatePointOfSalePayload', pointOfSale?: { __typename?: 'PointOfSale', key: string } | null } | null };

export type DeletePointOfSaleUserMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type DeletePointOfSaleUserMutation = { __typename?: 'Mutation', deletePointOfSaleUser?: { __typename?: 'DeletePointOfSaleUserPayload', pointOfSaleUser?: { __typename?: 'PointOfSaleUser', key: string } | null } | null };

export type PointOfSaleByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type PointOfSaleByKeyQuery = { __typename?: 'Query', pointOfSale?: { __typename?: 'PointOfSale', key: string, code: number, name?: string | null, description?: string | null, typeCode: number, typeName?: string | null, createdAt: any, cuis?: { __typename?: 'Cuis', code?: string | null, expireAt?: any | null, createdAt?: any | null } | null, cufd?: { __typename?: 'Cufd', code?: string | null, expireAt?: any | null, createdAt?: any | null } | null, branchOffice?: { __typename?: 'BranchOffice', code: number } | null } | null };

export type PointsOfSaleComboQueryVariables = Exact<{
  filters?: InputMaybe<ViewPointOfSaleFilter>;
}>;


export type PointsOfSaleComboQuery = { __typename?: 'Query', viewPointOfSales?: { __typename?: 'ViewPointOfSalesConnection', nodes: Array<{ __typename?: 'ViewPointOfSale', key?: string | null, code?: number | null, name?: string | null } | null> } | null };

export type PointOfSaleCufdQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type PointOfSaleCufdQuery = { __typename?: 'Query', pointOfSale?: { __typename?: 'PointOfSale', key: string, cufd?: { __typename?: 'Cufd', code?: string | null, generatedAt?: any | null, expireAt?: any | null } | null } | null };

export type SyncPointsOfSaleMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPointsOfSaleMutation = { __typename?: 'Mutation', syncPointsOfSale?: { __typename?: 'SyncPointsOfSalePayload', code: string, message: string } | null };

export type CreateProductMutationVariables = Exact<{
  code: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  type: ProductType;
  price: Scalars['BigFloat'];
  activityCode: Scalars['String'];
  productCode: Scalars['Int'];
  measureUnitCode: Scalars['Int'];
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'CreateProductPayload', product?: { __typename?: 'Product', key: string, code?: string | null, name?: string | null, description: string, type: ProductType, price: any, createdAt: any, homologation?: { __typename?: 'ProductHomologation', key: string, activityCode: string, productCode: number, measureUnitCode: number } | null } | null } | null };

export type DownloadProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadProductsQuery = { __typename?: 'Query', downloadProducts: { __typename?: 'File', filename?: string | null, mimetype?: string | null, encoding?: string | null, filesize?: any | null, uuid?: string | null, type?: string | null, base64?: string | null } };

export type PaginateProductsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewProductsOrderBy> | ViewProductsOrderBy>;
  filter?: InputMaybe<ViewProductFilter>;
}>;


export type PaginateProductsQuery = { __typename?: 'Query', viewProducts?: { __typename?: 'ViewProductsConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewProduct', key?: string | null, code?: string | null, name?: string | null, description?: string | null, type?: ProductType | null, price?: any | null, createdAt?: any | null, updatedAt?: any | null, homologationProductCode?: number | null, homologationProductDescription?: string | null, homologationActivityCode?: string | null, homologationActivityDescription?: string | null, homologationMeasureUnitCode?: number | null, homologationMeasureUnitDescription?: string | null } | null> } | null };

export type ProcessProductBatchImportMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type ProcessProductBatchImportMutation = { __typename?: 'Mutation', processProductBatchImport?: { __typename?: 'ProcessProductBatchImportPayload', productBatchImport?: { __typename?: 'ProductBatchImport', key?: string | null } | null } | null };

export type ProductBatchImportByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type ProductBatchImportByKeyQuery = { __typename?: 'Query', productBatchImport?: { __typename?: 'ProductBatchImport', key?: string | null, filename?: string | null, mimetype?: string | null, encoding?: string | null, createdAt?: any | null, details: { __typename?: 'ProductBatchImportDetailsConnection', totalCount: number, nodes: Array<{ __typename?: 'ProductBatchImportDetail', key?: string | null, code?: string | null, name?: string | null, description?: string | null, type?: string | null, price?: any | null, activityCode?: string | null, activityDescription?: string | null, productCode?: string | null, productDescription?: string | null, measureUnitCode?: string | null, measureUnitDescription?: string | null, errors?: Array<string | null> | null, createdAt?: any | null, updatedAt?: any | null } | null> } } | null };

export type ProductByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type ProductByKeyQuery = { __typename?: 'Query', product?: { __typename?: 'Product', key: string, code?: string | null, name?: string | null, description: string, type: ProductType, price: any, createdAt: any, updatedAt?: any | null, homologation?: { __typename?: 'ProductHomologation', key: string, activityCode: string, activityDescription: string, productCode: number, productDescription: string, measureUnitCode: number, measureUnitDescription: string, createdAt: any, updatedAt?: any | null } | null } | null };

export type SearchProductsByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SearchProductsByCodeQuery = { __typename?: 'Query', viewProducts?: { __typename?: 'ViewProductsConnection', nodes: Array<{ __typename?: 'ViewProduct', key?: string | null, code?: string | null, name?: string | null, description?: string | null, price?: any | null } | null> } | null };

export type SearchProductsByDescriptionQueryVariables = Exact<{
  description: Scalars['String'];
}>;


export type SearchProductsByDescriptionQuery = { __typename?: 'Query', viewProducts?: { __typename?: 'ViewProductsConnection', nodes: Array<{ __typename?: 'ViewProduct', key?: string | null, code?: string | null, name?: string | null, description?: string | null, price?: any | null } | null> } | null };

export type UpdateProductMutationVariables = Exact<{
  key: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  type: ProductType;
  price: Scalars['BigFloat'];
  homologationKey: Scalars['String'];
  activityCode: Scalars['String'];
  productCode: Scalars['Int'];
  measureUnitCode: Scalars['Int'];
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'UpdateProductPayload', product?: { __typename?: 'Product', key: string, code?: string | null, name?: string | null, description: string, type: ProductType, price: any, createdAt: any, homologation?: { __typename?: 'ProductHomologation', key: string, activityCode: string, productCode: number, measureUnitCode: number } | null } | null } | null };

export type UploadProductsMutationVariables = Exact<{
  tenantKey: Scalars['String'];
  file: Scalars['Upload'];
}>;


export type UploadProductsMutation = { __typename?: 'Mutation', uploadProducts: { __typename?: 'UploadProductsPayload', productBatchImportKey: string, message: string } };

export type UploadRegisterDocumentsMutationVariables = Exact<{
  token: Scalars['String'];
  frontDocumentPhoto: Scalars['Upload'];
  nitDocumentPhoto: Scalars['Upload'];
  frontDocumentSelfie: Scalars['Upload'];
  backDocumentPhoto: Scalars['Upload'];
  certificateRequestPhoto: Scalars['Upload'];
}>;


export type UploadRegisterDocumentsMutation = { __typename?: 'Mutation', uploadRegisterDocuments: { __typename?: 'UploadRegisterDocumentsPayload', frontDocumentPhotoValid: boolean, backDocumentPhotoValid: boolean, frontDocumentSelfieValid: boolean, nitDocumentPhotoValid: boolean, certificateRequestPhotoValid: boolean } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'RequestPasswordResetPayload', message?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordPayload', message?: string | null } | null };

export type ValidateTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidateTokenMutation = { __typename?: 'Mutation', validateToken?: { __typename?: 'ValidateTokenPayload', message?: string | null } | null };

export type CreateRoleMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'CreateRolePayload', string?: string | null } | null };

export type PaginateOwnRolesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<OwnRolesOrderBy> | OwnRolesOrderBy>;
  filter?: InputMaybe<OwnRoleFilter>;
}>;


export type PaginateOwnRolesQuery = { __typename?: 'Query', ownRoles?: { __typename?: 'OwnRolesConnection', totalCount: number, nodes: Array<{ __typename?: 'OwnRole', key?: string | null, name?: string | null, description?: string | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, permissionCount?: number | null, userCount?: number | null } | null> } | null };

export type RoleByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type RoleByKeyQuery = { __typename?: 'Query', role: { __typename?: 'Role', key: string, name: string, description: string, permissions: Array<{ __typename?: 'Permission', code: string }> } };

export type UpdateRoleMutationVariables = Exact<{
  key: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'UpdateRolePayload', string?: string | null } | null };

export type CreateSignificantEventMutationVariables = Exact<{
  pointOfSaleKey: Scalars['String'];
  reasonCode: Scalars['Int'];
  description: Scalars['String'];
  startDate: Scalars['Datetime'];
  cafc?: InputMaybe<Scalars['String']>;
}>;


export type CreateSignificantEventMutation = { __typename?: 'Mutation', createSignificantEvent?: { __typename?: 'CreateSignificantEventPayload', significantEvent?: { __typename?: 'SignificantEvent', key?: string | null, cufd?: string | null, cufdEvent?: string | null, startDate?: any | null, status?: string | null, createdAt?: any | null } | null } | null };

export type PaginateSinViewSignificantEventsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewSignificantEventsOrderBy> | ViewSignificantEventsOrderBy>;
  filter?: InputMaybe<ViewSignificantEventFilter>;
}>;


export type PaginateSinViewSignificantEventsQuery = { __typename?: 'Query', viewSignificantEvents?: { __typename?: 'ViewSignificantEventsConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewSignificantEvent', id?: number | null, key?: string | null, pointOfSaleCode?: number | null, pointOfSaleName?: string | null, reasonCode?: number | null, reasonDescription?: string | null, description?: string | null, receptionCode?: any | null, startDate?: any | null, finishDate?: any | null, status?: SignificantEventStatus | null, sendingType?: SendingType | null, sendingStatus?: SendingStatus | null, sentAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type SendSignificantEventMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type SendSignificantEventMutation = { __typename?: 'Mutation', sendSignificantEvent?: { __typename?: 'SendSignificantEventPayload', significantEvent?: { __typename?: 'SignificantEvent', key?: string | null, cufd?: string | null, startDate?: any | null, finishDate?: any | null, receptionCode?: any | null, status?: string | null, sendingStatus?: string | null, createdAt?: any | null, sentAt?: any | null } | null } | null };

export type SignificantEventByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type SignificantEventByKeyQuery = { __typename?: 'Query', significantEventByKey?: { __typename?: 'SignificantEvent', key?: string | null, branchOfficeCode?: number | null, branchOfficeName?: string | null, pointOfSaleCode?: number | null, pointOfSaleName?: string | null, cuis?: string | null, cufd?: string | null, cufdEvent?: string | null, reasonCode?: number | null, reasonDescription?: string | null, description?: string | null, startDate?: any | null, finishDate?: any | null, receptionCode?: any | null, status?: string | null, sendingStatus?: string | null, createdAt?: any | null, sentAt?: any | null, updatedAt?: any | null } | null };

export type GetSinMessagesQueryVariables = Exact<{
  type: MessageType;
  key: Scalars['String'];
}>;


export type GetSinMessagesQuery = { __typename?: 'Query', messages: { __typename?: 'MessagesPayload', messages: Array<{ __typename?: 'SinMessage', key?: string | null, code?: string | null, description?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> } };

export type PaginateSinActivitiesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type PaginateSinActivitiesQuery = { __typename?: 'Query', syncActivities?: { __typename?: 'SyncActivitiesConnection', totalCount: number, nodes: Array<{ __typename?: 'SyncActivity', caebCode?: string | null, description?: string | null, type?: string | null, createdAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PaginateSinActivitySectorDocumentsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type PaginateSinActivitySectorDocumentsQuery = { __typename?: 'Query', syncActivitySectorDocuments?: { __typename?: 'SyncActivitySectorDocumentsConnection', totalCount: number, nodes: Array<{ __typename?: 'SyncActivitySectorDocument', activityCode?: string | null, sectorDocumentCode?: string | null, sectorDocumentType?: string | null, createdAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PaginateSinViewParametersQueryVariables = Exact<{
  type: SyncParameterType;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewSyncParametersOrderBy> | ViewSyncParametersOrderBy>;
}>;


export type PaginateSinViewParametersQuery = { __typename?: 'Query', viewSyncParameters?: { __typename?: 'ViewSyncParametersConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewSyncParameter', classifierCode?: number | null, description?: string | null, createdAt?: any | null } | null> } | null };

export type PaginateViewPointOfSalesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewPointOfSalesOrderBy> | ViewPointOfSalesOrderBy>;
  filter?: InputMaybe<ViewPointOfSaleFilter>;
}>;


export type PaginateViewPointOfSalesQuery = { __typename?: 'Query', viewPointOfSales?: { __typename?: 'ViewPointOfSalesConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewPointOfSale', key?: string | null, branchOfficeCode?: number | null, branchOfficeName?: string | null, code?: number | null, name?: string | null, typeCode?: number | null, typeDescription?: string | null, description?: string | null, cuis?: string | null, cuisExpireAt?: any | null, cufd?: string | null, cufdExpireAt?: any | null, createdAt?: any | null } | null> } | null };

export type RequestSyncMutationVariables = Exact<{
  type: SyncRequestType;
  pointOfSaleKey?: InputMaybe<Scalars['String']>;
}>;


export type RequestSyncMutation = { __typename?: 'Mutation', requestSync?: { __typename?: 'RequestSyncPayload', syncRequest: { __typename?: 'SyncRequest', key?: string | null, type?: string | null, status?: string | null, createdAt?: any | null, createdBy?: number | null, updatedAt?: any | null } } | null };

export type SinActivitiesComboQueryVariables = Exact<{ [key: string]: never; }>;


export type SinActivitiesComboQuery = { __typename?: 'Query', syncActivities?: { __typename?: 'SyncActivitiesConnection', nodes: Array<{ __typename?: 'SyncActivity', caebCode?: string | null, description?: string | null } | null> } | null };

export type SinActivitySectorDocumentsComboQueryVariables = Exact<{ [key: string]: never; }>;


export type SinActivitySectorDocumentsComboQuery = { __typename?: 'Query', syncActivitySectorDocuments?: { __typename?: 'SyncActivitySectorDocumentsConnection', totalCount: number, nodes: Array<{ __typename?: 'SyncActivitySectorDocument', activityCode?: string | null, sectorDocumentCode?: string | null, sectorDocumentType?: string | null, createdAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type DateTimesQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type DateTimesQuery = { __typename?: 'Query', syncDatetimes?: { __typename?: 'SyncDatetimesConnection', totalCount: number, nodes: Array<{ __typename?: 'SyncDatetime', value?: string | null, createdAt?: any | null } | null> } | null };

export type InvoiceLegendsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type InvoiceLegendsQuery = { __typename?: 'Query', syncInvoiceLegends?: { __typename?: 'SyncInvoiceLegendsConnection', totalCount: number, nodes: Array<{ __typename?: 'SyncInvoiceLegend', activityCode?: string | null, description?: string | null, createdAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SinSectorDocumentInvoiceTypeByActivityCodeQueryVariables = Exact<{
  activityCode: Scalars['String'];
}>;


export type SinSectorDocumentInvoiceTypeByActivityCodeQuery = { __typename?: 'Query', sectorDocumentInvoiceTypesByActivityCode?: { __typename?: 'SectorDocumentInvoiceTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'SectorDocumentInvoiceType', sectorDocumentCode?: number | null, description?: string | null, features?: string | null, invoiceTypeCode?: number | null, invoiceTypeDescription?: string | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SinDocumentoSectorTipoFacturaQueryVariables = Exact<{ [key: string]: never; }>;


export type SinDocumentoSectorTipoFacturaQuery = { __typename?: 'Query', sectorDocumentInvoiceTypes?: { __typename?: 'SectorDocumentInvoiceTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'SectorDocumentInvoiceType', sectorDocumentCode?: number | null, description?: string | null, features?: string | null, invoiceTypeCode?: number | null, invoiceTypeDescription?: string | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PaginateSyncRequestsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewSyncRequestsOrderBy> | ViewSyncRequestsOrderBy>;
}>;


export type PaginateSyncRequestsQuery = { __typename?: 'Query', viewSyncRequests?: { __typename?: 'ViewSyncRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewSyncRequest', key?: string | null, type?: SyncRequestType | null, status?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type SyncRequestSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncRequestSummaryQuery = { __typename?: 'Query', syncRequestsSummary?: { __typename?: 'SyncRequestsConnection', nodes: Array<{ __typename?: 'SyncRequest', key?: string | null, type?: string | null, status?: string | null, createdBy?: number | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type PaymentMethodInfoByCodeQueryVariables = Exact<{
  code: Scalars['Int'];
}>;


export type PaymentMethodInfoByCodeQuery = { __typename?: 'Query', paymentMethodInfoByCode?: { __typename?: 'PaymentMethodInfo', showGiftCard?: boolean | null, showCardNumber?: boolean | null } | null };

export type SinSectorDocumentsByActividadComboQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SinSectorDocumentsByActividadComboQuery = { __typename?: 'Query', sectorDocumentsByActivityCode?: { __typename?: 'SyncParametersConnection', totalCount: number, nodes: Array<{ __typename?: 'SyncParameter', classifierCode?: string | null, description?: string | null, createdAt?: any | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SinVerifyNitOnRegisterQueryVariables = Exact<{
  nit: Scalars['BigFloat'];
}>;


export type SinVerifyNitOnRegisterQuery = { __typename?: 'Query', sinVerifyNitOnRegister: { __typename?: 'SinVerifyNitPayload', isValid: boolean } };

export type SinVerifyNitQueryVariables = Exact<{
  nit: Scalars['BigFloat'];
}>;


export type SinVerifyNitQuery = { __typename?: 'Query', sinVerifyNit: boolean };

export type ViewPaymentMethodsComboQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewPaymentMethodsComboQuery = { __typename?: 'Query', viewPaymentMethods?: { __typename?: 'ViewPaymentMethodsConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewPaymentMethod', classifierCode?: number | null, showGiftCard?: boolean | null, showCardNumber?: boolean | null, description?: string | null } | null> } | null };

export type ViewSyncParametersComboQueryVariables = Exact<{
  type: SyncParameterType;
  orderBy?: InputMaybe<Array<ViewSyncParametersOrderBy> | ViewSyncParametersOrderBy>;
}>;


export type ViewSyncParametersComboQuery = { __typename?: 'Query', viewSyncParameters?: { __typename?: 'ViewSyncParametersConnection', nodes: Array<{ __typename?: 'ViewSyncParameter', classifierCode?: number | null, description?: string | null, createdAt?: any | null } | null> } | null };

export type GetActiveSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSubscriptionQuery = { __typename?: 'Query', activeSubscription?: { __typename?: 'ActiveSubscription', key?: string | null, discount?: any | null, discountType?: string | null, status?: string | null, planKey?: string | null, planName?: string | null, planDescription?: string | null, planPrice?: any | null, planCurrency?: string | null, planBillingDay?: number | null, planBillingMonths?: number | null, quotas: { __typename?: 'SubscriptionQuotasConnection', nodes: Array<{ __typename?: 'SubscriptionQuota', key?: string | null, type?: string | null, used?: number | null, value?: number | null, overagePrice?: any | null, overageCurrency?: string | null } | null> } } | null };

export type PaginateAllSubscriptionChargesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSubscriptionChargesOrderBy> | AllSubscriptionChargesOrderBy>;
  filter?: InputMaybe<AllSubscriptionChargeFilter>;
  condition?: InputMaybe<AllSubscriptionChargeCondition>;
}>;


export type PaginateAllSubscriptionChargesQuery = { __typename?: 'Query', allSubscriptionCharges?: { __typename?: 'AllSubscriptionChargesConnection', totalCount: number, nodes: Array<{ __typename?: 'AllSubscriptionCharge', tenantKey?: string | null, tenantName?: string | null, tenantNit?: any | null, tenantBusinessName?: string | null, subscriptionKey?: string | null, subscriptionStartedAt?: any | null, subscriptionCancelledAt?: any | null, planPrice?: any | null, planName?: string | null, planCurrency?: string | null, periodKey?: string | null, periodDescription?: string | null, periodStartAt?: any | null, periodEndAt?: any | null, periodStatus?: SubscriptionPeriodStatus | null, chargeKey?: string | null, chargeDescription?: string | null, chargeAmount?: any | null, chargeOverageAmount?: any | null, chargeTotalAmount?: any | null, chargeType?: SubscriptionChargeType | null, chargeStatus?: SubscriptionChargeStatus | null, chargeCreatedAt?: any | null } | null> } | null };

export type PaginateAllSubscriptionPeriodsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AllSubscriptionPeriodsOrderBy> | AllSubscriptionPeriodsOrderBy>;
  filter?: InputMaybe<AllSubscriptionPeriodFilter>;
  condition?: InputMaybe<AllSubscriptionPeriodCondition>;
}>;


export type PaginateAllSubscriptionPeriodsQuery = { __typename?: 'Query', allSubscriptionPeriods?: { __typename?: 'AllSubscriptionPeriodsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllSubscriptionPeriod', key?: string | null, description?: string | null, startAt?: any | null, endAt?: any | null, status?: SubscriptionPeriodStatus | null, chargeKey?: string | null, chargeDescription?: string | null, chargeAmount?: any | null, chargeOverageAmount?: any | null, chargeTotalAmount?: any | null, chargeType?: SubscriptionChargeType | null, chargeStatus?: SubscriptionChargeStatus | null, chargeCreatedAt?: any | null, planPrice?: any | null, planName?: string | null, planCurrency?: string | null, tenantKey?: string | null, tenantName?: string | null, tenantNit?: any | null, tenantBusinessName?: string | null } | null> } | null };

export type PaginateOwnSubscriptionChargesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OwnSubscriptionPeriodsOrderBy> | OwnSubscriptionPeriodsOrderBy>;
  filter?: InputMaybe<OwnSubscriptionPeriodFilter>;
  condition?: InputMaybe<OwnSubscriptionPeriodCondition>;
}>;


export type PaginateOwnSubscriptionChargesQuery = { __typename?: 'Query', ownSubscriptionPeriods?: { __typename?: 'OwnSubscriptionPeriodsConnection', totalCount: number, nodes: Array<{ __typename?: 'OwnSubscriptionPeriod', key?: string | null, number?: number | null, description?: string | null, startAt?: any | null, endAt?: any | null, status?: SubscriptionPeriodStatus | null, chargeKey?: string | null, chargeDescription?: string | null, chargeAmount?: any | null, chargeOverageAmount?: any | null, chargeTotalAmount?: any | null, chargeType?: SubscriptionChargeType | null, chargeStatus?: SubscriptionChargeStatus | null, chargeCreatedAt?: any | null, planPrice?: any | null, planName?: string | null, planCurrency?: string | null } | null> } | null };

export type AllSyncProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSyncProductsQuery = { __typename?: 'Query', viewSyncProducts?: { __typename?: 'ViewSyncProductsConnection', nodes: Array<{ __typename?: 'ViewSyncProduct', activityCode?: string | null, code?: number | null, description?: string | null, createdAt?: any | null } | null> } | null };

export type SyncProductsByActivityCodeQueryVariables = Exact<{
  activityCode: Scalars['String'];
}>;


export type SyncProductsByActivityCodeQuery = { __typename?: 'Query', viewSyncProducts?: { __typename?: 'ViewSyncProductsConnection', nodes: Array<{ __typename?: 'ViewSyncProduct', code?: number | null, description?: string | null } | null> } | null };

export type ComboTenantsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ComboTenantsOrderBy> | ComboTenantsOrderBy>;
  filter?: InputMaybe<ComboTenantFilter>;
}>;


export type ComboTenantsQuery = { __typename?: 'Query', comboTenants?: { __typename?: 'ComboTenantsConnection', totalCount: number, nodes: Array<{ __typename?: 'ComboTenant', key?: string | null, name?: string | null, nit?: any | null, businessName?: string | null } | null> } | null };

export type CreateRegisterFormMutationVariables = Exact<{
  personFirstName: Scalars['String'];
  personLastName: Scalars['String'];
  personDocumentNumber: Scalars['String'];
  personJobTitle: Scalars['String'];
  personPhone: Scalars['String'];
  tenantNit: Scalars['BigInt'];
  tenantBusinessName: Scalars['String'];
  tenantSiatUsername: Scalars['String'];
  branchOfficeMunicipality: Scalars['String'];
  branchOfficeAddress: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateRegisterFormMutation = { __typename?: 'Mutation', createRegisterForm: { __typename?: 'CreateRegisterFormPayload', nit?: any | null, businessName?: string | null, email?: string | null } };

export type CreateTenantMutationVariables = Exact<{
  tenantName: Scalars['String'];
  businessName: Scalars['String'];
  nit: Scalars['BigInt'];
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  middleName: Scalars['String'];
  firstSurname: Scalars['String'];
  secondSurname: Scalars['String'];
  email: Scalars['String'];
  branchOfficeName: Scalars['String'];
  branchOfficeAddress: Scalars['String'];
  branchOfficeMunicipality: Scalars['String'];
  pointOfSaleName: Scalars['String'];
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant?: { __typename?: 'CreateTenantPayload', tenant?: { __typename?: 'Tenant', key?: string | null, name?: string | null, nit?: any | null, businessName?: string | null } | null } | null };

export type CurrentBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBillingInfoQuery = { __typename?: 'Query', currentBillingInfo?: { __typename?: 'CurrentBillingInfo', businessName?: string | null, documentTypeCode?: number | null, documentTypeDescription?: string | null, documentNumber?: string | null, documentComplement?: string | null, email?: string | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type CurrentTenantInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTenantInfoQuery = { __typename?: 'Query', currentTenantInfo?: { __typename?: 'CurrentTenantInfo', name?: string | null, nit?: any | null, businessName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type GetTenantFullInfoQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetTenantFullInfoQuery = { __typename?: 'Query', tenantFullInfo?: { __typename?: 'TenantFullInfo', key?: string | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, nit?: any | null, businessName?: string | null, email?: string | null, phone?: string | null, tokenValue?: string | null, tokenRevoked?: string | null, tokenIssuedAt?: any | null, tokenExpireAt?: any | null, digitalSignatureKey?: string | null, digitalSignatureIssuedAt?: any | null, digitalSignatureExpireAt?: any | null, digitalSignatureRevoked?: boolean | null, digitalSignatureCreatedAt?: any | null } | null };

export type GetTenantSubscriptionQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type GetTenantSubscriptionQuery = { __typename?: 'Query', tenantSubscription?: { __typename?: 'TenantSubscription', key?: string | null, discount?: any | null, discountType?: string | null, discountAppliedAt?: any | null, startedAt?: any | null, cancelledAt?: any | null, status?: string | null, createdAt?: any | null, planKey?: string | null, planName?: string | null, planDescription?: string | null, planPrice?: any | null, planCurrency?: string | null, planBillingDay?: number | null, planBillingPeriod?: string | null, quotaUsersLimit?: number | null, quotaInvoicesLimit?: number | null, quotaPointsOfSaleLimit?: number | null, quotaBranchOfficesLimit?: number | null, quotaUsersUsed?: number | null, quotaInvoicesUsed?: number | null, quotaPointsOfSaleUsed?: number | null, quotaBranchOfficesUsed?: number | null } | null };

export type PaginateAllTenantsQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<AllTenantsOrderBy> | AllTenantsOrderBy>;
  filter?: InputMaybe<AllTenantFilter>;
}>;


export type PaginateAllTenantsQuery = { __typename?: 'Query', allTenants?: { __typename?: 'AllTenantsConnection', totalCount: number, nodes: Array<{ __typename?: 'AllTenant', key?: string | null, nit?: string | null, businessName?: string | null, email?: string | null, phoneNumber?: string | null, createdAt?: any | null, subscriptionStatus?: SubscriptionStatus | null, subscriptionStartedAt?: any | null, planKey?: string | null, planName?: string | null, planPrice?: any | null, planCurrency?: string | null, planBillingPeriod?: string | null } | null> } | null };

export type UpdateCurrentBillingInfoMutationVariables = Exact<{
  businessName: Scalars['String'];
  documentTypeCode: Scalars['Int'];
  documentNumber: Scalars['String'];
  documentComplement: Scalars['String'];
  email: Scalars['String'];
}>;


export type UpdateCurrentBillingInfoMutation = { __typename?: 'Mutation', updateCurrentBillingInfo?: { __typename?: 'UpdateCurrentBillingInfoPayload', currentBillingInfo?: { __typename?: 'CurrentBillingInfo', businessName?: string | null, documentTypeCode?: number | null, documentTypeDescription?: string | null, documentNumber?: string | null, documentComplement?: string | null, email?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type UpdateCurrentTenantInfoMutationVariables = Exact<{
  businessName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
}>;


export type UpdateCurrentTenantInfoMutation = { __typename?: 'Mutation', updateCurrentTenantInfo?: { __typename?: 'UpdateCurrentTenantInfoPayload', currentTenantInfo?: { __typename?: 'CurrentTenantInfo', businessName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type PaginateAllDelegatedTokensQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<AllDelegatedTokensOrderBy> | AllDelegatedTokensOrderBy>;
  filter?: InputMaybe<AllDelegatedTokenFilter>;
}>;


export type PaginateAllDelegatedTokensQuery = { __typename?: 'Query', allDelegatedTokens?: { __typename?: 'AllDelegatedTokensConnection', totalCount: number, nodes: Array<{ __typename?: 'AllDelegatedToken', tenantKey?: string | null, tenantName?: string | null, tenantNit?: any | null, tenantBusinessName?: string | null, id?: number | null, key?: string | null, sub?: string | null, systemCode?: string | null, nit?: string | null, issuedAt?: any | null, expireAt?: any | null, enabled?: boolean | null, revoked?: boolean | null, createdAt?: any | null, updatedAt?: any | null, date?: any | null } | null> } | null };

export type PaginateDelegatedTokensQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ViewDelegatedTokensOrderBy> | ViewDelegatedTokensOrderBy>;
  filter?: InputMaybe<ViewDelegatedTokenFilter>;
}>;


export type PaginateDelegatedTokensQuery = { __typename?: 'Query', viewDelegatedTokens?: { __typename?: 'ViewDelegatedTokensConnection', totalCount: number, nodes: Array<{ __typename?: 'ViewDelegatedToken', id?: number | null, key?: string | null, sub?: string | null, systemCode?: string | null, nit?: string | null, issuedAt?: any | null, expireAt?: any | null, enabled?: boolean | null, revoked?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type UploadDelegatedTokenMutationVariables = Exact<{
  tenantKey: Scalars['String'];
  token: Scalars['String'];
}>;


export type UploadDelegatedTokenMutation = { __typename?: 'Mutation', uploadDelegatedToken: { __typename?: 'UploadDelegatedTokenPayload', message?: string | null } };

export type UpdateClientMutationVariables = Exact<{
  key: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  observation?: InputMaybe<Scalars['String']>;
  documentNumber: Scalars['String'];
  documentComplement?: InputMaybe<Scalars['String']>;
  documentTypeCode: Scalars['Int'];
  allowInvalidNit: Scalars['Boolean'];
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient?: { __typename?: 'UpdateClientPayload', client?: { __typename?: 'Client', key: string, name: string, observation?: string | null, phoneNumber?: string | null, email?: string | null, createdAt: any, homologation?: { __typename?: 'ClientHomologation', key: string, documentNumber: string, documentComplement?: string | null, documentTypeCode: number, allowInvalidNit: boolean } | null } | null } | null };

export type UserByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type UserByKeyQuery = { __typename?: 'Query', user?: { __typename?: 'User', key: string, email: string, createdAt: any, updatedAt?: any | null, person?: { __typename?: 'Person', key: string, fullName?: string | null } | null, pointOfSaleUsers: { __typename?: 'PointOfSaleUsersConnection', nodes: Array<{ __typename?: 'PointOfSaleUser', key: string, createdAt: any, updatedAt?: any | null, pointOfSale?: { __typename?: 'PointOfSale', key: string, code: number, name?: string | null, typeCode: number } | null } | null> } } | null };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  middleName: Scalars['String'];
  firstSurname: Scalars['String'];
  secondSurname: Scalars['String'];
  email: Scalars['String'];
  roleKey: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', user?: { __typename?: 'User', key: string, email: string } | null } | null };

export type CurrentPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPermissionsQuery = { __typename?: 'Query', currentPermissions?: { __typename?: 'UserPermissionRecordsConnection', nodes: Array<{ __typename?: 'UserPermissionRecord', code?: string | null, name?: string | null } | null> } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', key: string, action?: string | null, lastTenantKey?: string | null, person?: { __typename?: 'Person', key: string, firstName: string, firstSurname: string, fullName?: string | null } | null, tenant?: { __typename?: 'Tenant', key?: string | null, nit?: any | null, businessName?: string | null } | null, tenants: { __typename?: 'TenantsConnection', nodes: Array<{ __typename?: 'Tenant', key?: string | null, nit?: any | null, businessName?: string | null } | null> } } | null };

export type PaginateAllUsersQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<AllUsersOrderBy> | AllUsersOrderBy>;
  condition?: InputMaybe<AllUserCondition>;
  filter?: InputMaybe<AllUserFilter>;
}>;


export type PaginateAllUsersQuery = { __typename?: 'Query', allUsers?: { __typename?: 'AllUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'AllUser', key?: string | null, username?: string | null, email?: string | null, fullName?: string | null, blocked?: boolean | null, enabled?: boolean | null, lastConnection?: any | null, createdAt?: any | null, updatedAt?: any | null, tenantKey?: string | null, tenantName?: string | null, tenantNit?: any | null, tenantBusinessName?: string | null } | null> } | null };

export type PaginateOwnUsersQueryVariables = Exact<{
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<OwnUsersOrderBy> | OwnUsersOrderBy>;
  condition?: InputMaybe<OwnUserCondition>;
  filter?: InputMaybe<OwnUserFilter>;
}>;


export type PaginateOwnUsersQuery = { __typename?: 'Query', ownUsers?: { __typename?: 'OwnUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'OwnUser', key?: string | null, username?: string | null, email?: string | null, fullName?: string | null, blocked?: boolean | null, lastConnection?: any | null, roleCount?: number | null, permissionCount?: number | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null> } | null };

export type RolesByUserKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type RolesByUserKeyQuery = { __typename?: 'Query', rolesByUserKey?: Array<{ __typename?: 'Role', key: string, name: string, description: string, createdAt: any, updatedAt?: any | null }> | null };

export type SaveSelectedTenantMutationVariables = Exact<{
  tenantKey: Scalars['String'];
}>;


export type SaveSelectedTenantMutation = { __typename?: 'Mutation', saveSelectedTenant?: { __typename?: 'SaveSelectedTenantPayload', message?: string | null } | null };

export type UnlockUserMutationVariables = Exact<{
  tokenUser: Scalars['String'];
}>;


export type UnlockUserMutation = { __typename?: 'Mutation', unlockUser?: { __typename?: 'UnlockUserPayload', message?: string | null } | null };

export type UpdateUserRolesMutationVariables = Exact<{
  userKey: Scalars['String'];
  roleKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateUserRolesMutation = { __typename?: 'Mutation', updateUserRoles?: { __typename?: 'UpdateUserRolesPayload', strings?: Array<string | null> | null } | null };

export type UserDetailsByKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type UserDetailsByKeyQuery = { __typename?: 'Query', user?: { __typename?: 'User', key: string, email: string, username?: string | null, createdAt: any, updatedAt?: any | null, person?: { __typename?: 'Person', key: string, fullName?: string | null, createdAt: any, updatedAt?: any | null } | null, tenants: { __typename?: 'TenantsConnection', nodes: Array<{ __typename?: 'Tenant', key?: string | null, nit?: any | null, businessName?: string | null } | null> } } | null };

export type RolesComboQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesComboQuery = { __typename?: 'Query', viewRoles?: { __typename?: 'ViewRolesConnection', nodes: Array<{ __typename?: 'ViewRole', key?: string | null, name?: string | null, description?: string | null } | null> } | null };

export const AccountByTenantKeyDocument = gql`
    query AccountByTenantKey($key: String!) {
  accountByTenantKey(key: $key) {
    tenantKey
    tenantCreatedAt
    tenantNit
    tenantBusinessName
    tenantEmail
    tenantPhoneNumber
    systemCode
    delegateToken
    delegateEnabled
    delegateIssuedAt
    delegateExpireAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountByTenantKeyGQL extends Apollo.Query<AccountByTenantKeyQuery, AccountByTenantKeyQueryVariables> {
    override document = AccountByTenantKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadRegisterFileDocument = gql`
    query DownloadRegisterFile($uuid: String!) {
  downloadRegisterFile(uuid: $uuid) {
    filename
    filesize
    uuid
    type
    base64
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadRegisterFileGQL extends Apollo.Query<DownloadRegisterFileQuery, DownloadRegisterFileQueryVariables> {
    override document = DownloadRegisterFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegisterFilesByTenantKeyDocument = gql`
    query GetRegisterFilesByTenantKey($key: String!) {
  getRegisterFilesByTenantKey(key: $key) {
    nodes {
      filename
      filesize
      uuid
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegisterFilesByTenantKeyGQL extends Apollo.Query<GetRegisterFilesByTenantKeyQuery, GetRegisterFilesByTenantKeyQueryVariables> {
    override document = GetRegisterFilesByTenantKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthenticateDocument = gql`
    mutation authenticate($username: String!, $password: String!) {
  authenticate(input: {username: $username, password: $password}) {
    jwt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthenticateGQL extends Apollo.Mutation<AuthenticateMutation, AuthenticateMutationVariables> {
    override document = AuthenticateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BranchOfficesComboDocument = gql`
    query BranchOfficesCombo {
  viewBranchOffices {
    nodes {
      key
      code
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BranchOfficesComboGQL extends Apollo.Query<BranchOfficesComboQuery, BranchOfficesComboQueryVariables> {
    override document = BranchOfficesComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllClientsComboDocument = gql`
    query AllClientsCombo {
  viewClients(orderBy: KEY_ASC) {
    nodes {
      key
      name
      phoneNumber
      email
      documentNumber
      documentComplement
      documentTypeDescription
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllClientsComboGQL extends Apollo.Query<AllClientsComboQuery, AllClientsComboQueryVariables> {
    override document = AllClientsComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientByKeyDocument = gql`
    query ClientByKey($key: String!) {
  client(key: $key) {
    key
    name
    observation
    phoneNumber
    email
    createdAt
    updatedAt
    homologation {
      documentNumber
      documentComplement
      documentTypeCode
      documentTypeDescription
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientByKeyGQL extends Apollo.Query<ClientByKeyQuery, ClientByKeyQueryVariables> {
    override document = ClientByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateClientDocument = gql`
    mutation CreateClient($name: String!, $phoneNumber: String!, $email: String!, $observation: String, $documentNumber: String!, $documentComplement: String, $documentTypeCode: Int!, $allowInvalidNit: Boolean!) {
  createClient(
    input: {client: {name: $name, observation: $observation, phoneNumber: $phoneNumber, email: $email, homologations: {create: {documentNumber: $documentNumber, documentComplement: $documentComplement, documentTypeCode: $documentTypeCode, allowInvalidNit: $allowInvalidNit}}}}
  ) {
    client {
      key
      name
      observation
      phoneNumber
      email
      createdAt
      homologation {
        key
        documentNumber
        documentComplement
        documentTypeCode
        allowInvalidNit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateClientGQL extends Apollo.Mutation<CreateClientMutation, CreateClientMutationVariables> {
    override document = CreateClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateClientsDocument = gql`
    query PaginateClients($first: Int!, $offset: Int!, $orderBy: [ViewClientsOrderBy!], $filter: ViewClientFilter) {
  viewClients(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      name
      phoneNumber
      email
      createdAt
      documentNumber
      documentComplement
      documentTypeDescription
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateClientsGQL extends Apollo.Query<PaginateClientsQuery, PaginateClientsQueryVariables> {
    override document = PaginateClientsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchClientsDocument = gql`
    query SearchClients($first: Int!, $offset: Int!, $search: String!, $orderBy: [ViewClientsOrderBy!]) {
  viewClients(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {or: [{documentNumber: {likeInsensitive: $search}}, {name: {likeInsensitive: $search}}]}
  ) {
    nodes {
      key
      name
      phoneNumber
      email
      documentNumber
      documentComplement
      documentTypeDescription
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchClientsGQL extends Apollo.Query<SearchClientsQuery, SearchClientsQueryVariables> {
    override document = SearchClientsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateCufdDocument = gql`
    mutation GenerateCufd($pointOfSaleKey: String!, $executionMode: ExecutionMode!) {
  generateCufd(
    input: {pointOfSaleKey: $pointOfSaleKey, executionMode: $executionMode}
  ) {
    message
    cufd {
      key
      code
      controlCode
      status
      sendingStatus
      expireAt
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateCufdGQL extends Apollo.Mutation<GenerateCufdMutation, GenerateCufdMutationVariables> {
    override document = GenerateCufdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateCuisDocument = gql`
    mutation GenerateCuis($pointOfSaleKey: String!, $executionMode: ExecutionMode!) {
  generateCuis(
    input: {pointOfSaleKey: $pointOfSaleKey, executionMode: $executionMode}
  ) {
    message
    cuis {
      key
      code
      status
      sendingStatus
      expireAt
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateCuisGQL extends Apollo.Mutation<GenerateCuisMutation, GenerateCuisMutationVariables> {
    override document = GenerateCuisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateViewCufdCodesDocument = gql`
    query PaginateViewCufdCodes($first: Int!, $offset: Int!, $orderBy: [ViewCufdCodesOrderBy!], $filter: ViewCufdCodeFilter) {
  viewCufdCodes(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      key
      code
      controlCode
      branchOfficeCode
      branchOfficeName
      pointOfSaleCode
      pointOfSaleName
      enabled
      generatedAt
      expireAt
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateViewCufdCodesGQL extends Apollo.Query<PaginateViewCufdCodesQuery, PaginateViewCufdCodesQueryVariables> {
    override document = PaginateViewCufdCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateViewCuisCodesDocument = gql`
    query PaginateViewCuisCodes($first: Int!, $offset: Int!, $orderBy: [ViewCuisCodesOrderBy!], $filter: ViewCuisCodeFilter) {
  viewCuisCodes(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      key
      code
      branchOfficeCode
      branchOfficeName
      pointOfSaleCode
      pointOfSaleName
      status
      enabled
      expireAt
      createdAt
      updatedAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateViewCuisCodesGQL extends Apollo.Query<PaginateViewCuisCodesQuery, PaginateViewCuisCodesQueryVariables> {
    override document = PaginateViewCuisCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinGenerateMassiveCufdsDocument = gql`
    mutation SinGenerateMassiveCufds($pointOfSaleCodes: [Int]!) {
  sinGenerateMassiveCufds(input: {pointOfSaleCodes: $pointOfSaleCodes}) {
    cufds {
      key
      code
      controlCode
      pointOfSaleCode
      pointOfSaleName
      expireAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinGenerateMassiveCufdsGQL extends Apollo.Mutation<SinGenerateMassiveCufdsMutation, SinGenerateMassiveCufdsMutationVariables> {
    override document = SinGenerateMassiveCufdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmActionDocument = gql`
    mutation confirmAction($token: String!) {
  confirmAction(input: {pToken: $token}) {
    string
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmActionGQL extends Apollo.Mutation<ConfirmActionMutation, ConfirmActionMutationVariables> {
    override document = ConfirmActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportServiceOrderDocument = gql`
    mutation CreateExportServiceOrder($discount: BigFloat!, $paymentMethodCode: Int!, $currencyCode: Int!, $exchangeRate: BigFloat!, $activityCode: String!, $sectorDocumentCode: Int!, $invoiceTypeCode: Int!, $emissionTypeCode: Int!, $modalityTypeCode: Int!, $sinDireccionComprador: String!, $sinLugarDestino: String!, $sinCodigoPais: Int!, $sinInformacionAdicional: String, $exportServiceOrderDetails: [FkExportServiceOrderDetailToExportServiceOrderExportServiceOrderDetailCreateInput!], $clientKey: String!) {
  createOrder(
    input: {order: {discount: $discount, homologations: {create: {paymentMethodCode: $paymentMethodCode, currencyCode: $currencyCode, exchangeRate: $exchangeRate, activityCode: $activityCode, sectorDocumentCode: $sectorDocumentCode, emissionTypeCode: $emissionTypeCode, modalityTypeCode: $modalityTypeCode, invoiceTypeCode: $invoiceTypeCode}}, exportServiceOrders: {create: {sinDireccionComprador: $sinDireccionComprador, sinLugarDestino: $sinLugarDestino, sinCodigoPais: $sinCodigoPais, sinInformacionAdicional: $sinInformacionAdicional, exportServiceOrderDetails: {create: $exportServiceOrderDetails}}}, client: {connectByKey: {key: $clientKey}}}}
  ) {
    order {
      key
      quantity
      subtotal
      discount
      total
      homologation {
        paymentMethodDescription
      }
      exportServiceOrder {
        sinDireccionComprador
        sinLugarDestino
        sinCodigoPais
        sinInformacionAdicional
        exportServiceOrderDetails {
          nodes {
            key
            quantity
            price
            subtotal
            discount
            total
            productService {
              key
              name
              description
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportServiceOrderGQL extends Apollo.Mutation<CreateExportServiceOrderMutation, CreateExportServiceOrderMutationVariables> {
    override document = CreateExportServiceOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteClientDocument = gql`
    mutation DeleteClient($key: String!) {
  deleteClient(input: {key: $key}) {
    client {
      key
      homologation {
        key
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteClientGQL extends Apollo.Mutation<DeleteClientMutation, DeleteClientMutationVariables> {
    override document = DeleteClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateAllDigitalSignaturesDocument = gql`
    query PaginateAllDigitalSignatures($first: Int!, $offset: Int!, $orderBy: [AllDigitalSignaturesOrderBy!], $filter: AllDigitalSignatureFilter) {
  allDigitalSignatures(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      tenantKey
      tenantName
      tenantNit
      tenantBusinessName
      key
      issuerCountry
      issuerCommonName
      issuerOrganization
      subjectCountry
      subjectBusinessName
      subjectNit
      subjectLegalRepresentative
      subjectJobTitle
      subjectDocumentType
      subjectDocumentNumber
      subjectDocumentComplement
      issuedAt
      expireAt
      enabled
      revoked
      createdAt
      updatedAt
      date
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateAllDigitalSignaturesGQL extends Apollo.Query<PaginateAllDigitalSignaturesQuery, PaginateAllDigitalSignaturesQueryVariables> {
    override document = PaginateAllDigitalSignaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateDigitalSignaturesDocument = gql`
    query PaginateDigitalSignatures($first: Int!, $offset: Int!, $orderBy: [ViewDigitalSignaturesOrderBy!], $filter: ViewDigitalSignatureFilter) {
  viewDigitalSignatures(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      key
      issuerCountry
      issuerCommonName
      issuerOrganization
      subjectCountry
      subjectBusinessName
      subjectNit
      subjectLegalRepresentative
      subjectJobTitle
      subjectDocumentType
      subjectDocumentNumber
      subjectDocumentComplement
      issuedAt
      expireAt
      enabled
      revoked
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateDigitalSignaturesGQL extends Apollo.Query<PaginateDigitalSignaturesQuery, PaginateDigitalSignaturesQueryVariables> {
    override document = PaginateDigitalSignaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadDigitalSignatureDocument = gql`
    mutation UploadDigitalSignature($tenantKey: String!, $file: Upload!, $password: String!) {
  uploadDigitalSignature(
    input: {tenantKey: $tenantKey, file: $file, password: $password}
  ) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadDigitalSignatureGQL extends Apollo.Mutation<UploadDigitalSignatureMutation, UploadDigitalSignatureMutationVariables> {
    override document = UploadDigitalSignatureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserEventsDocument = gql`
    subscription UserEvents {
  userEvents {
    id
    event
    payload
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserEventsGQL extends Apollo.Subscription<UserEventsSubscription, UserEventsSubscriptionVariables> {
    override document = UserEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetParameterDocument = gql`
    query GetParameter($classifier: String!, $code: String!) {
  getParameter(classifier: $classifier, code: $code) {
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetParameterGQL extends Apollo.Query<GetParameterQuery, GetParameterQueryVariables> {
    override document = GetParameterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelInvoiceDocument = gql`
    mutation CancelInvoice($key: String!, $reasonCode: Int!) {
  cancelInvoice(input: {key: $key, reasonCode: $reasonCode}) {
    message
    invoiceCancellation {
      key
      status
      sendingStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelInvoiceGQL extends Apollo.Mutation<CancelInvoiceMutation, CancelInvoiceMutationVariables> {
    override document = CancelInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadInvoiceDocument = gql`
    query DownloadInvoice($key: String!) {
  downloadInvoice(key: $key) {
    base64
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadInvoiceGQL extends Apollo.Query<DownloadInvoiceQuery, DownloadInvoiceQueryVariables> {
    override document = DownloadInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateInvoiceDocument = gql`
    mutation GenerateInvoice($orderKey: String!) {
  generateInvoice(input: {orderKey: $orderKey}) {
    invoice {
      key
      number
      totalAmount
      totalAmountToPay
      totalAmountSubjectToIva
      url
      status
      verificationStatus
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateInvoiceGQL extends Apollo.Mutation<GenerateInvoiceMutation, GenerateInvoiceMutationVariables> {
    override document = GenerateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceByKeyDocument = gql`
    query InvoiceByKey($key: String!) {
  invoiceByKey(key: $key) {
    key
    sectorDocumentCode
    invoiceTypeCode
    emissionTypeCode
    modalityTypeCode
    businessName
    documentNumber
    documentTypeCode
    documentTypeDescription
    totalAmount
    totalAmountToPay
    totalAmountSubjectToIva
    currencyCode
    exchangeRate
    totalAmountCurrency
    additionalDiscount
    number
    issuedAt
    cuf
    url
    orderKey
    status
    verificationStatus
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceByKeyGQL extends Apollo.Query<InvoiceByKeyQuery, InvoiceByKeyQueryVariables> {
    override document = InvoiceByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateInvoicesByKeyDocument = gql`
    query PaginateInvoicesByKey($first: Int!, $offset: Int!, $condition: ViewInvoiceCondition, $filter: ViewInvoiceFilter) {
  viewInvoices(
    first: $first
    offset: $offset
    condition: $condition
    filter: $filter
  ) {
    nodes {
      key
      businessName
      documentNumber
      documentTypeCode
      documentTypeDescription
      totalAmount
      number
      issuedAt
      status
      verificationStatus
      createdAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateInvoicesByKeyGQL extends Apollo.Query<PaginateInvoicesByKeyQuery, PaginateInvoicesByKeyQueryVariables> {
    override document = PaginateInvoicesByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatePackageInvoicesDocument = gql`
    query PaginatePackageInvoices($first: Int!, $offset: Int!, $orderBy: [ViewPackageInvoicesOrderBy!], $condition: ViewPackageInvoiceCondition, $filter: ViewPackageInvoiceFilter) {
  viewPackageInvoices(
    first: $first
    offset: $offset
    orderBy: $orderBy
    condition: $condition
    filter: $filter
  ) {
    nodes {
      key
      businessName
      documentNumber
      documentTypeCode
      documentTypeDescription
      subtotal
      additionalDiscount
      totalAmount
      totalAmountCurrency
      totalAmountToPay
      totalAmountSubjectToIva
      number
      issuedAt
      status
      verificationStatus
      createdAt
      date
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatePackageInvoicesGQL extends Apollo.Query<PaginatePackageInvoicesQuery, PaginatePackageInvoicesQueryVariables> {
    override document = PaginatePackageInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateViewInvoicesDocument = gql`
    query PaginateViewInvoices($first: Int, $offset: Int, $orderBy: [ViewInvoicesOrderBy!], $filter: ViewInvoiceFilter) {
  viewInvoices(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      businessName
      documentNumber
      documentTypeCode
      documentTypeDescription
      subtotal
      additionalDiscount
      totalAmount
      totalAmountCurrency
      totalAmountToPay
      totalAmountSubjectToIva
      number
      issuedAt
      status
      verificationStatus
      createdAt
      date
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateViewInvoicesGQL extends Apollo.Query<PaginateViewInvoicesQuery, PaginateViewInvoicesQueryVariables> {
    override document = PaginateViewInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResentInvoiceDocument = gql`
    mutation ResentInvoice($key: String!) {
  resentInvoice(input: {key: $key}) {
    invoice {
      key
      number
      totalAmount
      totalAmountToPay
      totalAmountSubjectToIva
      url
      status
      verificationStatus
      createdAt
    }
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResentInvoiceGQL extends Apollo.Mutation<ResentInvoiceMutation, ResentInvoiceMutationVariables> {
    override document = ResentInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreInvoiceDocument = gql`
    mutation RestoreInvoice($key: String!) {
  restoreInvoice(input: {key: $key}) {
    code
    message
    invoiceRestoration {
      key
      status
      sendingStatus
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreInvoiceGQL extends Apollo.Mutation<RestoreInvoiceMutation, RestoreInvoiceMutationVariables> {
    override document = RestoreInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsDocument = gql`
    query Notifications($first: Int!, $offset: Int!, $orderBy: [NotificationsOrderBy!]) {
  notifications(first: $first, offset: $offset, orderBy: $orderBy) {
    nodes {
      key
      icon
      title
      body
      data
      severity
      readAt
      createdAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsGQL extends Apollo.Query<NotificationsQuery, NotificationsQueryVariables> {
    override document = NotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSaleOrderDocument = gql`
    mutation CreateSaleOrder($pointOfSaleKey: String!, $discount: BigFloat!, $paymentAmount: BigFloat!, $email: String!, $phoneNumber: String!, $paymentMethodCode: Int!, $cardNumber: BigInt, $currencyCode: Int!, $exchangeRate: BigFloat!, $activityCode: String!, $sectorDocumentCode: Int!, $invoiceTypeCode: Int!, $emissionTypeCode: Int!, $modalityTypeCode: Int!, $giftCard: BigFloat!, $saleOrderDetails: [FkSaleOrderDetailToSaleOrderSaleOrderDetailCreateInput!], $clientKey: String!) {
  createOrder(
    input: {order: {pointOfSaleKey: $pointOfSaleKey, discount: $discount, paymentAmount: $paymentAmount, phoneNumber: $phoneNumber, email: $email, homologations: {create: {paymentMethodCode: $paymentMethodCode, cardNumber: $cardNumber, currencyCode: $currencyCode, exchangeRate: $exchangeRate, activityCode: $activityCode, sectorDocumentCode: $sectorDocumentCode, invoiceTypeCode: $invoiceTypeCode, emissionTypeCode: $emissionTypeCode, modalityTypeCode: $modalityTypeCode}}, saleOrders: {create: {giftCard: $giftCard, saleOrderDetails: {create: $saleOrderDetails}}}, client: {connectByKey: {key: $clientKey}}}}
  ) {
    order {
      key
      quantity
      subtotal
      discount
      total
      paymentAmount
      changeAmount
      homologation {
        paymentMethodDescription
      }
      saleOrder {
        giftCard
        saleOrderDetails {
          nodes {
            key
            quantity
            price
            subtotal
            discount
            total
            productService {
              key
              name
              description
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSaleOrderGQL extends Apollo.Mutation<CreateSaleOrderMutation, CreateSaleOrderMutationVariables> {
    override document = CreateSaleOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadOrdersDocument = gql`
    query DownloadOrders {
  downloadOrders {
    filename
    mimetype
    encoding
    filesize
    uuid
    type
    base64
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadOrdersGQL extends Apollo.Query<DownloadOrdersQuery, DownloadOrdersQueryVariables> {
    override document = DownloadOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderByKeyDocument = gql`
    query OrderByKey($key: String!) {
  order(key: $key) {
    key
    quantity
    subtotal
    discount
    total
    phoneNumber
    email
    status
    createdAt
    homologation {
      sectorDocumentCode
      paymentMethodDescription
    }
    client {
      key
      name
      createdAt
      phoneNumber
      email
      homologation {
        documentNumber
        documentNumber
        documentTypeCode
        documentTypeDescription
      }
    }
    invoice {
      key
      number
      totalAmount
      totalAmountToPay
      totalAmountSubjectToIva
      url
      status
      verificationStatus
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderByKeyGQL extends Apollo.Query<OrderByKeyQuery, OrderByKeyQueryVariables> {
    override document = OrderByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateViewOrdersDocument = gql`
    query PaginateViewOrders($first: Int!, $offset: Int!, $orderBy: [ViewOrdersOrderBy!], $filter: ViewOrderFilter) {
  viewOrders(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      number
      businessName
      documentNumber
      documentTypeCode
      documentTypeDescription
      subtotal
      discount
      total
      invoiceIssuedAt
      invoiceStatus
      invoiceVerificationStatus
      createdAt
      date
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateViewOrdersGQL extends Apollo.Query<PaginateViewOrdersQuery, PaginateViewOrdersQueryVariables> {
    override document = PaginateViewOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaleOrderByOrderKeyDocument = gql`
    query SaleOrderByOrderKey($orderKey: String!) {
  saleOrderByOrderKey(orderKey: $orderKey) {
    orderKey
    giftCard
    saleOrderDetails {
      nodes {
        quantity
        price
        subtotal
        discount
        total
        productService {
          key
          code
          name
          description
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaleOrderByOrderKeyGQL extends Apollo.Query<SaleOrderByOrderKeyQuery, SaleOrderByOrderKeyQueryVariables> {
    override document = SaleOrderByOrderKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackageByKeyDocument = gql`
    query PackageByKey($key: String!) {
  packageByKey(key: $key) {
    key
    sectorDocumentCode
    sectorDocumentDescription
    branchOfficeCode
    branchOfficeName
    pointOfSaleCode
    pointOfSaleName
    quantity
    receptionCode
    status
    sendingStatus
    validationStatus
    validationSendingStatus
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PackageByKeyGQL extends Apollo.Query<PackageByKeyQuery, PackageByKeyQueryVariables> {
    override document = PackageByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatePackagesDocument = gql`
    query PaginatePackages($first: Int!, $offset: Int!, $orderBy: [ViewPackagesOrderBy!], $filter: ViewPackageFilter) {
  viewPackages(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      sectorDocumentCode
      sectorDocumentDescription
      quantity
      status
      sendingStatus
      validationStatus
      validationSendingStatus
      sentAt
      validatedAt
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatePackagesGQL extends Apollo.Query<PaginatePackagesQuery, PaginatePackagesQueryVariables> {
    override document = PaginatePackagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateSubscriptionChargePaymentRequestDocument = gql`
    mutation GenerateSubscriptionChargePaymentRequest($key: String!) {
  generateSubscriptionChargePaymentRequest(key: $key) {
    key
    amount
    currency
    description
    expiresAt
    paidAt
    data
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateSubscriptionChargePaymentRequestGQL extends Apollo.Mutation<GenerateSubscriptionChargePaymentRequestMutation, GenerateSubscriptionChargePaymentRequestMutationVariables> {
    override document = GenerateSubscriptionChargePaymentRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePointOfSaleUserDocument = gql`
    mutation CreatePointOfSaleUser($pointOfSaleKey: String!, $userKey: String!) {
  createPointOfSaleUser(
    input: {pointOfSaleUser: {pointOfSaleKey: $pointOfSaleKey, userKey: $userKey, enabled: true}}
  ) {
    pointOfSaleUser {
      key
      createdAt
      updatedAt
      pointOfSale {
        key
        code
        name
        description
        typeCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePointOfSaleUserGQL extends Apollo.Mutation<CreatePointOfSaleUserMutation, CreatePointOfSaleUserMutationVariables> {
    override document = CreatePointOfSaleUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePointOfSaleDocument = gql`
    mutation CreatePointOfSale($name: String!, $description: String!, $branchOfficeCode: Int!, $typeCode: Int!, $modalityCode: Int!, $commissionAgentNit: BigInt, $contractNumber: String, $startDate: Datetime, $finishDate: Datetime) {
  createPointOfSale(
    input: {name: $name, description: $description, branchOfficeCode: $branchOfficeCode, typeCode: $typeCode, modalityCode: $modalityCode, commissionAgentNit: $commissionAgentNit, contractNumber: $contractNumber, startDate: $startDate, finishDate: $finishDate}
  ) {
    pointOfSale {
      key
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePointOfSaleGQL extends Apollo.Mutation<CreatePointOfSaleMutation, CreatePointOfSaleMutationVariables> {
    override document = CreatePointOfSaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePointOfSaleUserDocument = gql`
    mutation DeletePointOfSaleUser($key: String!) {
  deletePointOfSaleUser(input: {key: $key}) {
    pointOfSaleUser {
      key
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePointOfSaleUserGQL extends Apollo.Mutation<DeletePointOfSaleUserMutation, DeletePointOfSaleUserMutationVariables> {
    override document = DeletePointOfSaleUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PointOfSaleByKeyDocument = gql`
    query PointOfSaleByKey($key: String!) {
  pointOfSale(key: $key) {
    key
    code
    name
    description
    typeCode
    typeName
    createdAt
    cuis {
      code
      expireAt
      createdAt
    }
    cufd {
      code
      expireAt
      createdAt
    }
    branchOffice {
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PointOfSaleByKeyGQL extends Apollo.Query<PointOfSaleByKeyQuery, PointOfSaleByKeyQueryVariables> {
    override document = PointOfSaleByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PointsOfSaleComboDocument = gql`
    query PointsOfSaleCombo($filters: ViewPointOfSaleFilter) {
  viewPointOfSales(filter: $filters) {
    nodes {
      key
      code
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PointsOfSaleComboGQL extends Apollo.Query<PointsOfSaleComboQuery, PointsOfSaleComboQueryVariables> {
    override document = PointsOfSaleComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PointOfSaleCufdDocument = gql`
    query PointOfSaleCufd($key: String!) {
  pointOfSale(key: $key) {
    key
    cufd {
      code
      generatedAt
      expireAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PointOfSaleCufdGQL extends Apollo.Query<PointOfSaleCufdQuery, PointOfSaleCufdQueryVariables> {
    override document = PointOfSaleCufdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncPointsOfSaleDocument = gql`
    mutation SyncPointsOfSale {
  syncPointsOfSale {
    code
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncPointsOfSaleGQL extends Apollo.Mutation<SyncPointsOfSaleMutation, SyncPointsOfSaleMutationVariables> {
    override document = SyncPointsOfSaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductDocument = gql`
    mutation CreateProduct($code: String!, $name: String!, $description: String!, $type: ProductType!, $price: BigFloat!, $activityCode: String!, $productCode: Int!, $measureUnitCode: Int!) {
  createProduct(
    input: {product: {code: $code, name: $name, description: $description, type: $type, price: $price, homologations: {create: {activityCode: $activityCode, productCode: $productCode, measureUnitCode: $measureUnitCode}}}}
  ) {
    product {
      key
      code
      name
      description
      type
      price
      createdAt
      homologation {
        key
        activityCode
        productCode
        measureUnitCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductGQL extends Apollo.Mutation<CreateProductMutation, CreateProductMutationVariables> {
    override document = CreateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadProductsDocument = gql`
    query DownloadProducts {
  downloadProducts {
    filename
    mimetype
    encoding
    filesize
    uuid
    type
    base64
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadProductsGQL extends Apollo.Query<DownloadProductsQuery, DownloadProductsQueryVariables> {
    override document = DownloadProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateProductsDocument = gql`
    query PaginateProducts($first: Int!, $offset: Int!, $orderBy: [ViewProductsOrderBy!], $filter: ViewProductFilter) {
  viewProducts(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      code
      name
      description
      type
      price
      createdAt
      updatedAt
      homologationProductCode
      homologationProductDescription
      homologationActivityCode
      homologationActivityDescription
      homologationMeasureUnitCode
      homologationMeasureUnitDescription
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateProductsGQL extends Apollo.Query<PaginateProductsQuery, PaginateProductsQueryVariables> {
    override document = PaginateProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessProductBatchImportDocument = gql`
    mutation ProcessProductBatchImport($key: String!) {
  processProductBatchImport(input: {pKey: $key}) {
    productBatchImport {
      key
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessProductBatchImportGQL extends Apollo.Mutation<ProcessProductBatchImportMutation, ProcessProductBatchImportMutationVariables> {
    override document = ProcessProductBatchImportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductBatchImportByKeyDocument = gql`
    query productBatchImportByKey($key: String!) {
  productBatchImport(pKey: $key) {
    key
    filename
    mimetype
    encoding
    createdAt
    details {
      nodes {
        key
        code
        name
        description
        type
        price
        activityCode
        activityDescription
        productCode
        productDescription
        measureUnitCode
        measureUnitDescription
        errors
        createdAt
        updatedAt
      }
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductBatchImportByKeyGQL extends Apollo.Query<ProductBatchImportByKeyQuery, ProductBatchImportByKeyQueryVariables> {
    override document = ProductBatchImportByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductByKeyDocument = gql`
    query ProductByKey($key: String!) {
  product(key: $key) {
    key
    code
    name
    description
    type
    price
    createdAt
    updatedAt
    homologation {
      key
      activityCode
      activityDescription
      productCode
      productDescription
      measureUnitCode
      measureUnitDescription
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductByKeyGQL extends Apollo.Query<ProductByKeyQuery, ProductByKeyQueryVariables> {
    override document = ProductByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProductsByCodeDocument = gql`
    query SearchProductsByCode($code: String!) {
  viewProducts(filter: {code: {likeInsensitive: $code}}, first: 10, offset: 0) {
    nodes {
      key
      code
      name
      description
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProductsByCodeGQL extends Apollo.Query<SearchProductsByCodeQuery, SearchProductsByCodeQueryVariables> {
    override document = SearchProductsByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProductsByDescriptionDocument = gql`
    query SearchProductsByDescription($description: String!) {
  viewProducts(
    filter: {description: {likeInsensitive: $description}}
    first: 10
    offset: 0
  ) {
    nodes {
      key
      code
      name
      description
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProductsByDescriptionGQL extends Apollo.Query<SearchProductsByDescriptionQuery, SearchProductsByDescriptionQueryVariables> {
    override document = SearchProductsByDescriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductDocument = gql`
    mutation UpdateProduct($key: String!, $code: String!, $name: String!, $description: String!, $type: ProductType!, $price: BigFloat!, $homologationKey: String!, $activityCode: String!, $productCode: Int!, $measureUnitCode: Int!) {
  updateProduct(
    input: {key: $key, patch: {code: $code, name: $name, description: $description, type: $type, price: $price, homologations: {updateByKey: {key: $homologationKey, patch: {activityCode: $activityCode, productCode: $productCode, measureUnitCode: $measureUnitCode}}}}}
  ) {
    product {
      key
      code
      name
      description
      type
      price
      createdAt
      homologation {
        key
        activityCode
        productCode
        measureUnitCode
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductGQL extends Apollo.Mutation<UpdateProductMutation, UpdateProductMutationVariables> {
    override document = UpdateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadProductsDocument = gql`
    mutation UploadProducts($tenantKey: String!, $file: Upload!) {
  uploadProducts(input: {tenantKey: $tenantKey, file: $file}) {
    productBatchImportKey
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadProductsGQL extends Apollo.Mutation<UploadProductsMutation, UploadProductsMutationVariables> {
    override document = UploadProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadRegisterDocumentsDocument = gql`
    mutation UploadRegisterDocuments($token: String!, $frontDocumentPhoto: Upload!, $nitDocumentPhoto: Upload!, $frontDocumentSelfie: Upload!, $backDocumentPhoto: Upload!, $certificateRequestPhoto: Upload!) {
  uploadRegisterDocuments(
    token: $token
    frontDocumentPhoto: $frontDocumentPhoto
    backDocumentPhoto: $backDocumentPhoto
    frontDocumentSelfie: $frontDocumentSelfie
    nitDocumentPhoto: $nitDocumentPhoto
    certificateRequestPhoto: $certificateRequestPhoto
  ) {
    frontDocumentPhotoValid
    backDocumentPhotoValid
    frontDocumentSelfieValid
    nitDocumentPhotoValid
    certificateRequestPhotoValid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadRegisterDocumentsGQL extends Apollo.Mutation<UploadRegisterDocumentsMutation, UploadRegisterDocumentsMutationVariables> {
    override document = UploadRegisterDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(input: {pEmail: $email}) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPasswordResetGQL extends Apollo.Mutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables> {
    override document = RequestPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!) {
  resetPassword(input: {pToken: $token, pNewPassword: $password}) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    override document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateTokenDocument = gql`
    mutation validateToken($token: String!) {
  validateToken(input: {pToken: $token}) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateTokenGQL extends Apollo.Mutation<ValidateTokenMutation, ValidateTokenMutationVariables> {
    override document = ValidateTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRoleDocument = gql`
    mutation CreateRole($name: String!, $description: String!, $permissions: [String!]) {
  createRole(
    input: {pName: $name, pDescription: $description, pPermissions: $permissions}
  ) {
    string
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRoleGQL extends Apollo.Mutation<CreateRoleMutation, CreateRoleMutationVariables> {
    override document = CreateRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateOwnRolesDocument = gql`
    query PaginateOwnRoles($first: Int!, $offset: Int!, $orderBy: [OwnRolesOrderBy!], $filter: OwnRoleFilter) {
  ownRoles(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      name
      description
      enabled
      createdAt
      updatedAt
      permissionCount
      userCount
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateOwnRolesGQL extends Apollo.Query<PaginateOwnRolesQuery, PaginateOwnRolesQueryVariables> {
    override document = PaginateOwnRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleByKeyDocument = gql`
    query RoleByKey($key: String!) {
  role(key: $key) {
    key
    name
    description
    permissions {
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleByKeyGQL extends Apollo.Query<RoleByKeyQuery, RoleByKeyQueryVariables> {
    override document = RoleByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRoleDocument = gql`
    mutation UpdateRole($key: String!, $name: String!, $description: String!, $permissions: [String!]) {
  updateRole(
    input: {pKey: $key, pName: $name, pDescription: $description, pPermissions: $permissions}
  ) {
    string
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRoleGQL extends Apollo.Mutation<UpdateRoleMutation, UpdateRoleMutationVariables> {
    override document = UpdateRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSignificantEventDocument = gql`
    mutation CreateSignificantEvent($pointOfSaleKey: String!, $reasonCode: Int!, $description: String!, $startDate: Datetime!, $cafc: String) {
  createSignificantEvent(
    input: {pointOfSaleKey: $pointOfSaleKey, reasonCode: $reasonCode, description: $description, startDate: $startDate, cafc: $cafc}
  ) {
    significantEvent {
      key
      cufd
      cufdEvent
      startDate
      status
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSignificantEventGQL extends Apollo.Mutation<CreateSignificantEventMutation, CreateSignificantEventMutationVariables> {
    override document = CreateSignificantEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateSinViewSignificantEventsDocument = gql`
    query PaginateSinViewSignificantEvents($first: Int!, $offset: Int!, $orderBy: [ViewSignificantEventsOrderBy!], $filter: ViewSignificantEventFilter) {
  viewSignificantEvents(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      id
      key
      pointOfSaleCode
      pointOfSaleName
      reasonCode
      reasonDescription
      description
      receptionCode
      startDate
      finishDate
      status
      sendingType
      sendingStatus
      sentAt
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateSinViewSignificantEventsGQL extends Apollo.Query<PaginateSinViewSignificantEventsQuery, PaginateSinViewSignificantEventsQueryVariables> {
    override document = PaginateSinViewSignificantEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendSignificantEventDocument = gql`
    mutation SendSignificantEvent($key: String!) {
  sendSignificantEvent(input: {key: $key}) {
    significantEvent {
      key
      cufd
      startDate
      finishDate
      receptionCode
      status
      sendingStatus
      createdAt
      sentAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendSignificantEventGQL extends Apollo.Mutation<SendSignificantEventMutation, SendSignificantEventMutationVariables> {
    override document = SendSignificantEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignificantEventByKeyDocument = gql`
    query SignificantEventByKey($key: String!) {
  significantEventByKey(pkey: $key) {
    key
    branchOfficeCode
    branchOfficeName
    pointOfSaleCode
    pointOfSaleName
    cuis
    cufd
    cufdEvent
    reasonCode
    reasonDescription
    description
    startDate
    finishDate
    receptionCode
    status
    sendingStatus
    createdAt
    sentAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignificantEventByKeyGQL extends Apollo.Query<SignificantEventByKeyQuery, SignificantEventByKeyQueryVariables> {
    override document = SignificantEventByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSinMessagesDocument = gql`
    query GetSinMessages($type: MessageType!, $key: String!) {
  messages(input: {type: $type, key: $key}) {
    messages {
      key
      code
      description
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSinMessagesGQL extends Apollo.Query<GetSinMessagesQuery, GetSinMessagesQueryVariables> {
    override document = GetSinMessagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateSinActivitiesDocument = gql`
    query PaginateSinActivities($first: Int!, $offset: Int!) {
  syncActivities(first: $first, offset: $offset) {
    nodes {
      caebCode
      description
      type
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateSinActivitiesGQL extends Apollo.Query<PaginateSinActivitiesQuery, PaginateSinActivitiesQueryVariables> {
    override document = PaginateSinActivitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateSinActivitySectorDocumentsDocument = gql`
    query PaginateSinActivitySectorDocuments($first: Int!, $offset: Int!) {
  syncActivitySectorDocuments(first: $first, offset: $offset) {
    nodes {
      activityCode
      sectorDocumentCode
      sectorDocumentType
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateSinActivitySectorDocumentsGQL extends Apollo.Query<PaginateSinActivitySectorDocumentsQuery, PaginateSinActivitySectorDocumentsQueryVariables> {
    override document = PaginateSinActivitySectorDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateSinViewParametersDocument = gql`
    query PaginateSinViewParameters($type: SyncParameterType!, $first: Int!, $offset: Int!, $orderBy: [ViewSyncParametersOrderBy!]) {
  viewSyncParameters(
    filter: {type: {equalTo: $type}}
    first: $first
    offset: $offset
    orderBy: $orderBy
  ) {
    nodes {
      classifierCode
      description
      createdAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateSinViewParametersGQL extends Apollo.Query<PaginateSinViewParametersQuery, PaginateSinViewParametersQueryVariables> {
    override document = PaginateSinViewParametersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateViewPointOfSalesDocument = gql`
    query PaginateViewPointOfSales($first: Int!, $offset: Int!, $orderBy: [ViewPointOfSalesOrderBy!], $filter: ViewPointOfSaleFilter) {
  viewPointOfSales(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      key
      branchOfficeCode
      branchOfficeName
      code
      name
      typeCode
      typeDescription
      description
      cuis
      cuisExpireAt
      cufd
      cufdExpireAt
      createdAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateViewPointOfSalesGQL extends Apollo.Query<PaginateViewPointOfSalesQuery, PaginateViewPointOfSalesQueryVariables> {
    override document = PaginateViewPointOfSalesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestSyncDocument = gql`
    mutation RequestSync($type: SyncRequestType!, $pointOfSaleKey: String) {
  requestSync(input: {type: $type, pointOfSaleKey: $pointOfSaleKey}) {
    syncRequest {
      key
      type
      status
      createdAt
      createdBy
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestSyncGQL extends Apollo.Mutation<RequestSyncMutation, RequestSyncMutationVariables> {
    override document = RequestSyncDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinActivitiesComboDocument = gql`
    query SinActivitiesCombo {
  syncActivities {
    nodes {
      caebCode
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinActivitiesComboGQL extends Apollo.Query<SinActivitiesComboQuery, SinActivitiesComboQueryVariables> {
    override document = SinActivitiesComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinActivitySectorDocumentsComboDocument = gql`
    query SinActivitySectorDocumentsCombo {
  syncActivitySectorDocuments {
    nodes {
      activityCode
      sectorDocumentCode
      sectorDocumentType
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinActivitySectorDocumentsComboGQL extends Apollo.Query<SinActivitySectorDocumentsComboQuery, SinActivitySectorDocumentsComboQueryVariables> {
    override document = SinActivitySectorDocumentsComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DateTimesDocument = gql`
    query DateTimes($first: Int!, $offset: Int!) {
  syncDatetimes(first: $first, offset: $offset) {
    nodes {
      value
      createdAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DateTimesGQL extends Apollo.Query<DateTimesQuery, DateTimesQueryVariables> {
    override document = DateTimesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceLegendsDocument = gql`
    query InvoiceLegends($first: Int!, $offset: Int!) {
  syncInvoiceLegends(first: $first, offset: $offset) {
    nodes {
      activityCode
      description
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceLegendsGQL extends Apollo.Query<InvoiceLegendsQuery, InvoiceLegendsQueryVariables> {
    override document = InvoiceLegendsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinSectorDocumentInvoiceTypeByActivityCodeDocument = gql`
    query SinSectorDocumentInvoiceTypeByActivityCode($activityCode: String!) {
  sectorDocumentInvoiceTypesByActivityCode(activityCode: $activityCode) {
    nodes {
      sectorDocumentCode
      description
      features
      invoiceTypeCode
      invoiceTypeDescription
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinSectorDocumentInvoiceTypeByActivityCodeGQL extends Apollo.Query<SinSectorDocumentInvoiceTypeByActivityCodeQuery, SinSectorDocumentInvoiceTypeByActivityCodeQueryVariables> {
    override document = SinSectorDocumentInvoiceTypeByActivityCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinDocumentoSectorTipoFacturaDocument = gql`
    query sinDocumentoSectorTipoFactura {
  sectorDocumentInvoiceTypes {
    nodes {
      sectorDocumentCode
      description
      features
      invoiceTypeCode
      invoiceTypeDescription
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinDocumentoSectorTipoFacturaGQL extends Apollo.Query<SinDocumentoSectorTipoFacturaQuery, SinDocumentoSectorTipoFacturaQueryVariables> {
    override document = SinDocumentoSectorTipoFacturaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateSyncRequestsDocument = gql`
    query PaginateSyncRequests($first: Int!, $offset: Int!, $orderBy: [ViewSyncRequestsOrderBy!]) {
  viewSyncRequests(first: $first, offset: $offset, orderBy: $orderBy) {
    nodes {
      key
      type
      status
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateSyncRequestsGQL extends Apollo.Query<PaginateSyncRequestsQuery, PaginateSyncRequestsQueryVariables> {
    override document = PaginateSyncRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncRequestSummaryDocument = gql`
    query SyncRequestSummary {
  syncRequestsSummary {
    nodes {
      key
      type
      status
      createdBy
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncRequestSummaryGQL extends Apollo.Query<SyncRequestSummaryQuery, SyncRequestSummaryQueryVariables> {
    override document = SyncRequestSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentMethodInfoByCodeDocument = gql`
    query PaymentMethodInfoByCode($code: Int!) {
  paymentMethodInfoByCode(code: $code) {
    showGiftCard
    showCardNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentMethodInfoByCodeGQL extends Apollo.Query<PaymentMethodInfoByCodeQuery, PaymentMethodInfoByCodeQueryVariables> {
    override document = PaymentMethodInfoByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinSectorDocumentsByActividadComboDocument = gql`
    query SinSectorDocumentsByActividadCombo($code: String!) {
  sectorDocumentsByActivityCode(code: $code) {
    nodes {
      classifierCode
      description
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinSectorDocumentsByActividadComboGQL extends Apollo.Query<SinSectorDocumentsByActividadComboQuery, SinSectorDocumentsByActividadComboQueryVariables> {
    override document = SinSectorDocumentsByActividadComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinVerifyNitOnRegisterDocument = gql`
    query SinVerifyNitOnRegister($nit: BigFloat!) {
  sinVerifyNitOnRegister(nit: $nit) {
    isValid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinVerifyNitOnRegisterGQL extends Apollo.Query<SinVerifyNitOnRegisterQuery, SinVerifyNitOnRegisterQueryVariables> {
    override document = SinVerifyNitOnRegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SinVerifyNitDocument = gql`
    query SinVerifyNit($nit: BigFloat!) {
  sinVerifyNit(nit: $nit)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SinVerifyNitGQL extends Apollo.Query<SinVerifyNitQuery, SinVerifyNitQueryVariables> {
    override document = SinVerifyNitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ViewPaymentMethodsComboDocument = gql`
    query ViewPaymentMethodsCombo {
  viewPaymentMethods(orderBy: CLASSIFIER_CODE_ASC) {
    nodes {
      classifierCode
      showGiftCard
      showCardNumber
      description
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewPaymentMethodsComboGQL extends Apollo.Query<ViewPaymentMethodsComboQuery, ViewPaymentMethodsComboQueryVariables> {
    override document = ViewPaymentMethodsComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ViewSyncParametersComboDocument = gql`
    query ViewSyncParametersCombo($type: SyncParameterType!, $orderBy: [ViewSyncParametersOrderBy!]) {
  viewSyncParameters(filter: {type: {equalTo: $type}}, orderBy: $orderBy) {
    nodes {
      classifierCode
      description
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewSyncParametersComboGQL extends Apollo.Query<ViewSyncParametersComboQuery, ViewSyncParametersComboQueryVariables> {
    override document = ViewSyncParametersComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActiveSubscriptionDocument = gql`
    query GetActiveSubscription {
  activeSubscription {
    key
    discount
    discountType
    status
    planKey
    planName
    planDescription
    planPrice
    planCurrency
    planBillingDay
    planBillingMonths
    quotas {
      nodes {
        key
        type
        used
        value
        overagePrice
        overageCurrency
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveSubscriptionGQL extends Apollo.Query<GetActiveSubscriptionQuery, GetActiveSubscriptionQueryVariables> {
    override document = GetActiveSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateAllSubscriptionChargesDocument = gql`
    query PaginateAllSubscriptionCharges($first: Int, $offset: Int, $orderBy: [AllSubscriptionChargesOrderBy!], $filter: AllSubscriptionChargeFilter, $condition: AllSubscriptionChargeCondition) {
  allSubscriptionCharges(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
    condition: $condition
  ) {
    nodes {
      tenantKey
      tenantName
      tenantNit
      tenantBusinessName
      subscriptionKey
      subscriptionStartedAt
      subscriptionCancelledAt
      planPrice
      planName
      planCurrency
      periodKey
      periodDescription
      periodStartAt
      periodEndAt
      periodStatus
      chargeKey
      chargeDescription
      chargeAmount
      chargeOverageAmount
      chargeTotalAmount
      chargeType
      chargeStatus
      chargeCreatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateAllSubscriptionChargesGQL extends Apollo.Query<PaginateAllSubscriptionChargesQuery, PaginateAllSubscriptionChargesQueryVariables> {
    override document = PaginateAllSubscriptionChargesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateAllSubscriptionPeriodsDocument = gql`
    query PaginateAllSubscriptionPeriods($first: Int, $offset: Int, $orderBy: [AllSubscriptionPeriodsOrderBy!], $filter: AllSubscriptionPeriodFilter, $condition: AllSubscriptionPeriodCondition) {
  allSubscriptionPeriods(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
    condition: $condition
  ) {
    nodes {
      key
      description
      startAt
      endAt
      status
      chargeKey
      chargeDescription
      chargeAmount
      chargeOverageAmount
      chargeTotalAmount
      chargeType
      chargeStatus
      chargeCreatedAt
      planPrice
      planName
      planCurrency
      tenantKey
      tenantName
      tenantNit
      tenantBusinessName
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateAllSubscriptionPeriodsGQL extends Apollo.Query<PaginateAllSubscriptionPeriodsQuery, PaginateAllSubscriptionPeriodsQueryVariables> {
    override document = PaginateAllSubscriptionPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateOwnSubscriptionChargesDocument = gql`
    query PaginateOwnSubscriptionCharges($first: Int, $offset: Int, $orderBy: [OwnSubscriptionPeriodsOrderBy!], $filter: OwnSubscriptionPeriodFilter, $condition: OwnSubscriptionPeriodCondition) {
  ownSubscriptionPeriods(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
    condition: $condition
  ) {
    nodes {
      key
      number
      description
      startAt
      endAt
      status
      chargeKey
      chargeDescription
      chargeAmount
      chargeOverageAmount
      chargeTotalAmount
      chargeType
      chargeStatus
      chargeCreatedAt
      planPrice
      planName
      planCurrency
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateOwnSubscriptionChargesGQL extends Apollo.Query<PaginateOwnSubscriptionChargesQuery, PaginateOwnSubscriptionChargesQueryVariables> {
    override document = PaginateOwnSubscriptionChargesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllSyncProductsDocument = gql`
    query AllSyncProducts {
  viewSyncProducts {
    nodes {
      activityCode
      code
      description
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllSyncProductsGQL extends Apollo.Query<AllSyncProductsQuery, AllSyncProductsQueryVariables> {
    override document = AllSyncProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncProductsByActivityCodeDocument = gql`
    query SyncProductsByActivityCode($activityCode: String!) {
  viewSyncProducts(condition: {activityCode: $activityCode}) {
    nodes {
      code
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncProductsByActivityCodeGQL extends Apollo.Query<SyncProductsByActivityCodeQuery, SyncProductsByActivityCodeQueryVariables> {
    override document = SyncProductsByActivityCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComboTenantsDocument = gql`
    query ComboTenants($orderBy: [ComboTenantsOrderBy!], $filter: ComboTenantFilter) {
  comboTenants(orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      name
      nit
      businessName
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComboTenantsGQL extends Apollo.Query<ComboTenantsQuery, ComboTenantsQueryVariables> {
    override document = ComboTenantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRegisterFormDocument = gql`
    mutation CreateRegisterForm($personFirstName: String!, $personLastName: String!, $personDocumentNumber: String!, $personJobTitle: String!, $personPhone: String!, $tenantNit: BigInt!, $tenantBusinessName: String!, $tenantSiatUsername: String!, $branchOfficeMunicipality: String!, $branchOfficeAddress: String!, $email: String!, $password: String!) {
  createRegisterForm(
    input: {personFirstName: $personFirstName, personLastName: $personLastName, personDocumentNumber: $personDocumentNumber, personJobTitle: $personJobTitle, personPhone: $personPhone, tenantNit: $tenantNit, tenantBusinessName: $tenantBusinessName, tenantSiatUsername: $tenantSiatUsername, branchOfficeMunicipality: $branchOfficeMunicipality, branchOfficeAddress: $branchOfficeAddress, email: $email, password: $password}
  ) {
    nit
    businessName
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRegisterFormGQL extends Apollo.Mutation<CreateRegisterFormMutation, CreateRegisterFormMutationVariables> {
    override document = CreateRegisterFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTenantDocument = gql`
    mutation CreateTenant($tenantName: String!, $businessName: String!, $nit: BigInt!, $phoneNumber: String!, $firstName: String!, $middleName: String!, $firstSurname: String!, $secondSurname: String!, $email: String!, $branchOfficeName: String!, $branchOfficeAddress: String!, $branchOfficeMunicipality: String!, $pointOfSaleName: String!) {
  createTenant(
    input: {pNameTenant: $tenantName, pBusinessName: $businessName, pNit: $nit, pEmail: $email, pPhoneNumber: $phoneNumber, pBranchOfficeName: $branchOfficeName, pBranchOfficeMunicipality: $branchOfficeMunicipality, pBranchOfficeAddress: $branchOfficeAddress, pPointOfSaleName: $pointOfSaleName, pFirstName: $firstName, pMiddleName: $middleName, pFirstSurname: $firstSurname, pSecondSurname: $secondSurname}
  ) {
    tenant {
      key
      name
      nit
      businessName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTenantGQL extends Apollo.Mutation<CreateTenantMutation, CreateTenantMutationVariables> {
    override document = CreateTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentBillingInfoDocument = gql`
    query CurrentBillingInfo {
  currentBillingInfo {
    businessName
    documentTypeCode
    documentTypeDescription
    documentNumber
    documentComplement
    email
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentBillingInfoGQL extends Apollo.Query<CurrentBillingInfoQuery, CurrentBillingInfoQueryVariables> {
    override document = CurrentBillingInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentTenantInfoDocument = gql`
    query CurrentTenantInfo {
  currentTenantInfo {
    name
    nit
    businessName
    email
    phone
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentTenantInfoGQL extends Apollo.Query<CurrentTenantInfoQuery, CurrentTenantInfoQueryVariables> {
    override document = CurrentTenantInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantFullInfoDocument = gql`
    query GetTenantFullInfo($key: String!) {
  tenantFullInfo(pKey: $key) {
    key
    name
    createdAt
    updatedAt
    nit
    businessName
    email
    phone
    tokenValue
    tokenRevoked
    tokenIssuedAt
    tokenExpireAt
    digitalSignatureKey
    digitalSignatureIssuedAt
    digitalSignatureExpireAt
    digitalSignatureRevoked
    digitalSignatureCreatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantFullInfoGQL extends Apollo.Query<GetTenantFullInfoQuery, GetTenantFullInfoQueryVariables> {
    override document = GetTenantFullInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantSubscriptionDocument = gql`
    query GetTenantSubscription($key: String!) {
  tenantSubscription(pKey: $key) {
    key
    discount
    discountType
    discountAppliedAt
    startedAt
    cancelledAt
    status
    createdAt
    planKey
    planName
    planDescription
    planPrice
    planCurrency
    planBillingDay
    planBillingPeriod
    quotaUsersLimit
    quotaInvoicesLimit
    quotaPointsOfSaleLimit
    quotaBranchOfficesLimit
    quotaUsersUsed
    quotaInvoicesUsed
    quotaPointsOfSaleUsed
    quotaBranchOfficesUsed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantSubscriptionGQL extends Apollo.Query<GetTenantSubscriptionQuery, GetTenantSubscriptionQueryVariables> {
    override document = GetTenantSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateAllTenantsDocument = gql`
    query PaginateAllTenants($first: Int!, $offset: Int!, $orderBy: [AllTenantsOrderBy!], $filter: AllTenantFilter) {
  allTenants(first: $first, offset: $offset, orderBy: $orderBy, filter: $filter) {
    nodes {
      key
      nit
      businessName
      email
      phoneNumber
      createdAt
      subscriptionStatus
      subscriptionStartedAt
      planKey
      planName
      planPrice
      planCurrency
      planBillingPeriod
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateAllTenantsGQL extends Apollo.Query<PaginateAllTenantsQuery, PaginateAllTenantsQueryVariables> {
    override document = PaginateAllTenantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCurrentBillingInfoDocument = gql`
    mutation UpdateCurrentBillingInfo($businessName: String!, $documentTypeCode: Int!, $documentNumber: String!, $documentComplement: String!, $email: String!) {
  updateCurrentBillingInfo(
    input: {pBusinessName: $businessName, pDocumentTypeCode: $documentTypeCode, pDocumentNumber: $documentNumber, pDocumentComplement: $documentComplement, pEmail: $email}
  ) {
    currentBillingInfo {
      businessName
      documentTypeCode
      documentTypeDescription
      documentNumber
      documentComplement
      email
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCurrentBillingInfoGQL extends Apollo.Mutation<UpdateCurrentBillingInfoMutation, UpdateCurrentBillingInfoMutationVariables> {
    override document = UpdateCurrentBillingInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCurrentTenantInfoDocument = gql`
    mutation UpdateCurrentTenantInfo($businessName: String!, $email: String!, $phone: String!) {
  updateCurrentTenantInfo(
    input: {pBusinessName: $businessName, pEmail: $email, pPhone: $phone}
  ) {
    currentTenantInfo {
      businessName
      email
      phone
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCurrentTenantInfoGQL extends Apollo.Mutation<UpdateCurrentTenantInfoMutation, UpdateCurrentTenantInfoMutationVariables> {
    override document = UpdateCurrentTenantInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateAllDelegatedTokensDocument = gql`
    query PaginateAllDelegatedTokens($first: Int!, $offset: Int!, $orderBy: [AllDelegatedTokensOrderBy!], $filter: AllDelegatedTokenFilter) {
  allDelegatedTokens(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      tenantKey
      tenantName
      tenantNit
      tenantBusinessName
      id
      key
      sub
      systemCode
      nit
      issuedAt
      expireAt
      enabled
      revoked
      createdAt
      updatedAt
      date
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateAllDelegatedTokensGQL extends Apollo.Query<PaginateAllDelegatedTokensQuery, PaginateAllDelegatedTokensQueryVariables> {
    override document = PaginateAllDelegatedTokensDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateDelegatedTokensDocument = gql`
    query PaginateDelegatedTokens($first: Int!, $offset: Int!, $orderBy: [ViewDelegatedTokensOrderBy!], $filter: ViewDelegatedTokenFilter) {
  viewDelegatedTokens(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      id
      key
      sub
      systemCode
      nit
      issuedAt
      expireAt
      enabled
      revoked
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateDelegatedTokensGQL extends Apollo.Query<PaginateDelegatedTokensQuery, PaginateDelegatedTokensQueryVariables> {
    override document = PaginateDelegatedTokensDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadDelegatedTokenDocument = gql`
    mutation UploadDelegatedToken($tenantKey: String!, $token: String!) {
  uploadDelegatedToken(input: {tenantKey: $tenantKey, token: $token}) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadDelegatedTokenGQL extends Apollo.Mutation<UploadDelegatedTokenMutation, UploadDelegatedTokenMutationVariables> {
    override document = UploadDelegatedTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClientDocument = gql`
    mutation UpdateClient($key: String!, $name: String!, $phoneNumber: String!, $email: String!, $observation: String, $documentNumber: String!, $documentComplement: String, $documentTypeCode: Int!, $allowInvalidNit: Boolean!) {
  updateClient(
    input: {key: $key, patch: {name: $name, phoneNumber: $phoneNumber, email: $email, observation: $observation, homologations: {updateByClientKey: {clientKey: $key, patch: {documentNumber: $documentNumber, documentComplement: $documentComplement, documentTypeCode: $documentTypeCode, allowInvalidNit: $allowInvalidNit}}}}}
  ) {
    client {
      key
      name
      observation
      phoneNumber
      email
      createdAt
      homologation {
        key
        documentNumber
        documentComplement
        documentTypeCode
        allowInvalidNit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClientGQL extends Apollo.Mutation<UpdateClientMutation, UpdateClientMutationVariables> {
    override document = UpdateClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserByKeyDocument = gql`
    query UserByKey($key: String!) {
  user(key: $key) {
    key
    email
    createdAt
    updatedAt
    person {
      key
      fullName
    }
    pointOfSaleUsers {
      nodes {
        key
        createdAt
        updatedAt
        pointOfSale {
          key
          code
          name
          typeCode
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserByKeyGQL extends Apollo.Query<UserByKeyQuery, UserByKeyQueryVariables> {
    override document = UserByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($firstName: String!, $middleName: String!, $firstSurname: String!, $secondSurname: String!, $email: String!, $roleKey: String!) {
  createUser(
    input: {pFirstName: $firstName, pMiddleName: $middleName, pFirstSurname: $firstSurname, pSecondSurname: $secondSurname, pEmail: $email, pRoleKey: $roleKey}
  ) {
    user {
      key
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    override document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentPermissionsDocument = gql`
    query CurrentPermissions {
  currentPermissions {
    nodes {
      code
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentPermissionsGQL extends Apollo.Query<CurrentPermissionsQuery, CurrentPermissionsQueryVariables> {
    override document = CurrentPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    key
    action
    lastTenantKey
    person {
      key
      firstName
      firstSurname
      fullName
    }
    tenant {
      key
      nit
      businessName
    }
    tenants {
      nodes {
        key
        nit
        businessName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    override document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateAllUsersDocument = gql`
    query PaginateAllUsers($first: Int!, $offset: Int!, $orderBy: [AllUsersOrderBy!], $condition: AllUserCondition, $filter: AllUserFilter) {
  allUsers(
    first: $first
    offset: $offset
    orderBy: $orderBy
    condition: $condition
    filter: $filter
  ) {
    nodes {
      key
      username
      email
      fullName
      blocked
      enabled
      lastConnection
      createdAt
      updatedAt
      tenantKey
      tenantName
      tenantNit
      tenantBusinessName
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateAllUsersGQL extends Apollo.Query<PaginateAllUsersQuery, PaginateAllUsersQueryVariables> {
    override document = PaginateAllUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginateOwnUsersDocument = gql`
    query PaginateOwnUsers($first: Int!, $offset: Int!, $orderBy: [OwnUsersOrderBy!], $condition: OwnUserCondition, $filter: OwnUserFilter) {
  ownUsers(
    first: $first
    offset: $offset
    orderBy: $orderBy
    condition: $condition
    filter: $filter
  ) {
    nodes {
      key
      username
      email
      fullName
      blocked
      lastConnection
      roleCount
      permissionCount
      enabled
      createdAt
      updatedAt
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginateOwnUsersGQL extends Apollo.Query<PaginateOwnUsersQuery, PaginateOwnUsersQueryVariables> {
    override document = PaginateOwnUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RolesByUserKeyDocument = gql`
    query RolesByUserKey($key: String!) {
  rolesByUserKey(key: $key) {
    key
    name
    description
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RolesByUserKeyGQL extends Apollo.Query<RolesByUserKeyQuery, RolesByUserKeyQueryVariables> {
    override document = RolesByUserKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveSelectedTenantDocument = gql`
    mutation SaveSelectedTenant($tenantKey: String!) {
  saveSelectedTenant(input: {pTenantKey: $tenantKey}) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveSelectedTenantGQL extends Apollo.Mutation<SaveSelectedTenantMutation, SaveSelectedTenantMutationVariables> {
    override document = SaveSelectedTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnlockUserDocument = gql`
    mutation UnlockUser($tokenUser: String!) {
  unlockUser(input: {pKeyUser: $tokenUser}) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnlockUserGQL extends Apollo.Mutation<UnlockUserMutation, UnlockUserMutationVariables> {
    override document = UnlockUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserRolesDocument = gql`
    mutation UpdateUserRoles($userKey: String!, $roleKeys: [String!]) {
  updateUserRoles(input: {pUserKey: $userKey, pRoleKeys: $roleKeys}) {
    strings
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserRolesGQL extends Apollo.Mutation<UpdateUserRolesMutation, UpdateUserRolesMutationVariables> {
    override document = UpdateUserRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDetailsByKeyDocument = gql`
    query UserDetailsByKey($key: String!) {
  user(key: $key) {
    key
    email
    username
    createdAt
    updatedAt
    person {
      key
      fullName
      createdAt
      updatedAt
    }
    tenants {
      nodes {
        key
        nit
        businessName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserDetailsByKeyGQL extends Apollo.Query<UserDetailsByKeyQuery, UserDetailsByKeyQueryVariables> {
    override document = UserDetailsByKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RolesComboDocument = gql`
    query RolesCombo {
  viewRoles {
    nodes {
      key
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RolesComboGQL extends Apollo.Query<RolesComboQuery, RolesComboQueryVariables> {
    override document = RolesComboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }